/*! emojione 02-12-2016 */
!(function(a) {
    a.emojioneList = {
        ':kiss_ww:': {
            unicode: [
                '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
                '1f469-2764-1f48b-1f469'
            ],
            fname: '1f469-2764-1f48b-1f469',
            uc: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
            isCanonical: !0
        },
        ':couplekiss_ww:': {
            unicode: [
                '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
                '1f469-2764-1f48b-1f469'
            ],
            fname: '1f469-2764-1f48b-1f469',
            uc: '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
            isCanonical: !1
        },
        ':kiss_mm:': {
            unicode: [
                '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
                '1f468-2764-1f48b-1f468'
            ],
            fname: '1f468-2764-1f48b-1f468',
            uc: '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
            isCanonical: !0
        },
        ':couplekiss_mm:': {
            unicode: [
                '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
                '1f468-2764-1f48b-1f468'
            ],
            fname: '1f468-2764-1f48b-1f468',
            uc: '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
            isCanonical: !1
        },
        ':family_mmbb:': {
            unicode: [
                '1f468-200d-1f468-200d-1f466-200d-1f466',
                '1f468-1f468-1f466-1f466'
            ],
            fname: '1f468-1f468-1f466-1f466',
            uc: '1f468-200d-1f468-200d-1f466-200d-1f466',
            isCanonical: !0
        },
        ':family_mmgb:': {
            unicode: [
                '1f468-200d-1f468-200d-1f467-200d-1f466',
                '1f468-1f468-1f467-1f466'
            ],
            fname: '1f468-1f468-1f467-1f466',
            uc: '1f468-200d-1f468-200d-1f467-200d-1f466',
            isCanonical: !0
        },
        ':family_mmgg:': {
            unicode: [
                '1f468-200d-1f468-200d-1f467-200d-1f467',
                '1f468-1f468-1f467-1f467'
            ],
            fname: '1f468-1f468-1f467-1f467',
            uc: '1f468-200d-1f468-200d-1f467-200d-1f467',
            isCanonical: !0
        },
        ':family_mwbb:': {
            unicode: [
                '1f468-200d-1f469-200d-1f466-200d-1f466',
                '1f468-1f469-1f466-1f466'
            ],
            fname: '1f468-1f469-1f466-1f466',
            uc: '1f468-200d-1f469-200d-1f466-200d-1f466',
            isCanonical: !0
        },
        ':family_mwgb:': {
            unicode: [
                '1f468-200d-1f469-200d-1f467-200d-1f466',
                '1f468-1f469-1f467-1f466'
            ],
            fname: '1f468-1f469-1f467-1f466',
            uc: '1f468-200d-1f469-200d-1f467-200d-1f466',
            isCanonical: !0
        },
        ':family_mwgg:': {
            unicode: [
                '1f468-200d-1f469-200d-1f467-200d-1f467',
                '1f468-1f469-1f467-1f467'
            ],
            fname: '1f468-1f469-1f467-1f467',
            uc: '1f468-200d-1f469-200d-1f467-200d-1f467',
            isCanonical: !0
        },
        ':family_wwbb:': {
            unicode: [
                '1f469-200d-1f469-200d-1f466-200d-1f466',
                '1f469-1f469-1f466-1f466'
            ],
            fname: '1f469-1f469-1f466-1f466',
            uc: '1f469-200d-1f469-200d-1f466-200d-1f466',
            isCanonical: !0
        },
        ':family_wwgb:': {
            unicode: [
                '1f469-200d-1f469-200d-1f467-200d-1f466',
                '1f469-1f469-1f467-1f466'
            ],
            fname: '1f469-1f469-1f467-1f466',
            uc: '1f469-200d-1f469-200d-1f467-200d-1f466',
            isCanonical: !0
        },
        ':family_wwgg:': {
            unicode: [
                '1f469-200d-1f469-200d-1f467-200d-1f467',
                '1f469-1f469-1f467-1f467'
            ],
            fname: '1f469-1f469-1f467-1f467',
            uc: '1f469-200d-1f469-200d-1f467-200d-1f467',
            isCanonical: !0
        },
        ':couple_ww:': {
            unicode: ['1f469-200d-2764-fe0f-200d-1f469', '1f469-2764-1f469'],
            fname: '1f469-2764-1f469',
            uc: '1f469-200d-2764-fe0f-200d-1f469',
            isCanonical: !0
        },
        ':couple_with_heart_ww:': {
            unicode: ['1f469-200d-2764-fe0f-200d-1f469', '1f469-2764-1f469'],
            fname: '1f469-2764-1f469',
            uc: '1f469-200d-2764-fe0f-200d-1f469',
            isCanonical: !1
        },
        ':couple_mm:': {
            unicode: ['1f468-200d-2764-fe0f-200d-1f468', '1f468-2764-1f468'],
            fname: '1f468-2764-1f468',
            uc: '1f468-200d-2764-fe0f-200d-1f468',
            isCanonical: !0
        },
        ':couple_with_heart_mm:': {
            unicode: ['1f468-200d-2764-fe0f-200d-1f468', '1f468-2764-1f468'],
            fname: '1f468-2764-1f468',
            uc: '1f468-200d-2764-fe0f-200d-1f468',
            isCanonical: !1
        },
        ':family_mmb:': {
            unicode: ['1f468-200d-1f468-200d-1f466', '1f468-1f468-1f466'],
            fname: '1f468-1f468-1f466',
            uc: '1f468-200d-1f468-200d-1f466',
            isCanonical: !0
        },
        ':family_mmg:': {
            unicode: ['1f468-200d-1f468-200d-1f467', '1f468-1f468-1f467'],
            fname: '1f468-1f468-1f467',
            uc: '1f468-200d-1f468-200d-1f467',
            isCanonical: !0
        },
        ':family_mwg:': {
            unicode: ['1f468-200d-1f469-200d-1f467', '1f468-1f469-1f467'],
            fname: '1f468-1f469-1f467',
            uc: '1f468-200d-1f469-200d-1f467',
            isCanonical: !0
        },
        ':family_wwb:': {
            unicode: ['1f469-200d-1f469-200d-1f466', '1f469-1f469-1f466'],
            fname: '1f469-1f469-1f466',
            uc: '1f469-200d-1f469-200d-1f466',
            isCanonical: !0
        },
        ':family_wwg:': {
            unicode: ['1f469-200d-1f469-200d-1f467', '1f469-1f469-1f467'],
            fname: '1f469-1f469-1f467',
            uc: '1f469-200d-1f469-200d-1f467',
            isCanonical: !0
        },
        ':rainbow_flag:': {
            unicode: ['1f3f3-fe0f-200d-1f308', '1f3f3-1f308'],
            fname: '1f3f3-1f308',
            uc: '1f3f3-fe0f-200d-1f308',
            isCanonical: !0
        },
        ':gay_pride_flag:': {
            unicode: ['1f3f3-fe0f-200d-1f308', '1f3f3-1f308'],
            fname: '1f3f3-1f308',
            uc: '1f3f3-fe0f-200d-1f308',
            isCanonical: !1
        },
        ':eye_in_speech_bubble:': {
            unicode: ['1f441-200d-1f5e8', '1f441-1f5e8'],
            fname: '1f441-1f5e8',
            uc: '1f441-200d-1f5e8',
            isCanonical: !0
        },
        ':hash:': {
            unicode: ['0023-fe0f-20e3', '0023-20e3'],
            fname: '0023-20e3',
            uc: '0023-20e3',
            isCanonical: !0
        },
        ':zero:': {
            unicode: ['0030-fe0f-20e3', '0030-20e3'],
            fname: '0030-20e3',
            uc: '0030-20e3',
            isCanonical: !0
        },
        ':one:': {
            unicode: ['0031-fe0f-20e3', '0031-20e3'],
            fname: '0031-20e3',
            uc: '0031-20e3',
            isCanonical: !0
        },
        ':two:': {
            unicode: ['0032-fe0f-20e3', '0032-20e3'],
            fname: '0032-20e3',
            uc: '0032-20e3',
            isCanonical: !0
        },
        ':three:': {
            unicode: ['0033-fe0f-20e3', '0033-20e3'],
            fname: '0033-20e3',
            uc: '0033-20e3',
            isCanonical: !0
        },
        ':four:': {
            unicode: ['0034-fe0f-20e3', '0034-20e3'],
            fname: '0034-20e3',
            uc: '0034-20e3',
            isCanonical: !0
        },
        ':five:': {
            unicode: ['0035-fe0f-20e3', '0035-20e3'],
            fname: '0035-20e3',
            uc: '0035-20e3',
            isCanonical: !0
        },
        ':six:': {
            unicode: ['0036-fe0f-20e3', '0036-20e3'],
            fname: '0036-20e3',
            uc: '0036-20e3',
            isCanonical: !0
        },
        ':seven:': {
            unicode: ['0037-fe0f-20e3', '0037-20e3'],
            fname: '0037-20e3',
            uc: '0037-20e3',
            isCanonical: !0
        },
        ':eight:': {
            unicode: ['0038-fe0f-20e3', '0038-20e3'],
            fname: '0038-20e3',
            uc: '0038-20e3',
            isCanonical: !0
        },
        ':nine:': {
            unicode: ['0039-fe0f-20e3', '0039-20e3'],
            fname: '0039-20e3',
            uc: '0039-20e3',
            isCanonical: !0
        },
        ':asterisk:': {
            unicode: ['002a-fe0f-20e3', '002a-20e3'],
            fname: '002a-20e3',
            uc: '002a-20e3',
            isCanonical: !0
        },
        ':keycap_asterisk:': {
            unicode: ['002a-fe0f-20e3', '002a-20e3'],
            fname: '002a-20e3',
            uc: '002a-20e3',
            isCanonical: !1
        },
        ':handball_tone5:': {
            unicode: ['1f93e-1f3ff'],
            fname: '1f93e-1f3ff',
            uc: '1f93e-1f3ff',
            isCanonical: !0
        },
        ':handball_tone4:': {
            unicode: ['1f93e-1f3fe'],
            fname: '1f93e-1f3fe',
            uc: '1f93e-1f3fe',
            isCanonical: !0
        },
        ':handball_tone3:': {
            unicode: ['1f93e-1f3fd'],
            fname: '1f93e-1f3fd',
            uc: '1f93e-1f3fd',
            isCanonical: !0
        },
        ':handball_tone2:': {
            unicode: ['1f93e-1f3fc'],
            fname: '1f93e-1f3fc',
            uc: '1f93e-1f3fc',
            isCanonical: !0
        },
        ':handball_tone1:': {
            unicode: ['1f93e-1f3fb'],
            fname: '1f93e-1f3fb',
            uc: '1f93e-1f3fb',
            isCanonical: !0
        },
        ':water_polo_tone5:': {
            unicode: ['1f93d-1f3ff'],
            fname: '1f93d-1f3ff',
            uc: '1f93d-1f3ff',
            isCanonical: !0
        },
        ':water_polo_tone4:': {
            unicode: ['1f93d-1f3fe'],
            fname: '1f93d-1f3fe',
            uc: '1f93d-1f3fe',
            isCanonical: !0
        },
        ':water_polo_tone3:': {
            unicode: ['1f93d-1f3fd'],
            fname: '1f93d-1f3fd',
            uc: '1f93d-1f3fd',
            isCanonical: !0
        },
        ':water_polo_tone2:': {
            unicode: ['1f93d-1f3fc'],
            fname: '1f93d-1f3fc',
            uc: '1f93d-1f3fc',
            isCanonical: !0
        },
        ':water_polo_tone1:': {
            unicode: ['1f93d-1f3fb'],
            fname: '1f93d-1f3fb',
            uc: '1f93d-1f3fb',
            isCanonical: !0
        },
        ':wrestlers_tone5:': {
            unicode: ['1f93c-1f3ff'],
            fname: '1f93c-1f3ff',
            uc: '1f93c-1f3ff',
            isCanonical: !0
        },
        ':wrestling_tone5:': {
            unicode: ['1f93c-1f3ff'],
            fname: '1f93c-1f3ff',
            uc: '1f93c-1f3ff',
            isCanonical: !1
        },
        ':wrestlers_tone4:': {
            unicode: ['1f93c-1f3fe'],
            fname: '1f93c-1f3fe',
            uc: '1f93c-1f3fe',
            isCanonical: !0
        },
        ':wrestling_tone4:': {
            unicode: ['1f93c-1f3fe'],
            fname: '1f93c-1f3fe',
            uc: '1f93c-1f3fe',
            isCanonical: !1
        },
        ':wrestlers_tone3:': {
            unicode: ['1f93c-1f3fd'],
            fname: '1f93c-1f3fd',
            uc: '1f93c-1f3fd',
            isCanonical: !0
        },
        ':wrestling_tone3:': {
            unicode: ['1f93c-1f3fd'],
            fname: '1f93c-1f3fd',
            uc: '1f93c-1f3fd',
            isCanonical: !1
        },
        ':wrestlers_tone2:': {
            unicode: ['1f93c-1f3fc'],
            fname: '1f93c-1f3fc',
            uc: '1f93c-1f3fc',
            isCanonical: !0
        },
        ':wrestling_tone2:': {
            unicode: ['1f93c-1f3fc'],
            fname: '1f93c-1f3fc',
            uc: '1f93c-1f3fc',
            isCanonical: !1
        },
        ':wrestlers_tone1:': {
            unicode: ['1f93c-1f3fb'],
            fname: '1f93c-1f3fb',
            uc: '1f93c-1f3fb',
            isCanonical: !0
        },
        ':wrestling_tone1:': {
            unicode: ['1f93c-1f3fb'],
            fname: '1f93c-1f3fb',
            uc: '1f93c-1f3fb',
            isCanonical: !1
        },
        ':juggling_tone5:': {
            unicode: ['1f939-1f3ff'],
            fname: '1f939-1f3ff',
            uc: '1f939-1f3ff',
            isCanonical: !0
        },
        ':juggler_tone5:': {
            unicode: ['1f939-1f3ff'],
            fname: '1f939-1f3ff',
            uc: '1f939-1f3ff',
            isCanonical: !1
        },
        ':juggling_tone4:': {
            unicode: ['1f939-1f3fe'],
            fname: '1f939-1f3fe',
            uc: '1f939-1f3fe',
            isCanonical: !0
        },
        ':juggler_tone4:': {
            unicode: ['1f939-1f3fe'],
            fname: '1f939-1f3fe',
            uc: '1f939-1f3fe',
            isCanonical: !1
        },
        ':juggling_tone3:': {
            unicode: ['1f939-1f3fd'],
            fname: '1f939-1f3fd',
            uc: '1f939-1f3fd',
            isCanonical: !0
        },
        ':juggler_tone3:': {
            unicode: ['1f939-1f3fd'],
            fname: '1f939-1f3fd',
            uc: '1f939-1f3fd',
            isCanonical: !1
        },
        ':juggling_tone2:': {
            unicode: ['1f939-1f3fc'],
            fname: '1f939-1f3fc',
            uc: '1f939-1f3fc',
            isCanonical: !0
        },
        ':juggler_tone2:': {
            unicode: ['1f939-1f3fc'],
            fname: '1f939-1f3fc',
            uc: '1f939-1f3fc',
            isCanonical: !1
        },
        ':juggling_tone1:': {
            unicode: ['1f939-1f3fb'],
            fname: '1f939-1f3fb',
            uc: '1f939-1f3fb',
            isCanonical: !0
        },
        ':juggler_tone1:': {
            unicode: ['1f939-1f3fb'],
            fname: '1f939-1f3fb',
            uc: '1f939-1f3fb',
            isCanonical: !1
        },
        ':cartwheel_tone5:': {
            unicode: ['1f938-1f3ff'],
            fname: '1f938-1f3ff',
            uc: '1f938-1f3ff',
            isCanonical: !0
        },
        ':person_doing_cartwheel_tone5:': {
            unicode: ['1f938-1f3ff'],
            fname: '1f938-1f3ff',
            uc: '1f938-1f3ff',
            isCanonical: !1
        },
        ':cartwheel_tone4:': {
            unicode: ['1f938-1f3fe'],
            fname: '1f938-1f3fe',
            uc: '1f938-1f3fe',
            isCanonical: !0
        },
        ':person_doing_cartwheel_tone4:': {
            unicode: ['1f938-1f3fe'],
            fname: '1f938-1f3fe',
            uc: '1f938-1f3fe',
            isCanonical: !1
        },
        ':cartwheel_tone3:': {
            unicode: ['1f938-1f3fd'],
            fname: '1f938-1f3fd',
            uc: '1f938-1f3fd',
            isCanonical: !0
        },
        ':person_doing_cartwheel_tone3:': {
            unicode: ['1f938-1f3fd'],
            fname: '1f938-1f3fd',
            uc: '1f938-1f3fd',
            isCanonical: !1
        },
        ':cartwheel_tone2:': {
            unicode: ['1f938-1f3fc'],
            fname: '1f938-1f3fc',
            uc: '1f938-1f3fc',
            isCanonical: !0
        },
        ':person_doing_cartwheel_tone2:': {
            unicode: ['1f938-1f3fc'],
            fname: '1f938-1f3fc',
            uc: '1f938-1f3fc',
            isCanonical: !1
        },
        ':cartwheel_tone1:': {
            unicode: ['1f938-1f3fb'],
            fname: '1f938-1f3fb',
            uc: '1f938-1f3fb',
            isCanonical: !0
        },
        ':person_doing_cartwheel_tone1:': {
            unicode: ['1f938-1f3fb'],
            fname: '1f938-1f3fb',
            uc: '1f938-1f3fb',
            isCanonical: !1
        },
        ':shrug_tone5:': {
            unicode: ['1f937-1f3ff'],
            fname: '1f937-1f3ff',
            uc: '1f937-1f3ff',
            isCanonical: !0
        },
        ':shrug_tone4:': {
            unicode: ['1f937-1f3fe'],
            fname: '1f937-1f3fe',
            uc: '1f937-1f3fe',
            isCanonical: !0
        },
        ':shrug_tone3:': {
            unicode: ['1f937-1f3fd'],
            fname: '1f937-1f3fd',
            uc: '1f937-1f3fd',
            isCanonical: !0
        },
        ':shrug_tone2:': {
            unicode: ['1f937-1f3fc'],
            fname: '1f937-1f3fc',
            uc: '1f937-1f3fc',
            isCanonical: !0
        },
        ':shrug_tone1:': {
            unicode: ['1f937-1f3fb'],
            fname: '1f937-1f3fb',
            uc: '1f937-1f3fb',
            isCanonical: !0
        },
        ':mrs_claus_tone5:': {
            unicode: ['1f936-1f3ff'],
            fname: '1f936-1f3ff',
            uc: '1f936-1f3ff',
            isCanonical: !0
        },
        ':mother_christmas_tone5:': {
            unicode: ['1f936-1f3ff'],
            fname: '1f936-1f3ff',
            uc: '1f936-1f3ff',
            isCanonical: !1
        },
        ':mrs_claus_tone4:': {
            unicode: ['1f936-1f3fe'],
            fname: '1f936-1f3fe',
            uc: '1f936-1f3fe',
            isCanonical: !0
        },
        ':mother_christmas_tone4:': {
            unicode: ['1f936-1f3fe'],
            fname: '1f936-1f3fe',
            uc: '1f936-1f3fe',
            isCanonical: !1
        },
        ':mrs_claus_tone3:': {
            unicode: ['1f936-1f3fd'],
            fname: '1f936-1f3fd',
            uc: '1f936-1f3fd',
            isCanonical: !0
        },
        ':mother_christmas_tone3:': {
            unicode: ['1f936-1f3fd'],
            fname: '1f936-1f3fd',
            uc: '1f936-1f3fd',
            isCanonical: !1
        },
        ':mrs_claus_tone2:': {
            unicode: ['1f936-1f3fc'],
            fname: '1f936-1f3fc',
            uc: '1f936-1f3fc',
            isCanonical: !0
        },
        ':mother_christmas_tone2:': {
            unicode: ['1f936-1f3fc'],
            fname: '1f936-1f3fc',
            uc: '1f936-1f3fc',
            isCanonical: !1
        },
        ':mrs_claus_tone1:': {
            unicode: ['1f936-1f3fb'],
            fname: '1f936-1f3fb',
            uc: '1f936-1f3fb',
            isCanonical: !0
        },
        ':mother_christmas_tone1:': {
            unicode: ['1f936-1f3fb'],
            fname: '1f936-1f3fb',
            uc: '1f936-1f3fb',
            isCanonical: !1
        },
        ':man_in_tuxedo_tone5:': {
            unicode: ['1f935-1f3ff'],
            fname: '1f935-1f3ff',
            uc: '1f935-1f3ff',
            isCanonical: !0
        },
        ':tuxedo_tone5:': {
            unicode: ['1f935-1f3ff'],
            fname: '1f935-1f3ff',
            uc: '1f935-1f3ff',
            isCanonical: !1
        },
        ':man_in_tuxedo_tone4:': {
            unicode: ['1f935-1f3fe'],
            fname: '1f935-1f3fe',
            uc: '1f935-1f3fe',
            isCanonical: !0
        },
        ':tuxedo_tone4:': {
            unicode: ['1f935-1f3fe'],
            fname: '1f935-1f3fe',
            uc: '1f935-1f3fe',
            isCanonical: !1
        },
        ':man_in_tuxedo_tone3:': {
            unicode: ['1f935-1f3fd'],
            fname: '1f935-1f3fd',
            uc: '1f935-1f3fd',
            isCanonical: !0
        },
        ':tuxedo_tone3:': {
            unicode: ['1f935-1f3fd'],
            fname: '1f935-1f3fd',
            uc: '1f935-1f3fd',
            isCanonical: !1
        },
        ':man_in_tuxedo_tone2:': {
            unicode: ['1f935-1f3fc'],
            fname: '1f935-1f3fc',
            uc: '1f935-1f3fc',
            isCanonical: !0
        },
        ':tuxedo_tone2:': {
            unicode: ['1f935-1f3fc'],
            fname: '1f935-1f3fc',
            uc: '1f935-1f3fc',
            isCanonical: !1
        },
        ':man_in_tuxedo_tone1:': {
            unicode: ['1f935-1f3fb'],
            fname: '1f935-1f3fb',
            uc: '1f935-1f3fb',
            isCanonical: !0
        },
        ':tuxedo_tone1:': {
            unicode: ['1f935-1f3fb'],
            fname: '1f935-1f3fb',
            uc: '1f935-1f3fb',
            isCanonical: !1
        },
        ':prince_tone5:': {
            unicode: ['1f934-1f3ff'],
            fname: '1f934-1f3ff',
            uc: '1f934-1f3ff',
            isCanonical: !0
        },
        ':prince_tone4:': {
            unicode: ['1f934-1f3fe'],
            fname: '1f934-1f3fe',
            uc: '1f934-1f3fe',
            isCanonical: !0
        },
        ':prince_tone3:': {
            unicode: ['1f934-1f3fd'],
            fname: '1f934-1f3fd',
            uc: '1f934-1f3fd',
            isCanonical: !0
        },
        ':prince_tone2:': {
            unicode: ['1f934-1f3fc'],
            fname: '1f934-1f3fc',
            uc: '1f934-1f3fc',
            isCanonical: !0
        },
        ':prince_tone1:': {
            unicode: ['1f934-1f3fb'],
            fname: '1f934-1f3fb',
            uc: '1f934-1f3fb',
            isCanonical: !0
        },
        ':selfie_tone5:': {
            unicode: ['1f933-1f3ff'],
            fname: '1f933-1f3ff',
            uc: '1f933-1f3ff',
            isCanonical: !0
        },
        ':selfie_tone4:': {
            unicode: ['1f933-1f3fe'],
            fname: '1f933-1f3fe',
            uc: '1f933-1f3fe',
            isCanonical: !0
        },
        ':selfie_tone3:': {
            unicode: ['1f933-1f3fd'],
            fname: '1f933-1f3fd',
            uc: '1f933-1f3fd',
            isCanonical: !0
        },
        ':selfie_tone2:': {
            unicode: ['1f933-1f3fc'],
            fname: '1f933-1f3fc',
            uc: '1f933-1f3fc',
            isCanonical: !0
        },
        ':selfie_tone1:': {
            unicode: ['1f933-1f3fb'],
            fname: '1f933-1f3fb',
            uc: '1f933-1f3fb',
            isCanonical: !0
        },
        ':pregnant_woman_tone5:': {
            unicode: ['1f930-1f3ff'],
            fname: '1f930-1f3ff',
            uc: '1f930-1f3ff',
            isCanonical: !0
        },
        ':expecting_woman_tone5:': {
            unicode: ['1f930-1f3ff'],
            fname: '1f930-1f3ff',
            uc: '1f930-1f3ff',
            isCanonical: !1
        },
        ':pregnant_woman_tone4:': {
            unicode: ['1f930-1f3fe'],
            fname: '1f930-1f3fe',
            uc: '1f930-1f3fe',
            isCanonical: !0
        },
        ':expecting_woman_tone4:': {
            unicode: ['1f930-1f3fe'],
            fname: '1f930-1f3fe',
            uc: '1f930-1f3fe',
            isCanonical: !1
        },
        ':pregnant_woman_tone3:': {
            unicode: ['1f930-1f3fd'],
            fname: '1f930-1f3fd',
            uc: '1f930-1f3fd',
            isCanonical: !0
        },
        ':expecting_woman_tone3:': {
            unicode: ['1f930-1f3fd'],
            fname: '1f930-1f3fd',
            uc: '1f930-1f3fd',
            isCanonical: !1
        },
        ':pregnant_woman_tone2:': {
            unicode: ['1f930-1f3fc'],
            fname: '1f930-1f3fc',
            uc: '1f930-1f3fc',
            isCanonical: !0
        },
        ':expecting_woman_tone2:': {
            unicode: ['1f930-1f3fc'],
            fname: '1f930-1f3fc',
            uc: '1f930-1f3fc',
            isCanonical: !1
        },
        ':pregnant_woman_tone1:': {
            unicode: ['1f930-1f3fb'],
            fname: '1f930-1f3fb',
            uc: '1f930-1f3fb',
            isCanonical: !0
        },
        ':expecting_woman_tone1:': {
            unicode: ['1f930-1f3fb'],
            fname: '1f930-1f3fb',
            uc: '1f930-1f3fb',
            isCanonical: !1
        },
        ':face_palm_tone5:': {
            unicode: ['1f926-1f3ff'],
            fname: '1f926-1f3ff',
            uc: '1f926-1f3ff',
            isCanonical: !0
        },
        ':facepalm_tone5:': {
            unicode: ['1f926-1f3ff'],
            fname: '1f926-1f3ff',
            uc: '1f926-1f3ff',
            isCanonical: !1
        },
        ':face_palm_tone4:': {
            unicode: ['1f926-1f3fe'],
            fname: '1f926-1f3fe',
            uc: '1f926-1f3fe',
            isCanonical: !0
        },
        ':facepalm_tone4:': {
            unicode: ['1f926-1f3fe'],
            fname: '1f926-1f3fe',
            uc: '1f926-1f3fe',
            isCanonical: !1
        },
        ':face_palm_tone3:': {
            unicode: ['1f926-1f3fd'],
            fname: '1f926-1f3fd',
            uc: '1f926-1f3fd',
            isCanonical: !0
        },
        ':facepalm_tone3:': {
            unicode: ['1f926-1f3fd'],
            fname: '1f926-1f3fd',
            uc: '1f926-1f3fd',
            isCanonical: !1
        },
        ':face_palm_tone2:': {
            unicode: ['1f926-1f3fc'],
            fname: '1f926-1f3fc',
            uc: '1f926-1f3fc',
            isCanonical: !0
        },
        ':facepalm_tone2:': {
            unicode: ['1f926-1f3fc'],
            fname: '1f926-1f3fc',
            uc: '1f926-1f3fc',
            isCanonical: !1
        },
        ':face_palm_tone1:': {
            unicode: ['1f926-1f3fb'],
            fname: '1f926-1f3fb',
            uc: '1f926-1f3fb',
            isCanonical: !0
        },
        ':facepalm_tone1:': {
            unicode: ['1f926-1f3fb'],
            fname: '1f926-1f3fb',
            uc: '1f926-1f3fb',
            isCanonical: !1
        },
        ':fingers_crossed_tone5:': {
            unicode: ['1f91e-1f3ff'],
            fname: '1f91e-1f3ff',
            uc: '1f91e-1f3ff',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_fingers_crossed_tone5:': {
            unicode: ['1f91e-1f3ff'],
            fname: '1f91e-1f3ff',
            uc: '1f91e-1f3ff',
            isCanonical: !1
        },
        ':fingers_crossed_tone4:': {
            unicode: ['1f91e-1f3fe'],
            fname: '1f91e-1f3fe',
            uc: '1f91e-1f3fe',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_fingers_crossed_tone4:': {
            unicode: ['1f91e-1f3fe'],
            fname: '1f91e-1f3fe',
            uc: '1f91e-1f3fe',
            isCanonical: !1
        },
        ':fingers_crossed_tone3:': {
            unicode: ['1f91e-1f3fd'],
            fname: '1f91e-1f3fd',
            uc: '1f91e-1f3fd',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_fingers_crossed_tone3:': {
            unicode: ['1f91e-1f3fd'],
            fname: '1f91e-1f3fd',
            uc: '1f91e-1f3fd',
            isCanonical: !1
        },
        ':fingers_crossed_tone2:': {
            unicode: ['1f91e-1f3fc'],
            fname: '1f91e-1f3fc',
            uc: '1f91e-1f3fc',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_fingers_crossed_tone2:': {
            unicode: ['1f91e-1f3fc'],
            fname: '1f91e-1f3fc',
            uc: '1f91e-1f3fc',
            isCanonical: !1
        },
        ':fingers_crossed_tone1:': {
            unicode: ['1f91e-1f3fb'],
            fname: '1f91e-1f3fb',
            uc: '1f91e-1f3fb',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_fingers_crossed_tone1:': {
            unicode: ['1f91e-1f3fb'],
            fname: '1f91e-1f3fb',
            uc: '1f91e-1f3fb',
            isCanonical: !1
        },
        ':handshake_tone5:': {
            unicode: ['1f91d-1f3ff'],
            fname: '1f91d-1f3ff',
            uc: '1f91d-1f3ff',
            isCanonical: !0
        },
        ':shaking_hands_tone5:': {
            unicode: ['1f91d-1f3ff'],
            fname: '1f91d-1f3ff',
            uc: '1f91d-1f3ff',
            isCanonical: !1
        },
        ':handshake_tone4:': {
            unicode: ['1f91d-1f3fe'],
            fname: '1f91d-1f3fe',
            uc: '1f91d-1f3fe',
            isCanonical: !0
        },
        ':shaking_hands_tone4:': {
            unicode: ['1f91d-1f3fe'],
            fname: '1f91d-1f3fe',
            uc: '1f91d-1f3fe',
            isCanonical: !1
        },
        ':handshake_tone3:': {
            unicode: ['1f91d-1f3fd'],
            fname: '1f91d-1f3fd',
            uc: '1f91d-1f3fd',
            isCanonical: !0
        },
        ':shaking_hands_tone3:': {
            unicode: ['1f91d-1f3fd'],
            fname: '1f91d-1f3fd',
            uc: '1f91d-1f3fd',
            isCanonical: !1
        },
        ':handshake_tone2:': {
            unicode: ['1f91d-1f3fc'],
            fname: '1f91d-1f3fc',
            uc: '1f91d-1f3fc',
            isCanonical: !0
        },
        ':shaking_hands_tone2:': {
            unicode: ['1f91d-1f3fc'],
            fname: '1f91d-1f3fc',
            uc: '1f91d-1f3fc',
            isCanonical: !1
        },
        ':handshake_tone1:': {
            unicode: ['1f91d-1f3fb'],
            fname: '1f91d-1f3fb',
            uc: '1f91d-1f3fb',
            isCanonical: !0
        },
        ':shaking_hands_tone1:': {
            unicode: ['1f91d-1f3fb'],
            fname: '1f91d-1f3fb',
            uc: '1f91d-1f3fb',
            isCanonical: !1
        },
        ':right_facing_fist_tone5:': {
            unicode: ['1f91c-1f3ff'],
            fname: '1f91c-1f3ff',
            uc: '1f91c-1f3ff',
            isCanonical: !0
        },
        ':right_fist_tone5:': {
            unicode: ['1f91c-1f3ff'],
            fname: '1f91c-1f3ff',
            uc: '1f91c-1f3ff',
            isCanonical: !1
        },
        ':right_facing_fist_tone4:': {
            unicode: ['1f91c-1f3fe'],
            fname: '1f91c-1f3fe',
            uc: '1f91c-1f3fe',
            isCanonical: !0
        },
        ':right_fist_tone4:': {
            unicode: ['1f91c-1f3fe'],
            fname: '1f91c-1f3fe',
            uc: '1f91c-1f3fe',
            isCanonical: !1
        },
        ':right_facing_fist_tone3:': {
            unicode: ['1f91c-1f3fd'],
            fname: '1f91c-1f3fd',
            uc: '1f91c-1f3fd',
            isCanonical: !0
        },
        ':right_fist_tone3:': {
            unicode: ['1f91c-1f3fd'],
            fname: '1f91c-1f3fd',
            uc: '1f91c-1f3fd',
            isCanonical: !1
        },
        ':right_facing_fist_tone2:': {
            unicode: ['1f91c-1f3fc'],
            fname: '1f91c-1f3fc',
            uc: '1f91c-1f3fc',
            isCanonical: !0
        },
        ':right_fist_tone2:': {
            unicode: ['1f91c-1f3fc'],
            fname: '1f91c-1f3fc',
            uc: '1f91c-1f3fc',
            isCanonical: !1
        },
        ':right_facing_fist_tone1:': {
            unicode: ['1f91c-1f3fb'],
            fname: '1f91c-1f3fb',
            uc: '1f91c-1f3fb',
            isCanonical: !0
        },
        ':right_fist_tone1:': {
            unicode: ['1f91c-1f3fb'],
            fname: '1f91c-1f3fb',
            uc: '1f91c-1f3fb',
            isCanonical: !1
        },
        ':left_facing_fist_tone5:': {
            unicode: ['1f91b-1f3ff'],
            fname: '1f91b-1f3ff',
            uc: '1f91b-1f3ff',
            isCanonical: !0
        },
        ':left_fist_tone5:': {
            unicode: ['1f91b-1f3ff'],
            fname: '1f91b-1f3ff',
            uc: '1f91b-1f3ff',
            isCanonical: !1
        },
        ':left_facing_fist_tone4:': {
            unicode: ['1f91b-1f3fe'],
            fname: '1f91b-1f3fe',
            uc: '1f91b-1f3fe',
            isCanonical: !0
        },
        ':left_fist_tone4:': {
            unicode: ['1f91b-1f3fe'],
            fname: '1f91b-1f3fe',
            uc: '1f91b-1f3fe',
            isCanonical: !1
        },
        ':left_facing_fist_tone3:': {
            unicode: ['1f91b-1f3fd'],
            fname: '1f91b-1f3fd',
            uc: '1f91b-1f3fd',
            isCanonical: !0
        },
        ':left_fist_tone3:': {
            unicode: ['1f91b-1f3fd'],
            fname: '1f91b-1f3fd',
            uc: '1f91b-1f3fd',
            isCanonical: !1
        },
        ':left_facing_fist_tone2:': {
            unicode: ['1f91b-1f3fc'],
            fname: '1f91b-1f3fc',
            uc: '1f91b-1f3fc',
            isCanonical: !0
        },
        ':left_fist_tone2:': {
            unicode: ['1f91b-1f3fc'],
            fname: '1f91b-1f3fc',
            uc: '1f91b-1f3fc',
            isCanonical: !1
        },
        ':left_facing_fist_tone1:': {
            unicode: ['1f91b-1f3fb'],
            fname: '1f91b-1f3fb',
            uc: '1f91b-1f3fb',
            isCanonical: !0
        },
        ':left_fist_tone1:': {
            unicode: ['1f91b-1f3fb'],
            fname: '1f91b-1f3fb',
            uc: '1f91b-1f3fb',
            isCanonical: !1
        },
        ':raised_back_of_hand_tone5:': {
            unicode: ['1f91a-1f3ff'],
            fname: '1f91a-1f3ff',
            uc: '1f91a-1f3ff',
            isCanonical: !0
        },
        ':back_of_hand_tone5:': {
            unicode: ['1f91a-1f3ff'],
            fname: '1f91a-1f3ff',
            uc: '1f91a-1f3ff',
            isCanonical: !1
        },
        ':raised_back_of_hand_tone4:': {
            unicode: ['1f91a-1f3fe'],
            fname: '1f91a-1f3fe',
            uc: '1f91a-1f3fe',
            isCanonical: !0
        },
        ':back_of_hand_tone4:': {
            unicode: ['1f91a-1f3fe'],
            fname: '1f91a-1f3fe',
            uc: '1f91a-1f3fe',
            isCanonical: !1
        },
        ':raised_back_of_hand_tone3:': {
            unicode: ['1f91a-1f3fd'],
            fname: '1f91a-1f3fd',
            uc: '1f91a-1f3fd',
            isCanonical: !0
        },
        ':back_of_hand_tone3:': {
            unicode: ['1f91a-1f3fd'],
            fname: '1f91a-1f3fd',
            uc: '1f91a-1f3fd',
            isCanonical: !1
        },
        ':raised_back_of_hand_tone2:': {
            unicode: ['1f91a-1f3fc'],
            fname: '1f91a-1f3fc',
            uc: '1f91a-1f3fc',
            isCanonical: !0
        },
        ':back_of_hand_tone2:': {
            unicode: ['1f91a-1f3fc'],
            fname: '1f91a-1f3fc',
            uc: '1f91a-1f3fc',
            isCanonical: !1
        },
        ':raised_back_of_hand_tone1:': {
            unicode: ['1f91a-1f3fb'],
            fname: '1f91a-1f3fb',
            uc: '1f91a-1f3fb',
            isCanonical: !0
        },
        ':back_of_hand_tone1:': {
            unicode: ['1f91a-1f3fb'],
            fname: '1f91a-1f3fb',
            uc: '1f91a-1f3fb',
            isCanonical: !1
        },
        ':call_me_tone5:': {
            unicode: ['1f919-1f3ff'],
            fname: '1f919-1f3ff',
            uc: '1f919-1f3ff',
            isCanonical: !0
        },
        ':call_me_hand_tone5:': {
            unicode: ['1f919-1f3ff'],
            fname: '1f919-1f3ff',
            uc: '1f919-1f3ff',
            isCanonical: !1
        },
        ':call_me_tone4:': {
            unicode: ['1f919-1f3fe'],
            fname: '1f919-1f3fe',
            uc: '1f919-1f3fe',
            isCanonical: !0
        },
        ':call_me_hand_tone4:': {
            unicode: ['1f919-1f3fe'],
            fname: '1f919-1f3fe',
            uc: '1f919-1f3fe',
            isCanonical: !1
        },
        ':call_me_tone3:': {
            unicode: ['1f919-1f3fd'],
            fname: '1f919-1f3fd',
            uc: '1f919-1f3fd',
            isCanonical: !0
        },
        ':call_me_hand_tone3:': {
            unicode: ['1f919-1f3fd'],
            fname: '1f919-1f3fd',
            uc: '1f919-1f3fd',
            isCanonical: !1
        },
        ':call_me_tone2:': {
            unicode: ['1f919-1f3fc'],
            fname: '1f919-1f3fc',
            uc: '1f919-1f3fc',
            isCanonical: !0
        },
        ':call_me_hand_tone2:': {
            unicode: ['1f919-1f3fc'],
            fname: '1f919-1f3fc',
            uc: '1f919-1f3fc',
            isCanonical: !1
        },
        ':call_me_tone1:': {
            unicode: ['1f919-1f3fb'],
            fname: '1f919-1f3fb',
            uc: '1f919-1f3fb',
            isCanonical: !0
        },
        ':call_me_hand_tone1:': {
            unicode: ['1f919-1f3fb'],
            fname: '1f919-1f3fb',
            uc: '1f919-1f3fb',
            isCanonical: !1
        },
        ':metal_tone5:': {
            unicode: ['1f918-1f3ff'],
            fname: '1f918-1f3ff',
            uc: '1f918-1f3ff',
            isCanonical: !0
        },
        ':sign_of_the_horns_tone5:': {
            unicode: ['1f918-1f3ff'],
            fname: '1f918-1f3ff',
            uc: '1f918-1f3ff',
            isCanonical: !1
        },
        ':metal_tone4:': {
            unicode: ['1f918-1f3fe'],
            fname: '1f918-1f3fe',
            uc: '1f918-1f3fe',
            isCanonical: !0
        },
        ':sign_of_the_horns_tone4:': {
            unicode: ['1f918-1f3fe'],
            fname: '1f918-1f3fe',
            uc: '1f918-1f3fe',
            isCanonical: !1
        },
        ':metal_tone3:': {
            unicode: ['1f918-1f3fd'],
            fname: '1f918-1f3fd',
            uc: '1f918-1f3fd',
            isCanonical: !0
        },
        ':sign_of_the_horns_tone3:': {
            unicode: ['1f918-1f3fd'],
            fname: '1f918-1f3fd',
            uc: '1f918-1f3fd',
            isCanonical: !1
        },
        ':metal_tone2:': {
            unicode: ['1f918-1f3fc'],
            fname: '1f918-1f3fc',
            uc: '1f918-1f3fc',
            isCanonical: !0
        },
        ':sign_of_the_horns_tone2:': {
            unicode: ['1f918-1f3fc'],
            fname: '1f918-1f3fc',
            uc: '1f918-1f3fc',
            isCanonical: !1
        },
        ':metal_tone1:': {
            unicode: ['1f918-1f3fb'],
            fname: '1f918-1f3fb',
            uc: '1f918-1f3fb',
            isCanonical: !0
        },
        ':sign_of_the_horns_tone1:': {
            unicode: ['1f918-1f3fb'],
            fname: '1f918-1f3fb',
            uc: '1f918-1f3fb',
            isCanonical: !1
        },
        ':bath_tone5:': {
            unicode: ['1f6c0-1f3ff'],
            fname: '1f6c0-1f3ff',
            uc: '1f6c0-1f3ff',
            isCanonical: !0
        },
        ':bath_tone4:': {
            unicode: ['1f6c0-1f3fe'],
            fname: '1f6c0-1f3fe',
            uc: '1f6c0-1f3fe',
            isCanonical: !0
        },
        ':bath_tone3:': {
            unicode: ['1f6c0-1f3fd'],
            fname: '1f6c0-1f3fd',
            uc: '1f6c0-1f3fd',
            isCanonical: !0
        },
        ':bath_tone2:': {
            unicode: ['1f6c0-1f3fc'],
            fname: '1f6c0-1f3fc',
            uc: '1f6c0-1f3fc',
            isCanonical: !0
        },
        ':bath_tone1:': {
            unicode: ['1f6c0-1f3fb'],
            fname: '1f6c0-1f3fb',
            uc: '1f6c0-1f3fb',
            isCanonical: !0
        },
        ':walking_tone5:': {
            unicode: ['1f6b6-1f3ff'],
            fname: '1f6b6-1f3ff',
            uc: '1f6b6-1f3ff',
            isCanonical: !0
        },
        ':walking_tone4:': {
            unicode: ['1f6b6-1f3fe'],
            fname: '1f6b6-1f3fe',
            uc: '1f6b6-1f3fe',
            isCanonical: !0
        },
        ':walking_tone3:': {
            unicode: ['1f6b6-1f3fd'],
            fname: '1f6b6-1f3fd',
            uc: '1f6b6-1f3fd',
            isCanonical: !0
        },
        ':walking_tone2:': {
            unicode: ['1f6b6-1f3fc'],
            fname: '1f6b6-1f3fc',
            uc: '1f6b6-1f3fc',
            isCanonical: !0
        },
        ':walking_tone1:': {
            unicode: ['1f6b6-1f3fb'],
            fname: '1f6b6-1f3fb',
            uc: '1f6b6-1f3fb',
            isCanonical: !0
        },
        ':mountain_bicyclist_tone5:': {
            unicode: ['1f6b5-1f3ff'],
            fname: '1f6b5-1f3ff',
            uc: '1f6b5-1f3ff',
            isCanonical: !0
        },
        ':mountain_bicyclist_tone4:': {
            unicode: ['1f6b5-1f3fe'],
            fname: '1f6b5-1f3fe',
            uc: '1f6b5-1f3fe',
            isCanonical: !0
        },
        ':mountain_bicyclist_tone3:': {
            unicode: ['1f6b5-1f3fd'],
            fname: '1f6b5-1f3fd',
            uc: '1f6b5-1f3fd',
            isCanonical: !0
        },
        ':mountain_bicyclist_tone2:': {
            unicode: ['1f6b5-1f3fc'],
            fname: '1f6b5-1f3fc',
            uc: '1f6b5-1f3fc',
            isCanonical: !0
        },
        ':mountain_bicyclist_tone1:': {
            unicode: ['1f6b5-1f3fb'],
            fname: '1f6b5-1f3fb',
            uc: '1f6b5-1f3fb',
            isCanonical: !0
        },
        ':bicyclist_tone5:': {
            unicode: ['1f6b4-1f3ff'],
            fname: '1f6b4-1f3ff',
            uc: '1f6b4-1f3ff',
            isCanonical: !0
        },
        ':bicyclist_tone4:': {
            unicode: ['1f6b4-1f3fe'],
            fname: '1f6b4-1f3fe',
            uc: '1f6b4-1f3fe',
            isCanonical: !0
        },
        ':bicyclist_tone3:': {
            unicode: ['1f6b4-1f3fd'],
            fname: '1f6b4-1f3fd',
            uc: '1f6b4-1f3fd',
            isCanonical: !0
        },
        ':bicyclist_tone2:': {
            unicode: ['1f6b4-1f3fc'],
            fname: '1f6b4-1f3fc',
            uc: '1f6b4-1f3fc',
            isCanonical: !0
        },
        ':bicyclist_tone1:': {
            unicode: ['1f6b4-1f3fb'],
            fname: '1f6b4-1f3fb',
            uc: '1f6b4-1f3fb',
            isCanonical: !0
        },
        ':rowboat_tone5:': {
            unicode: ['1f6a3-1f3ff'],
            fname: '1f6a3-1f3ff',
            uc: '1f6a3-1f3ff',
            isCanonical: !0
        },
        ':rowboat_tone4:': {
            unicode: ['1f6a3-1f3fe'],
            fname: '1f6a3-1f3fe',
            uc: '1f6a3-1f3fe',
            isCanonical: !0
        },
        ':rowboat_tone3:': {
            unicode: ['1f6a3-1f3fd'],
            fname: '1f6a3-1f3fd',
            uc: '1f6a3-1f3fd',
            isCanonical: !0
        },
        ':rowboat_tone2:': {
            unicode: ['1f6a3-1f3fc'],
            fname: '1f6a3-1f3fc',
            uc: '1f6a3-1f3fc',
            isCanonical: !0
        },
        ':rowboat_tone1:': {
            unicode: ['1f6a3-1f3fb'],
            fname: '1f6a3-1f3fb',
            uc: '1f6a3-1f3fb',
            isCanonical: !0
        },
        ':pray_tone5:': {
            unicode: ['1f64f-1f3ff'],
            fname: '1f64f-1f3ff',
            uc: '1f64f-1f3ff',
            isCanonical: !0
        },
        ':pray_tone4:': {
            unicode: ['1f64f-1f3fe'],
            fname: '1f64f-1f3fe',
            uc: '1f64f-1f3fe',
            isCanonical: !0
        },
        ':pray_tone3:': {
            unicode: ['1f64f-1f3fd'],
            fname: '1f64f-1f3fd',
            uc: '1f64f-1f3fd',
            isCanonical: !0
        },
        ':pray_tone2:': {
            unicode: ['1f64f-1f3fc'],
            fname: '1f64f-1f3fc',
            uc: '1f64f-1f3fc',
            isCanonical: !0
        },
        ':pray_tone1:': {
            unicode: ['1f64f-1f3fb'],
            fname: '1f64f-1f3fb',
            uc: '1f64f-1f3fb',
            isCanonical: !0
        },
        ':person_with_pouting_face_tone5:': {
            unicode: ['1f64e-1f3ff'],
            fname: '1f64e-1f3ff',
            uc: '1f64e-1f3ff',
            isCanonical: !0
        },
        ':person_with_pouting_face_tone4:': {
            unicode: ['1f64e-1f3fe'],
            fname: '1f64e-1f3fe',
            uc: '1f64e-1f3fe',
            isCanonical: !0
        },
        ':person_with_pouting_face_tone3:': {
            unicode: ['1f64e-1f3fd'],
            fname: '1f64e-1f3fd',
            uc: '1f64e-1f3fd',
            isCanonical: !0
        },
        ':person_with_pouting_face_tone2:': {
            unicode: ['1f64e-1f3fc'],
            fname: '1f64e-1f3fc',
            uc: '1f64e-1f3fc',
            isCanonical: !0
        },
        ':person_with_pouting_face_tone1:': {
            unicode: ['1f64e-1f3fb'],
            fname: '1f64e-1f3fb',
            uc: '1f64e-1f3fb',
            isCanonical: !0
        },
        ':person_frowning_tone5:': {
            unicode: ['1f64d-1f3ff'],
            fname: '1f64d-1f3ff',
            uc: '1f64d-1f3ff',
            isCanonical: !0
        },
        ':person_frowning_tone4:': {
            unicode: ['1f64d-1f3fe'],
            fname: '1f64d-1f3fe',
            uc: '1f64d-1f3fe',
            isCanonical: !0
        },
        ':person_frowning_tone3:': {
            unicode: ['1f64d-1f3fd'],
            fname: '1f64d-1f3fd',
            uc: '1f64d-1f3fd',
            isCanonical: !0
        },
        ':person_frowning_tone2:': {
            unicode: ['1f64d-1f3fc'],
            fname: '1f64d-1f3fc',
            uc: '1f64d-1f3fc',
            isCanonical: !0
        },
        ':person_frowning_tone1:': {
            unicode: ['1f64d-1f3fb'],
            fname: '1f64d-1f3fb',
            uc: '1f64d-1f3fb',
            isCanonical: !0
        },
        ':raised_hands_tone5:': {
            unicode: ['1f64c-1f3ff'],
            fname: '1f64c-1f3ff',
            uc: '1f64c-1f3ff',
            isCanonical: !0
        },
        ':raised_hands_tone4:': {
            unicode: ['1f64c-1f3fe'],
            fname: '1f64c-1f3fe',
            uc: '1f64c-1f3fe',
            isCanonical: !0
        },
        ':raised_hands_tone3:': {
            unicode: ['1f64c-1f3fd'],
            fname: '1f64c-1f3fd',
            uc: '1f64c-1f3fd',
            isCanonical: !0
        },
        ':raised_hands_tone2:': {
            unicode: ['1f64c-1f3fc'],
            fname: '1f64c-1f3fc',
            uc: '1f64c-1f3fc',
            isCanonical: !0
        },
        ':raised_hands_tone1:': {
            unicode: ['1f64c-1f3fb'],
            fname: '1f64c-1f3fb',
            uc: '1f64c-1f3fb',
            isCanonical: !0
        },
        ':raising_hand_tone5:': {
            unicode: ['1f64b-1f3ff'],
            fname: '1f64b-1f3ff',
            uc: '1f64b-1f3ff',
            isCanonical: !0
        },
        ':raising_hand_tone4:': {
            unicode: ['1f64b-1f3fe'],
            fname: '1f64b-1f3fe',
            uc: '1f64b-1f3fe',
            isCanonical: !0
        },
        ':raising_hand_tone3:': {
            unicode: ['1f64b-1f3fd'],
            fname: '1f64b-1f3fd',
            uc: '1f64b-1f3fd',
            isCanonical: !0
        },
        ':raising_hand_tone2:': {
            unicode: ['1f64b-1f3fc'],
            fname: '1f64b-1f3fc',
            uc: '1f64b-1f3fc',
            isCanonical: !0
        },
        ':raising_hand_tone1:': {
            unicode: ['1f64b-1f3fb'],
            fname: '1f64b-1f3fb',
            uc: '1f64b-1f3fb',
            isCanonical: !0
        },
        ':bow_tone5:': {
            unicode: ['1f647-1f3ff'],
            fname: '1f647-1f3ff',
            uc: '1f647-1f3ff',
            isCanonical: !0
        },
        ':bow_tone4:': {
            unicode: ['1f647-1f3fe'],
            fname: '1f647-1f3fe',
            uc: '1f647-1f3fe',
            isCanonical: !0
        },
        ':bow_tone3:': {
            unicode: ['1f647-1f3fd'],
            fname: '1f647-1f3fd',
            uc: '1f647-1f3fd',
            isCanonical: !0
        },
        ':bow_tone2:': {
            unicode: ['1f647-1f3fc'],
            fname: '1f647-1f3fc',
            uc: '1f647-1f3fc',
            isCanonical: !0
        },
        ':bow_tone1:': {
            unicode: ['1f647-1f3fb'],
            fname: '1f647-1f3fb',
            uc: '1f647-1f3fb',
            isCanonical: !0
        },
        ':ok_woman_tone5:': {
            unicode: ['1f646-1f3ff'],
            fname: '1f646-1f3ff',
            uc: '1f646-1f3ff',
            isCanonical: !0
        },
        ':ok_woman_tone4:': {
            unicode: ['1f646-1f3fe'],
            fname: '1f646-1f3fe',
            uc: '1f646-1f3fe',
            isCanonical: !0
        },
        ':ok_woman_tone3:': {
            unicode: ['1f646-1f3fd'],
            fname: '1f646-1f3fd',
            uc: '1f646-1f3fd',
            isCanonical: !0
        },
        ':ok_woman_tone2:': {
            unicode: ['1f646-1f3fc'],
            fname: '1f646-1f3fc',
            uc: '1f646-1f3fc',
            isCanonical: !0
        },
        ':ok_woman_tone1:': {
            unicode: ['1f646-1f3fb'],
            fname: '1f646-1f3fb',
            uc: '1f646-1f3fb',
            isCanonical: !0
        },
        ':no_good_tone5:': {
            unicode: ['1f645-1f3ff'],
            fname: '1f645-1f3ff',
            uc: '1f645-1f3ff',
            isCanonical: !0
        },
        ':no_good_tone4:': {
            unicode: ['1f645-1f3fe'],
            fname: '1f645-1f3fe',
            uc: '1f645-1f3fe',
            isCanonical: !0
        },
        ':no_good_tone3:': {
            unicode: ['1f645-1f3fd'],
            fname: '1f645-1f3fd',
            uc: '1f645-1f3fd',
            isCanonical: !0
        },
        ':no_good_tone2:': {
            unicode: ['1f645-1f3fc'],
            fname: '1f645-1f3fc',
            uc: '1f645-1f3fc',
            isCanonical: !0
        },
        ':no_good_tone1:': {
            unicode: ['1f645-1f3fb'],
            fname: '1f645-1f3fb',
            uc: '1f645-1f3fb',
            isCanonical: !0
        },
        ':vulcan_tone5:': {
            unicode: ['1f596-1f3ff'],
            fname: '1f596-1f3ff',
            uc: '1f596-1f3ff',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers_tone5:': {
            unicode: ['1f596-1f3ff'],
            fname: '1f596-1f3ff',
            uc: '1f596-1f3ff',
            isCanonical: !1
        },
        ':vulcan_tone4:': {
            unicode: ['1f596-1f3fe'],
            fname: '1f596-1f3fe',
            uc: '1f596-1f3fe',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers_tone4:': {
            unicode: ['1f596-1f3fe'],
            fname: '1f596-1f3fe',
            uc: '1f596-1f3fe',
            isCanonical: !1
        },
        ':vulcan_tone3:': {
            unicode: ['1f596-1f3fd'],
            fname: '1f596-1f3fd',
            uc: '1f596-1f3fd',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers_tone3:': {
            unicode: ['1f596-1f3fd'],
            fname: '1f596-1f3fd',
            uc: '1f596-1f3fd',
            isCanonical: !1
        },
        ':vulcan_tone2:': {
            unicode: ['1f596-1f3fc'],
            fname: '1f596-1f3fc',
            uc: '1f596-1f3fc',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers_tone2:': {
            unicode: ['1f596-1f3fc'],
            fname: '1f596-1f3fc',
            uc: '1f596-1f3fc',
            isCanonical: !1
        },
        ':vulcan_tone1:': {
            unicode: ['1f596-1f3fb'],
            fname: '1f596-1f3fb',
            uc: '1f596-1f3fb',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers_tone1:': {
            unicode: ['1f596-1f3fb'],
            fname: '1f596-1f3fb',
            uc: '1f596-1f3fb',
            isCanonical: !1
        },
        ':middle_finger_tone5:': {
            unicode: ['1f595-1f3ff'],
            fname: '1f595-1f3ff',
            uc: '1f595-1f3ff',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended_tone5:': {
            unicode: ['1f595-1f3ff'],
            fname: '1f595-1f3ff',
            uc: '1f595-1f3ff',
            isCanonical: !1
        },
        ':middle_finger_tone4:': {
            unicode: ['1f595-1f3fe'],
            fname: '1f595-1f3fe',
            uc: '1f595-1f3fe',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended_tone4:': {
            unicode: ['1f595-1f3fe'],
            fname: '1f595-1f3fe',
            uc: '1f595-1f3fe',
            isCanonical: !1
        },
        ':middle_finger_tone3:': {
            unicode: ['1f595-1f3fd'],
            fname: '1f595-1f3fd',
            uc: '1f595-1f3fd',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended_tone3:': {
            unicode: ['1f595-1f3fd'],
            fname: '1f595-1f3fd',
            uc: '1f595-1f3fd',
            isCanonical: !1
        },
        ':middle_finger_tone2:': {
            unicode: ['1f595-1f3fc'],
            fname: '1f595-1f3fc',
            uc: '1f595-1f3fc',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended_tone2:': {
            unicode: ['1f595-1f3fc'],
            fname: '1f595-1f3fc',
            uc: '1f595-1f3fc',
            isCanonical: !1
        },
        ':middle_finger_tone1:': {
            unicode: ['1f595-1f3fb'],
            fname: '1f595-1f3fb',
            uc: '1f595-1f3fb',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended_tone1:': {
            unicode: ['1f595-1f3fb'],
            fname: '1f595-1f3fb',
            uc: '1f595-1f3fb',
            isCanonical: !1
        },
        ':hand_splayed_tone5:': {
            unicode: ['1f590-1f3ff'],
            fname: '1f590-1f3ff',
            uc: '1f590-1f3ff',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed_tone5:': {
            unicode: ['1f590-1f3ff'],
            fname: '1f590-1f3ff',
            uc: '1f590-1f3ff',
            isCanonical: !1
        },
        ':hand_splayed_tone4:': {
            unicode: ['1f590-1f3fe'],
            fname: '1f590-1f3fe',
            uc: '1f590-1f3fe',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed_tone4:': {
            unicode: ['1f590-1f3fe'],
            fname: '1f590-1f3fe',
            uc: '1f590-1f3fe',
            isCanonical: !1
        },
        ':hand_splayed_tone3:': {
            unicode: ['1f590-1f3fd'],
            fname: '1f590-1f3fd',
            uc: '1f590-1f3fd',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed_tone3:': {
            unicode: ['1f590-1f3fd'],
            fname: '1f590-1f3fd',
            uc: '1f590-1f3fd',
            isCanonical: !1
        },
        ':hand_splayed_tone2:': {
            unicode: ['1f590-1f3fc'],
            fname: '1f590-1f3fc',
            uc: '1f590-1f3fc',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed_tone2:': {
            unicode: ['1f590-1f3fc'],
            fname: '1f590-1f3fc',
            uc: '1f590-1f3fc',
            isCanonical: !1
        },
        ':hand_splayed_tone1:': {
            unicode: ['1f590-1f3fb'],
            fname: '1f590-1f3fb',
            uc: '1f590-1f3fb',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed_tone1:': {
            unicode: ['1f590-1f3fb'],
            fname: '1f590-1f3fb',
            uc: '1f590-1f3fb',
            isCanonical: !1
        },
        ':man_dancing_tone5:': {
            unicode: ['1f57a-1f3ff'],
            fname: '1f57a-1f3ff',
            uc: '1f57a-1f3ff',
            isCanonical: !0
        },
        ':male_dancer_tone5:': {
            unicode: ['1f57a-1f3ff'],
            fname: '1f57a-1f3ff',
            uc: '1f57a-1f3ff',
            isCanonical: !1
        },
        ':man_dancing_tone4:': {
            unicode: ['1f57a-1f3fe'],
            fname: '1f57a-1f3fe',
            uc: '1f57a-1f3fe',
            isCanonical: !0
        },
        ':male_dancer_tone4:': {
            unicode: ['1f57a-1f3fe'],
            fname: '1f57a-1f3fe',
            uc: '1f57a-1f3fe',
            isCanonical: !1
        },
        ':man_dancing_tone3:': {
            unicode: ['1f57a-1f3fd'],
            fname: '1f57a-1f3fd',
            uc: '1f57a-1f3fd',
            isCanonical: !0
        },
        ':male_dancer_tone3:': {
            unicode: ['1f57a-1f3fd'],
            fname: '1f57a-1f3fd',
            uc: '1f57a-1f3fd',
            isCanonical: !1
        },
        ':man_dancing_tone2:': {
            unicode: ['1f57a-1f3fc'],
            fname: '1f57a-1f3fc',
            uc: '1f57a-1f3fc',
            isCanonical: !0
        },
        ':male_dancer_tone2:': {
            unicode: ['1f57a-1f3fc'],
            fname: '1f57a-1f3fc',
            uc: '1f57a-1f3fc',
            isCanonical: !1
        },
        ':man_dancing_tone1:': {
            unicode: ['1f57a-1f3fb'],
            fname: '1f57a-1f3fb',
            uc: '1f57a-1f3fb',
            isCanonical: !0
        },
        ':male_dancer_tone1:': {
            unicode: ['1f57a-1f3fb'],
            fname: '1f57a-1f3fb',
            uc: '1f57a-1f3fb',
            isCanonical: !1
        },
        ':spy_tone5:': {
            unicode: ['1f575-1f3ff'],
            fname: '1f575-1f3ff',
            uc: '1f575-1f3ff',
            isCanonical: !0
        },
        ':sleuth_or_spy_tone5:': {
            unicode: ['1f575-1f3ff'],
            fname: '1f575-1f3ff',
            uc: '1f575-1f3ff',
            isCanonical: !1
        },
        ':spy_tone4:': {
            unicode: ['1f575-1f3fe'],
            fname: '1f575-1f3fe',
            uc: '1f575-1f3fe',
            isCanonical: !0
        },
        ':sleuth_or_spy_tone4:': {
            unicode: ['1f575-1f3fe'],
            fname: '1f575-1f3fe',
            uc: '1f575-1f3fe',
            isCanonical: !1
        },
        ':spy_tone3:': {
            unicode: ['1f575-1f3fd'],
            fname: '1f575-1f3fd',
            uc: '1f575-1f3fd',
            isCanonical: !0
        },
        ':sleuth_or_spy_tone3:': {
            unicode: ['1f575-1f3fd'],
            fname: '1f575-1f3fd',
            uc: '1f575-1f3fd',
            isCanonical: !1
        },
        ':spy_tone2:': {
            unicode: ['1f575-1f3fc'],
            fname: '1f575-1f3fc',
            uc: '1f575-1f3fc',
            isCanonical: !0
        },
        ':sleuth_or_spy_tone2:': {
            unicode: ['1f575-1f3fc'],
            fname: '1f575-1f3fc',
            uc: '1f575-1f3fc',
            isCanonical: !1
        },
        ':spy_tone1:': {
            unicode: ['1f575-1f3fb'],
            fname: '1f575-1f3fb',
            uc: '1f575-1f3fb',
            isCanonical: !0
        },
        ':sleuth_or_spy_tone1:': {
            unicode: ['1f575-1f3fb'],
            fname: '1f575-1f3fb',
            uc: '1f575-1f3fb',
            isCanonical: !1
        },
        ':muscle_tone5:': {
            unicode: ['1f4aa-1f3ff'],
            fname: '1f4aa-1f3ff',
            uc: '1f4aa-1f3ff',
            isCanonical: !0
        },
        ':muscle_tone4:': {
            unicode: ['1f4aa-1f3fe'],
            fname: '1f4aa-1f3fe',
            uc: '1f4aa-1f3fe',
            isCanonical: !0
        },
        ':muscle_tone3:': {
            unicode: ['1f4aa-1f3fd'],
            fname: '1f4aa-1f3fd',
            uc: '1f4aa-1f3fd',
            isCanonical: !0
        },
        ':muscle_tone2:': {
            unicode: ['1f4aa-1f3fc'],
            fname: '1f4aa-1f3fc',
            uc: '1f4aa-1f3fc',
            isCanonical: !0
        },
        ':muscle_tone1:': {
            unicode: ['1f4aa-1f3fb'],
            fname: '1f4aa-1f3fb',
            uc: '1f4aa-1f3fb',
            isCanonical: !0
        },
        ':haircut_tone5:': {
            unicode: ['1f487-1f3ff'],
            fname: '1f487-1f3ff',
            uc: '1f487-1f3ff',
            isCanonical: !0
        },
        ':haircut_tone4:': {
            unicode: ['1f487-1f3fe'],
            fname: '1f487-1f3fe',
            uc: '1f487-1f3fe',
            isCanonical: !0
        },
        ':haircut_tone3:': {
            unicode: ['1f487-1f3fd'],
            fname: '1f487-1f3fd',
            uc: '1f487-1f3fd',
            isCanonical: !0
        },
        ':haircut_tone2:': {
            unicode: ['1f487-1f3fc'],
            fname: '1f487-1f3fc',
            uc: '1f487-1f3fc',
            isCanonical: !0
        },
        ':haircut_tone1:': {
            unicode: ['1f487-1f3fb'],
            fname: '1f487-1f3fb',
            uc: '1f487-1f3fb',
            isCanonical: !0
        },
        ':massage_tone5:': {
            unicode: ['1f486-1f3ff'],
            fname: '1f486-1f3ff',
            uc: '1f486-1f3ff',
            isCanonical: !0
        },
        ':massage_tone4:': {
            unicode: ['1f486-1f3fe'],
            fname: '1f486-1f3fe',
            uc: '1f486-1f3fe',
            isCanonical: !0
        },
        ':massage_tone3:': {
            unicode: ['1f486-1f3fd'],
            fname: '1f486-1f3fd',
            uc: '1f486-1f3fd',
            isCanonical: !0
        },
        ':massage_tone2:': {
            unicode: ['1f486-1f3fc'],
            fname: '1f486-1f3fc',
            uc: '1f486-1f3fc',
            isCanonical: !0
        },
        ':massage_tone1:': {
            unicode: ['1f486-1f3fb'],
            fname: '1f486-1f3fb',
            uc: '1f486-1f3fb',
            isCanonical: !0
        },
        ':nail_care_tone5:': {
            unicode: ['1f485-1f3ff'],
            fname: '1f485-1f3ff',
            uc: '1f485-1f3ff',
            isCanonical: !0
        },
        ':nail_care_tone4:': {
            unicode: ['1f485-1f3fe'],
            fname: '1f485-1f3fe',
            uc: '1f485-1f3fe',
            isCanonical: !0
        },
        ':nail_care_tone3:': {
            unicode: ['1f485-1f3fd'],
            fname: '1f485-1f3fd',
            uc: '1f485-1f3fd',
            isCanonical: !0
        },
        ':nail_care_tone2:': {
            unicode: ['1f485-1f3fc'],
            fname: '1f485-1f3fc',
            uc: '1f485-1f3fc',
            isCanonical: !0
        },
        ':nail_care_tone1:': {
            unicode: ['1f485-1f3fb'],
            fname: '1f485-1f3fb',
            uc: '1f485-1f3fb',
            isCanonical: !0
        },
        ':dancer_tone5:': {
            unicode: ['1f483-1f3ff'],
            fname: '1f483-1f3ff',
            uc: '1f483-1f3ff',
            isCanonical: !0
        },
        ':dancer_tone4:': {
            unicode: ['1f483-1f3fe'],
            fname: '1f483-1f3fe',
            uc: '1f483-1f3fe',
            isCanonical: !0
        },
        ':dancer_tone3:': {
            unicode: ['1f483-1f3fd'],
            fname: '1f483-1f3fd',
            uc: '1f483-1f3fd',
            isCanonical: !0
        },
        ':dancer_tone2:': {
            unicode: ['1f483-1f3fc'],
            fname: '1f483-1f3fc',
            uc: '1f483-1f3fc',
            isCanonical: !0
        },
        ':dancer_tone1:': {
            unicode: ['1f483-1f3fb'],
            fname: '1f483-1f3fb',
            uc: '1f483-1f3fb',
            isCanonical: !0
        },
        ':guardsman_tone5:': {
            unicode: ['1f482-1f3ff'],
            fname: '1f482-1f3ff',
            uc: '1f482-1f3ff',
            isCanonical: !0
        },
        ':guardsman_tone4:': {
            unicode: ['1f482-1f3fe'],
            fname: '1f482-1f3fe',
            uc: '1f482-1f3fe',
            isCanonical: !0
        },
        ':guardsman_tone3:': {
            unicode: ['1f482-1f3fd'],
            fname: '1f482-1f3fd',
            uc: '1f482-1f3fd',
            isCanonical: !0
        },
        ':guardsman_tone2:': {
            unicode: ['1f482-1f3fc'],
            fname: '1f482-1f3fc',
            uc: '1f482-1f3fc',
            isCanonical: !0
        },
        ':guardsman_tone1:': {
            unicode: ['1f482-1f3fb'],
            fname: '1f482-1f3fb',
            uc: '1f482-1f3fb',
            isCanonical: !0
        },
        ':information_desk_person_tone5:': {
            unicode: ['1f481-1f3ff'],
            fname: '1f481-1f3ff',
            uc: '1f481-1f3ff',
            isCanonical: !0
        },
        ':information_desk_person_tone4:': {
            unicode: ['1f481-1f3fe'],
            fname: '1f481-1f3fe',
            uc: '1f481-1f3fe',
            isCanonical: !0
        },
        ':information_desk_person_tone3:': {
            unicode: ['1f481-1f3fd'],
            fname: '1f481-1f3fd',
            uc: '1f481-1f3fd',
            isCanonical: !0
        },
        ':information_desk_person_tone2:': {
            unicode: ['1f481-1f3fc'],
            fname: '1f481-1f3fc',
            uc: '1f481-1f3fc',
            isCanonical: !0
        },
        ':information_desk_person_tone1:': {
            unicode: ['1f481-1f3fb'],
            fname: '1f481-1f3fb',
            uc: '1f481-1f3fb',
            isCanonical: !0
        },
        ':angel_tone5:': {
            unicode: ['1f47c-1f3ff'],
            fname: '1f47c-1f3ff',
            uc: '1f47c-1f3ff',
            isCanonical: !0
        },
        ':angel_tone4:': {
            unicode: ['1f47c-1f3fe'],
            fname: '1f47c-1f3fe',
            uc: '1f47c-1f3fe',
            isCanonical: !0
        },
        ':angel_tone3:': {
            unicode: ['1f47c-1f3fd'],
            fname: '1f47c-1f3fd',
            uc: '1f47c-1f3fd',
            isCanonical: !0
        },
        ':angel_tone2:': {
            unicode: ['1f47c-1f3fc'],
            fname: '1f47c-1f3fc',
            uc: '1f47c-1f3fc',
            isCanonical: !0
        },
        ':angel_tone1:': {
            unicode: ['1f47c-1f3fb'],
            fname: '1f47c-1f3fb',
            uc: '1f47c-1f3fb',
            isCanonical: !0
        },
        ':princess_tone5:': {
            unicode: ['1f478-1f3ff'],
            fname: '1f478-1f3ff',
            uc: '1f478-1f3ff',
            isCanonical: !0
        },
        ':princess_tone4:': {
            unicode: ['1f478-1f3fe'],
            fname: '1f478-1f3fe',
            uc: '1f478-1f3fe',
            isCanonical: !0
        },
        ':princess_tone3:': {
            unicode: ['1f478-1f3fd'],
            fname: '1f478-1f3fd',
            uc: '1f478-1f3fd',
            isCanonical: !0
        },
        ':princess_tone2:': {
            unicode: ['1f478-1f3fc'],
            fname: '1f478-1f3fc',
            uc: '1f478-1f3fc',
            isCanonical: !0
        },
        ':princess_tone1:': {
            unicode: ['1f478-1f3fb'],
            fname: '1f478-1f3fb',
            uc: '1f478-1f3fb',
            isCanonical: !0
        },
        ':construction_worker_tone5:': {
            unicode: ['1f477-1f3ff'],
            fname: '1f477-1f3ff',
            uc: '1f477-1f3ff',
            isCanonical: !0
        },
        ':construction_worker_tone4:': {
            unicode: ['1f477-1f3fe'],
            fname: '1f477-1f3fe',
            uc: '1f477-1f3fe',
            isCanonical: !0
        },
        ':construction_worker_tone3:': {
            unicode: ['1f477-1f3fd'],
            fname: '1f477-1f3fd',
            uc: '1f477-1f3fd',
            isCanonical: !0
        },
        ':construction_worker_tone2:': {
            unicode: ['1f477-1f3fc'],
            fname: '1f477-1f3fc',
            uc: '1f477-1f3fc',
            isCanonical: !0
        },
        ':construction_worker_tone1:': {
            unicode: ['1f477-1f3fb'],
            fname: '1f477-1f3fb',
            uc: '1f477-1f3fb',
            isCanonical: !0
        },
        ':baby_tone5:': {
            unicode: ['1f476-1f3ff'],
            fname: '1f476-1f3ff',
            uc: '1f476-1f3ff',
            isCanonical: !0
        },
        ':baby_tone4:': {
            unicode: ['1f476-1f3fe'],
            fname: '1f476-1f3fe',
            uc: '1f476-1f3fe',
            isCanonical: !0
        },
        ':baby_tone3:': {
            unicode: ['1f476-1f3fd'],
            fname: '1f476-1f3fd',
            uc: '1f476-1f3fd',
            isCanonical: !0
        },
        ':baby_tone2:': {
            unicode: ['1f476-1f3fc'],
            fname: '1f476-1f3fc',
            uc: '1f476-1f3fc',
            isCanonical: !0
        },
        ':baby_tone1:': {
            unicode: ['1f476-1f3fb'],
            fname: '1f476-1f3fb',
            uc: '1f476-1f3fb',
            isCanonical: !0
        },
        ':older_woman_tone5:': {
            unicode: ['1f475-1f3ff'],
            fname: '1f475-1f3ff',
            uc: '1f475-1f3ff',
            isCanonical: !0
        },
        ':grandma_tone5:': {
            unicode: ['1f475-1f3ff'],
            fname: '1f475-1f3ff',
            uc: '1f475-1f3ff',
            isCanonical: !1
        },
        ':older_woman_tone4:': {
            unicode: ['1f475-1f3fe'],
            fname: '1f475-1f3fe',
            uc: '1f475-1f3fe',
            isCanonical: !0
        },
        ':grandma_tone4:': {
            unicode: ['1f475-1f3fe'],
            fname: '1f475-1f3fe',
            uc: '1f475-1f3fe',
            isCanonical: !1
        },
        ':older_woman_tone3:': {
            unicode: ['1f475-1f3fd'],
            fname: '1f475-1f3fd',
            uc: '1f475-1f3fd',
            isCanonical: !0
        },
        ':grandma_tone3:': {
            unicode: ['1f475-1f3fd'],
            fname: '1f475-1f3fd',
            uc: '1f475-1f3fd',
            isCanonical: !1
        },
        ':older_woman_tone2:': {
            unicode: ['1f475-1f3fc'],
            fname: '1f475-1f3fc',
            uc: '1f475-1f3fc',
            isCanonical: !0
        },
        ':grandma_tone2:': {
            unicode: ['1f475-1f3fc'],
            fname: '1f475-1f3fc',
            uc: '1f475-1f3fc',
            isCanonical: !1
        },
        ':older_woman_tone1:': {
            unicode: ['1f475-1f3fb'],
            fname: '1f475-1f3fb',
            uc: '1f475-1f3fb',
            isCanonical: !0
        },
        ':grandma_tone1:': {
            unicode: ['1f475-1f3fb'],
            fname: '1f475-1f3fb',
            uc: '1f475-1f3fb',
            isCanonical: !1
        },
        ':older_man_tone5:': {
            unicode: ['1f474-1f3ff'],
            fname: '1f474-1f3ff',
            uc: '1f474-1f3ff',
            isCanonical: !0
        },
        ':older_man_tone4:': {
            unicode: ['1f474-1f3fe'],
            fname: '1f474-1f3fe',
            uc: '1f474-1f3fe',
            isCanonical: !0
        },
        ':older_man_tone3:': {
            unicode: ['1f474-1f3fd'],
            fname: '1f474-1f3fd',
            uc: '1f474-1f3fd',
            isCanonical: !0
        },
        ':older_man_tone2:': {
            unicode: ['1f474-1f3fc'],
            fname: '1f474-1f3fc',
            uc: '1f474-1f3fc',
            isCanonical: !0
        },
        ':older_man_tone1:': {
            unicode: ['1f474-1f3fb'],
            fname: '1f474-1f3fb',
            uc: '1f474-1f3fb',
            isCanonical: !0
        },
        ':man_with_turban_tone5:': {
            unicode: ['1f473-1f3ff'],
            fname: '1f473-1f3ff',
            uc: '1f473-1f3ff',
            isCanonical: !0
        },
        ':man_with_turban_tone4:': {
            unicode: ['1f473-1f3fe'],
            fname: '1f473-1f3fe',
            uc: '1f473-1f3fe',
            isCanonical: !0
        },
        ':man_with_turban_tone3:': {
            unicode: ['1f473-1f3fd'],
            fname: '1f473-1f3fd',
            uc: '1f473-1f3fd',
            isCanonical: !0
        },
        ':man_with_turban_tone2:': {
            unicode: ['1f473-1f3fc'],
            fname: '1f473-1f3fc',
            uc: '1f473-1f3fc',
            isCanonical: !0
        },
        ':man_with_turban_tone1:': {
            unicode: ['1f473-1f3fb'],
            fname: '1f473-1f3fb',
            uc: '1f473-1f3fb',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao_tone5:': {
            unicode: ['1f472-1f3ff'],
            fname: '1f472-1f3ff',
            uc: '1f472-1f3ff',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao_tone4:': {
            unicode: ['1f472-1f3fe'],
            fname: '1f472-1f3fe',
            uc: '1f472-1f3fe',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao_tone3:': {
            unicode: ['1f472-1f3fd'],
            fname: '1f472-1f3fd',
            uc: '1f472-1f3fd',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao_tone2:': {
            unicode: ['1f472-1f3fc'],
            fname: '1f472-1f3fc',
            uc: '1f472-1f3fc',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao_tone1:': {
            unicode: ['1f472-1f3fb'],
            fname: '1f472-1f3fb',
            uc: '1f472-1f3fb',
            isCanonical: !0
        },
        ':person_with_blond_hair_tone5:': {
            unicode: ['1f471-1f3ff'],
            fname: '1f471-1f3ff',
            uc: '1f471-1f3ff',
            isCanonical: !0
        },
        ':person_with_blond_hair_tone4:': {
            unicode: ['1f471-1f3fe'],
            fname: '1f471-1f3fe',
            uc: '1f471-1f3fe',
            isCanonical: !0
        },
        ':person_with_blond_hair_tone3:': {
            unicode: ['1f471-1f3fd'],
            fname: '1f471-1f3fd',
            uc: '1f471-1f3fd',
            isCanonical: !0
        },
        ':person_with_blond_hair_tone2:': {
            unicode: ['1f471-1f3fc'],
            fname: '1f471-1f3fc',
            uc: '1f471-1f3fc',
            isCanonical: !0
        },
        ':person_with_blond_hair_tone1:': {
            unicode: ['1f471-1f3fb'],
            fname: '1f471-1f3fb',
            uc: '1f471-1f3fb',
            isCanonical: !0
        },
        ':bride_with_veil_tone5:': {
            unicode: ['1f470-1f3ff'],
            fname: '1f470-1f3ff',
            uc: '1f470-1f3ff',
            isCanonical: !0
        },
        ':bride_with_veil_tone4:': {
            unicode: ['1f470-1f3fe'],
            fname: '1f470-1f3fe',
            uc: '1f470-1f3fe',
            isCanonical: !0
        },
        ':bride_with_veil_tone3:': {
            unicode: ['1f470-1f3fd'],
            fname: '1f470-1f3fd',
            uc: '1f470-1f3fd',
            isCanonical: !0
        },
        ':bride_with_veil_tone2:': {
            unicode: ['1f470-1f3fc'],
            fname: '1f470-1f3fc',
            uc: '1f470-1f3fc',
            isCanonical: !0
        },
        ':bride_with_veil_tone1:': {
            unicode: ['1f470-1f3fb'],
            fname: '1f470-1f3fb',
            uc: '1f470-1f3fb',
            isCanonical: !0
        },
        ':cop_tone5:': {
            unicode: ['1f46e-1f3ff'],
            fname: '1f46e-1f3ff',
            uc: '1f46e-1f3ff',
            isCanonical: !0
        },
        ':cop_tone4:': {
            unicode: ['1f46e-1f3fe'],
            fname: '1f46e-1f3fe',
            uc: '1f46e-1f3fe',
            isCanonical: !0
        },
        ':cop_tone3:': {
            unicode: ['1f46e-1f3fd'],
            fname: '1f46e-1f3fd',
            uc: '1f46e-1f3fd',
            isCanonical: !0
        },
        ':cop_tone2:': {
            unicode: ['1f46e-1f3fc'],
            fname: '1f46e-1f3fc',
            uc: '1f46e-1f3fc',
            isCanonical: !0
        },
        ':cop_tone1:': {
            unicode: ['1f46e-1f3fb'],
            fname: '1f46e-1f3fb',
            uc: '1f46e-1f3fb',
            isCanonical: !0
        },
        ':woman_tone5:': {
            unicode: ['1f469-1f3ff'],
            fname: '1f469-1f3ff',
            uc: '1f469-1f3ff',
            isCanonical: !0
        },
        ':woman_tone4:': {
            unicode: ['1f469-1f3fe'],
            fname: '1f469-1f3fe',
            uc: '1f469-1f3fe',
            isCanonical: !0
        },
        ':woman_tone3:': {
            unicode: ['1f469-1f3fd'],
            fname: '1f469-1f3fd',
            uc: '1f469-1f3fd',
            isCanonical: !0
        },
        ':woman_tone2:': {
            unicode: ['1f469-1f3fc'],
            fname: '1f469-1f3fc',
            uc: '1f469-1f3fc',
            isCanonical: !0
        },
        ':woman_tone1:': {
            unicode: ['1f469-1f3fb'],
            fname: '1f469-1f3fb',
            uc: '1f469-1f3fb',
            isCanonical: !0
        },
        ':man_tone5:': {
            unicode: ['1f468-1f3ff'],
            fname: '1f468-1f3ff',
            uc: '1f468-1f3ff',
            isCanonical: !0
        },
        ':man_tone4:': {
            unicode: ['1f468-1f3fe'],
            fname: '1f468-1f3fe',
            uc: '1f468-1f3fe',
            isCanonical: !0
        },
        ':man_tone3:': {
            unicode: ['1f468-1f3fd'],
            fname: '1f468-1f3fd',
            uc: '1f468-1f3fd',
            isCanonical: !0
        },
        ':man_tone2:': {
            unicode: ['1f468-1f3fc'],
            fname: '1f468-1f3fc',
            uc: '1f468-1f3fc',
            isCanonical: !0
        },
        ':man_tone1:': {
            unicode: ['1f468-1f3fb'],
            fname: '1f468-1f3fb',
            uc: '1f468-1f3fb',
            isCanonical: !0
        },
        ':girl_tone5:': {
            unicode: ['1f467-1f3ff'],
            fname: '1f467-1f3ff',
            uc: '1f467-1f3ff',
            isCanonical: !0
        },
        ':girl_tone4:': {
            unicode: ['1f467-1f3fe'],
            fname: '1f467-1f3fe',
            uc: '1f467-1f3fe',
            isCanonical: !0
        },
        ':girl_tone3:': {
            unicode: ['1f467-1f3fd'],
            fname: '1f467-1f3fd',
            uc: '1f467-1f3fd',
            isCanonical: !0
        },
        ':girl_tone2:': {
            unicode: ['1f467-1f3fc'],
            fname: '1f467-1f3fc',
            uc: '1f467-1f3fc',
            isCanonical: !0
        },
        ':girl_tone1:': {
            unicode: ['1f467-1f3fb'],
            fname: '1f467-1f3fb',
            uc: '1f467-1f3fb',
            isCanonical: !0
        },
        ':boy_tone5:': {
            unicode: ['1f466-1f3ff'],
            fname: '1f466-1f3ff',
            uc: '1f466-1f3ff',
            isCanonical: !0
        },
        ':boy_tone4:': {
            unicode: ['1f466-1f3fe'],
            fname: '1f466-1f3fe',
            uc: '1f466-1f3fe',
            isCanonical: !0
        },
        ':boy_tone3:': {
            unicode: ['1f466-1f3fd'],
            fname: '1f466-1f3fd',
            uc: '1f466-1f3fd',
            isCanonical: !0
        },
        ':boy_tone2:': {
            unicode: ['1f466-1f3fc'],
            fname: '1f466-1f3fc',
            uc: '1f466-1f3fc',
            isCanonical: !0
        },
        ':boy_tone1:': {
            unicode: ['1f466-1f3fb'],
            fname: '1f466-1f3fb',
            uc: '1f466-1f3fb',
            isCanonical: !0
        },
        ':open_hands_tone5:': {
            unicode: ['1f450-1f3ff'],
            fname: '1f450-1f3ff',
            uc: '1f450-1f3ff',
            isCanonical: !0
        },
        ':open_hands_tone4:': {
            unicode: ['1f450-1f3fe'],
            fname: '1f450-1f3fe',
            uc: '1f450-1f3fe',
            isCanonical: !0
        },
        ':open_hands_tone3:': {
            unicode: ['1f450-1f3fd'],
            fname: '1f450-1f3fd',
            uc: '1f450-1f3fd',
            isCanonical: !0
        },
        ':open_hands_tone2:': {
            unicode: ['1f450-1f3fc'],
            fname: '1f450-1f3fc',
            uc: '1f450-1f3fc',
            isCanonical: !0
        },
        ':open_hands_tone1:': {
            unicode: ['1f450-1f3fb'],
            fname: '1f450-1f3fb',
            uc: '1f450-1f3fb',
            isCanonical: !0
        },
        ':clap_tone5:': {
            unicode: ['1f44f-1f3ff'],
            fname: '1f44f-1f3ff',
            uc: '1f44f-1f3ff',
            isCanonical: !0
        },
        ':clap_tone4:': {
            unicode: ['1f44f-1f3fe'],
            fname: '1f44f-1f3fe',
            uc: '1f44f-1f3fe',
            isCanonical: !0
        },
        ':clap_tone3:': {
            unicode: ['1f44f-1f3fd'],
            fname: '1f44f-1f3fd',
            uc: '1f44f-1f3fd',
            isCanonical: !0
        },
        ':clap_tone2:': {
            unicode: ['1f44f-1f3fc'],
            fname: '1f44f-1f3fc',
            uc: '1f44f-1f3fc',
            isCanonical: !0
        },
        ':clap_tone1:': {
            unicode: ['1f44f-1f3fb'],
            fname: '1f44f-1f3fb',
            uc: '1f44f-1f3fb',
            isCanonical: !0
        },
        ':thumbsdown_tone5:': {
            unicode: ['1f44e-1f3ff'],
            fname: '1f44e-1f3ff',
            uc: '1f44e-1f3ff',
            isCanonical: !0
        },
        ':-1_tone5:': {
            unicode: ['1f44e-1f3ff'],
            fname: '1f44e-1f3ff',
            uc: '1f44e-1f3ff',
            isCanonical: !1
        },
        ':thumbdown_tone5:': {
            unicode: ['1f44e-1f3ff'],
            fname: '1f44e-1f3ff',
            uc: '1f44e-1f3ff',
            isCanonical: !1
        },
        ':thumbsdown_tone4:': {
            unicode: ['1f44e-1f3fe'],
            fname: '1f44e-1f3fe',
            uc: '1f44e-1f3fe',
            isCanonical: !0
        },
        ':-1_tone4:': {
            unicode: ['1f44e-1f3fe'],
            fname: '1f44e-1f3fe',
            uc: '1f44e-1f3fe',
            isCanonical: !1
        },
        ':thumbdown_tone4:': {
            unicode: ['1f44e-1f3fe'],
            fname: '1f44e-1f3fe',
            uc: '1f44e-1f3fe',
            isCanonical: !1
        },
        ':thumbsdown_tone3:': {
            unicode: ['1f44e-1f3fd'],
            fname: '1f44e-1f3fd',
            uc: '1f44e-1f3fd',
            isCanonical: !0
        },
        ':-1_tone3:': {
            unicode: ['1f44e-1f3fd'],
            fname: '1f44e-1f3fd',
            uc: '1f44e-1f3fd',
            isCanonical: !1
        },
        ':thumbdown_tone3:': {
            unicode: ['1f44e-1f3fd'],
            fname: '1f44e-1f3fd',
            uc: '1f44e-1f3fd',
            isCanonical: !1
        },
        ':thumbsdown_tone2:': {
            unicode: ['1f44e-1f3fc'],
            fname: '1f44e-1f3fc',
            uc: '1f44e-1f3fc',
            isCanonical: !0
        },
        ':-1_tone2:': {
            unicode: ['1f44e-1f3fc'],
            fname: '1f44e-1f3fc',
            uc: '1f44e-1f3fc',
            isCanonical: !1
        },
        ':thumbdown_tone2:': {
            unicode: ['1f44e-1f3fc'],
            fname: '1f44e-1f3fc',
            uc: '1f44e-1f3fc',
            isCanonical: !1
        },
        ':thumbsdown_tone1:': {
            unicode: ['1f44e-1f3fb'],
            fname: '1f44e-1f3fb',
            uc: '1f44e-1f3fb',
            isCanonical: !0
        },
        ':-1_tone1:': {
            unicode: ['1f44e-1f3fb'],
            fname: '1f44e-1f3fb',
            uc: '1f44e-1f3fb',
            isCanonical: !1
        },
        ':thumbdown_tone1:': {
            unicode: ['1f44e-1f3fb'],
            fname: '1f44e-1f3fb',
            uc: '1f44e-1f3fb',
            isCanonical: !1
        },
        ':thumbsup_tone5:': {
            unicode: ['1f44d-1f3ff'],
            fname: '1f44d-1f3ff',
            uc: '1f44d-1f3ff',
            isCanonical: !0
        },
        ':+1_tone5:': {
            unicode: ['1f44d-1f3ff'],
            fname: '1f44d-1f3ff',
            uc: '1f44d-1f3ff',
            isCanonical: !1
        },
        ':thumbup_tone5:': {
            unicode: ['1f44d-1f3ff'],
            fname: '1f44d-1f3ff',
            uc: '1f44d-1f3ff',
            isCanonical: !1
        },
        ':thumbsup_tone4:': {
            unicode: ['1f44d-1f3fe'],
            fname: '1f44d-1f3fe',
            uc: '1f44d-1f3fe',
            isCanonical: !0
        },
        ':+1_tone4:': {
            unicode: ['1f44d-1f3fe'],
            fname: '1f44d-1f3fe',
            uc: '1f44d-1f3fe',
            isCanonical: !1
        },
        ':thumbup_tone4:': {
            unicode: ['1f44d-1f3fe'],
            fname: '1f44d-1f3fe',
            uc: '1f44d-1f3fe',
            isCanonical: !1
        },
        ':thumbsup_tone3:': {
            unicode: ['1f44d-1f3fd'],
            fname: '1f44d-1f3fd',
            uc: '1f44d-1f3fd',
            isCanonical: !0
        },
        ':+1_tone3:': {
            unicode: ['1f44d-1f3fd'],
            fname: '1f44d-1f3fd',
            uc: '1f44d-1f3fd',
            isCanonical: !1
        },
        ':thumbup_tone3:': {
            unicode: ['1f44d-1f3fd'],
            fname: '1f44d-1f3fd',
            uc: '1f44d-1f3fd',
            isCanonical: !1
        },
        ':thumbsup_tone2:': {
            unicode: ['1f44d-1f3fc'],
            fname: '1f44d-1f3fc',
            uc: '1f44d-1f3fc',
            isCanonical: !0
        },
        ':+1_tone2:': {
            unicode: ['1f44d-1f3fc'],
            fname: '1f44d-1f3fc',
            uc: '1f44d-1f3fc',
            isCanonical: !1
        },
        ':thumbup_tone2:': {
            unicode: ['1f44d-1f3fc'],
            fname: '1f44d-1f3fc',
            uc: '1f44d-1f3fc',
            isCanonical: !1
        },
        ':thumbsup_tone1:': {
            unicode: ['1f44d-1f3fb'],
            fname: '1f44d-1f3fb',
            uc: '1f44d-1f3fb',
            isCanonical: !0
        },
        ':+1_tone1:': {
            unicode: ['1f44d-1f3fb'],
            fname: '1f44d-1f3fb',
            uc: '1f44d-1f3fb',
            isCanonical: !1
        },
        ':thumbup_tone1:': {
            unicode: ['1f44d-1f3fb'],
            fname: '1f44d-1f3fb',
            uc: '1f44d-1f3fb',
            isCanonical: !1
        },
        ':ok_hand_tone5:': {
            unicode: ['1f44c-1f3ff'],
            fname: '1f44c-1f3ff',
            uc: '1f44c-1f3ff',
            isCanonical: !0
        },
        ':ok_hand_tone4:': {
            unicode: ['1f44c-1f3fe'],
            fname: '1f44c-1f3fe',
            uc: '1f44c-1f3fe',
            isCanonical: !0
        },
        ':ok_hand_tone3:': {
            unicode: ['1f44c-1f3fd'],
            fname: '1f44c-1f3fd',
            uc: '1f44c-1f3fd',
            isCanonical: !0
        },
        ':ok_hand_tone2:': {
            unicode: ['1f44c-1f3fc'],
            fname: '1f44c-1f3fc',
            uc: '1f44c-1f3fc',
            isCanonical: !0
        },
        ':ok_hand_tone1:': {
            unicode: ['1f44c-1f3fb'],
            fname: '1f44c-1f3fb',
            uc: '1f44c-1f3fb',
            isCanonical: !0
        },
        ':wave_tone5:': {
            unicode: ['1f44b-1f3ff'],
            fname: '1f44b-1f3ff',
            uc: '1f44b-1f3ff',
            isCanonical: !0
        },
        ':wave_tone4:': {
            unicode: ['1f44b-1f3fe'],
            fname: '1f44b-1f3fe',
            uc: '1f44b-1f3fe',
            isCanonical: !0
        },
        ':wave_tone3:': {
            unicode: ['1f44b-1f3fd'],
            fname: '1f44b-1f3fd',
            uc: '1f44b-1f3fd',
            isCanonical: !0
        },
        ':wave_tone2:': {
            unicode: ['1f44b-1f3fc'],
            fname: '1f44b-1f3fc',
            uc: '1f44b-1f3fc',
            isCanonical: !0
        },
        ':wave_tone1:': {
            unicode: ['1f44b-1f3fb'],
            fname: '1f44b-1f3fb',
            uc: '1f44b-1f3fb',
            isCanonical: !0
        },
        ':punch_tone5:': {
            unicode: ['1f44a-1f3ff'],
            fname: '1f44a-1f3ff',
            uc: '1f44a-1f3ff',
            isCanonical: !0
        },
        ':punch_tone4:': {
            unicode: ['1f44a-1f3fe'],
            fname: '1f44a-1f3fe',
            uc: '1f44a-1f3fe',
            isCanonical: !0
        },
        ':punch_tone3:': {
            unicode: ['1f44a-1f3fd'],
            fname: '1f44a-1f3fd',
            uc: '1f44a-1f3fd',
            isCanonical: !0
        },
        ':punch_tone2:': {
            unicode: ['1f44a-1f3fc'],
            fname: '1f44a-1f3fc',
            uc: '1f44a-1f3fc',
            isCanonical: !0
        },
        ':punch_tone1:': {
            unicode: ['1f44a-1f3fb'],
            fname: '1f44a-1f3fb',
            uc: '1f44a-1f3fb',
            isCanonical: !0
        },
        ':point_right_tone5:': {
            unicode: ['1f449-1f3ff'],
            fname: '1f449-1f3ff',
            uc: '1f449-1f3ff',
            isCanonical: !0
        },
        ':point_right_tone4:': {
            unicode: ['1f449-1f3fe'],
            fname: '1f449-1f3fe',
            uc: '1f449-1f3fe',
            isCanonical: !0
        },
        ':point_right_tone3:': {
            unicode: ['1f449-1f3fd'],
            fname: '1f449-1f3fd',
            uc: '1f449-1f3fd',
            isCanonical: !0
        },
        ':point_right_tone2:': {
            unicode: ['1f449-1f3fc'],
            fname: '1f449-1f3fc',
            uc: '1f449-1f3fc',
            isCanonical: !0
        },
        ':point_right_tone1:': {
            unicode: ['1f449-1f3fb'],
            fname: '1f449-1f3fb',
            uc: '1f449-1f3fb',
            isCanonical: !0
        },
        ':point_left_tone5:': {
            unicode: ['1f448-1f3ff'],
            fname: '1f448-1f3ff',
            uc: '1f448-1f3ff',
            isCanonical: !0
        },
        ':point_left_tone4:': {
            unicode: ['1f448-1f3fe'],
            fname: '1f448-1f3fe',
            uc: '1f448-1f3fe',
            isCanonical: !0
        },
        ':point_left_tone3:': {
            unicode: ['1f448-1f3fd'],
            fname: '1f448-1f3fd',
            uc: '1f448-1f3fd',
            isCanonical: !0
        },
        ':point_left_tone2:': {
            unicode: ['1f448-1f3fc'],
            fname: '1f448-1f3fc',
            uc: '1f448-1f3fc',
            isCanonical: !0
        },
        ':point_left_tone1:': {
            unicode: ['1f448-1f3fb'],
            fname: '1f448-1f3fb',
            uc: '1f448-1f3fb',
            isCanonical: !0
        },
        ':point_down_tone5:': {
            unicode: ['1f447-1f3ff'],
            fname: '1f447-1f3ff',
            uc: '1f447-1f3ff',
            isCanonical: !0
        },
        ':point_down_tone4:': {
            unicode: ['1f447-1f3fe'],
            fname: '1f447-1f3fe',
            uc: '1f447-1f3fe',
            isCanonical: !0
        },
        ':point_down_tone3:': {
            unicode: ['1f447-1f3fd'],
            fname: '1f447-1f3fd',
            uc: '1f447-1f3fd',
            isCanonical: !0
        },
        ':point_down_tone2:': {
            unicode: ['1f447-1f3fc'],
            fname: '1f447-1f3fc',
            uc: '1f447-1f3fc',
            isCanonical: !0
        },
        ':point_down_tone1:': {
            unicode: ['1f447-1f3fb'],
            fname: '1f447-1f3fb',
            uc: '1f447-1f3fb',
            isCanonical: !0
        },
        ':point_up_2_tone5:': {
            unicode: ['1f446-1f3ff'],
            fname: '1f446-1f3ff',
            uc: '1f446-1f3ff',
            isCanonical: !0
        },
        ':point_up_2_tone4:': {
            unicode: ['1f446-1f3fe'],
            fname: '1f446-1f3fe',
            uc: '1f446-1f3fe',
            isCanonical: !0
        },
        ':point_up_2_tone3:': {
            unicode: ['1f446-1f3fd'],
            fname: '1f446-1f3fd',
            uc: '1f446-1f3fd',
            isCanonical: !0
        },
        ':point_up_2_tone2:': {
            unicode: ['1f446-1f3fc'],
            fname: '1f446-1f3fc',
            uc: '1f446-1f3fc',
            isCanonical: !0
        },
        ':point_up_2_tone1:': {
            unicode: ['1f446-1f3fb'],
            fname: '1f446-1f3fb',
            uc: '1f446-1f3fb',
            isCanonical: !0
        },
        ':nose_tone5:': {
            unicode: ['1f443-1f3ff'],
            fname: '1f443-1f3ff',
            uc: '1f443-1f3ff',
            isCanonical: !0
        },
        ':nose_tone4:': {
            unicode: ['1f443-1f3fe'],
            fname: '1f443-1f3fe',
            uc: '1f443-1f3fe',
            isCanonical: !0
        },
        ':nose_tone3:': {
            unicode: ['1f443-1f3fd'],
            fname: '1f443-1f3fd',
            uc: '1f443-1f3fd',
            isCanonical: !0
        },
        ':nose_tone2:': {
            unicode: ['1f443-1f3fc'],
            fname: '1f443-1f3fc',
            uc: '1f443-1f3fc',
            isCanonical: !0
        },
        ':nose_tone1:': {
            unicode: ['1f443-1f3fb'],
            fname: '1f443-1f3fb',
            uc: '1f443-1f3fb',
            isCanonical: !0
        },
        ':ear_tone5:': {
            unicode: ['1f442-1f3ff'],
            fname: '1f442-1f3ff',
            uc: '1f442-1f3ff',
            isCanonical: !0
        },
        ':ear_tone4:': {
            unicode: ['1f442-1f3fe'],
            fname: '1f442-1f3fe',
            uc: '1f442-1f3fe',
            isCanonical: !0
        },
        ':ear_tone3:': {
            unicode: ['1f442-1f3fd'],
            fname: '1f442-1f3fd',
            uc: '1f442-1f3fd',
            isCanonical: !0
        },
        ':ear_tone2:': {
            unicode: ['1f442-1f3fc'],
            fname: '1f442-1f3fc',
            uc: '1f442-1f3fc',
            isCanonical: !0
        },
        ':ear_tone1:': {
            unicode: ['1f442-1f3fb'],
            fname: '1f442-1f3fb',
            uc: '1f442-1f3fb',
            isCanonical: !0
        },
        ':lifter_tone5:': {
            unicode: ['1f3cb-1f3ff'],
            fname: '1f3cb-1f3ff',
            uc: '1f3cb-1f3ff',
            isCanonical: !0
        },
        ':weight_lifter_tone5:': {
            unicode: ['1f3cb-1f3ff'],
            fname: '1f3cb-1f3ff',
            uc: '1f3cb-1f3ff',
            isCanonical: !1
        },
        ':lifter_tone4:': {
            unicode: ['1f3cb-1f3fe'],
            fname: '1f3cb-1f3fe',
            uc: '1f3cb-1f3fe',
            isCanonical: !0
        },
        ':weight_lifter_tone4:': {
            unicode: ['1f3cb-1f3fe'],
            fname: '1f3cb-1f3fe',
            uc: '1f3cb-1f3fe',
            isCanonical: !1
        },
        ':lifter_tone3:': {
            unicode: ['1f3cb-1f3fd'],
            fname: '1f3cb-1f3fd',
            uc: '1f3cb-1f3fd',
            isCanonical: !0
        },
        ':weight_lifter_tone3:': {
            unicode: ['1f3cb-1f3fd'],
            fname: '1f3cb-1f3fd',
            uc: '1f3cb-1f3fd',
            isCanonical: !1
        },
        ':lifter_tone2:': {
            unicode: ['1f3cb-1f3fc'],
            fname: '1f3cb-1f3fc',
            uc: '1f3cb-1f3fc',
            isCanonical: !0
        },
        ':weight_lifter_tone2:': {
            unicode: ['1f3cb-1f3fc'],
            fname: '1f3cb-1f3fc',
            uc: '1f3cb-1f3fc',
            isCanonical: !1
        },
        ':lifter_tone1:': {
            unicode: ['1f3cb-1f3fb'],
            fname: '1f3cb-1f3fb',
            uc: '1f3cb-1f3fb',
            isCanonical: !0
        },
        ':weight_lifter_tone1:': {
            unicode: ['1f3cb-1f3fb'],
            fname: '1f3cb-1f3fb',
            uc: '1f3cb-1f3fb',
            isCanonical: !1
        },
        ':swimmer_tone5:': {
            unicode: ['1f3ca-1f3ff'],
            fname: '1f3ca-1f3ff',
            uc: '1f3ca-1f3ff',
            isCanonical: !0
        },
        ':swimmer_tone4:': {
            unicode: ['1f3ca-1f3fe'],
            fname: '1f3ca-1f3fe',
            uc: '1f3ca-1f3fe',
            isCanonical: !0
        },
        ':swimmer_tone3:': {
            unicode: ['1f3ca-1f3fd'],
            fname: '1f3ca-1f3fd',
            uc: '1f3ca-1f3fd',
            isCanonical: !0
        },
        ':swimmer_tone2:': {
            unicode: ['1f3ca-1f3fc'],
            fname: '1f3ca-1f3fc',
            uc: '1f3ca-1f3fc',
            isCanonical: !0
        },
        ':swimmer_tone1:': {
            unicode: ['1f3ca-1f3fb'],
            fname: '1f3ca-1f3fb',
            uc: '1f3ca-1f3fb',
            isCanonical: !0
        },
        ':horse_racing_tone5:': {
            unicode: ['1f3c7-1f3ff'],
            fname: '1f3c7-1f3ff',
            uc: '1f3c7-1f3ff',
            isCanonical: !0
        },
        ':horse_racing_tone4:': {
            unicode: ['1f3c7-1f3fe'],
            fname: '1f3c7-1f3fe',
            uc: '1f3c7-1f3fe',
            isCanonical: !0
        },
        ':horse_racing_tone3:': {
            unicode: ['1f3c7-1f3fd'],
            fname: '1f3c7-1f3fd',
            uc: '1f3c7-1f3fd',
            isCanonical: !0
        },
        ':horse_racing_tone2:': {
            unicode: ['1f3c7-1f3fc'],
            fname: '1f3c7-1f3fc',
            uc: '1f3c7-1f3fc',
            isCanonical: !0
        },
        ':horse_racing_tone1:': {
            unicode: ['1f3c7-1f3fb'],
            fname: '1f3c7-1f3fb',
            uc: '1f3c7-1f3fb',
            isCanonical: !0
        },
        ':surfer_tone5:': {
            unicode: ['1f3c4-1f3ff'],
            fname: '1f3c4-1f3ff',
            uc: '1f3c4-1f3ff',
            isCanonical: !0
        },
        ':surfer_tone4:': {
            unicode: ['1f3c4-1f3fe'],
            fname: '1f3c4-1f3fe',
            uc: '1f3c4-1f3fe',
            isCanonical: !0
        },
        ':surfer_tone3:': {
            unicode: ['1f3c4-1f3fd'],
            fname: '1f3c4-1f3fd',
            uc: '1f3c4-1f3fd',
            isCanonical: !0
        },
        ':surfer_tone2:': {
            unicode: ['1f3c4-1f3fc'],
            fname: '1f3c4-1f3fc',
            uc: '1f3c4-1f3fc',
            isCanonical: !0
        },
        ':surfer_tone1:': {
            unicode: ['1f3c4-1f3fb'],
            fname: '1f3c4-1f3fb',
            uc: '1f3c4-1f3fb',
            isCanonical: !0
        },
        ':runner_tone5:': {
            unicode: ['1f3c3-1f3ff'],
            fname: '1f3c3-1f3ff',
            uc: '1f3c3-1f3ff',
            isCanonical: !0
        },
        ':runner_tone4:': {
            unicode: ['1f3c3-1f3fe'],
            fname: '1f3c3-1f3fe',
            uc: '1f3c3-1f3fe',
            isCanonical: !0
        },
        ':runner_tone3:': {
            unicode: ['1f3c3-1f3fd'],
            fname: '1f3c3-1f3fd',
            uc: '1f3c3-1f3fd',
            isCanonical: !0
        },
        ':runner_tone2:': {
            unicode: ['1f3c3-1f3fc'],
            fname: '1f3c3-1f3fc',
            uc: '1f3c3-1f3fc',
            isCanonical: !0
        },
        ':runner_tone1:': {
            unicode: ['1f3c3-1f3fb'],
            fname: '1f3c3-1f3fb',
            uc: '1f3c3-1f3fb',
            isCanonical: !0
        },
        ':santa_tone5:': {
            unicode: ['1f385-1f3ff'],
            fname: '1f385-1f3ff',
            uc: '1f385-1f3ff',
            isCanonical: !0
        },
        ':santa_tone4:': {
            unicode: ['1f385-1f3fe'],
            fname: '1f385-1f3fe',
            uc: '1f385-1f3fe',
            isCanonical: !0
        },
        ':santa_tone3:': {
            unicode: ['1f385-1f3fd'],
            fname: '1f385-1f3fd',
            uc: '1f385-1f3fd',
            isCanonical: !0
        },
        ':santa_tone2:': {
            unicode: ['1f385-1f3fc'],
            fname: '1f385-1f3fc',
            uc: '1f385-1f3fc',
            isCanonical: !0
        },
        ':santa_tone1:': {
            unicode: ['1f385-1f3fb'],
            fname: '1f385-1f3fb',
            uc: '1f385-1f3fb',
            isCanonical: !0
        },
        ':flag_zw:': {
            unicode: ['1f1ff-1f1fc'],
            fname: '1f1ff-1f1fc',
            uc: '1f1ff-1f1fc',
            isCanonical: !0
        },
        ':zw:': {
            unicode: ['1f1ff-1f1fc'],
            fname: '1f1ff-1f1fc',
            uc: '1f1ff-1f1fc',
            isCanonical: !1
        },
        ':flag_zm:': {
            unicode: ['1f1ff-1f1f2'],
            fname: '1f1ff-1f1f2',
            uc: '1f1ff-1f1f2',
            isCanonical: !0
        },
        ':zm:': {
            unicode: ['1f1ff-1f1f2'],
            fname: '1f1ff-1f1f2',
            uc: '1f1ff-1f1f2',
            isCanonical: !1
        },
        ':flag_za:': {
            unicode: ['1f1ff-1f1e6'],
            fname: '1f1ff-1f1e6',
            uc: '1f1ff-1f1e6',
            isCanonical: !0
        },
        ':za:': {
            unicode: ['1f1ff-1f1e6'],
            fname: '1f1ff-1f1e6',
            uc: '1f1ff-1f1e6',
            isCanonical: !1
        },
        ':flag_yt:': {
            unicode: ['1f1fe-1f1f9'],
            fname: '1f1fe-1f1f9',
            uc: '1f1fe-1f1f9',
            isCanonical: !0
        },
        ':yt:': {
            unicode: ['1f1fe-1f1f9'],
            fname: '1f1fe-1f1f9',
            uc: '1f1fe-1f1f9',
            isCanonical: !1
        },
        ':flag_ye:': {
            unicode: ['1f1fe-1f1ea'],
            fname: '1f1fe-1f1ea',
            uc: '1f1fe-1f1ea',
            isCanonical: !0
        },
        ':ye:': {
            unicode: ['1f1fe-1f1ea'],
            fname: '1f1fe-1f1ea',
            uc: '1f1fe-1f1ea',
            isCanonical: !1
        },
        ':flag_xk:': {
            unicode: ['1f1fd-1f1f0'],
            fname: '1f1fd-1f1f0',
            uc: '1f1fd-1f1f0',
            isCanonical: !0
        },
        ':xk:': {
            unicode: ['1f1fd-1f1f0'],
            fname: '1f1fd-1f1f0',
            uc: '1f1fd-1f1f0',
            isCanonical: !1
        },
        ':flag_ws:': {
            unicode: ['1f1fc-1f1f8'],
            fname: '1f1fc-1f1f8',
            uc: '1f1fc-1f1f8',
            isCanonical: !0
        },
        ':ws:': {
            unicode: ['1f1fc-1f1f8'],
            fname: '1f1fc-1f1f8',
            uc: '1f1fc-1f1f8',
            isCanonical: !1
        },
        ':flag_wf:': {
            unicode: ['1f1fc-1f1eb'],
            fname: '1f1fc-1f1eb',
            uc: '1f1fc-1f1eb',
            isCanonical: !0
        },
        ':wf:': {
            unicode: ['1f1fc-1f1eb'],
            fname: '1f1fc-1f1eb',
            uc: '1f1fc-1f1eb',
            isCanonical: !1
        },
        ':flag_vu:': {
            unicode: ['1f1fb-1f1fa'],
            fname: '1f1fb-1f1fa',
            uc: '1f1fb-1f1fa',
            isCanonical: !0
        },
        ':vu:': {
            unicode: ['1f1fb-1f1fa'],
            fname: '1f1fb-1f1fa',
            uc: '1f1fb-1f1fa',
            isCanonical: !1
        },
        ':flag_vn:': {
            unicode: ['1f1fb-1f1f3'],
            fname: '1f1fb-1f1f3',
            uc: '1f1fb-1f1f3',
            isCanonical: !0
        },
        ':vn:': {
            unicode: ['1f1fb-1f1f3'],
            fname: '1f1fb-1f1f3',
            uc: '1f1fb-1f1f3',
            isCanonical: !1
        },
        ':flag_vi:': {
            unicode: ['1f1fb-1f1ee'],
            fname: '1f1fb-1f1ee',
            uc: '1f1fb-1f1ee',
            isCanonical: !0
        },
        ':vi:': {
            unicode: ['1f1fb-1f1ee'],
            fname: '1f1fb-1f1ee',
            uc: '1f1fb-1f1ee',
            isCanonical: !1
        },
        ':flag_vg:': {
            unicode: ['1f1fb-1f1ec'],
            fname: '1f1fb-1f1ec',
            uc: '1f1fb-1f1ec',
            isCanonical: !0
        },
        ':vg:': {
            unicode: ['1f1fb-1f1ec'],
            fname: '1f1fb-1f1ec',
            uc: '1f1fb-1f1ec',
            isCanonical: !1
        },
        ':flag_ve:': {
            unicode: ['1f1fb-1f1ea'],
            fname: '1f1fb-1f1ea',
            uc: '1f1fb-1f1ea',
            isCanonical: !0
        },
        ':ve:': {
            unicode: ['1f1fb-1f1ea'],
            fname: '1f1fb-1f1ea',
            uc: '1f1fb-1f1ea',
            isCanonical: !1
        },
        ':flag_vc:': {
            unicode: ['1f1fb-1f1e8'],
            fname: '1f1fb-1f1e8',
            uc: '1f1fb-1f1e8',
            isCanonical: !0
        },
        ':vc:': {
            unicode: ['1f1fb-1f1e8'],
            fname: '1f1fb-1f1e8',
            uc: '1f1fb-1f1e8',
            isCanonical: !1
        },
        ':flag_va:': {
            unicode: ['1f1fb-1f1e6'],
            fname: '1f1fb-1f1e6',
            uc: '1f1fb-1f1e6',
            isCanonical: !0
        },
        ':va:': {
            unicode: ['1f1fb-1f1e6'],
            fname: '1f1fb-1f1e6',
            uc: '1f1fb-1f1e6',
            isCanonical: !1
        },
        ':flag_uz:': {
            unicode: ['1f1fa-1f1ff'],
            fname: '1f1fa-1f1ff',
            uc: '1f1fa-1f1ff',
            isCanonical: !0
        },
        ':uz:': {
            unicode: ['1f1fa-1f1ff'],
            fname: '1f1fa-1f1ff',
            uc: '1f1fa-1f1ff',
            isCanonical: !1
        },
        ':flag_uy:': {
            unicode: ['1f1fa-1f1fe'],
            fname: '1f1fa-1f1fe',
            uc: '1f1fa-1f1fe',
            isCanonical: !0
        },
        ':uy:': {
            unicode: ['1f1fa-1f1fe'],
            fname: '1f1fa-1f1fe',
            uc: '1f1fa-1f1fe',
            isCanonical: !1
        },
        ':flag_us:': {
            unicode: ['1f1fa-1f1f8'],
            fname: '1f1fa-1f1f8',
            uc: '1f1fa-1f1f8',
            isCanonical: !0
        },
        ':us:': {
            unicode: ['1f1fa-1f1f8'],
            fname: '1f1fa-1f1f8',
            uc: '1f1fa-1f1f8',
            isCanonical: !1
        },
        ':flag_um:': {
            unicode: ['1f1fa-1f1f2'],
            fname: '1f1fa-1f1f2',
            uc: '1f1fa-1f1f2',
            isCanonical: !0
        },
        ':um:': {
            unicode: ['1f1fa-1f1f2'],
            fname: '1f1fa-1f1f2',
            uc: '1f1fa-1f1f2',
            isCanonical: !1
        },
        ':flag_ug:': {
            unicode: ['1f1fa-1f1ec'],
            fname: '1f1fa-1f1ec',
            uc: '1f1fa-1f1ec',
            isCanonical: !0
        },
        ':ug:': {
            unicode: ['1f1fa-1f1ec'],
            fname: '1f1fa-1f1ec',
            uc: '1f1fa-1f1ec',
            isCanonical: !1
        },
        ':flag_ua:': {
            unicode: ['1f1fa-1f1e6'],
            fname: '1f1fa-1f1e6',
            uc: '1f1fa-1f1e6',
            isCanonical: !0
        },
        ':ua:': {
            unicode: ['1f1fa-1f1e6'],
            fname: '1f1fa-1f1e6',
            uc: '1f1fa-1f1e6',
            isCanonical: !1
        },
        ':flag_tz:': {
            unicode: ['1f1f9-1f1ff'],
            fname: '1f1f9-1f1ff',
            uc: '1f1f9-1f1ff',
            isCanonical: !0
        },
        ':tz:': {
            unicode: ['1f1f9-1f1ff'],
            fname: '1f1f9-1f1ff',
            uc: '1f1f9-1f1ff',
            isCanonical: !1
        },
        ':flag_tw:': {
            unicode: ['1f1f9-1f1fc'],
            fname: '1f1f9-1f1fc',
            uc: '1f1f9-1f1fc',
            isCanonical: !0
        },
        ':tw:': {
            unicode: ['1f1f9-1f1fc'],
            fname: '1f1f9-1f1fc',
            uc: '1f1f9-1f1fc',
            isCanonical: !1
        },
        ':flag_tv:': {
            unicode: ['1f1f9-1f1fb'],
            fname: '1f1f9-1f1fb',
            uc: '1f1f9-1f1fb',
            isCanonical: !0
        },
        ':tuvalu:': {
            unicode: ['1f1f9-1f1fb'],
            fname: '1f1f9-1f1fb',
            uc: '1f1f9-1f1fb',
            isCanonical: !1
        },
        ':flag_tt:': {
            unicode: ['1f1f9-1f1f9'],
            fname: '1f1f9-1f1f9',
            uc: '1f1f9-1f1f9',
            isCanonical: !0
        },
        ':tt:': {
            unicode: ['1f1f9-1f1f9'],
            fname: '1f1f9-1f1f9',
            uc: '1f1f9-1f1f9',
            isCanonical: !1
        },
        ':flag_tr:': {
            unicode: ['1f1f9-1f1f7'],
            fname: '1f1f9-1f1f7',
            uc: '1f1f9-1f1f7',
            isCanonical: !0
        },
        ':tr:': {
            unicode: ['1f1f9-1f1f7'],
            fname: '1f1f9-1f1f7',
            uc: '1f1f9-1f1f7',
            isCanonical: !1
        },
        ':flag_to:': {
            unicode: ['1f1f9-1f1f4'],
            fname: '1f1f9-1f1f4',
            uc: '1f1f9-1f1f4',
            isCanonical: !0
        },
        ':to:': {
            unicode: ['1f1f9-1f1f4'],
            fname: '1f1f9-1f1f4',
            uc: '1f1f9-1f1f4',
            isCanonical: !1
        },
        ':flag_tn:': {
            unicode: ['1f1f9-1f1f3'],
            fname: '1f1f9-1f1f3',
            uc: '1f1f9-1f1f3',
            isCanonical: !0
        },
        ':tn:': {
            unicode: ['1f1f9-1f1f3'],
            fname: '1f1f9-1f1f3',
            uc: '1f1f9-1f1f3',
            isCanonical: !1
        },
        ':flag_tm:': {
            unicode: ['1f1f9-1f1f2'],
            fname: '1f1f9-1f1f2',
            uc: '1f1f9-1f1f2',
            isCanonical: !0
        },
        ':turkmenistan:': {
            unicode: ['1f1f9-1f1f2'],
            fname: '1f1f9-1f1f2',
            uc: '1f1f9-1f1f2',
            isCanonical: !1
        },
        ':flag_tl:': {
            unicode: ['1f1f9-1f1f1'],
            fname: '1f1f9-1f1f1',
            uc: '1f1f9-1f1f1',
            isCanonical: !0
        },
        ':tl:': {
            unicode: ['1f1f9-1f1f1'],
            fname: '1f1f9-1f1f1',
            uc: '1f1f9-1f1f1',
            isCanonical: !1
        },
        ':flag_tk:': {
            unicode: ['1f1f9-1f1f0'],
            fname: '1f1f9-1f1f0',
            uc: '1f1f9-1f1f0',
            isCanonical: !0
        },
        ':tk:': {
            unicode: ['1f1f9-1f1f0'],
            fname: '1f1f9-1f1f0',
            uc: '1f1f9-1f1f0',
            isCanonical: !1
        },
        ':flag_tj:': {
            unicode: ['1f1f9-1f1ef'],
            fname: '1f1f9-1f1ef',
            uc: '1f1f9-1f1ef',
            isCanonical: !0
        },
        ':tj:': {
            unicode: ['1f1f9-1f1ef'],
            fname: '1f1f9-1f1ef',
            uc: '1f1f9-1f1ef',
            isCanonical: !1
        },
        ':flag_th:': {
            unicode: ['1f1f9-1f1ed'],
            fname: '1f1f9-1f1ed',
            uc: '1f1f9-1f1ed',
            isCanonical: !0
        },
        ':th:': {
            unicode: ['1f1f9-1f1ed'],
            fname: '1f1f9-1f1ed',
            uc: '1f1f9-1f1ed',
            isCanonical: !1
        },
        ':flag_tg:': {
            unicode: ['1f1f9-1f1ec'],
            fname: '1f1f9-1f1ec',
            uc: '1f1f9-1f1ec',
            isCanonical: !0
        },
        ':tg:': {
            unicode: ['1f1f9-1f1ec'],
            fname: '1f1f9-1f1ec',
            uc: '1f1f9-1f1ec',
            isCanonical: !1
        },
        ':flag_tf:': {
            unicode: ['1f1f9-1f1eb'],
            fname: '1f1f9-1f1eb',
            uc: '1f1f9-1f1eb',
            isCanonical: !0
        },
        ':tf:': {
            unicode: ['1f1f9-1f1eb'],
            fname: '1f1f9-1f1eb',
            uc: '1f1f9-1f1eb',
            isCanonical: !1
        },
        ':flag_td:': {
            unicode: ['1f1f9-1f1e9'],
            fname: '1f1f9-1f1e9',
            uc: '1f1f9-1f1e9',
            isCanonical: !0
        },
        ':td:': {
            unicode: ['1f1f9-1f1e9'],
            fname: '1f1f9-1f1e9',
            uc: '1f1f9-1f1e9',
            isCanonical: !1
        },
        ':flag_tc:': {
            unicode: ['1f1f9-1f1e8'],
            fname: '1f1f9-1f1e8',
            uc: '1f1f9-1f1e8',
            isCanonical: !0
        },
        ':tc:': {
            unicode: ['1f1f9-1f1e8'],
            fname: '1f1f9-1f1e8',
            uc: '1f1f9-1f1e8',
            isCanonical: !1
        },
        ':flag_ta:': {
            unicode: ['1f1f9-1f1e6'],
            fname: '1f1f9-1f1e6',
            uc: '1f1f9-1f1e6',
            isCanonical: !0
        },
        ':ta:': {
            unicode: ['1f1f9-1f1e6'],
            fname: '1f1f9-1f1e6',
            uc: '1f1f9-1f1e6',
            isCanonical: !1
        },
        ':flag_sz:': {
            unicode: ['1f1f8-1f1ff'],
            fname: '1f1f8-1f1ff',
            uc: '1f1f8-1f1ff',
            isCanonical: !0
        },
        ':sz:': {
            unicode: ['1f1f8-1f1ff'],
            fname: '1f1f8-1f1ff',
            uc: '1f1f8-1f1ff',
            isCanonical: !1
        },
        ':flag_sy:': {
            unicode: ['1f1f8-1f1fe'],
            fname: '1f1f8-1f1fe',
            uc: '1f1f8-1f1fe',
            isCanonical: !0
        },
        ':sy:': {
            unicode: ['1f1f8-1f1fe'],
            fname: '1f1f8-1f1fe',
            uc: '1f1f8-1f1fe',
            isCanonical: !1
        },
        ':flag_sx:': {
            unicode: ['1f1f8-1f1fd'],
            fname: '1f1f8-1f1fd',
            uc: '1f1f8-1f1fd',
            isCanonical: !0
        },
        ':sx:': {
            unicode: ['1f1f8-1f1fd'],
            fname: '1f1f8-1f1fd',
            uc: '1f1f8-1f1fd',
            isCanonical: !1
        },
        ':flag_sv:': {
            unicode: ['1f1f8-1f1fb'],
            fname: '1f1f8-1f1fb',
            uc: '1f1f8-1f1fb',
            isCanonical: !0
        },
        ':sv:': {
            unicode: ['1f1f8-1f1fb'],
            fname: '1f1f8-1f1fb',
            uc: '1f1f8-1f1fb',
            isCanonical: !1
        },
        ':flag_st:': {
            unicode: ['1f1f8-1f1f9'],
            fname: '1f1f8-1f1f9',
            uc: '1f1f8-1f1f9',
            isCanonical: !0
        },
        ':st:': {
            unicode: ['1f1f8-1f1f9'],
            fname: '1f1f8-1f1f9',
            uc: '1f1f8-1f1f9',
            isCanonical: !1
        },
        ':flag_ss:': {
            unicode: ['1f1f8-1f1f8'],
            fname: '1f1f8-1f1f8',
            uc: '1f1f8-1f1f8',
            isCanonical: !0
        },
        ':ss:': {
            unicode: ['1f1f8-1f1f8'],
            fname: '1f1f8-1f1f8',
            uc: '1f1f8-1f1f8',
            isCanonical: !1
        },
        ':flag_sr:': {
            unicode: ['1f1f8-1f1f7'],
            fname: '1f1f8-1f1f7',
            uc: '1f1f8-1f1f7',
            isCanonical: !0
        },
        ':sr:': {
            unicode: ['1f1f8-1f1f7'],
            fname: '1f1f8-1f1f7',
            uc: '1f1f8-1f1f7',
            isCanonical: !1
        },
        ':flag_so:': {
            unicode: ['1f1f8-1f1f4'],
            fname: '1f1f8-1f1f4',
            uc: '1f1f8-1f1f4',
            isCanonical: !0
        },
        ':so:': {
            unicode: ['1f1f8-1f1f4'],
            fname: '1f1f8-1f1f4',
            uc: '1f1f8-1f1f4',
            isCanonical: !1
        },
        ':flag_sn:': {
            unicode: ['1f1f8-1f1f3'],
            fname: '1f1f8-1f1f3',
            uc: '1f1f8-1f1f3',
            isCanonical: !0
        },
        ':sn:': {
            unicode: ['1f1f8-1f1f3'],
            fname: '1f1f8-1f1f3',
            uc: '1f1f8-1f1f3',
            isCanonical: !1
        },
        ':flag_sm:': {
            unicode: ['1f1f8-1f1f2'],
            fname: '1f1f8-1f1f2',
            uc: '1f1f8-1f1f2',
            isCanonical: !0
        },
        ':sm:': {
            unicode: ['1f1f8-1f1f2'],
            fname: '1f1f8-1f1f2',
            uc: '1f1f8-1f1f2',
            isCanonical: !1
        },
        ':flag_sl:': {
            unicode: ['1f1f8-1f1f1'],
            fname: '1f1f8-1f1f1',
            uc: '1f1f8-1f1f1',
            isCanonical: !0
        },
        ':sl:': {
            unicode: ['1f1f8-1f1f1'],
            fname: '1f1f8-1f1f1',
            uc: '1f1f8-1f1f1',
            isCanonical: !1
        },
        ':flag_sk:': {
            unicode: ['1f1f8-1f1f0'],
            fname: '1f1f8-1f1f0',
            uc: '1f1f8-1f1f0',
            isCanonical: !0
        },
        ':sk:': {
            unicode: ['1f1f8-1f1f0'],
            fname: '1f1f8-1f1f0',
            uc: '1f1f8-1f1f0',
            isCanonical: !1
        },
        ':flag_sj:': {
            unicode: ['1f1f8-1f1ef'],
            fname: '1f1f8-1f1ef',
            uc: '1f1f8-1f1ef',
            isCanonical: !0
        },
        ':sj:': {
            unicode: ['1f1f8-1f1ef'],
            fname: '1f1f8-1f1ef',
            uc: '1f1f8-1f1ef',
            isCanonical: !1
        },
        ':flag_si:': {
            unicode: ['1f1f8-1f1ee'],
            fname: '1f1f8-1f1ee',
            uc: '1f1f8-1f1ee',
            isCanonical: !0
        },
        ':si:': {
            unicode: ['1f1f8-1f1ee'],
            fname: '1f1f8-1f1ee',
            uc: '1f1f8-1f1ee',
            isCanonical: !1
        },
        ':flag_sh:': {
            unicode: ['1f1f8-1f1ed'],
            fname: '1f1f8-1f1ed',
            uc: '1f1f8-1f1ed',
            isCanonical: !0
        },
        ':sh:': {
            unicode: ['1f1f8-1f1ed'],
            fname: '1f1f8-1f1ed',
            uc: '1f1f8-1f1ed',
            isCanonical: !1
        },
        ':flag_sg:': {
            unicode: ['1f1f8-1f1ec'],
            fname: '1f1f8-1f1ec',
            uc: '1f1f8-1f1ec',
            isCanonical: !0
        },
        ':sg:': {
            unicode: ['1f1f8-1f1ec'],
            fname: '1f1f8-1f1ec',
            uc: '1f1f8-1f1ec',
            isCanonical: !1
        },
        ':flag_se:': {
            unicode: ['1f1f8-1f1ea'],
            fname: '1f1f8-1f1ea',
            uc: '1f1f8-1f1ea',
            isCanonical: !0
        },
        ':se:': {
            unicode: ['1f1f8-1f1ea'],
            fname: '1f1f8-1f1ea',
            uc: '1f1f8-1f1ea',
            isCanonical: !1
        },
        ':flag_sd:': {
            unicode: ['1f1f8-1f1e9'],
            fname: '1f1f8-1f1e9',
            uc: '1f1f8-1f1e9',
            isCanonical: !0
        },
        ':sd:': {
            unicode: ['1f1f8-1f1e9'],
            fname: '1f1f8-1f1e9',
            uc: '1f1f8-1f1e9',
            isCanonical: !1
        },
        ':flag_sc:': {
            unicode: ['1f1f8-1f1e8'],
            fname: '1f1f8-1f1e8',
            uc: '1f1f8-1f1e8',
            isCanonical: !0
        },
        ':sc:': {
            unicode: ['1f1f8-1f1e8'],
            fname: '1f1f8-1f1e8',
            uc: '1f1f8-1f1e8',
            isCanonical: !1
        },
        ':flag_sb:': {
            unicode: ['1f1f8-1f1e7'],
            fname: '1f1f8-1f1e7',
            uc: '1f1f8-1f1e7',
            isCanonical: !0
        },
        ':sb:': {
            unicode: ['1f1f8-1f1e7'],
            fname: '1f1f8-1f1e7',
            uc: '1f1f8-1f1e7',
            isCanonical: !1
        },
        ':flag_sa:': {
            unicode: ['1f1f8-1f1e6'],
            fname: '1f1f8-1f1e6',
            uc: '1f1f8-1f1e6',
            isCanonical: !0
        },
        ':saudiarabia:': {
            unicode: ['1f1f8-1f1e6'],
            fname: '1f1f8-1f1e6',
            uc: '1f1f8-1f1e6',
            isCanonical: !1
        },
        ':saudi:': {
            unicode: ['1f1f8-1f1e6'],
            fname: '1f1f8-1f1e6',
            uc: '1f1f8-1f1e6',
            isCanonical: !1
        },
        ':flag_rw:': {
            unicode: ['1f1f7-1f1fc'],
            fname: '1f1f7-1f1fc',
            uc: '1f1f7-1f1fc',
            isCanonical: !0
        },
        ':rw:': {
            unicode: ['1f1f7-1f1fc'],
            fname: '1f1f7-1f1fc',
            uc: '1f1f7-1f1fc',
            isCanonical: !1
        },
        ':flag_ru:': {
            unicode: ['1f1f7-1f1fa'],
            fname: '1f1f7-1f1fa',
            uc: '1f1f7-1f1fa',
            isCanonical: !0
        },
        ':ru:': {
            unicode: ['1f1f7-1f1fa'],
            fname: '1f1f7-1f1fa',
            uc: '1f1f7-1f1fa',
            isCanonical: !1
        },
        ':flag_rs:': {
            unicode: ['1f1f7-1f1f8'],
            fname: '1f1f7-1f1f8',
            uc: '1f1f7-1f1f8',
            isCanonical: !0
        },
        ':rs:': {
            unicode: ['1f1f7-1f1f8'],
            fname: '1f1f7-1f1f8',
            uc: '1f1f7-1f1f8',
            isCanonical: !1
        },
        ':flag_ro:': {
            unicode: ['1f1f7-1f1f4'],
            fname: '1f1f7-1f1f4',
            uc: '1f1f7-1f1f4',
            isCanonical: !0
        },
        ':ro:': {
            unicode: ['1f1f7-1f1f4'],
            fname: '1f1f7-1f1f4',
            uc: '1f1f7-1f1f4',
            isCanonical: !1
        },
        ':flag_re:': {
            unicode: ['1f1f7-1f1ea'],
            fname: '1f1f7-1f1ea',
            uc: '1f1f7-1f1ea',
            isCanonical: !0
        },
        ':re:': {
            unicode: ['1f1f7-1f1ea'],
            fname: '1f1f7-1f1ea',
            uc: '1f1f7-1f1ea',
            isCanonical: !1
        },
        ':flag_qa:': {
            unicode: ['1f1f6-1f1e6'],
            fname: '1f1f6-1f1e6',
            uc: '1f1f6-1f1e6',
            isCanonical: !0
        },
        ':qa:': {
            unicode: ['1f1f6-1f1e6'],
            fname: '1f1f6-1f1e6',
            uc: '1f1f6-1f1e6',
            isCanonical: !1
        },
        ':flag_py:': {
            unicode: ['1f1f5-1f1fe'],
            fname: '1f1f5-1f1fe',
            uc: '1f1f5-1f1fe',
            isCanonical: !0
        },
        ':py:': {
            unicode: ['1f1f5-1f1fe'],
            fname: '1f1f5-1f1fe',
            uc: '1f1f5-1f1fe',
            isCanonical: !1
        },
        ':flag_pw:': {
            unicode: ['1f1f5-1f1fc'],
            fname: '1f1f5-1f1fc',
            uc: '1f1f5-1f1fc',
            isCanonical: !0
        },
        ':pw:': {
            unicode: ['1f1f5-1f1fc'],
            fname: '1f1f5-1f1fc',
            uc: '1f1f5-1f1fc',
            isCanonical: !1
        },
        ':flag_pt:': {
            unicode: ['1f1f5-1f1f9'],
            fname: '1f1f5-1f1f9',
            uc: '1f1f5-1f1f9',
            isCanonical: !0
        },
        ':pt:': {
            unicode: ['1f1f5-1f1f9'],
            fname: '1f1f5-1f1f9',
            uc: '1f1f5-1f1f9',
            isCanonical: !1
        },
        ':flag_ps:': {
            unicode: ['1f1f5-1f1f8'],
            fname: '1f1f5-1f1f8',
            uc: '1f1f5-1f1f8',
            isCanonical: !0
        },
        ':ps:': {
            unicode: ['1f1f5-1f1f8'],
            fname: '1f1f5-1f1f8',
            uc: '1f1f5-1f1f8',
            isCanonical: !1
        },
        ':flag_pr:': {
            unicode: ['1f1f5-1f1f7'],
            fname: '1f1f5-1f1f7',
            uc: '1f1f5-1f1f7',
            isCanonical: !0
        },
        ':pr:': {
            unicode: ['1f1f5-1f1f7'],
            fname: '1f1f5-1f1f7',
            uc: '1f1f5-1f1f7',
            isCanonical: !1
        },
        ':flag_pn:': {
            unicode: ['1f1f5-1f1f3'],
            fname: '1f1f5-1f1f3',
            uc: '1f1f5-1f1f3',
            isCanonical: !0
        },
        ':pn:': {
            unicode: ['1f1f5-1f1f3'],
            fname: '1f1f5-1f1f3',
            uc: '1f1f5-1f1f3',
            isCanonical: !1
        },
        ':flag_pm:': {
            unicode: ['1f1f5-1f1f2'],
            fname: '1f1f5-1f1f2',
            uc: '1f1f5-1f1f2',
            isCanonical: !0
        },
        ':pm:': {
            unicode: ['1f1f5-1f1f2'],
            fname: '1f1f5-1f1f2',
            uc: '1f1f5-1f1f2',
            isCanonical: !1
        },
        ':flag_pl:': {
            unicode: ['1f1f5-1f1f1'],
            fname: '1f1f5-1f1f1',
            uc: '1f1f5-1f1f1',
            isCanonical: !0
        },
        ':pl:': {
            unicode: ['1f1f5-1f1f1'],
            fname: '1f1f5-1f1f1',
            uc: '1f1f5-1f1f1',
            isCanonical: !1
        },
        ':flag_pk:': {
            unicode: ['1f1f5-1f1f0'],
            fname: '1f1f5-1f1f0',
            uc: '1f1f5-1f1f0',
            isCanonical: !0
        },
        ':pk:': {
            unicode: ['1f1f5-1f1f0'],
            fname: '1f1f5-1f1f0',
            uc: '1f1f5-1f1f0',
            isCanonical: !1
        },
        ':flag_ph:': {
            unicode: ['1f1f5-1f1ed'],
            fname: '1f1f5-1f1ed',
            uc: '1f1f5-1f1ed',
            isCanonical: !0
        },
        ':ph:': {
            unicode: ['1f1f5-1f1ed'],
            fname: '1f1f5-1f1ed',
            uc: '1f1f5-1f1ed',
            isCanonical: !1
        },
        ':flag_pg:': {
            unicode: ['1f1f5-1f1ec'],
            fname: '1f1f5-1f1ec',
            uc: '1f1f5-1f1ec',
            isCanonical: !0
        },
        ':pg:': {
            unicode: ['1f1f5-1f1ec'],
            fname: '1f1f5-1f1ec',
            uc: '1f1f5-1f1ec',
            isCanonical: !1
        },
        ':flag_pf:': {
            unicode: ['1f1f5-1f1eb'],
            fname: '1f1f5-1f1eb',
            uc: '1f1f5-1f1eb',
            isCanonical: !0
        },
        ':pf:': {
            unicode: ['1f1f5-1f1eb'],
            fname: '1f1f5-1f1eb',
            uc: '1f1f5-1f1eb',
            isCanonical: !1
        },
        ':flag_pe:': {
            unicode: ['1f1f5-1f1ea'],
            fname: '1f1f5-1f1ea',
            uc: '1f1f5-1f1ea',
            isCanonical: !0
        },
        ':pe:': {
            unicode: ['1f1f5-1f1ea'],
            fname: '1f1f5-1f1ea',
            uc: '1f1f5-1f1ea',
            isCanonical: !1
        },
        ':flag_pa:': {
            unicode: ['1f1f5-1f1e6'],
            fname: '1f1f5-1f1e6',
            uc: '1f1f5-1f1e6',
            isCanonical: !0
        },
        ':pa:': {
            unicode: ['1f1f5-1f1e6'],
            fname: '1f1f5-1f1e6',
            uc: '1f1f5-1f1e6',
            isCanonical: !1
        },
        ':flag_om:': {
            unicode: ['1f1f4-1f1f2'],
            fname: '1f1f4-1f1f2',
            uc: '1f1f4-1f1f2',
            isCanonical: !0
        },
        ':om:': {
            unicode: ['1f1f4-1f1f2'],
            fname: '1f1f4-1f1f2',
            uc: '1f1f4-1f1f2',
            isCanonical: !1
        },
        ':flag_nz:': {
            unicode: ['1f1f3-1f1ff'],
            fname: '1f1f3-1f1ff',
            uc: '1f1f3-1f1ff',
            isCanonical: !0
        },
        ':nz:': {
            unicode: ['1f1f3-1f1ff'],
            fname: '1f1f3-1f1ff',
            uc: '1f1f3-1f1ff',
            isCanonical: !1
        },
        ':flag_nu:': {
            unicode: ['1f1f3-1f1fa'],
            fname: '1f1f3-1f1fa',
            uc: '1f1f3-1f1fa',
            isCanonical: !0
        },
        ':nu:': {
            unicode: ['1f1f3-1f1fa'],
            fname: '1f1f3-1f1fa',
            uc: '1f1f3-1f1fa',
            isCanonical: !1
        },
        ':flag_nr:': {
            unicode: ['1f1f3-1f1f7'],
            fname: '1f1f3-1f1f7',
            uc: '1f1f3-1f1f7',
            isCanonical: !0
        },
        ':nr:': {
            unicode: ['1f1f3-1f1f7'],
            fname: '1f1f3-1f1f7',
            uc: '1f1f3-1f1f7',
            isCanonical: !1
        },
        ':flag_np:': {
            unicode: ['1f1f3-1f1f5'],
            fname: '1f1f3-1f1f5',
            uc: '1f1f3-1f1f5',
            isCanonical: !0
        },
        ':np:': {
            unicode: ['1f1f3-1f1f5'],
            fname: '1f1f3-1f1f5',
            uc: '1f1f3-1f1f5',
            isCanonical: !1
        },
        ':flag_no:': {
            unicode: ['1f1f3-1f1f4'],
            fname: '1f1f3-1f1f4',
            uc: '1f1f3-1f1f4',
            isCanonical: !0
        },
        ':no:': {
            unicode: ['1f1f3-1f1f4'],
            fname: '1f1f3-1f1f4',
            uc: '1f1f3-1f1f4',
            isCanonical: !1
        },
        ':flag_nl:': {
            unicode: ['1f1f3-1f1f1'],
            fname: '1f1f3-1f1f1',
            uc: '1f1f3-1f1f1',
            isCanonical: !0
        },
        ':nl:': {
            unicode: ['1f1f3-1f1f1'],
            fname: '1f1f3-1f1f1',
            uc: '1f1f3-1f1f1',
            isCanonical: !1
        },
        ':flag_ni:': {
            unicode: ['1f1f3-1f1ee'],
            fname: '1f1f3-1f1ee',
            uc: '1f1f3-1f1ee',
            isCanonical: !0
        },
        ':ni:': {
            unicode: ['1f1f3-1f1ee'],
            fname: '1f1f3-1f1ee',
            uc: '1f1f3-1f1ee',
            isCanonical: !1
        },
        ':flag_ng:': {
            unicode: ['1f1f3-1f1ec'],
            fname: '1f1f3-1f1ec',
            uc: '1f1f3-1f1ec',
            isCanonical: !0
        },
        ':nigeria:': {
            unicode: ['1f1f3-1f1ec'],
            fname: '1f1f3-1f1ec',
            uc: '1f1f3-1f1ec',
            isCanonical: !1
        },
        ':flag_nf:': {
            unicode: ['1f1f3-1f1eb'],
            fname: '1f1f3-1f1eb',
            uc: '1f1f3-1f1eb',
            isCanonical: !0
        },
        ':nf:': {
            unicode: ['1f1f3-1f1eb'],
            fname: '1f1f3-1f1eb',
            uc: '1f1f3-1f1eb',
            isCanonical: !1
        },
        ':flag_ne:': {
            unicode: ['1f1f3-1f1ea'],
            fname: '1f1f3-1f1ea',
            uc: '1f1f3-1f1ea',
            isCanonical: !0
        },
        ':ne:': {
            unicode: ['1f1f3-1f1ea'],
            fname: '1f1f3-1f1ea',
            uc: '1f1f3-1f1ea',
            isCanonical: !1
        },
        ':flag_nc:': {
            unicode: ['1f1f3-1f1e8'],
            fname: '1f1f3-1f1e8',
            uc: '1f1f3-1f1e8',
            isCanonical: !0
        },
        ':nc:': {
            unicode: ['1f1f3-1f1e8'],
            fname: '1f1f3-1f1e8',
            uc: '1f1f3-1f1e8',
            isCanonical: !1
        },
        ':flag_na:': {
            unicode: ['1f1f3-1f1e6'],
            fname: '1f1f3-1f1e6',
            uc: '1f1f3-1f1e6',
            isCanonical: !0
        },
        ':na:': {
            unicode: ['1f1f3-1f1e6'],
            fname: '1f1f3-1f1e6',
            uc: '1f1f3-1f1e6',
            isCanonical: !1
        },
        ':flag_mz:': {
            unicode: ['1f1f2-1f1ff'],
            fname: '1f1f2-1f1ff',
            uc: '1f1f2-1f1ff',
            isCanonical: !0
        },
        ':mz:': {
            unicode: ['1f1f2-1f1ff'],
            fname: '1f1f2-1f1ff',
            uc: '1f1f2-1f1ff',
            isCanonical: !1
        },
        ':flag_my:': {
            unicode: ['1f1f2-1f1fe'],
            fname: '1f1f2-1f1fe',
            uc: '1f1f2-1f1fe',
            isCanonical: !0
        },
        ':my:': {
            unicode: ['1f1f2-1f1fe'],
            fname: '1f1f2-1f1fe',
            uc: '1f1f2-1f1fe',
            isCanonical: !1
        },
        ':flag_mx:': {
            unicode: ['1f1f2-1f1fd'],
            fname: '1f1f2-1f1fd',
            uc: '1f1f2-1f1fd',
            isCanonical: !0
        },
        ':mx:': {
            unicode: ['1f1f2-1f1fd'],
            fname: '1f1f2-1f1fd',
            uc: '1f1f2-1f1fd',
            isCanonical: !1
        },
        ':flag_mw:': {
            unicode: ['1f1f2-1f1fc'],
            fname: '1f1f2-1f1fc',
            uc: '1f1f2-1f1fc',
            isCanonical: !0
        },
        ':mw:': {
            unicode: ['1f1f2-1f1fc'],
            fname: '1f1f2-1f1fc',
            uc: '1f1f2-1f1fc',
            isCanonical: !1
        },
        ':flag_mv:': {
            unicode: ['1f1f2-1f1fb'],
            fname: '1f1f2-1f1fb',
            uc: '1f1f2-1f1fb',
            isCanonical: !0
        },
        ':mv:': {
            unicode: ['1f1f2-1f1fb'],
            fname: '1f1f2-1f1fb',
            uc: '1f1f2-1f1fb',
            isCanonical: !1
        },
        ':flag_mu:': {
            unicode: ['1f1f2-1f1fa'],
            fname: '1f1f2-1f1fa',
            uc: '1f1f2-1f1fa',
            isCanonical: !0
        },
        ':mu:': {
            unicode: ['1f1f2-1f1fa'],
            fname: '1f1f2-1f1fa',
            uc: '1f1f2-1f1fa',
            isCanonical: !1
        },
        ':flag_mt:': {
            unicode: ['1f1f2-1f1f9'],
            fname: '1f1f2-1f1f9',
            uc: '1f1f2-1f1f9',
            isCanonical: !0
        },
        ':mt:': {
            unicode: ['1f1f2-1f1f9'],
            fname: '1f1f2-1f1f9',
            uc: '1f1f2-1f1f9',
            isCanonical: !1
        },
        ':flag_ms:': {
            unicode: ['1f1f2-1f1f8'],
            fname: '1f1f2-1f1f8',
            uc: '1f1f2-1f1f8',
            isCanonical: !0
        },
        ':ms:': {
            unicode: ['1f1f2-1f1f8'],
            fname: '1f1f2-1f1f8',
            uc: '1f1f2-1f1f8',
            isCanonical: !1
        },
        ':flag_mr:': {
            unicode: ['1f1f2-1f1f7'],
            fname: '1f1f2-1f1f7',
            uc: '1f1f2-1f1f7',
            isCanonical: !0
        },
        ':mr:': {
            unicode: ['1f1f2-1f1f7'],
            fname: '1f1f2-1f1f7',
            uc: '1f1f2-1f1f7',
            isCanonical: !1
        },
        ':flag_mq:': {
            unicode: ['1f1f2-1f1f6'],
            fname: '1f1f2-1f1f6',
            uc: '1f1f2-1f1f6',
            isCanonical: !0
        },
        ':mq:': {
            unicode: ['1f1f2-1f1f6'],
            fname: '1f1f2-1f1f6',
            uc: '1f1f2-1f1f6',
            isCanonical: !1
        },
        ':flag_mp:': {
            unicode: ['1f1f2-1f1f5'],
            fname: '1f1f2-1f1f5',
            uc: '1f1f2-1f1f5',
            isCanonical: !0
        },
        ':mp:': {
            unicode: ['1f1f2-1f1f5'],
            fname: '1f1f2-1f1f5',
            uc: '1f1f2-1f1f5',
            isCanonical: !1
        },
        ':flag_mo:': {
            unicode: ['1f1f2-1f1f4'],
            fname: '1f1f2-1f1f4',
            uc: '1f1f2-1f1f4',
            isCanonical: !0
        },
        ':mo:': {
            unicode: ['1f1f2-1f1f4'],
            fname: '1f1f2-1f1f4',
            uc: '1f1f2-1f1f4',
            isCanonical: !1
        },
        ':flag_mn:': {
            unicode: ['1f1f2-1f1f3'],
            fname: '1f1f2-1f1f3',
            uc: '1f1f2-1f1f3',
            isCanonical: !0
        },
        ':mn:': {
            unicode: ['1f1f2-1f1f3'],
            fname: '1f1f2-1f1f3',
            uc: '1f1f2-1f1f3',
            isCanonical: !1
        },
        ':flag_mm:': {
            unicode: ['1f1f2-1f1f2'],
            fname: '1f1f2-1f1f2',
            uc: '1f1f2-1f1f2',
            isCanonical: !0
        },
        ':mm:': {
            unicode: ['1f1f2-1f1f2'],
            fname: '1f1f2-1f1f2',
            uc: '1f1f2-1f1f2',
            isCanonical: !1
        },
        ':flag_ml:': {
            unicode: ['1f1f2-1f1f1'],
            fname: '1f1f2-1f1f1',
            uc: '1f1f2-1f1f1',
            isCanonical: !0
        },
        ':ml:': {
            unicode: ['1f1f2-1f1f1'],
            fname: '1f1f2-1f1f1',
            uc: '1f1f2-1f1f1',
            isCanonical: !1
        },
        ':flag_mk:': {
            unicode: ['1f1f2-1f1f0'],
            fname: '1f1f2-1f1f0',
            uc: '1f1f2-1f1f0',
            isCanonical: !0
        },
        ':mk:': {
            unicode: ['1f1f2-1f1f0'],
            fname: '1f1f2-1f1f0',
            uc: '1f1f2-1f1f0',
            isCanonical: !1
        },
        ':flag_mh:': {
            unicode: ['1f1f2-1f1ed'],
            fname: '1f1f2-1f1ed',
            uc: '1f1f2-1f1ed',
            isCanonical: !0
        },
        ':mh:': {
            unicode: ['1f1f2-1f1ed'],
            fname: '1f1f2-1f1ed',
            uc: '1f1f2-1f1ed',
            isCanonical: !1
        },
        ':flag_mg:': {
            unicode: ['1f1f2-1f1ec'],
            fname: '1f1f2-1f1ec',
            uc: '1f1f2-1f1ec',
            isCanonical: !0
        },
        ':mg:': {
            unicode: ['1f1f2-1f1ec'],
            fname: '1f1f2-1f1ec',
            uc: '1f1f2-1f1ec',
            isCanonical: !1
        },
        ':flag_mf:': {
            unicode: ['1f1f2-1f1eb'],
            fname: '1f1f2-1f1eb',
            uc: '1f1f2-1f1eb',
            isCanonical: !0
        },
        ':mf:': {
            unicode: ['1f1f2-1f1eb'],
            fname: '1f1f2-1f1eb',
            uc: '1f1f2-1f1eb',
            isCanonical: !1
        },
        ':flag_me:': {
            unicode: ['1f1f2-1f1ea'],
            fname: '1f1f2-1f1ea',
            uc: '1f1f2-1f1ea',
            isCanonical: !0
        },
        ':me:': {
            unicode: ['1f1f2-1f1ea'],
            fname: '1f1f2-1f1ea',
            uc: '1f1f2-1f1ea',
            isCanonical: !1
        },
        ':flag_md:': {
            unicode: ['1f1f2-1f1e9'],
            fname: '1f1f2-1f1e9',
            uc: '1f1f2-1f1e9',
            isCanonical: !0
        },
        ':md:': {
            unicode: ['1f1f2-1f1e9'],
            fname: '1f1f2-1f1e9',
            uc: '1f1f2-1f1e9',
            isCanonical: !1
        },
        ':flag_mc:': {
            unicode: ['1f1f2-1f1e8'],
            fname: '1f1f2-1f1e8',
            uc: '1f1f2-1f1e8',
            isCanonical: !0
        },
        ':mc:': {
            unicode: ['1f1f2-1f1e8'],
            fname: '1f1f2-1f1e8',
            uc: '1f1f2-1f1e8',
            isCanonical: !1
        },
        ':flag_ma:': {
            unicode: ['1f1f2-1f1e6'],
            fname: '1f1f2-1f1e6',
            uc: '1f1f2-1f1e6',
            isCanonical: !0
        },
        ':ma:': {
            unicode: ['1f1f2-1f1e6'],
            fname: '1f1f2-1f1e6',
            uc: '1f1f2-1f1e6',
            isCanonical: !1
        },
        ':flag_ly:': {
            unicode: ['1f1f1-1f1fe'],
            fname: '1f1f1-1f1fe',
            uc: '1f1f1-1f1fe',
            isCanonical: !0
        },
        ':ly:': {
            unicode: ['1f1f1-1f1fe'],
            fname: '1f1f1-1f1fe',
            uc: '1f1f1-1f1fe',
            isCanonical: !1
        },
        ':flag_lv:': {
            unicode: ['1f1f1-1f1fb'],
            fname: '1f1f1-1f1fb',
            uc: '1f1f1-1f1fb',
            isCanonical: !0
        },
        ':lv:': {
            unicode: ['1f1f1-1f1fb'],
            fname: '1f1f1-1f1fb',
            uc: '1f1f1-1f1fb',
            isCanonical: !1
        },
        ':flag_lu:': {
            unicode: ['1f1f1-1f1fa'],
            fname: '1f1f1-1f1fa',
            uc: '1f1f1-1f1fa',
            isCanonical: !0
        },
        ':lu:': {
            unicode: ['1f1f1-1f1fa'],
            fname: '1f1f1-1f1fa',
            uc: '1f1f1-1f1fa',
            isCanonical: !1
        },
        ':flag_lt:': {
            unicode: ['1f1f1-1f1f9'],
            fname: '1f1f1-1f1f9',
            uc: '1f1f1-1f1f9',
            isCanonical: !0
        },
        ':lt:': {
            unicode: ['1f1f1-1f1f9'],
            fname: '1f1f1-1f1f9',
            uc: '1f1f1-1f1f9',
            isCanonical: !1
        },
        ':flag_ls:': {
            unicode: ['1f1f1-1f1f8'],
            fname: '1f1f1-1f1f8',
            uc: '1f1f1-1f1f8',
            isCanonical: !0
        },
        ':ls:': {
            unicode: ['1f1f1-1f1f8'],
            fname: '1f1f1-1f1f8',
            uc: '1f1f1-1f1f8',
            isCanonical: !1
        },
        ':flag_lr:': {
            unicode: ['1f1f1-1f1f7'],
            fname: '1f1f1-1f1f7',
            uc: '1f1f1-1f1f7',
            isCanonical: !0
        },
        ':lr:': {
            unicode: ['1f1f1-1f1f7'],
            fname: '1f1f1-1f1f7',
            uc: '1f1f1-1f1f7',
            isCanonical: !1
        },
        ':flag_lk:': {
            unicode: ['1f1f1-1f1f0'],
            fname: '1f1f1-1f1f0',
            uc: '1f1f1-1f1f0',
            isCanonical: !0
        },
        ':lk:': {
            unicode: ['1f1f1-1f1f0'],
            fname: '1f1f1-1f1f0',
            uc: '1f1f1-1f1f0',
            isCanonical: !1
        },
        ':flag_li:': {
            unicode: ['1f1f1-1f1ee'],
            fname: '1f1f1-1f1ee',
            uc: '1f1f1-1f1ee',
            isCanonical: !0
        },
        ':li:': {
            unicode: ['1f1f1-1f1ee'],
            fname: '1f1f1-1f1ee',
            uc: '1f1f1-1f1ee',
            isCanonical: !1
        },
        ':flag_lc:': {
            unicode: ['1f1f1-1f1e8'],
            fname: '1f1f1-1f1e8',
            uc: '1f1f1-1f1e8',
            isCanonical: !0
        },
        ':lc:': {
            unicode: ['1f1f1-1f1e8'],
            fname: '1f1f1-1f1e8',
            uc: '1f1f1-1f1e8',
            isCanonical: !1
        },
        ':flag_lb:': {
            unicode: ['1f1f1-1f1e7'],
            fname: '1f1f1-1f1e7',
            uc: '1f1f1-1f1e7',
            isCanonical: !0
        },
        ':lb:': {
            unicode: ['1f1f1-1f1e7'],
            fname: '1f1f1-1f1e7',
            uc: '1f1f1-1f1e7',
            isCanonical: !1
        },
        ':flag_la:': {
            unicode: ['1f1f1-1f1e6'],
            fname: '1f1f1-1f1e6',
            uc: '1f1f1-1f1e6',
            isCanonical: !0
        },
        ':la:': {
            unicode: ['1f1f1-1f1e6'],
            fname: '1f1f1-1f1e6',
            uc: '1f1f1-1f1e6',
            isCanonical: !1
        },
        ':flag_kz:': {
            unicode: ['1f1f0-1f1ff'],
            fname: '1f1f0-1f1ff',
            uc: '1f1f0-1f1ff',
            isCanonical: !0
        },
        ':kz:': {
            unicode: ['1f1f0-1f1ff'],
            fname: '1f1f0-1f1ff',
            uc: '1f1f0-1f1ff',
            isCanonical: !1
        },
        ':flag_ky:': {
            unicode: ['1f1f0-1f1fe'],
            fname: '1f1f0-1f1fe',
            uc: '1f1f0-1f1fe',
            isCanonical: !0
        },
        ':ky:': {
            unicode: ['1f1f0-1f1fe'],
            fname: '1f1f0-1f1fe',
            uc: '1f1f0-1f1fe',
            isCanonical: !1
        },
        ':flag_kw:': {
            unicode: ['1f1f0-1f1fc'],
            fname: '1f1f0-1f1fc',
            uc: '1f1f0-1f1fc',
            isCanonical: !0
        },
        ':kw:': {
            unicode: ['1f1f0-1f1fc'],
            fname: '1f1f0-1f1fc',
            uc: '1f1f0-1f1fc',
            isCanonical: !1
        },
        ':flag_kr:': {
            unicode: ['1f1f0-1f1f7'],
            fname: '1f1f0-1f1f7',
            uc: '1f1f0-1f1f7',
            isCanonical: !0
        },
        ':kr:': {
            unicode: ['1f1f0-1f1f7'],
            fname: '1f1f0-1f1f7',
            uc: '1f1f0-1f1f7',
            isCanonical: !1
        },
        ':flag_kp:': {
            unicode: ['1f1f0-1f1f5'],
            fname: '1f1f0-1f1f5',
            uc: '1f1f0-1f1f5',
            isCanonical: !0
        },
        ':kp:': {
            unicode: ['1f1f0-1f1f5'],
            fname: '1f1f0-1f1f5',
            uc: '1f1f0-1f1f5',
            isCanonical: !1
        },
        ':flag_kn:': {
            unicode: ['1f1f0-1f1f3'],
            fname: '1f1f0-1f1f3',
            uc: '1f1f0-1f1f3',
            isCanonical: !0
        },
        ':kn:': {
            unicode: ['1f1f0-1f1f3'],
            fname: '1f1f0-1f1f3',
            uc: '1f1f0-1f1f3',
            isCanonical: !1
        },
        ':flag_km:': {
            unicode: ['1f1f0-1f1f2'],
            fname: '1f1f0-1f1f2',
            uc: '1f1f0-1f1f2',
            isCanonical: !0
        },
        ':km:': {
            unicode: ['1f1f0-1f1f2'],
            fname: '1f1f0-1f1f2',
            uc: '1f1f0-1f1f2',
            isCanonical: !1
        },
        ':flag_ki:': {
            unicode: ['1f1f0-1f1ee'],
            fname: '1f1f0-1f1ee',
            uc: '1f1f0-1f1ee',
            isCanonical: !0
        },
        ':ki:': {
            unicode: ['1f1f0-1f1ee'],
            fname: '1f1f0-1f1ee',
            uc: '1f1f0-1f1ee',
            isCanonical: !1
        },
        ':flag_kh:': {
            unicode: ['1f1f0-1f1ed'],
            fname: '1f1f0-1f1ed',
            uc: '1f1f0-1f1ed',
            isCanonical: !0
        },
        ':kh:': {
            unicode: ['1f1f0-1f1ed'],
            fname: '1f1f0-1f1ed',
            uc: '1f1f0-1f1ed',
            isCanonical: !1
        },
        ':flag_kg:': {
            unicode: ['1f1f0-1f1ec'],
            fname: '1f1f0-1f1ec',
            uc: '1f1f0-1f1ec',
            isCanonical: !0
        },
        ':kg:': {
            unicode: ['1f1f0-1f1ec'],
            fname: '1f1f0-1f1ec',
            uc: '1f1f0-1f1ec',
            isCanonical: !1
        },
        ':flag_ke:': {
            unicode: ['1f1f0-1f1ea'],
            fname: '1f1f0-1f1ea',
            uc: '1f1f0-1f1ea',
            isCanonical: !0
        },
        ':ke:': {
            unicode: ['1f1f0-1f1ea'],
            fname: '1f1f0-1f1ea',
            uc: '1f1f0-1f1ea',
            isCanonical: !1
        },
        ':flag_jp:': {
            unicode: ['1f1ef-1f1f5'],
            fname: '1f1ef-1f1f5',
            uc: '1f1ef-1f1f5',
            isCanonical: !0
        },
        ':jp:': {
            unicode: ['1f1ef-1f1f5'],
            fname: '1f1ef-1f1f5',
            uc: '1f1ef-1f1f5',
            isCanonical: !1
        },
        ':flag_jo:': {
            unicode: ['1f1ef-1f1f4'],
            fname: '1f1ef-1f1f4',
            uc: '1f1ef-1f1f4',
            isCanonical: !0
        },
        ':jo:': {
            unicode: ['1f1ef-1f1f4'],
            fname: '1f1ef-1f1f4',
            uc: '1f1ef-1f1f4',
            isCanonical: !1
        },
        ':flag_jm:': {
            unicode: ['1f1ef-1f1f2'],
            fname: '1f1ef-1f1f2',
            uc: '1f1ef-1f1f2',
            isCanonical: !0
        },
        ':jm:': {
            unicode: ['1f1ef-1f1f2'],
            fname: '1f1ef-1f1f2',
            uc: '1f1ef-1f1f2',
            isCanonical: !1
        },
        ':flag_je:': {
            unicode: ['1f1ef-1f1ea'],
            fname: '1f1ef-1f1ea',
            uc: '1f1ef-1f1ea',
            isCanonical: !0
        },
        ':je:': {
            unicode: ['1f1ef-1f1ea'],
            fname: '1f1ef-1f1ea',
            uc: '1f1ef-1f1ea',
            isCanonical: !1
        },
        ':flag_it:': {
            unicode: ['1f1ee-1f1f9'],
            fname: '1f1ee-1f1f9',
            uc: '1f1ee-1f1f9',
            isCanonical: !0
        },
        ':it:': {
            unicode: ['1f1ee-1f1f9'],
            fname: '1f1ee-1f1f9',
            uc: '1f1ee-1f1f9',
            isCanonical: !1
        },
        ':flag_is:': {
            unicode: ['1f1ee-1f1f8'],
            fname: '1f1ee-1f1f8',
            uc: '1f1ee-1f1f8',
            isCanonical: !0
        },
        ':is:': {
            unicode: ['1f1ee-1f1f8'],
            fname: '1f1ee-1f1f8',
            uc: '1f1ee-1f1f8',
            isCanonical: !1
        },
        ':flag_ir:': {
            unicode: ['1f1ee-1f1f7'],
            fname: '1f1ee-1f1f7',
            uc: '1f1ee-1f1f7',
            isCanonical: !0
        },
        ':ir:': {
            unicode: ['1f1ee-1f1f7'],
            fname: '1f1ee-1f1f7',
            uc: '1f1ee-1f1f7',
            isCanonical: !1
        },
        ':flag_iq:': {
            unicode: ['1f1ee-1f1f6'],
            fname: '1f1ee-1f1f6',
            uc: '1f1ee-1f1f6',
            isCanonical: !0
        },
        ':iq:': {
            unicode: ['1f1ee-1f1f6'],
            fname: '1f1ee-1f1f6',
            uc: '1f1ee-1f1f6',
            isCanonical: !1
        },
        ':flag_io:': {
            unicode: ['1f1ee-1f1f4'],
            fname: '1f1ee-1f1f4',
            uc: '1f1ee-1f1f4',
            isCanonical: !0
        },
        ':io:': {
            unicode: ['1f1ee-1f1f4'],
            fname: '1f1ee-1f1f4',
            uc: '1f1ee-1f1f4',
            isCanonical: !1
        },
        ':flag_in:': {
            unicode: ['1f1ee-1f1f3'],
            fname: '1f1ee-1f1f3',
            uc: '1f1ee-1f1f3',
            isCanonical: !0
        },
        ':in:': {
            unicode: ['1f1ee-1f1f3'],
            fname: '1f1ee-1f1f3',
            uc: '1f1ee-1f1f3',
            isCanonical: !1
        },
        ':flag_im:': {
            unicode: ['1f1ee-1f1f2'],
            fname: '1f1ee-1f1f2',
            uc: '1f1ee-1f1f2',
            isCanonical: !0
        },
        ':im:': {
            unicode: ['1f1ee-1f1f2'],
            fname: '1f1ee-1f1f2',
            uc: '1f1ee-1f1f2',
            isCanonical: !1
        },
        ':flag_il:': {
            unicode: ['1f1ee-1f1f1'],
            fname: '1f1ee-1f1f1',
            uc: '1f1ee-1f1f1',
            isCanonical: !0
        },
        ':il:': {
            unicode: ['1f1ee-1f1f1'],
            fname: '1f1ee-1f1f1',
            uc: '1f1ee-1f1f1',
            isCanonical: !1
        },
        ':flag_ie:': {
            unicode: ['1f1ee-1f1ea'],
            fname: '1f1ee-1f1ea',
            uc: '1f1ee-1f1ea',
            isCanonical: !0
        },
        ':ie:': {
            unicode: ['1f1ee-1f1ea'],
            fname: '1f1ee-1f1ea',
            uc: '1f1ee-1f1ea',
            isCanonical: !1
        },
        ':flag_id:': {
            unicode: ['1f1ee-1f1e9'],
            fname: '1f1ee-1f1e9',
            uc: '1f1ee-1f1e9',
            isCanonical: !0
        },
        ':indonesia:': {
            unicode: ['1f1ee-1f1e9'],
            fname: '1f1ee-1f1e9',
            uc: '1f1ee-1f1e9',
            isCanonical: !1
        },
        ':flag_ic:': {
            unicode: ['1f1ee-1f1e8'],
            fname: '1f1ee-1f1e8',
            uc: '1f1ee-1f1e8',
            isCanonical: !0
        },
        ':ic:': {
            unicode: ['1f1ee-1f1e8'],
            fname: '1f1ee-1f1e8',
            uc: '1f1ee-1f1e8',
            isCanonical: !1
        },
        ':flag_hu:': {
            unicode: ['1f1ed-1f1fa'],
            fname: '1f1ed-1f1fa',
            uc: '1f1ed-1f1fa',
            isCanonical: !0
        },
        ':hu:': {
            unicode: ['1f1ed-1f1fa'],
            fname: '1f1ed-1f1fa',
            uc: '1f1ed-1f1fa',
            isCanonical: !1
        },
        ':flag_ht:': {
            unicode: ['1f1ed-1f1f9'],
            fname: '1f1ed-1f1f9',
            uc: '1f1ed-1f1f9',
            isCanonical: !0
        },
        ':ht:': {
            unicode: ['1f1ed-1f1f9'],
            fname: '1f1ed-1f1f9',
            uc: '1f1ed-1f1f9',
            isCanonical: !1
        },
        ':flag_hr:': {
            unicode: ['1f1ed-1f1f7'],
            fname: '1f1ed-1f1f7',
            uc: '1f1ed-1f1f7',
            isCanonical: !0
        },
        ':hr:': {
            unicode: ['1f1ed-1f1f7'],
            fname: '1f1ed-1f1f7',
            uc: '1f1ed-1f1f7',
            isCanonical: !1
        },
        ':flag_hn:': {
            unicode: ['1f1ed-1f1f3'],
            fname: '1f1ed-1f1f3',
            uc: '1f1ed-1f1f3',
            isCanonical: !0
        },
        ':hn:': {
            unicode: ['1f1ed-1f1f3'],
            fname: '1f1ed-1f1f3',
            uc: '1f1ed-1f1f3',
            isCanonical: !1
        },
        ':flag_hm:': {
            unicode: ['1f1ed-1f1f2'],
            fname: '1f1ed-1f1f2',
            uc: '1f1ed-1f1f2',
            isCanonical: !0
        },
        ':hm:': {
            unicode: ['1f1ed-1f1f2'],
            fname: '1f1ed-1f1f2',
            uc: '1f1ed-1f1f2',
            isCanonical: !1
        },
        ':flag_hk:': {
            unicode: ['1f1ed-1f1f0'],
            fname: '1f1ed-1f1f0',
            uc: '1f1ed-1f1f0',
            isCanonical: !0
        },
        ':hk:': {
            unicode: ['1f1ed-1f1f0'],
            fname: '1f1ed-1f1f0',
            uc: '1f1ed-1f1f0',
            isCanonical: !1
        },
        ':flag_gy:': {
            unicode: ['1f1ec-1f1fe'],
            fname: '1f1ec-1f1fe',
            uc: '1f1ec-1f1fe',
            isCanonical: !0
        },
        ':gy:': {
            unicode: ['1f1ec-1f1fe'],
            fname: '1f1ec-1f1fe',
            uc: '1f1ec-1f1fe',
            isCanonical: !1
        },
        ':flag_gw:': {
            unicode: ['1f1ec-1f1fc'],
            fname: '1f1ec-1f1fc',
            uc: '1f1ec-1f1fc',
            isCanonical: !0
        },
        ':gw:': {
            unicode: ['1f1ec-1f1fc'],
            fname: '1f1ec-1f1fc',
            uc: '1f1ec-1f1fc',
            isCanonical: !1
        },
        ':flag_gu:': {
            unicode: ['1f1ec-1f1fa'],
            fname: '1f1ec-1f1fa',
            uc: '1f1ec-1f1fa',
            isCanonical: !0
        },
        ':gu:': {
            unicode: ['1f1ec-1f1fa'],
            fname: '1f1ec-1f1fa',
            uc: '1f1ec-1f1fa',
            isCanonical: !1
        },
        ':flag_gt:': {
            unicode: ['1f1ec-1f1f9'],
            fname: '1f1ec-1f1f9',
            uc: '1f1ec-1f1f9',
            isCanonical: !0
        },
        ':gt:': {
            unicode: ['1f1ec-1f1f9'],
            fname: '1f1ec-1f1f9',
            uc: '1f1ec-1f1f9',
            isCanonical: !1
        },
        ':flag_gs:': {
            unicode: ['1f1ec-1f1f8'],
            fname: '1f1ec-1f1f8',
            uc: '1f1ec-1f1f8',
            isCanonical: !0
        },
        ':gs:': {
            unicode: ['1f1ec-1f1f8'],
            fname: '1f1ec-1f1f8',
            uc: '1f1ec-1f1f8',
            isCanonical: !1
        },
        ':flag_gr:': {
            unicode: ['1f1ec-1f1f7'],
            fname: '1f1ec-1f1f7',
            uc: '1f1ec-1f1f7',
            isCanonical: !0
        },
        ':gr:': {
            unicode: ['1f1ec-1f1f7'],
            fname: '1f1ec-1f1f7',
            uc: '1f1ec-1f1f7',
            isCanonical: !1
        },
        ':flag_gq:': {
            unicode: ['1f1ec-1f1f6'],
            fname: '1f1ec-1f1f6',
            uc: '1f1ec-1f1f6',
            isCanonical: !0
        },
        ':gq:': {
            unicode: ['1f1ec-1f1f6'],
            fname: '1f1ec-1f1f6',
            uc: '1f1ec-1f1f6',
            isCanonical: !1
        },
        ':flag_gp:': {
            unicode: ['1f1ec-1f1f5'],
            fname: '1f1ec-1f1f5',
            uc: '1f1ec-1f1f5',
            isCanonical: !0
        },
        ':gp:': {
            unicode: ['1f1ec-1f1f5'],
            fname: '1f1ec-1f1f5',
            uc: '1f1ec-1f1f5',
            isCanonical: !1
        },
        ':flag_gn:': {
            unicode: ['1f1ec-1f1f3'],
            fname: '1f1ec-1f1f3',
            uc: '1f1ec-1f1f3',
            isCanonical: !0
        },
        ':gn:': {
            unicode: ['1f1ec-1f1f3'],
            fname: '1f1ec-1f1f3',
            uc: '1f1ec-1f1f3',
            isCanonical: !1
        },
        ':flag_gm:': {
            unicode: ['1f1ec-1f1f2'],
            fname: '1f1ec-1f1f2',
            uc: '1f1ec-1f1f2',
            isCanonical: !0
        },
        ':gm:': {
            unicode: ['1f1ec-1f1f2'],
            fname: '1f1ec-1f1f2',
            uc: '1f1ec-1f1f2',
            isCanonical: !1
        },
        ':flag_gl:': {
            unicode: ['1f1ec-1f1f1'],
            fname: '1f1ec-1f1f1',
            uc: '1f1ec-1f1f1',
            isCanonical: !0
        },
        ':gl:': {
            unicode: ['1f1ec-1f1f1'],
            fname: '1f1ec-1f1f1',
            uc: '1f1ec-1f1f1',
            isCanonical: !1
        },
        ':flag_gi:': {
            unicode: ['1f1ec-1f1ee'],
            fname: '1f1ec-1f1ee',
            uc: '1f1ec-1f1ee',
            isCanonical: !0
        },
        ':gi:': {
            unicode: ['1f1ec-1f1ee'],
            fname: '1f1ec-1f1ee',
            uc: '1f1ec-1f1ee',
            isCanonical: !1
        },
        ':flag_gh:': {
            unicode: ['1f1ec-1f1ed'],
            fname: '1f1ec-1f1ed',
            uc: '1f1ec-1f1ed',
            isCanonical: !0
        },
        ':gh:': {
            unicode: ['1f1ec-1f1ed'],
            fname: '1f1ec-1f1ed',
            uc: '1f1ec-1f1ed',
            isCanonical: !1
        },
        ':flag_gg:': {
            unicode: ['1f1ec-1f1ec'],
            fname: '1f1ec-1f1ec',
            uc: '1f1ec-1f1ec',
            isCanonical: !0
        },
        ':gg:': {
            unicode: ['1f1ec-1f1ec'],
            fname: '1f1ec-1f1ec',
            uc: '1f1ec-1f1ec',
            isCanonical: !1
        },
        ':flag_gf:': {
            unicode: ['1f1ec-1f1eb'],
            fname: '1f1ec-1f1eb',
            uc: '1f1ec-1f1eb',
            isCanonical: !0
        },
        ':gf:': {
            unicode: ['1f1ec-1f1eb'],
            fname: '1f1ec-1f1eb',
            uc: '1f1ec-1f1eb',
            isCanonical: !1
        },
        ':flag_ge:': {
            unicode: ['1f1ec-1f1ea'],
            fname: '1f1ec-1f1ea',
            uc: '1f1ec-1f1ea',
            isCanonical: !0
        },
        ':ge:': {
            unicode: ['1f1ec-1f1ea'],
            fname: '1f1ec-1f1ea',
            uc: '1f1ec-1f1ea',
            isCanonical: !1
        },
        ':flag_gd:': {
            unicode: ['1f1ec-1f1e9'],
            fname: '1f1ec-1f1e9',
            uc: '1f1ec-1f1e9',
            isCanonical: !0
        },
        ':gd:': {
            unicode: ['1f1ec-1f1e9'],
            fname: '1f1ec-1f1e9',
            uc: '1f1ec-1f1e9',
            isCanonical: !1
        },
        ':flag_gb:': {
            unicode: ['1f1ec-1f1e7'],
            fname: '1f1ec-1f1e7',
            uc: '1f1ec-1f1e7',
            isCanonical: !0
        },
        ':gb:': {
            unicode: ['1f1ec-1f1e7'],
            fname: '1f1ec-1f1e7',
            uc: '1f1ec-1f1e7',
            isCanonical: !1
        },
        ':flag_ga:': {
            unicode: ['1f1ec-1f1e6'],
            fname: '1f1ec-1f1e6',
            uc: '1f1ec-1f1e6',
            isCanonical: !0
        },
        ':ga:': {
            unicode: ['1f1ec-1f1e6'],
            fname: '1f1ec-1f1e6',
            uc: '1f1ec-1f1e6',
            isCanonical: !1
        },
        ':flag_fr:': {
            unicode: ['1f1eb-1f1f7'],
            fname: '1f1eb-1f1f7',
            uc: '1f1eb-1f1f7',
            isCanonical: !0
        },
        ':fr:': {
            unicode: ['1f1eb-1f1f7'],
            fname: '1f1eb-1f1f7',
            uc: '1f1eb-1f1f7',
            isCanonical: !1
        },
        ':flag_fo:': {
            unicode: ['1f1eb-1f1f4'],
            fname: '1f1eb-1f1f4',
            uc: '1f1eb-1f1f4',
            isCanonical: !0
        },
        ':fo:': {
            unicode: ['1f1eb-1f1f4'],
            fname: '1f1eb-1f1f4',
            uc: '1f1eb-1f1f4',
            isCanonical: !1
        },
        ':flag_fm:': {
            unicode: ['1f1eb-1f1f2'],
            fname: '1f1eb-1f1f2',
            uc: '1f1eb-1f1f2',
            isCanonical: !0
        },
        ':fm:': {
            unicode: ['1f1eb-1f1f2'],
            fname: '1f1eb-1f1f2',
            uc: '1f1eb-1f1f2',
            isCanonical: !1
        },
        ':flag_fk:': {
            unicode: ['1f1eb-1f1f0'],
            fname: '1f1eb-1f1f0',
            uc: '1f1eb-1f1f0',
            isCanonical: !0
        },
        ':fk:': {
            unicode: ['1f1eb-1f1f0'],
            fname: '1f1eb-1f1f0',
            uc: '1f1eb-1f1f0',
            isCanonical: !1
        },
        ':flag_fj:': {
            unicode: ['1f1eb-1f1ef'],
            fname: '1f1eb-1f1ef',
            uc: '1f1eb-1f1ef',
            isCanonical: !0
        },
        ':fj:': {
            unicode: ['1f1eb-1f1ef'],
            fname: '1f1eb-1f1ef',
            uc: '1f1eb-1f1ef',
            isCanonical: !1
        },
        ':flag_fi:': {
            unicode: ['1f1eb-1f1ee'],
            fname: '1f1eb-1f1ee',
            uc: '1f1eb-1f1ee',
            isCanonical: !0
        },
        ':fi:': {
            unicode: ['1f1eb-1f1ee'],
            fname: '1f1eb-1f1ee',
            uc: '1f1eb-1f1ee',
            isCanonical: !1
        },
        ':flag_eu:': {
            unicode: ['1f1ea-1f1fa'],
            fname: '1f1ea-1f1fa',
            uc: '1f1ea-1f1fa',
            isCanonical: !0
        },
        ':eu:': {
            unicode: ['1f1ea-1f1fa'],
            fname: '1f1ea-1f1fa',
            uc: '1f1ea-1f1fa',
            isCanonical: !1
        },
        ':flag_et:': {
            unicode: ['1f1ea-1f1f9'],
            fname: '1f1ea-1f1f9',
            uc: '1f1ea-1f1f9',
            isCanonical: !0
        },
        ':et:': {
            unicode: ['1f1ea-1f1f9'],
            fname: '1f1ea-1f1f9',
            uc: '1f1ea-1f1f9',
            isCanonical: !1
        },
        ':flag_es:': {
            unicode: ['1f1ea-1f1f8'],
            fname: '1f1ea-1f1f8',
            uc: '1f1ea-1f1f8',
            isCanonical: !0
        },
        ':es:': {
            unicode: ['1f1ea-1f1f8'],
            fname: '1f1ea-1f1f8',
            uc: '1f1ea-1f1f8',
            isCanonical: !1
        },
        ':flag_er:': {
            unicode: ['1f1ea-1f1f7'],
            fname: '1f1ea-1f1f7',
            uc: '1f1ea-1f1f7',
            isCanonical: !0
        },
        ':er:': {
            unicode: ['1f1ea-1f1f7'],
            fname: '1f1ea-1f1f7',
            uc: '1f1ea-1f1f7',
            isCanonical: !1
        },
        ':flag_eh:': {
            unicode: ['1f1ea-1f1ed'],
            fname: '1f1ea-1f1ed',
            uc: '1f1ea-1f1ed',
            isCanonical: !0
        },
        ':eh:': {
            unicode: ['1f1ea-1f1ed'],
            fname: '1f1ea-1f1ed',
            uc: '1f1ea-1f1ed',
            isCanonical: !1
        },
        ':flag_eg:': {
            unicode: ['1f1ea-1f1ec'],
            fname: '1f1ea-1f1ec',
            uc: '1f1ea-1f1ec',
            isCanonical: !0
        },
        ':eg:': {
            unicode: ['1f1ea-1f1ec'],
            fname: '1f1ea-1f1ec',
            uc: '1f1ea-1f1ec',
            isCanonical: !1
        },
        ':flag_ee:': {
            unicode: ['1f1ea-1f1ea'],
            fname: '1f1ea-1f1ea',
            uc: '1f1ea-1f1ea',
            isCanonical: !0
        },
        ':ee:': {
            unicode: ['1f1ea-1f1ea'],
            fname: '1f1ea-1f1ea',
            uc: '1f1ea-1f1ea',
            isCanonical: !1
        },
        ':flag_ec:': {
            unicode: ['1f1ea-1f1e8'],
            fname: '1f1ea-1f1e8',
            uc: '1f1ea-1f1e8',
            isCanonical: !0
        },
        ':ec:': {
            unicode: ['1f1ea-1f1e8'],
            fname: '1f1ea-1f1e8',
            uc: '1f1ea-1f1e8',
            isCanonical: !1
        },
        ':flag_ea:': {
            unicode: ['1f1ea-1f1e6'],
            fname: '1f1ea-1f1e6',
            uc: '1f1ea-1f1e6',
            isCanonical: !0
        },
        ':ea:': {
            unicode: ['1f1ea-1f1e6'],
            fname: '1f1ea-1f1e6',
            uc: '1f1ea-1f1e6',
            isCanonical: !1
        },
        ':flag_dz:': {
            unicode: ['1f1e9-1f1ff'],
            fname: '1f1e9-1f1ff',
            uc: '1f1e9-1f1ff',
            isCanonical: !0
        },
        ':dz:': {
            unicode: ['1f1e9-1f1ff'],
            fname: '1f1e9-1f1ff',
            uc: '1f1e9-1f1ff',
            isCanonical: !1
        },
        ':flag_do:': {
            unicode: ['1f1e9-1f1f4'],
            fname: '1f1e9-1f1f4',
            uc: '1f1e9-1f1f4',
            isCanonical: !0
        },
        ':do:': {
            unicode: ['1f1e9-1f1f4'],
            fname: '1f1e9-1f1f4',
            uc: '1f1e9-1f1f4',
            isCanonical: !1
        },
        ':flag_dm:': {
            unicode: ['1f1e9-1f1f2'],
            fname: '1f1e9-1f1f2',
            uc: '1f1e9-1f1f2',
            isCanonical: !0
        },
        ':dm:': {
            unicode: ['1f1e9-1f1f2'],
            fname: '1f1e9-1f1f2',
            uc: '1f1e9-1f1f2',
            isCanonical: !1
        },
        ':flag_dk:': {
            unicode: ['1f1e9-1f1f0'],
            fname: '1f1e9-1f1f0',
            uc: '1f1e9-1f1f0',
            isCanonical: !0
        },
        ':dk:': {
            unicode: ['1f1e9-1f1f0'],
            fname: '1f1e9-1f1f0',
            uc: '1f1e9-1f1f0',
            isCanonical: !1
        },
        ':flag_dj:': {
            unicode: ['1f1e9-1f1ef'],
            fname: '1f1e9-1f1ef',
            uc: '1f1e9-1f1ef',
            isCanonical: !0
        },
        ':dj:': {
            unicode: ['1f1e9-1f1ef'],
            fname: '1f1e9-1f1ef',
            uc: '1f1e9-1f1ef',
            isCanonical: !1
        },
        ':flag_dg:': {
            unicode: ['1f1e9-1f1ec'],
            fname: '1f1e9-1f1ec',
            uc: '1f1e9-1f1ec',
            isCanonical: !0
        },
        ':dg:': {
            unicode: ['1f1e9-1f1ec'],
            fname: '1f1e9-1f1ec',
            uc: '1f1e9-1f1ec',
            isCanonical: !1
        },
        ':flag_de:': {
            unicode: ['1f1e9-1f1ea'],
            fname: '1f1e9-1f1ea',
            uc: '1f1e9-1f1ea',
            isCanonical: !0
        },
        ':de:': {
            unicode: ['1f1e9-1f1ea'],
            fname: '1f1e9-1f1ea',
            uc: '1f1e9-1f1ea',
            isCanonical: !1
        },
        ':flag_cz:': {
            unicode: ['1f1e8-1f1ff'],
            fname: '1f1e8-1f1ff',
            uc: '1f1e8-1f1ff',
            isCanonical: !0
        },
        ':cz:': {
            unicode: ['1f1e8-1f1ff'],
            fname: '1f1e8-1f1ff',
            uc: '1f1e8-1f1ff',
            isCanonical: !1
        },
        ':flag_cy:': {
            unicode: ['1f1e8-1f1fe'],
            fname: '1f1e8-1f1fe',
            uc: '1f1e8-1f1fe',
            isCanonical: !0
        },
        ':cy:': {
            unicode: ['1f1e8-1f1fe'],
            fname: '1f1e8-1f1fe',
            uc: '1f1e8-1f1fe',
            isCanonical: !1
        },
        ':flag_cx:': {
            unicode: ['1f1e8-1f1fd'],
            fname: '1f1e8-1f1fd',
            uc: '1f1e8-1f1fd',
            isCanonical: !0
        },
        ':cx:': {
            unicode: ['1f1e8-1f1fd'],
            fname: '1f1e8-1f1fd',
            uc: '1f1e8-1f1fd',
            isCanonical: !1
        },
        ':flag_cw:': {
            unicode: ['1f1e8-1f1fc'],
            fname: '1f1e8-1f1fc',
            uc: '1f1e8-1f1fc',
            isCanonical: !0
        },
        ':cw:': {
            unicode: ['1f1e8-1f1fc'],
            fname: '1f1e8-1f1fc',
            uc: '1f1e8-1f1fc',
            isCanonical: !1
        },
        ':flag_cv:': {
            unicode: ['1f1e8-1f1fb'],
            fname: '1f1e8-1f1fb',
            uc: '1f1e8-1f1fb',
            isCanonical: !0
        },
        ':cv:': {
            unicode: ['1f1e8-1f1fb'],
            fname: '1f1e8-1f1fb',
            uc: '1f1e8-1f1fb',
            isCanonical: !1
        },
        ':flag_cu:': {
            unicode: ['1f1e8-1f1fa'],
            fname: '1f1e8-1f1fa',
            uc: '1f1e8-1f1fa',
            isCanonical: !0
        },
        ':cu:': {
            unicode: ['1f1e8-1f1fa'],
            fname: '1f1e8-1f1fa',
            uc: '1f1e8-1f1fa',
            isCanonical: !1
        },
        ':flag_cr:': {
            unicode: ['1f1e8-1f1f7'],
            fname: '1f1e8-1f1f7',
            uc: '1f1e8-1f1f7',
            isCanonical: !0
        },
        ':cr:': {
            unicode: ['1f1e8-1f1f7'],
            fname: '1f1e8-1f1f7',
            uc: '1f1e8-1f1f7',
            isCanonical: !1
        },
        ':flag_cp:': {
            unicode: ['1f1e8-1f1f5'],
            fname: '1f1e8-1f1f5',
            uc: '1f1e8-1f1f5',
            isCanonical: !0
        },
        ':cp:': {
            unicode: ['1f1e8-1f1f5'],
            fname: '1f1e8-1f1f5',
            uc: '1f1e8-1f1f5',
            isCanonical: !1
        },
        ':flag_co:': {
            unicode: ['1f1e8-1f1f4'],
            fname: '1f1e8-1f1f4',
            uc: '1f1e8-1f1f4',
            isCanonical: !0
        },
        ':co:': {
            unicode: ['1f1e8-1f1f4'],
            fname: '1f1e8-1f1f4',
            uc: '1f1e8-1f1f4',
            isCanonical: !1
        },
        ':flag_cn:': {
            unicode: ['1f1e8-1f1f3'],
            fname: '1f1e8-1f1f3',
            uc: '1f1e8-1f1f3',
            isCanonical: !0
        },
        ':cn:': {
            unicode: ['1f1e8-1f1f3'],
            fname: '1f1e8-1f1f3',
            uc: '1f1e8-1f1f3',
            isCanonical: !1
        },
        ':flag_cm:': {
            unicode: ['1f1e8-1f1f2'],
            fname: '1f1e8-1f1f2',
            uc: '1f1e8-1f1f2',
            isCanonical: !0
        },
        ':cm:': {
            unicode: ['1f1e8-1f1f2'],
            fname: '1f1e8-1f1f2',
            uc: '1f1e8-1f1f2',
            isCanonical: !1
        },
        ':flag_cl:': {
            unicode: ['1f1e8-1f1f1'],
            fname: '1f1e8-1f1f1',
            uc: '1f1e8-1f1f1',
            isCanonical: !0
        },
        ':chile:': {
            unicode: ['1f1e8-1f1f1'],
            fname: '1f1e8-1f1f1',
            uc: '1f1e8-1f1f1',
            isCanonical: !1
        },
        ':flag_ck:': {
            unicode: ['1f1e8-1f1f0'],
            fname: '1f1e8-1f1f0',
            uc: '1f1e8-1f1f0',
            isCanonical: !0
        },
        ':ck:': {
            unicode: ['1f1e8-1f1f0'],
            fname: '1f1e8-1f1f0',
            uc: '1f1e8-1f1f0',
            isCanonical: !1
        },
        ':flag_ci:': {
            unicode: ['1f1e8-1f1ee'],
            fname: '1f1e8-1f1ee',
            uc: '1f1e8-1f1ee',
            isCanonical: !0
        },
        ':ci:': {
            unicode: ['1f1e8-1f1ee'],
            fname: '1f1e8-1f1ee',
            uc: '1f1e8-1f1ee',
            isCanonical: !1
        },
        ':flag_ch:': {
            unicode: ['1f1e8-1f1ed'],
            fname: '1f1e8-1f1ed',
            uc: '1f1e8-1f1ed',
            isCanonical: !0
        },
        ':ch:': {
            unicode: ['1f1e8-1f1ed'],
            fname: '1f1e8-1f1ed',
            uc: '1f1e8-1f1ed',
            isCanonical: !1
        },
        ':flag_cg:': {
            unicode: ['1f1e8-1f1ec'],
            fname: '1f1e8-1f1ec',
            uc: '1f1e8-1f1ec',
            isCanonical: !0
        },
        ':cg:': {
            unicode: ['1f1e8-1f1ec'],
            fname: '1f1e8-1f1ec',
            uc: '1f1e8-1f1ec',
            isCanonical: !1
        },
        ':flag_cf:': {
            unicode: ['1f1e8-1f1eb'],
            fname: '1f1e8-1f1eb',
            uc: '1f1e8-1f1eb',
            isCanonical: !0
        },
        ':cf:': {
            unicode: ['1f1e8-1f1eb'],
            fname: '1f1e8-1f1eb',
            uc: '1f1e8-1f1eb',
            isCanonical: !1
        },
        ':flag_cd:': {
            unicode: ['1f1e8-1f1e9'],
            fname: '1f1e8-1f1e9',
            uc: '1f1e8-1f1e9',
            isCanonical: !0
        },
        ':congo:': {
            unicode: ['1f1e8-1f1e9'],
            fname: '1f1e8-1f1e9',
            uc: '1f1e8-1f1e9',
            isCanonical: !1
        },
        ':flag_cc:': {
            unicode: ['1f1e8-1f1e8'],
            fname: '1f1e8-1f1e8',
            uc: '1f1e8-1f1e8',
            isCanonical: !0
        },
        ':cc:': {
            unicode: ['1f1e8-1f1e8'],
            fname: '1f1e8-1f1e8',
            uc: '1f1e8-1f1e8',
            isCanonical: !1
        },
        ':flag_ca:': {
            unicode: ['1f1e8-1f1e6'],
            fname: '1f1e8-1f1e6',
            uc: '1f1e8-1f1e6',
            isCanonical: !0
        },
        ':ca:': {
            unicode: ['1f1e8-1f1e6'],
            fname: '1f1e8-1f1e6',
            uc: '1f1e8-1f1e6',
            isCanonical: !1
        },
        ':flag_bz:': {
            unicode: ['1f1e7-1f1ff'],
            fname: '1f1e7-1f1ff',
            uc: '1f1e7-1f1ff',
            isCanonical: !0
        },
        ':bz:': {
            unicode: ['1f1e7-1f1ff'],
            fname: '1f1e7-1f1ff',
            uc: '1f1e7-1f1ff',
            isCanonical: !1
        },
        ':flag_by:': {
            unicode: ['1f1e7-1f1fe'],
            fname: '1f1e7-1f1fe',
            uc: '1f1e7-1f1fe',
            isCanonical: !0
        },
        ':by:': {
            unicode: ['1f1e7-1f1fe'],
            fname: '1f1e7-1f1fe',
            uc: '1f1e7-1f1fe',
            isCanonical: !1
        },
        ':flag_bw:': {
            unicode: ['1f1e7-1f1fc'],
            fname: '1f1e7-1f1fc',
            uc: '1f1e7-1f1fc',
            isCanonical: !0
        },
        ':bw:': {
            unicode: ['1f1e7-1f1fc'],
            fname: '1f1e7-1f1fc',
            uc: '1f1e7-1f1fc',
            isCanonical: !1
        },
        ':flag_bv:': {
            unicode: ['1f1e7-1f1fb'],
            fname: '1f1e7-1f1fb',
            uc: '1f1e7-1f1fb',
            isCanonical: !0
        },
        ':bv:': {
            unicode: ['1f1e7-1f1fb'],
            fname: '1f1e7-1f1fb',
            uc: '1f1e7-1f1fb',
            isCanonical: !1
        },
        ':flag_bt:': {
            unicode: ['1f1e7-1f1f9'],
            fname: '1f1e7-1f1f9',
            uc: '1f1e7-1f1f9',
            isCanonical: !0
        },
        ':bt:': {
            unicode: ['1f1e7-1f1f9'],
            fname: '1f1e7-1f1f9',
            uc: '1f1e7-1f1f9',
            isCanonical: !1
        },
        ':flag_bs:': {
            unicode: ['1f1e7-1f1f8'],
            fname: '1f1e7-1f1f8',
            uc: '1f1e7-1f1f8',
            isCanonical: !0
        },
        ':bs:': {
            unicode: ['1f1e7-1f1f8'],
            fname: '1f1e7-1f1f8',
            uc: '1f1e7-1f1f8',
            isCanonical: !1
        },
        ':flag_br:': {
            unicode: ['1f1e7-1f1f7'],
            fname: '1f1e7-1f1f7',
            uc: '1f1e7-1f1f7',
            isCanonical: !0
        },
        ':br:': {
            unicode: ['1f1e7-1f1f7'],
            fname: '1f1e7-1f1f7',
            uc: '1f1e7-1f1f7',
            isCanonical: !1
        },
        ':flag_bq:': {
            unicode: ['1f1e7-1f1f6'],
            fname: '1f1e7-1f1f6',
            uc: '1f1e7-1f1f6',
            isCanonical: !0
        },
        ':bq:': {
            unicode: ['1f1e7-1f1f6'],
            fname: '1f1e7-1f1f6',
            uc: '1f1e7-1f1f6',
            isCanonical: !1
        },
        ':flag_bo:': {
            unicode: ['1f1e7-1f1f4'],
            fname: '1f1e7-1f1f4',
            uc: '1f1e7-1f1f4',
            isCanonical: !0
        },
        ':bo:': {
            unicode: ['1f1e7-1f1f4'],
            fname: '1f1e7-1f1f4',
            uc: '1f1e7-1f1f4',
            isCanonical: !1
        },
        ':flag_bn:': {
            unicode: ['1f1e7-1f1f3'],
            fname: '1f1e7-1f1f3',
            uc: '1f1e7-1f1f3',
            isCanonical: !0
        },
        ':bn:': {
            unicode: ['1f1e7-1f1f3'],
            fname: '1f1e7-1f1f3',
            uc: '1f1e7-1f1f3',
            isCanonical: !1
        },
        ':flag_bm:': {
            unicode: ['1f1e7-1f1f2'],
            fname: '1f1e7-1f1f2',
            uc: '1f1e7-1f1f2',
            isCanonical: !0
        },
        ':bm:': {
            unicode: ['1f1e7-1f1f2'],
            fname: '1f1e7-1f1f2',
            uc: '1f1e7-1f1f2',
            isCanonical: !1
        },
        ':flag_bl:': {
            unicode: ['1f1e7-1f1f1'],
            fname: '1f1e7-1f1f1',
            uc: '1f1e7-1f1f1',
            isCanonical: !0
        },
        ':bl:': {
            unicode: ['1f1e7-1f1f1'],
            fname: '1f1e7-1f1f1',
            uc: '1f1e7-1f1f1',
            isCanonical: !1
        },
        ':flag_bj:': {
            unicode: ['1f1e7-1f1ef'],
            fname: '1f1e7-1f1ef',
            uc: '1f1e7-1f1ef',
            isCanonical: !0
        },
        ':bj:': {
            unicode: ['1f1e7-1f1ef'],
            fname: '1f1e7-1f1ef',
            uc: '1f1e7-1f1ef',
            isCanonical: !1
        },
        ':flag_bi:': {
            unicode: ['1f1e7-1f1ee'],
            fname: '1f1e7-1f1ee',
            uc: '1f1e7-1f1ee',
            isCanonical: !0
        },
        ':bi:': {
            unicode: ['1f1e7-1f1ee'],
            fname: '1f1e7-1f1ee',
            uc: '1f1e7-1f1ee',
            isCanonical: !1
        },
        ':flag_bh:': {
            unicode: ['1f1e7-1f1ed'],
            fname: '1f1e7-1f1ed',
            uc: '1f1e7-1f1ed',
            isCanonical: !0
        },
        ':bh:': {
            unicode: ['1f1e7-1f1ed'],
            fname: '1f1e7-1f1ed',
            uc: '1f1e7-1f1ed',
            isCanonical: !1
        },
        ':flag_bg:': {
            unicode: ['1f1e7-1f1ec'],
            fname: '1f1e7-1f1ec',
            uc: '1f1e7-1f1ec',
            isCanonical: !0
        },
        ':bg:': {
            unicode: ['1f1e7-1f1ec'],
            fname: '1f1e7-1f1ec',
            uc: '1f1e7-1f1ec',
            isCanonical: !1
        },
        ':flag_bf:': {
            unicode: ['1f1e7-1f1eb'],
            fname: '1f1e7-1f1eb',
            uc: '1f1e7-1f1eb',
            isCanonical: !0
        },
        ':bf:': {
            unicode: ['1f1e7-1f1eb'],
            fname: '1f1e7-1f1eb',
            uc: '1f1e7-1f1eb',
            isCanonical: !1
        },
        ':flag_be:': {
            unicode: ['1f1e7-1f1ea'],
            fname: '1f1e7-1f1ea',
            uc: '1f1e7-1f1ea',
            isCanonical: !0
        },
        ':be:': {
            unicode: ['1f1e7-1f1ea'],
            fname: '1f1e7-1f1ea',
            uc: '1f1e7-1f1ea',
            isCanonical: !1
        },
        ':flag_bd:': {
            unicode: ['1f1e7-1f1e9'],
            fname: '1f1e7-1f1e9',
            uc: '1f1e7-1f1e9',
            isCanonical: !0
        },
        ':bd:': {
            unicode: ['1f1e7-1f1e9'],
            fname: '1f1e7-1f1e9',
            uc: '1f1e7-1f1e9',
            isCanonical: !1
        },
        ':flag_bb:': {
            unicode: ['1f1e7-1f1e7'],
            fname: '1f1e7-1f1e7',
            uc: '1f1e7-1f1e7',
            isCanonical: !0
        },
        ':bb:': {
            unicode: ['1f1e7-1f1e7'],
            fname: '1f1e7-1f1e7',
            uc: '1f1e7-1f1e7',
            isCanonical: !1
        },
        ':flag_ba:': {
            unicode: ['1f1e7-1f1e6'],
            fname: '1f1e7-1f1e6',
            uc: '1f1e7-1f1e6',
            isCanonical: !0
        },
        ':ba:': {
            unicode: ['1f1e7-1f1e6'],
            fname: '1f1e7-1f1e6',
            uc: '1f1e7-1f1e6',
            isCanonical: !1
        },
        ':flag_az:': {
            unicode: ['1f1e6-1f1ff'],
            fname: '1f1e6-1f1ff',
            uc: '1f1e6-1f1ff',
            isCanonical: !0
        },
        ':az:': {
            unicode: ['1f1e6-1f1ff'],
            fname: '1f1e6-1f1ff',
            uc: '1f1e6-1f1ff',
            isCanonical: !1
        },
        ':flag_ax:': {
            unicode: ['1f1e6-1f1fd'],
            fname: '1f1e6-1f1fd',
            uc: '1f1e6-1f1fd',
            isCanonical: !0
        },
        ':ax:': {
            unicode: ['1f1e6-1f1fd'],
            fname: '1f1e6-1f1fd',
            uc: '1f1e6-1f1fd',
            isCanonical: !1
        },
        ':flag_aw:': {
            unicode: ['1f1e6-1f1fc'],
            fname: '1f1e6-1f1fc',
            uc: '1f1e6-1f1fc',
            isCanonical: !0
        },
        ':aw:': {
            unicode: ['1f1e6-1f1fc'],
            fname: '1f1e6-1f1fc',
            uc: '1f1e6-1f1fc',
            isCanonical: !1
        },
        ':flag_au:': {
            unicode: ['1f1e6-1f1fa'],
            fname: '1f1e6-1f1fa',
            uc: '1f1e6-1f1fa',
            isCanonical: !0
        },
        ':au:': {
            unicode: ['1f1e6-1f1fa'],
            fname: '1f1e6-1f1fa',
            uc: '1f1e6-1f1fa',
            isCanonical: !1
        },
        ':flag_at:': {
            unicode: ['1f1e6-1f1f9'],
            fname: '1f1e6-1f1f9',
            uc: '1f1e6-1f1f9',
            isCanonical: !0
        },
        ':at:': {
            unicode: ['1f1e6-1f1f9'],
            fname: '1f1e6-1f1f9',
            uc: '1f1e6-1f1f9',
            isCanonical: !1
        },
        ':flag_as:': {
            unicode: ['1f1e6-1f1f8'],
            fname: '1f1e6-1f1f8',
            uc: '1f1e6-1f1f8',
            isCanonical: !0
        },
        ':as:': {
            unicode: ['1f1e6-1f1f8'],
            fname: '1f1e6-1f1f8',
            uc: '1f1e6-1f1f8',
            isCanonical: !1
        },
        ':flag_ar:': {
            unicode: ['1f1e6-1f1f7'],
            fname: '1f1e6-1f1f7',
            uc: '1f1e6-1f1f7',
            isCanonical: !0
        },
        ':ar:': {
            unicode: ['1f1e6-1f1f7'],
            fname: '1f1e6-1f1f7',
            uc: '1f1e6-1f1f7',
            isCanonical: !1
        },
        ':flag_aq:': {
            unicode: ['1f1e6-1f1f6'],
            fname: '1f1e6-1f1f6',
            uc: '1f1e6-1f1f6',
            isCanonical: !0
        },
        ':aq:': {
            unicode: ['1f1e6-1f1f6'],
            fname: '1f1e6-1f1f6',
            uc: '1f1e6-1f1f6',
            isCanonical: !1
        },
        ':flag_ao:': {
            unicode: ['1f1e6-1f1f4'],
            fname: '1f1e6-1f1f4',
            uc: '1f1e6-1f1f4',
            isCanonical: !0
        },
        ':ao:': {
            unicode: ['1f1e6-1f1f4'],
            fname: '1f1e6-1f1f4',
            uc: '1f1e6-1f1f4',
            isCanonical: !1
        },
        ':flag_am:': {
            unicode: ['1f1e6-1f1f2'],
            fname: '1f1e6-1f1f2',
            uc: '1f1e6-1f1f2',
            isCanonical: !0
        },
        ':am:': {
            unicode: ['1f1e6-1f1f2'],
            fname: '1f1e6-1f1f2',
            uc: '1f1e6-1f1f2',
            isCanonical: !1
        },
        ':flag_al:': {
            unicode: ['1f1e6-1f1f1'],
            fname: '1f1e6-1f1f1',
            uc: '1f1e6-1f1f1',
            isCanonical: !0
        },
        ':al:': {
            unicode: ['1f1e6-1f1f1'],
            fname: '1f1e6-1f1f1',
            uc: '1f1e6-1f1f1',
            isCanonical: !1
        },
        ':flag_ai:': {
            unicode: ['1f1e6-1f1ee'],
            fname: '1f1e6-1f1ee',
            uc: '1f1e6-1f1ee',
            isCanonical: !0
        },
        ':ai:': {
            unicode: ['1f1e6-1f1ee'],
            fname: '1f1e6-1f1ee',
            uc: '1f1e6-1f1ee',
            isCanonical: !1
        },
        ':flag_ag:': {
            unicode: ['1f1e6-1f1ec'],
            fname: '1f1e6-1f1ec',
            uc: '1f1e6-1f1ec',
            isCanonical: !0
        },
        ':ag:': {
            unicode: ['1f1e6-1f1ec'],
            fname: '1f1e6-1f1ec',
            uc: '1f1e6-1f1ec',
            isCanonical: !1
        },
        ':flag_af:': {
            unicode: ['1f1e6-1f1eb'],
            fname: '1f1e6-1f1eb',
            uc: '1f1e6-1f1eb',
            isCanonical: !0
        },
        ':af:': {
            unicode: ['1f1e6-1f1eb'],
            fname: '1f1e6-1f1eb',
            uc: '1f1e6-1f1eb',
            isCanonical: !1
        },
        ':flag_ae:': {
            unicode: ['1f1e6-1f1ea'],
            fname: '1f1e6-1f1ea',
            uc: '1f1e6-1f1ea',
            isCanonical: !0
        },
        ':ae:': {
            unicode: ['1f1e6-1f1ea'],
            fname: '1f1e6-1f1ea',
            uc: '1f1e6-1f1ea',
            isCanonical: !1
        },
        ':flag_ad:': {
            unicode: ['1f1e6-1f1e9'],
            fname: '1f1e6-1f1e9',
            uc: '1f1e6-1f1e9',
            isCanonical: !0
        },
        ':ad:': {
            unicode: ['1f1e6-1f1e9'],
            fname: '1f1e6-1f1e9',
            uc: '1f1e6-1f1e9',
            isCanonical: !1
        },
        ':flag_ac:': {
            unicode: ['1f1e6-1f1e8'],
            fname: '1f1e6-1f1e8',
            uc: '1f1e6-1f1e8',
            isCanonical: !0
        },
        ':ac:': {
            unicode: ['1f1e6-1f1e8'],
            fname: '1f1e6-1f1e8',
            uc: '1f1e6-1f1e8',
            isCanonical: !1
        },
        ':mahjong:': {
            unicode: ['1f004-fe0f', '1f004'],
            fname: '1f004',
            uc: '1f004',
            isCanonical: !0
        },
        ':parking:': {
            unicode: ['1f17f-fe0f', '1f17f'],
            fname: '1f17f',
            uc: '1f17f',
            isCanonical: !0
        },
        ':sa:': {
            unicode: ['1f202-fe0f', '1f202'],
            fname: '1f202',
            uc: '1f202',
            isCanonical: !0
        },
        ':u7121:': {
            unicode: ['1f21a-fe0f', '1f21a'],
            fname: '1f21a',
            uc: '1f21a',
            isCanonical: !0
        },
        ':u6307:': {
            unicode: ['1f22f-fe0f', '1f22f'],
            fname: '1f22f',
            uc: '1f22f',
            isCanonical: !0
        },
        ':u6708:': {
            unicode: ['1f237-fe0f', '1f237'],
            fname: '1f237',
            uc: '1f237',
            isCanonical: !0
        },
        ':film_frames:': {
            unicode: ['1f39e-fe0f', '1f39e'],
            fname: '1f39e',
            uc: '1f39e',
            isCanonical: !0
        },
        ':tickets:': {
            unicode: ['1f39f-fe0f', '1f39f'],
            fname: '1f39f',
            uc: '1f39f',
            isCanonical: !0
        },
        ':admission_tickets:': {
            unicode: ['1f39f-fe0f', '1f39f'],
            fname: '1f39f',
            uc: '1f39f',
            isCanonical: !1
        },
        ':lifter:': {
            unicode: ['1f3cb-fe0f', '1f3cb'],
            fname: '1f3cb',
            uc: '1f3cb',
            isCanonical: !0
        },
        ':weight_lifter:': {
            unicode: ['1f3cb-fe0f', '1f3cb'],
            fname: '1f3cb',
            uc: '1f3cb',
            isCanonical: !1
        },
        ':golfer:': {
            unicode: ['1f3cc-fe0f', '1f3cc'],
            fname: '1f3cc',
            uc: '1f3cc',
            isCanonical: !0
        },
        ':motorcycle:': {
            unicode: ['1f3cd-fe0f', '1f3cd'],
            fname: '1f3cd',
            uc: '1f3cd',
            isCanonical: !0
        },
        ':racing_motorcycle:': {
            unicode: ['1f3cd-fe0f', '1f3cd'],
            fname: '1f3cd',
            uc: '1f3cd',
            isCanonical: !1
        },
        ':race_car:': {
            unicode: ['1f3ce-fe0f', '1f3ce'],
            fname: '1f3ce',
            uc: '1f3ce',
            isCanonical: !0
        },
        ':racing_car:': {
            unicode: ['1f3ce-fe0f', '1f3ce'],
            fname: '1f3ce',
            uc: '1f3ce',
            isCanonical: !1
        },
        ':military_medal:': {
            unicode: ['1f396-fe0f', '1f396'],
            fname: '1f396',
            uc: '1f396',
            isCanonical: !0
        },
        ':reminder_ribbon:': {
            unicode: ['1f397-fe0f', '1f397'],
            fname: '1f397',
            uc: '1f397',
            isCanonical: !0
        },
        ':hot_pepper:': {
            unicode: ['1f336-fe0f', '1f336'],
            fname: '1f336',
            uc: '1f336',
            isCanonical: !0
        },
        ':cloud_rain:': {
            unicode: ['1f327-fe0f', '1f327'],
            fname: '1f327',
            uc: '1f327',
            isCanonical: !0
        },
        ':cloud_with_rain:': {
            unicode: ['1f327-fe0f', '1f327'],
            fname: '1f327',
            uc: '1f327',
            isCanonical: !1
        },
        ':cloud_snow:': {
            unicode: ['1f328-fe0f', '1f328'],
            fname: '1f328',
            uc: '1f328',
            isCanonical: !0
        },
        ':cloud_with_snow:': {
            unicode: ['1f328-fe0f', '1f328'],
            fname: '1f328',
            uc: '1f328',
            isCanonical: !1
        },
        ':cloud_lightning:': {
            unicode: ['1f329-fe0f', '1f329'],
            fname: '1f329',
            uc: '1f329',
            isCanonical: !0
        },
        ':cloud_with_lightning:': {
            unicode: ['1f329-fe0f', '1f329'],
            fname: '1f329',
            uc: '1f329',
            isCanonical: !1
        },
        ':cloud_tornado:': {
            unicode: ['1f32a-fe0f', '1f32a'],
            fname: '1f32a',
            uc: '1f32a',
            isCanonical: !0
        },
        ':cloud_with_tornado:': {
            unicode: ['1f32a-fe0f', '1f32a'],
            fname: '1f32a',
            uc: '1f32a',
            isCanonical: !1
        },
        ':fog:': {
            unicode: ['1f32b-fe0f', '1f32b'],
            fname: '1f32b',
            uc: '1f32b',
            isCanonical: !0
        },
        ':wind_blowing_face:': {
            unicode: ['1f32c-fe0f', '1f32c'],
            fname: '1f32c',
            uc: '1f32c',
            isCanonical: !0
        },
        ':chipmunk:': {
            unicode: ['1f43f-fe0f', '1f43f'],
            fname: '1f43f',
            uc: '1f43f',
            isCanonical: !0
        },
        ':spider:': {
            unicode: ['1f577-fe0f', '1f577'],
            fname: '1f577',
            uc: '1f577',
            isCanonical: !0
        },
        ':spider_web:': {
            unicode: ['1f578-fe0f', '1f578'],
            fname: '1f578',
            uc: '1f578',
            isCanonical: !0
        },
        ':thermometer:': {
            unicode: ['1f321-fe0f', '1f321'],
            fname: '1f321',
            uc: '1f321',
            isCanonical: !0
        },
        ':microphone2:': {
            unicode: ['1f399-fe0f', '1f399'],
            fname: '1f399',
            uc: '1f399',
            isCanonical: !0
        },
        ':studio_microphone:': {
            unicode: ['1f399-fe0f', '1f399'],
            fname: '1f399',
            uc: '1f399',
            isCanonical: !1
        },
        ':level_slider:': {
            unicode: ['1f39a-fe0f', '1f39a'],
            fname: '1f39a',
            uc: '1f39a',
            isCanonical: !0
        },
        ':control_knobs:': {
            unicode: ['1f39b-fe0f', '1f39b'],
            fname: '1f39b',
            uc: '1f39b',
            isCanonical: !0
        },
        ':flag_white:': {
            unicode: ['1f3f3-fe0f', '1f3f3'],
            fname: '1f3f3',
            uc: '1f3f3',
            isCanonical: !0
        },
        ':waving_white_flag:': {
            unicode: ['1f3f3-fe0f', '1f3f3'],
            fname: '1f3f3',
            uc: '1f3f3',
            isCanonical: !1
        },
        ':rosette:': {
            unicode: ['1f3f5-fe0f', '1f3f5'],
            fname: '1f3f5',
            uc: '1f3f5',
            isCanonical: !0
        },
        ':label:': {
            unicode: ['1f3f7-fe0f', '1f3f7'],
            fname: '1f3f7',
            uc: '1f3f7',
            isCanonical: !0
        },
        ':projector:': {
            unicode: ['1f4fd-fe0f', '1f4fd'],
            fname: '1f4fd',
            uc: '1f4fd',
            isCanonical: !0
        },
        ':film_projector:': {
            unicode: ['1f4fd-fe0f', '1f4fd'],
            fname: '1f4fd',
            uc: '1f4fd',
            isCanonical: !1
        },
        ':om_symbol:': {
            unicode: ['1f549-fe0f', '1f549'],
            fname: '1f549',
            uc: '1f549',
            isCanonical: !0
        },
        ':dove:': {
            unicode: ['1f54a-fe0f', '1f54a'],
            fname: '1f54a',
            uc: '1f54a',
            isCanonical: !0
        },
        ':dove_of_peace:': {
            unicode: ['1f54a-fe0f', '1f54a'],
            fname: '1f54a',
            uc: '1f54a',
            isCanonical: !1
        },
        ':candle:': {
            unicode: ['1f56f-fe0f', '1f56f'],
            fname: '1f56f',
            uc: '1f56f',
            isCanonical: !0
        },
        ':clock:': {
            unicode: ['1f570-fe0f', '1f570'],
            fname: '1f570',
            uc: '1f570',
            isCanonical: !0
        },
        ':mantlepiece_clock:': {
            unicode: ['1f570-fe0f', '1f570'],
            fname: '1f570',
            uc: '1f570',
            isCanonical: !1
        },
        ':hole:': {
            unicode: ['1f573-fe0f', '1f573'],
            fname: '1f573',
            uc: '1f573',
            isCanonical: !0
        },
        ':dark_sunglasses:': {
            unicode: ['1f576-fe0f', '1f576'],
            fname: '1f576',
            uc: '1f576',
            isCanonical: !0
        },
        ':joystick:': {
            unicode: ['1f579-fe0f', '1f579'],
            fname: '1f579',
            uc: '1f579',
            isCanonical: !0
        },
        ':paperclips:': {
            unicode: ['1f587-fe0f', '1f587'],
            fname: '1f587',
            uc: '1f587',
            isCanonical: !0
        },
        ':linked_paperclips:': {
            unicode: ['1f587-fe0f', '1f587'],
            fname: '1f587',
            uc: '1f587',
            isCanonical: !1
        },
        ':pen_ballpoint:': {
            unicode: ['1f58a-fe0f', '1f58a'],
            fname: '1f58a',
            uc: '1f58a',
            isCanonical: !0
        },
        ':lower_left_ballpoint_pen:': {
            unicode: ['1f58a-fe0f', '1f58a'],
            fname: '1f58a',
            uc: '1f58a',
            isCanonical: !1
        },
        ':pen_fountain:': {
            unicode: ['1f58b-fe0f', '1f58b'],
            fname: '1f58b',
            uc: '1f58b',
            isCanonical: !0
        },
        ':lower_left_fountain_pen:': {
            unicode: ['1f58b-fe0f', '1f58b'],
            fname: '1f58b',
            uc: '1f58b',
            isCanonical: !1
        },
        ':paintbrush:': {
            unicode: ['1f58c-fe0f', '1f58c'],
            fname: '1f58c',
            uc: '1f58c',
            isCanonical: !0
        },
        ':lower_left_paintbrush:': {
            unicode: ['1f58c-fe0f', '1f58c'],
            fname: '1f58c',
            uc: '1f58c',
            isCanonical: !1
        },
        ':crayon:': {
            unicode: ['1f58d-fe0f', '1f58d'],
            fname: '1f58d',
            uc: '1f58d',
            isCanonical: !0
        },
        ':lower_left_crayon:': {
            unicode: ['1f58d-fe0f', '1f58d'],
            fname: '1f58d',
            uc: '1f58d',
            isCanonical: !1
        },
        ':desktop:': {
            unicode: ['1f5a5-fe0f', '1f5a5'],
            fname: '1f5a5',
            uc: '1f5a5',
            isCanonical: !0
        },
        ':desktop_computer:': {
            unicode: ['1f5a5-fe0f', '1f5a5'],
            fname: '1f5a5',
            uc: '1f5a5',
            isCanonical: !1
        },
        ':printer:': {
            unicode: ['1f5a8-fe0f', '1f5a8'],
            fname: '1f5a8',
            uc: '1f5a8',
            isCanonical: !0
        },
        ':trackball:': {
            unicode: ['1f5b2-fe0f', '1f5b2'],
            fname: '1f5b2',
            uc: '1f5b2',
            isCanonical: !0
        },
        ':frame_photo:': {
            unicode: ['1f5bc-fe0f', '1f5bc'],
            fname: '1f5bc',
            uc: '1f5bc',
            isCanonical: !0
        },
        ':frame_with_picture:': {
            unicode: ['1f5bc-fe0f', '1f5bc'],
            fname: '1f5bc',
            uc: '1f5bc',
            isCanonical: !1
        },
        ':dividers:': {
            unicode: ['1f5c2-fe0f', '1f5c2'],
            fname: '1f5c2',
            uc: '1f5c2',
            isCanonical: !0
        },
        ':card_index_dividers:': {
            unicode: ['1f5c2-fe0f', '1f5c2'],
            fname: '1f5c2',
            uc: '1f5c2',
            isCanonical: !1
        },
        ':card_box:': {
            unicode: ['1f5c3-fe0f', '1f5c3'],
            fname: '1f5c3',
            uc: '1f5c3',
            isCanonical: !0
        },
        ':card_file_box:': {
            unicode: ['1f5c3-fe0f', '1f5c3'],
            fname: '1f5c3',
            uc: '1f5c3',
            isCanonical: !1
        },
        ':file_cabinet:': {
            unicode: ['1f5c4-fe0f', '1f5c4'],
            fname: '1f5c4',
            uc: '1f5c4',
            isCanonical: !0
        },
        ':wastebasket:': {
            unicode: ['1f5d1-fe0f', '1f5d1'],
            fname: '1f5d1',
            uc: '1f5d1',
            isCanonical: !0
        },
        ':notepad_spiral:': {
            unicode: ['1f5d2-fe0f', '1f5d2'],
            fname: '1f5d2',
            uc: '1f5d2',
            isCanonical: !0
        },
        ':spiral_note_pad:': {
            unicode: ['1f5d2-fe0f', '1f5d2'],
            fname: '1f5d2',
            uc: '1f5d2',
            isCanonical: !1
        },
        ':calendar_spiral:': {
            unicode: ['1f5d3-fe0f', '1f5d3'],
            fname: '1f5d3',
            uc: '1f5d3',
            isCanonical: !0
        },
        ':spiral_calendar_pad:': {
            unicode: ['1f5d3-fe0f', '1f5d3'],
            fname: '1f5d3',
            uc: '1f5d3',
            isCanonical: !1
        },
        ':compression:': {
            unicode: ['1f5dc-fe0f', '1f5dc'],
            fname: '1f5dc',
            uc: '1f5dc',
            isCanonical: !0
        },
        ':key2:': {
            unicode: ['1f5dd-fe0f', '1f5dd'],
            fname: '1f5dd',
            uc: '1f5dd',
            isCanonical: !0
        },
        ':old_key:': {
            unicode: ['1f5dd-fe0f', '1f5dd'],
            fname: '1f5dd',
            uc: '1f5dd',
            isCanonical: !1
        },
        ':newspaper2:': {
            unicode: ['1f5de-fe0f', '1f5de'],
            fname: '1f5de',
            uc: '1f5de',
            isCanonical: !0
        },
        ':rolled_up_newspaper:': {
            unicode: ['1f5de-fe0f', '1f5de'],
            fname: '1f5de',
            uc: '1f5de',
            isCanonical: !1
        },
        ':dagger:': {
            unicode: ['1f5e1-fe0f', '1f5e1'],
            fname: '1f5e1',
            uc: '1f5e1',
            isCanonical: !0
        },
        ':dagger_knife:': {
            unicode: ['1f5e1-fe0f', '1f5e1'],
            fname: '1f5e1',
            uc: '1f5e1',
            isCanonical: !1
        },
        ':speaking_head:': {
            unicode: ['1f5e3-fe0f', '1f5e3'],
            fname: '1f5e3',
            uc: '1f5e3',
            isCanonical: !0
        },
        ':speaking_head_in_silhouette:': {
            unicode: ['1f5e3-fe0f', '1f5e3'],
            fname: '1f5e3',
            uc: '1f5e3',
            isCanonical: !1
        },
        ':speech_left:': {
            unicode: ['1f5e8-fe0f', '1f5e8'],
            fname: '1f5e8',
            uc: '1f5e8',
            isCanonical: !0
        },
        ':left_speech_bubble:': {
            unicode: ['1f5e8-fe0f', '1f5e8'],
            fname: '1f5e8',
            uc: '1f5e8',
            isCanonical: !1
        },
        ':anger_right:': {
            unicode: ['1f5ef-fe0f', '1f5ef'],
            fname: '1f5ef',
            uc: '1f5ef',
            isCanonical: !0
        },
        ':right_anger_bubble:': {
            unicode: ['1f5ef-fe0f', '1f5ef'],
            fname: '1f5ef',
            uc: '1f5ef',
            isCanonical: !1
        },
        ':ballot_box:': {
            unicode: ['1f5f3-fe0f', '1f5f3'],
            fname: '1f5f3',
            uc: '1f5f3',
            isCanonical: !0
        },
        ':ballot_box_with_ballot:': {
            unicode: ['1f5f3-fe0f', '1f5f3'],
            fname: '1f5f3',
            uc: '1f5f3',
            isCanonical: !1
        },
        ':map:': {
            unicode: ['1f5fa-fe0f', '1f5fa'],
            fname: '1f5fa',
            uc: '1f5fa',
            isCanonical: !0
        },
        ':world_map:': {
            unicode: ['1f5fa-fe0f', '1f5fa'],
            fname: '1f5fa',
            uc: '1f5fa',
            isCanonical: !1
        },
        ':tools:': {
            unicode: ['1f6e0-fe0f', '1f6e0'],
            fname: '1f6e0',
            uc: '1f6e0',
            isCanonical: !0
        },
        ':hammer_and_wrench:': {
            unicode: ['1f6e0-fe0f', '1f6e0'],
            fname: '1f6e0',
            uc: '1f6e0',
            isCanonical: !1
        },
        ':shield:': {
            unicode: ['1f6e1-fe0f', '1f6e1'],
            fname: '1f6e1',
            uc: '1f6e1',
            isCanonical: !0
        },
        ':oil:': {
            unicode: ['1f6e2-fe0f', '1f6e2'],
            fname: '1f6e2',
            uc: '1f6e2',
            isCanonical: !0
        },
        ':oil_drum:': {
            unicode: ['1f6e2-fe0f', '1f6e2'],
            fname: '1f6e2',
            uc: '1f6e2',
            isCanonical: !1
        },
        ':satellite_orbital:': {
            unicode: ['1f6f0-fe0f', '1f6f0'],
            fname: '1f6f0',
            uc: '1f6f0',
            isCanonical: !0
        },
        ':fork_knife_plate:': {
            unicode: ['1f37d-fe0f', '1f37d'],
            fname: '1f37d',
            uc: '1f37d',
            isCanonical: !0
        },
        ':fork_and_knife_with_plate:': {
            unicode: ['1f37d-fe0f', '1f37d'],
            fname: '1f37d',
            uc: '1f37d',
            isCanonical: !1
        },
        ':eye:': {
            unicode: ['1f441-fe0f', '1f441'],
            fname: '1f441',
            uc: '1f441',
            isCanonical: !0
        },
        ':levitate:': {
            unicode: ['1f574-fe0f', '1f574'],
            fname: '1f574',
            uc: '1f574',
            isCanonical: !0
        },
        ':man_in_business_suit_levitating:': {
            unicode: ['1f574-fe0f', '1f574'],
            fname: '1f574',
            uc: '1f574',
            isCanonical: !1
        },
        ':spy:': {
            unicode: ['1f575-fe0f', '1f575'],
            fname: '1f575',
            uc: '1f575',
            isCanonical: !0
        },
        ':sleuth_or_spy:': {
            unicode: ['1f575-fe0f', '1f575'],
            fname: '1f575',
            uc: '1f575',
            isCanonical: !1
        },
        ':hand_splayed:': {
            unicode: ['1f590-fe0f', '1f590'],
            fname: '1f590',
            uc: '1f590',
            isCanonical: !0
        },
        ':raised_hand_with_fingers_splayed:': {
            unicode: ['1f590-fe0f', '1f590'],
            fname: '1f590',
            uc: '1f590',
            isCanonical: !1
        },
        ':mountain_snow:': {
            unicode: ['1f3d4-fe0f', '1f3d4'],
            fname: '1f3d4',
            uc: '1f3d4',
            isCanonical: !0
        },
        ':snow_capped_mountain:': {
            unicode: ['1f3d4-fe0f', '1f3d4'],
            fname: '1f3d4',
            uc: '1f3d4',
            isCanonical: !1
        },
        ':camping:': {
            unicode: ['1f3d5-fe0f', '1f3d5'],
            fname: '1f3d5',
            uc: '1f3d5',
            isCanonical: !0
        },
        ':beach:': {
            unicode: ['1f3d6-fe0f', '1f3d6'],
            fname: '1f3d6',
            uc: '1f3d6',
            isCanonical: !0
        },
        ':beach_with_umbrella:': {
            unicode: ['1f3d6-fe0f', '1f3d6'],
            fname: '1f3d6',
            uc: '1f3d6',
            isCanonical: !1
        },
        ':construction_site:': {
            unicode: ['1f3d7-fe0f', '1f3d7'],
            fname: '1f3d7',
            uc: '1f3d7',
            isCanonical: !0
        },
        ':building_construction:': {
            unicode: ['1f3d7-fe0f', '1f3d7'],
            fname: '1f3d7',
            uc: '1f3d7',
            isCanonical: !1
        },
        ':homes:': {
            unicode: ['1f3d8-fe0f', '1f3d8'],
            fname: '1f3d8',
            uc: '1f3d8',
            isCanonical: !0
        },
        ':house_buildings:': {
            unicode: ['1f3d8-fe0f', '1f3d8'],
            fname: '1f3d8',
            uc: '1f3d8',
            isCanonical: !1
        },
        ':cityscape:': {
            unicode: ['1f3d9-fe0f', '1f3d9'],
            fname: '1f3d9',
            uc: '1f3d9',
            isCanonical: !0
        },
        ':house_abandoned:': {
            unicode: ['1f3da-fe0f', '1f3da'],
            fname: '1f3da',
            uc: '1f3da',
            isCanonical: !0
        },
        ':derelict_house_building:': {
            unicode: ['1f3da-fe0f', '1f3da'],
            fname: '1f3da',
            uc: '1f3da',
            isCanonical: !1
        },
        ':classical_building:': {
            unicode: ['1f3db-fe0f', '1f3db'],
            fname: '1f3db',
            uc: '1f3db',
            isCanonical: !0
        },
        ':desert:': {
            unicode: ['1f3dc-fe0f', '1f3dc'],
            fname: '1f3dc',
            uc: '1f3dc',
            isCanonical: !0
        },
        ':island:': {
            unicode: ['1f3dd-fe0f', '1f3dd'],
            fname: '1f3dd',
            uc: '1f3dd',
            isCanonical: !0
        },
        ':desert_island:': {
            unicode: ['1f3dd-fe0f', '1f3dd'],
            fname: '1f3dd',
            uc: '1f3dd',
            isCanonical: !1
        },
        ':park:': {
            unicode: ['1f3de-fe0f', '1f3de'],
            fname: '1f3de',
            uc: '1f3de',
            isCanonical: !0
        },
        ':national_park:': {
            unicode: ['1f3de-fe0f', '1f3de'],
            fname: '1f3de',
            uc: '1f3de',
            isCanonical: !1
        },
        ':stadium:': {
            unicode: ['1f3df-fe0f', '1f3df'],
            fname: '1f3df',
            uc: '1f3df',
            isCanonical: !0
        },
        ':couch:': {
            unicode: ['1f6cb-fe0f', '1f6cb'],
            fname: '1f6cb',
            uc: '1f6cb',
            isCanonical: !0
        },
        ':couch_and_lamp:': {
            unicode: ['1f6cb-fe0f', '1f6cb'],
            fname: '1f6cb',
            uc: '1f6cb',
            isCanonical: !1
        },
        ':shopping_bags:': {
            unicode: ['1f6cd-fe0f', '1f6cd'],
            fname: '1f6cd',
            uc: '1f6cd',
            isCanonical: !0
        },
        ':bellhop:': {
            unicode: ['1f6ce-fe0f', '1f6ce'],
            fname: '1f6ce',
            uc: '1f6ce',
            isCanonical: !0
        },
        ':bellhop_bell:': {
            unicode: ['1f6ce-fe0f', '1f6ce'],
            fname: '1f6ce',
            uc: '1f6ce',
            isCanonical: !1
        },
        ':bed:': {
            unicode: ['1f6cf-fe0f', '1f6cf'],
            fname: '1f6cf',
            uc: '1f6cf',
            isCanonical: !0
        },
        ':motorway:': {
            unicode: ['1f6e3-fe0f', '1f6e3'],
            fname: '1f6e3',
            uc: '1f6e3',
            isCanonical: !0
        },
        ':railway_track:': {
            unicode: ['1f6e4-fe0f', '1f6e4'],
            fname: '1f6e4',
            uc: '1f6e4',
            isCanonical: !0
        },
        ':railroad_track:': {
            unicode: ['1f6e4-fe0f', '1f6e4'],
            fname: '1f6e4',
            uc: '1f6e4',
            isCanonical: !1
        },
        ':motorboat:': {
            unicode: ['1f6e5-fe0f', '1f6e5'],
            fname: '1f6e5',
            uc: '1f6e5',
            isCanonical: !0
        },
        ':airplane_small:': {
            unicode: ['1f6e9-fe0f', '1f6e9'],
            fname: '1f6e9',
            uc: '1f6e9',
            isCanonical: !0
        },
        ':small_airplane:': {
            unicode: ['1f6e9-fe0f', '1f6e9'],
            fname: '1f6e9',
            uc: '1f6e9',
            isCanonical: !1
        },
        ':cruise_ship:': {
            unicode: ['1f6f3-fe0f', '1f6f3'],
            fname: '1f6f3',
            uc: '1f6f3',
            isCanonical: !0
        },
        ':passenger_ship:': {
            unicode: ['1f6f3-fe0f', '1f6f3'],
            fname: '1f6f3',
            uc: '1f6f3',
            isCanonical: !1
        },
        ':white_sun_small_cloud:': {
            unicode: ['1f324-fe0f', '1f324'],
            fname: '1f324',
            uc: '1f324',
            isCanonical: !0
        },
        ':white_sun_with_small_cloud:': {
            unicode: ['1f324-fe0f', '1f324'],
            fname: '1f324',
            uc: '1f324',
            isCanonical: !1
        },
        ':white_sun_cloud:': {
            unicode: ['1f325-fe0f', '1f325'],
            fname: '1f325',
            uc: '1f325',
            isCanonical: !0
        },
        ':white_sun_behind_cloud:': {
            unicode: ['1f325-fe0f', '1f325'],
            fname: '1f325',
            uc: '1f325',
            isCanonical: !1
        },
        ':white_sun_rain_cloud:': {
            unicode: ['1f326-fe0f', '1f326'],
            fname: '1f326',
            uc: '1f326',
            isCanonical: !0
        },
        ':white_sun_behind_cloud_with_rain:': {
            unicode: ['1f326-fe0f', '1f326'],
            fname: '1f326',
            uc: '1f326',
            isCanonical: !1
        },
        ':mouse_three_button:': {
            unicode: ['1f5b1-fe0f', '1f5b1'],
            fname: '1f5b1',
            uc: '1f5b1',
            isCanonical: !0
        },
        ':three_button_mouse:': {
            unicode: ['1f5b1-fe0f', '1f5b1'],
            fname: '1f5b1',
            uc: '1f5b1',
            isCanonical: !1
        },
        ':point_up_tone1:': {
            unicode: ['261d-1f3fb'],
            fname: '261d-1f3fb',
            uc: '261d-1f3fb',
            isCanonical: !0
        },
        ':point_up_tone2:': {
            unicode: ['261d-1f3fc'],
            fname: '261d-1f3fc',
            uc: '261d-1f3fc',
            isCanonical: !0
        },
        ':point_up_tone3:': {
            unicode: ['261d-1f3fd'],
            fname: '261d-1f3fd',
            uc: '261d-1f3fd',
            isCanonical: !0
        },
        ':point_up_tone4:': {
            unicode: ['261d-1f3fe'],
            fname: '261d-1f3fe',
            uc: '261d-1f3fe',
            isCanonical: !0
        },
        ':point_up_tone5:': {
            unicode: ['261d-1f3ff'],
            fname: '261d-1f3ff',
            uc: '261d-1f3ff',
            isCanonical: !0
        },
        ':v_tone1:': {
            unicode: ['270c-1f3fb'],
            fname: '270c-1f3fb',
            uc: '270c-1f3fb',
            isCanonical: !0
        },
        ':v_tone2:': {
            unicode: ['270c-1f3fc'],
            fname: '270c-1f3fc',
            uc: '270c-1f3fc',
            isCanonical: !0
        },
        ':v_tone3:': {
            unicode: ['270c-1f3fd'],
            fname: '270c-1f3fd',
            uc: '270c-1f3fd',
            isCanonical: !0
        },
        ':v_tone4:': {
            unicode: ['270c-1f3fe'],
            fname: '270c-1f3fe',
            uc: '270c-1f3fe',
            isCanonical: !0
        },
        ':v_tone5:': {
            unicode: ['270c-1f3ff'],
            fname: '270c-1f3ff',
            uc: '270c-1f3ff',
            isCanonical: !0
        },
        ':fist_tone1:': {
            unicode: ['270a-1f3fb'],
            fname: '270a-1f3fb',
            uc: '270a-1f3fb',
            isCanonical: !0
        },
        ':fist_tone2:': {
            unicode: ['270a-1f3fc'],
            fname: '270a-1f3fc',
            uc: '270a-1f3fc',
            isCanonical: !0
        },
        ':fist_tone3:': {
            unicode: ['270a-1f3fd'],
            fname: '270a-1f3fd',
            uc: '270a-1f3fd',
            isCanonical: !0
        },
        ':fist_tone4:': {
            unicode: ['270a-1f3fe'],
            fname: '270a-1f3fe',
            uc: '270a-1f3fe',
            isCanonical: !0
        },
        ':fist_tone5:': {
            unicode: ['270a-1f3ff'],
            fname: '270a-1f3ff',
            uc: '270a-1f3ff',
            isCanonical: !0
        },
        ':raised_hand_tone1:': {
            unicode: ['270b-1f3fb'],
            fname: '270b-1f3fb',
            uc: '270b-1f3fb',
            isCanonical: !0
        },
        ':raised_hand_tone2:': {
            unicode: ['270b-1f3fc'],
            fname: '270b-1f3fc',
            uc: '270b-1f3fc',
            isCanonical: !0
        },
        ':raised_hand_tone3:': {
            unicode: ['270b-1f3fd'],
            fname: '270b-1f3fd',
            uc: '270b-1f3fd',
            isCanonical: !0
        },
        ':raised_hand_tone4:': {
            unicode: ['270b-1f3fe'],
            fname: '270b-1f3fe',
            uc: '270b-1f3fe',
            isCanonical: !0
        },
        ':raised_hand_tone5:': {
            unicode: ['270b-1f3ff'],
            fname: '270b-1f3ff',
            uc: '270b-1f3ff',
            isCanonical: !0
        },
        ':writing_hand_tone1:': {
            unicode: ['270d-1f3fb'],
            fname: '270d-1f3fb',
            uc: '270d-1f3fb',
            isCanonical: !0
        },
        ':writing_hand_tone2:': {
            unicode: ['270d-1f3fc'],
            fname: '270d-1f3fc',
            uc: '270d-1f3fc',
            isCanonical: !0
        },
        ':writing_hand_tone3:': {
            unicode: ['270d-1f3fd'],
            fname: '270d-1f3fd',
            uc: '270d-1f3fd',
            isCanonical: !0
        },
        ':writing_hand_tone4:': {
            unicode: ['270d-1f3fe'],
            fname: '270d-1f3fe',
            uc: '270d-1f3fe',
            isCanonical: !0
        },
        ':writing_hand_tone5:': {
            unicode: ['270d-1f3ff'],
            fname: '270d-1f3ff',
            uc: '270d-1f3ff',
            isCanonical: !0
        },
        ':basketball_player_tone1:': {
            unicode: ['26f9-1f3fb'],
            fname: '26f9-1f3fb',
            uc: '26f9-1f3fb',
            isCanonical: !0
        },
        ':person_with_ball_tone1:': {
            unicode: ['26f9-1f3fb'],
            fname: '26f9-1f3fb',
            uc: '26f9-1f3fb',
            isCanonical: !1
        },
        ':basketball_player_tone2:': {
            unicode: ['26f9-1f3fc'],
            fname: '26f9-1f3fc',
            uc: '26f9-1f3fc',
            isCanonical: !0
        },
        ':person_with_ball_tone2:': {
            unicode: ['26f9-1f3fc'],
            fname: '26f9-1f3fc',
            uc: '26f9-1f3fc',
            isCanonical: !1
        },
        ':basketball_player_tone3:': {
            unicode: ['26f9-1f3fd'],
            fname: '26f9-1f3fd',
            uc: '26f9-1f3fd',
            isCanonical: !0
        },
        ':person_with_ball_tone3:': {
            unicode: ['26f9-1f3fd'],
            fname: '26f9-1f3fd',
            uc: '26f9-1f3fd',
            isCanonical: !1
        },
        ':basketball_player_tone4:': {
            unicode: ['26f9-1f3fe'],
            fname: '26f9-1f3fe',
            uc: '26f9-1f3fe',
            isCanonical: !0
        },
        ':person_with_ball_tone4:': {
            unicode: ['26f9-1f3fe'],
            fname: '26f9-1f3fe',
            uc: '26f9-1f3fe',
            isCanonical: !1
        },
        ':basketball_player_tone5:': {
            unicode: ['26f9-1f3ff'],
            fname: '26f9-1f3ff',
            uc: '26f9-1f3ff',
            isCanonical: !0
        },
        ':person_with_ball_tone5:': {
            unicode: ['26f9-1f3ff'],
            fname: '26f9-1f3ff',
            uc: '26f9-1f3ff',
            isCanonical: !1
        },
        ':copyright:': {
            unicode: ['00a9-fe0f', '00a9'],
            fname: '00a9',
            uc: '00a9',
            isCanonical: !0
        },
        ':registered:': {
            unicode: ['00ae-fe0f', '00ae'],
            fname: '00ae',
            uc: '00ae',
            isCanonical: !0
        },
        ':bangbang:': {
            unicode: ['203c-fe0f', '203c'],
            fname: '203c',
            uc: '203c',
            isCanonical: !0
        },
        ':interrobang:': {
            unicode: ['2049-fe0f', '2049'],
            fname: '2049',
            uc: '2049',
            isCanonical: !0
        },
        ':tm:': {
            unicode: ['2122-fe0f', '2122'],
            fname: '2122',
            uc: '2122',
            isCanonical: !0
        },
        ':information_source:': {
            unicode: ['2139-fe0f', '2139'],
            fname: '2139',
            uc: '2139',
            isCanonical: !0
        },
        ':left_right_arrow:': {
            unicode: ['2194-fe0f', '2194'],
            fname: '2194',
            uc: '2194',
            isCanonical: !0
        },
        ':arrow_up_down:': {
            unicode: ['2195-fe0f', '2195'],
            fname: '2195',
            uc: '2195',
            isCanonical: !0
        },
        ':arrow_upper_left:': {
            unicode: ['2196-fe0f', '2196'],
            fname: '2196',
            uc: '2196',
            isCanonical: !0
        },
        ':arrow_upper_right:': {
            unicode: ['2197-fe0f', '2197'],
            fname: '2197',
            uc: '2197',
            isCanonical: !0
        },
        ':arrow_lower_right:': {
            unicode: ['2198-fe0f', '2198'],
            fname: '2198',
            uc: '2198',
            isCanonical: !0
        },
        ':arrow_lower_left:': {
            unicode: ['2199-fe0f', '2199'],
            fname: '2199',
            uc: '2199',
            isCanonical: !0
        },
        ':leftwards_arrow_with_hook:': {
            unicode: ['21a9-fe0f', '21a9'],
            fname: '21a9',
            uc: '21a9',
            isCanonical: !0
        },
        ':arrow_right_hook:': {
            unicode: ['21aa-fe0f', '21aa'],
            fname: '21aa',
            uc: '21aa',
            isCanonical: !0
        },
        ':watch:': {
            unicode: ['231a-fe0f', '231a'],
            fname: '231a',
            uc: '231a',
            isCanonical: !0
        },
        ':hourglass:': {
            unicode: ['231b-fe0f', '231b'],
            fname: '231b',
            uc: '231b',
            isCanonical: !0
        },
        ':m:': {
            unicode: ['24c2-fe0f', '24c2'],
            fname: '24c2',
            uc: '24c2',
            isCanonical: !0
        },
        ':black_small_square:': {
            unicode: ['25aa-fe0f', '25aa'],
            fname: '25aa',
            uc: '25aa',
            isCanonical: !0
        },
        ':white_small_square:': {
            unicode: ['25ab-fe0f', '25ab'],
            fname: '25ab',
            uc: '25ab',
            isCanonical: !0
        },
        ':arrow_forward:': {
            unicode: ['25b6-fe0f', '25b6'],
            fname: '25b6',
            uc: '25b6',
            isCanonical: !0
        },
        ':arrow_backward:': {
            unicode: ['25c0-fe0f', '25c0'],
            fname: '25c0',
            uc: '25c0',
            isCanonical: !0
        },
        ':white_medium_square:': {
            unicode: ['25fb-fe0f', '25fb'],
            fname: '25fb',
            uc: '25fb',
            isCanonical: !0
        },
        ':black_medium_square:': {
            unicode: ['25fc-fe0f', '25fc'],
            fname: '25fc',
            uc: '25fc',
            isCanonical: !0
        },
        ':white_medium_small_square:': {
            unicode: ['25fd-fe0f', '25fd'],
            fname: '25fd',
            uc: '25fd',
            isCanonical: !0
        },
        ':black_medium_small_square:': {
            unicode: ['25fe-fe0f', '25fe'],
            fname: '25fe',
            uc: '25fe',
            isCanonical: !0
        },
        ':sunny:': {
            unicode: ['2600-fe0f', '2600'],
            fname: '2600',
            uc: '2600',
            isCanonical: !0
        },
        ':cloud:': {
            unicode: ['2601-fe0f', '2601'],
            fname: '2601',
            uc: '2601',
            isCanonical: !0
        },
        ':telephone:': {
            unicode: ['260e-fe0f', '260e'],
            fname: '260e',
            uc: '260e',
            isCanonical: !0
        },
        ':ballot_box_with_check:': {
            unicode: ['2611-fe0f', '2611'],
            fname: '2611',
            uc: '2611',
            isCanonical: !0
        },
        ':umbrella:': {
            unicode: ['2614-fe0f', '2614'],
            fname: '2614',
            uc: '2614',
            isCanonical: !0
        },
        ':coffee:': {
            unicode: ['2615-fe0f', '2615'],
            fname: '2615',
            uc: '2615',
            isCanonical: !0
        },
        ':point_up:': {
            unicode: ['261d-fe0f', '261d'],
            fname: '261d',
            uc: '261d',
            isCanonical: !0
        },
        ':relaxed:': {
            unicode: ['263a-fe0f', '263a'],
            fname: '263a',
            uc: '263a',
            isCanonical: !0
        },
        ':aries:': {
            unicode: ['2648-fe0f', '2648'],
            fname: '2648',
            uc: '2648',
            isCanonical: !0
        },
        ':taurus:': {
            unicode: ['2649-fe0f', '2649'],
            fname: '2649',
            uc: '2649',
            isCanonical: !0
        },
        ':gemini:': {
            unicode: ['264a-fe0f', '264a'],
            fname: '264a',
            uc: '264a',
            isCanonical: !0
        },
        ':cancer:': {
            unicode: ['264b-fe0f', '264b'],
            fname: '264b',
            uc: '264b',
            isCanonical: !0
        },
        ':leo:': {
            unicode: ['264c-fe0f', '264c'],
            fname: '264c',
            uc: '264c',
            isCanonical: !0
        },
        ':virgo:': {
            unicode: ['264d-fe0f', '264d'],
            fname: '264d',
            uc: '264d',
            isCanonical: !0
        },
        ':libra:': {
            unicode: ['264e-fe0f', '264e'],
            fname: '264e',
            uc: '264e',
            isCanonical: !0
        },
        ':scorpius:': {
            unicode: ['264f-fe0f', '264f'],
            fname: '264f',
            uc: '264f',
            isCanonical: !0
        },
        ':sagittarius:': {
            unicode: ['2650-fe0f', '2650'],
            fname: '2650',
            uc: '2650',
            isCanonical: !0
        },
        ':capricorn:': {
            unicode: ['2651-fe0f', '2651'],
            fname: '2651',
            uc: '2651',
            isCanonical: !0
        },
        ':aquarius:': {
            unicode: ['2652-fe0f', '2652'],
            fname: '2652',
            uc: '2652',
            isCanonical: !0
        },
        ':pisces:': {
            unicode: ['2653-fe0f', '2653'],
            fname: '2653',
            uc: '2653',
            isCanonical: !0
        },
        ':spades:': {
            unicode: ['2660-fe0f', '2660'],
            fname: '2660',
            uc: '2660',
            isCanonical: !0
        },
        ':clubs:': {
            unicode: ['2663-fe0f', '2663'],
            fname: '2663',
            uc: '2663',
            isCanonical: !0
        },
        ':hearts:': {
            unicode: ['2665-fe0f', '2665'],
            fname: '2665',
            uc: '2665',
            isCanonical: !0
        },
        ':diamonds:': {
            unicode: ['2666-fe0f', '2666'],
            fname: '2666',
            uc: '2666',
            isCanonical: !0
        },
        ':hotsprings:': {
            unicode: ['2668-fe0f', '2668'],
            fname: '2668',
            uc: '2668',
            isCanonical: !0
        },
        ':recycle:': {
            unicode: ['267b-fe0f', '267b'],
            fname: '267b',
            uc: '267b',
            isCanonical: !0
        },
        ':wheelchair:': {
            unicode: ['267f-fe0f', '267f'],
            fname: '267f',
            uc: '267f',
            isCanonical: !0
        },
        ':anchor:': {
            unicode: ['2693-fe0f', '2693'],
            fname: '2693',
            uc: '2693',
            isCanonical: !0
        },
        ':warning:': {
            unicode: ['26a0-fe0f', '26a0'],
            fname: '26a0',
            uc: '26a0',
            isCanonical: !0
        },
        ':zap:': {
            unicode: ['26a1-fe0f', '26a1'],
            fname: '26a1',
            uc: '26a1',
            isCanonical: !0
        },
        ':white_circle:': {
            unicode: ['26aa-fe0f', '26aa'],
            fname: '26aa',
            uc: '26aa',
            isCanonical: !0
        },
        ':black_circle:': {
            unicode: ['26ab-fe0f', '26ab'],
            fname: '26ab',
            uc: '26ab',
            isCanonical: !0
        },
        ':soccer:': {
            unicode: ['26bd-fe0f', '26bd'],
            fname: '26bd',
            uc: '26bd',
            isCanonical: !0
        },
        ':baseball:': {
            unicode: ['26be-fe0f', '26be'],
            fname: '26be',
            uc: '26be',
            isCanonical: !0
        },
        ':snowman:': {
            unicode: ['26c4-fe0f', '26c4'],
            fname: '26c4',
            uc: '26c4',
            isCanonical: !0
        },
        ':partly_sunny:': {
            unicode: ['26c5-fe0f', '26c5'],
            fname: '26c5',
            uc: '26c5',
            isCanonical: !0
        },
        ':no_entry:': {
            unicode: ['26d4-fe0f', '26d4'],
            fname: '26d4',
            uc: '26d4',
            isCanonical: !0
        },
        ':church:': {
            unicode: ['26ea-fe0f', '26ea'],
            fname: '26ea',
            uc: '26ea',
            isCanonical: !0
        },
        ':fountain:': {
            unicode: ['26f2-fe0f', '26f2'],
            fname: '26f2',
            uc: '26f2',
            isCanonical: !0
        },
        ':golf:': {
            unicode: ['26f3-fe0f', '26f3'],
            fname: '26f3',
            uc: '26f3',
            isCanonical: !0
        },
        ':sailboat:': {
            unicode: ['26f5-fe0f', '26f5'],
            fname: '26f5',
            uc: '26f5',
            isCanonical: !0
        },
        ':tent:': {
            unicode: ['26fa-fe0f', '26fa'],
            fname: '26fa',
            uc: '26fa',
            isCanonical: !0
        },
        ':fuelpump:': {
            unicode: ['26fd-fe0f', '26fd'],
            fname: '26fd',
            uc: '26fd',
            isCanonical: !0
        },
        ':scissors:': {
            unicode: ['2702-fe0f', '2702'],
            fname: '2702',
            uc: '2702',
            isCanonical: !0
        },
        ':airplane:': {
            unicode: ['2708-fe0f', '2708'],
            fname: '2708',
            uc: '2708',
            isCanonical: !0
        },
        ':envelope:': {
            unicode: ['2709-fe0f', '2709'],
            fname: '2709',
            uc: '2709',
            isCanonical: !0
        },
        ':v:': {
            unicode: ['270c-fe0f', '270c'],
            fname: '270c',
            uc: '270c',
            isCanonical: !0
        },
        ':pencil2:': {
            unicode: ['270f-fe0f', '270f'],
            fname: '270f',
            uc: '270f',
            isCanonical: !0
        },
        ':black_nib:': {
            unicode: ['2712-fe0f', '2712'],
            fname: '2712',
            uc: '2712',
            isCanonical: !0
        },
        ':heavy_check_mark:': {
            unicode: ['2714-fe0f', '2714'],
            fname: '2714',
            uc: '2714',
            isCanonical: !0
        },
        ':heavy_multiplication_x:': {
            unicode: ['2716-fe0f', '2716'],
            fname: '2716',
            uc: '2716',
            isCanonical: !0
        },
        ':eight_spoked_asterisk:': {
            unicode: ['2733-fe0f', '2733'],
            fname: '2733',
            uc: '2733',
            isCanonical: !0
        },
        ':eight_pointed_black_star:': {
            unicode: ['2734-fe0f', '2734'],
            fname: '2734',
            uc: '2734',
            isCanonical: !0
        },
        ':snowflake:': {
            unicode: ['2744-fe0f', '2744'],
            fname: '2744',
            uc: '2744',
            isCanonical: !0
        },
        ':sparkle:': {
            unicode: ['2747-fe0f', '2747'],
            fname: '2747',
            uc: '2747',
            isCanonical: !0
        },
        ':exclamation:': {
            unicode: ['2757-fe0f', '2757'],
            fname: '2757',
            uc: '2757',
            isCanonical: !0
        },
        ':heart:': {
            unicode: ['2764-fe0f', '2764'],
            fname: '2764',
            uc: '2764',
            isCanonical: !0
        },
        ':arrow_right:': {
            unicode: ['27a1-fe0f', '27a1'],
            fname: '27a1',
            uc: '27a1',
            isCanonical: !0
        },
        ':arrow_heading_up:': {
            unicode: ['2934-fe0f', '2934'],
            fname: '2934',
            uc: '2934',
            isCanonical: !0
        },
        ':arrow_heading_down:': {
            unicode: ['2935-fe0f', '2935'],
            fname: '2935',
            uc: '2935',
            isCanonical: !0
        },
        ':arrow_left:': {
            unicode: ['2b05-fe0f', '2b05'],
            fname: '2b05',
            uc: '2b05',
            isCanonical: !0
        },
        ':arrow_up:': {
            unicode: ['2b06-fe0f', '2b06'],
            fname: '2b06',
            uc: '2b06',
            isCanonical: !0
        },
        ':arrow_down:': {
            unicode: ['2b07-fe0f', '2b07'],
            fname: '2b07',
            uc: '2b07',
            isCanonical: !0
        },
        ':black_large_square:': {
            unicode: ['2b1b-fe0f', '2b1b'],
            fname: '2b1b',
            uc: '2b1b',
            isCanonical: !0
        },
        ':white_large_square:': {
            unicode: ['2b1c-fe0f', '2b1c'],
            fname: '2b1c',
            uc: '2b1c',
            isCanonical: !0
        },
        ':star:': {
            unicode: ['2b50-fe0f', '2b50'],
            fname: '2b50',
            uc: '2b50',
            isCanonical: !0
        },
        ':o:': {
            unicode: ['2b55-fe0f', '2b55'],
            fname: '2b55',
            uc: '2b55',
            isCanonical: !0
        },
        ':wavy_dash:': {
            unicode: ['3030-fe0f', '3030'],
            fname: '3030',
            uc: '3030',
            isCanonical: !0
        },
        ':part_alternation_mark:': {
            unicode: ['303d-fe0f', '303d'],
            fname: '303d',
            uc: '303d',
            isCanonical: !0
        },
        ':congratulations:': {
            unicode: ['3297-fe0f', '3297'],
            fname: '3297',
            uc: '3297',
            isCanonical: !0
        },
        ':secret:': {
            unicode: ['3299-fe0f', '3299'],
            fname: '3299',
            uc: '3299',
            isCanonical: !0
        },
        ':cross:': {
            unicode: ['271d-fe0f', '271d'],
            fname: '271d',
            uc: '271d',
            isCanonical: !0
        },
        ':latin_cross:': {
            unicode: ['271d-fe0f', '271d'],
            fname: '271d',
            uc: '271d',
            isCanonical: !1
        },
        ':keyboard:': {
            unicode: ['2328-fe0f', '2328'],
            fname: '2328',
            uc: '2328',
            isCanonical: !0
        },
        ':writing_hand:': {
            unicode: ['270d-fe0f', '270d'],
            fname: '270d',
            uc: '270d',
            isCanonical: !0
        },
        ':eject:': {
            unicode: ['23cf-fe0f', '23cf'],
            fname: '23cf',
            uc: '23cf',
            isCanonical: !0
        },
        ':eject_symbol:': {
            unicode: ['23cf-fe0f', '23cf'],
            fname: '23cf',
            uc: '23cf',
            isCanonical: !1
        },
        ':track_next:': {
            unicode: ['23ed-fe0f', '23ed'],
            fname: '23ed',
            uc: '23ed',
            isCanonical: !0
        },
        ':next_track:': {
            unicode: ['23ed-fe0f', '23ed'],
            fname: '23ed',
            uc: '23ed',
            isCanonical: !1
        },
        ':track_previous:': {
            unicode: ['23ee-fe0f', '23ee'],
            fname: '23ee',
            uc: '23ee',
            isCanonical: !0
        },
        ':previous_track:': {
            unicode: ['23ee-fe0f', '23ee'],
            fname: '23ee',
            uc: '23ee',
            isCanonical: !1
        },
        ':play_pause:': {
            unicode: ['23ef-fe0f', '23ef'],
            fname: '23ef',
            uc: '23ef',
            isCanonical: !0
        },
        ':stopwatch:': {
            unicode: ['23f1-fe0f', '23f1'],
            fname: '23f1',
            uc: '23f1',
            isCanonical: !0
        },
        ':timer:': {
            unicode: ['23f2-fe0f', '23f2'],
            fname: '23f2',
            uc: '23f2',
            isCanonical: !0
        },
        ':timer_clock:': {
            unicode: ['23f2-fe0f', '23f2'],
            fname: '23f2',
            uc: '23f2',
            isCanonical: !1
        },
        ':pause_button:': {
            unicode: ['23f8-fe0f', '23f8'],
            fname: '23f8',
            uc: '23f8',
            isCanonical: !0
        },
        ':double_vertical_bar:': {
            unicode: ['23f8-fe0f', '23f8'],
            fname: '23f8',
            uc: '23f8',
            isCanonical: !1
        },
        ':stop_button:': {
            unicode: ['23f9-fe0f', '23f9'],
            fname: '23f9',
            uc: '23f9',
            isCanonical: !0
        },
        ':record_button:': {
            unicode: ['23fa-fe0f', '23fa'],
            fname: '23fa',
            uc: '23fa',
            isCanonical: !0
        },
        ':umbrella2:': {
            unicode: ['2602-fe0f', '2602'],
            fname: '2602',
            uc: '2602',
            isCanonical: !0
        },
        ':snowman2:': {
            unicode: ['2603-fe0f', '2603'],
            fname: '2603',
            uc: '2603',
            isCanonical: !0
        },
        ':comet:': {
            unicode: ['2604-fe0f', '2604'],
            fname: '2604',
            uc: '2604',
            isCanonical: !0
        },
        ':shamrock:': {
            unicode: ['2618-fe0f', '2618'],
            fname: '2618',
            uc: '2618',
            isCanonical: !0
        },
        ':skull_crossbones:': {
            unicode: ['2620-fe0f', '2620'],
            fname: '2620',
            uc: '2620',
            isCanonical: !0
        },
        ':skull_and_crossbones:': {
            unicode: ['2620-fe0f', '2620'],
            fname: '2620',
            uc: '2620',
            isCanonical: !1
        },
        ':radioactive:': {
            unicode: ['2622-fe0f', '2622'],
            fname: '2622',
            uc: '2622',
            isCanonical: !0
        },
        ':radioactive_sign:': {
            unicode: ['2622-fe0f', '2622'],
            fname: '2622',
            uc: '2622',
            isCanonical: !1
        },
        ':biohazard:': {
            unicode: ['2623-fe0f', '2623'],
            fname: '2623',
            uc: '2623',
            isCanonical: !0
        },
        ':biohazard_sign:': {
            unicode: ['2623-fe0f', '2623'],
            fname: '2623',
            uc: '2623',
            isCanonical: !1
        },
        ':orthodox_cross:': {
            unicode: ['2626-fe0f', '2626'],
            fname: '2626',
            uc: '2626',
            isCanonical: !0
        },
        ':star_and_crescent:': {
            unicode: ['262a-fe0f', '262a'],
            fname: '262a',
            uc: '262a',
            isCanonical: !0
        },
        ':peace:': {
            unicode: ['262e-fe0f', '262e'],
            fname: '262e',
            uc: '262e',
            isCanonical: !0
        },
        ':peace_symbol:': {
            unicode: ['262e-fe0f', '262e'],
            fname: '262e',
            uc: '262e',
            isCanonical: !1
        },
        ':yin_yang:': {
            unicode: ['262f-fe0f', '262f'],
            fname: '262f',
            uc: '262f',
            isCanonical: !0
        },
        ':wheel_of_dharma:': {
            unicode: ['2638-fe0f', '2638'],
            fname: '2638',
            uc: '2638',
            isCanonical: !0
        },
        ':frowning2:': {
            unicode: ['2639-fe0f', '2639'],
            fname: '2639',
            uc: '2639',
            isCanonical: !0
        },
        ':white_frowning_face:': {
            unicode: ['2639-fe0f', '2639'],
            fname: '2639',
            uc: '2639',
            isCanonical: !1
        },
        ':hammer_pick:': {
            unicode: ['2692-fe0f', '2692'],
            fname: '2692',
            uc: '2692',
            isCanonical: !0
        },
        ':hammer_and_pick:': {
            unicode: ['2692-fe0f', '2692'],
            fname: '2692',
            uc: '2692',
            isCanonical: !1
        },
        ':crossed_swords:': {
            unicode: ['2694-fe0f', '2694'],
            fname: '2694',
            uc: '2694',
            isCanonical: !0
        },
        ':scales:': {
            unicode: ['2696-fe0f', '2696'],
            fname: '2696',
            uc: '2696',
            isCanonical: !0
        },
        ':alembic:': {
            unicode: ['2697-fe0f', '2697'],
            fname: '2697',
            uc: '2697',
            isCanonical: !0
        },
        ':gear:': {
            unicode: ['2699-fe0f', '2699'],
            fname: '2699',
            uc: '2699',
            isCanonical: !0
        },
        ':atom:': {
            unicode: ['269b-fe0f', '269b'],
            fname: '269b',
            uc: '269b',
            isCanonical: !0
        },
        ':atom_symbol:': {
            unicode: ['269b-fe0f', '269b'],
            fname: '269b',
            uc: '269b',
            isCanonical: !1
        },
        ':fleur-de-lis:': {
            unicode: ['269c-fe0f', '269c'],
            fname: '269c',
            uc: '269c',
            isCanonical: !0
        },
        ':coffin:': {
            unicode: ['26b0-fe0f', '26b0'],
            fname: '26b0',
            uc: '26b0',
            isCanonical: !0
        },
        ':urn:': {
            unicode: ['26b1-fe0f', '26b1'],
            fname: '26b1',
            uc: '26b1',
            isCanonical: !0
        },
        ':funeral_urn:': {
            unicode: ['26b1-fe0f', '26b1'],
            fname: '26b1',
            uc: '26b1',
            isCanonical: !1
        },
        ':thunder_cloud_rain:': {
            unicode: ['26c8-fe0f', '26c8'],
            fname: '26c8',
            uc: '26c8',
            isCanonical: !0
        },
        ':thunder_cloud_and_rain:': {
            unicode: ['26c8-fe0f', '26c8'],
            fname: '26c8',
            uc: '26c8',
            isCanonical: !1
        },
        ':pick:': {
            unicode: ['26cf-fe0f', '26cf'],
            fname: '26cf',
            uc: '26cf',
            isCanonical: !0
        },
        ':helmet_with_cross:': {
            unicode: ['26d1-fe0f', '26d1'],
            fname: '26d1',
            uc: '26d1',
            isCanonical: !0
        },
        ':helmet_with_white_cross:': {
            unicode: ['26d1-fe0f', '26d1'],
            fname: '26d1',
            uc: '26d1',
            isCanonical: !1
        },
        ':chains:': {
            unicode: ['26d3-fe0f', '26d3'],
            fname: '26d3',
            uc: '26d3',
            isCanonical: !0
        },
        ':shinto_shrine:': {
            unicode: ['26e9-fe0f', '26e9'],
            fname: '26e9',
            uc: '26e9',
            isCanonical: !0
        },
        ':mountain:': {
            unicode: ['26f0-fe0f', '26f0'],
            fname: '26f0',
            uc: '26f0',
            isCanonical: !0
        },
        ':beach_umbrella:': {
            unicode: ['26f1-fe0f', '26f1'],
            fname: '26f1',
            uc: '26f1',
            isCanonical: !0
        },
        ':umbrella_on_ground:': {
            unicode: ['26f1-fe0f', '26f1'],
            fname: '26f1',
            uc: '26f1',
            isCanonical: !1
        },
        ':ferry:': {
            unicode: ['26f4-fe0f', '26f4'],
            fname: '26f4',
            uc: '26f4',
            isCanonical: !0
        },
        ':skier:': {
            unicode: ['26f7-fe0f', '26f7'],
            fname: '26f7',
            uc: '26f7',
            isCanonical: !0
        },
        ':ice_skate:': {
            unicode: ['26f8-fe0f', '26f8'],
            fname: '26f8',
            uc: '26f8',
            isCanonical: !0
        },
        ':basketball_player:': {
            unicode: ['26f9-fe0f', '26f9'],
            fname: '26f9',
            uc: '26f9',
            isCanonical: !0
        },
        ':person_with_ball:': {
            unicode: ['26f9-fe0f', '26f9'],
            fname: '26f9',
            uc: '26f9',
            isCanonical: !1
        },
        ':star_of_david:': {
            unicode: ['2721-fe0f', '2721'],
            fname: '2721',
            uc: '2721',
            isCanonical: !0
        },
        ':heart_exclamation:': {
            unicode: ['2763-fe0f', '2763'],
            fname: '2763',
            uc: '2763',
            isCanonical: !0
        },
        ':heavy_heart_exclamation_mark_ornament:': {
            unicode: ['2763-fe0f', '2763'],
            fname: '2763',
            uc: '2763',
            isCanonical: !1
        },
        ':third_place:': {
            unicode: ['1f949'],
            fname: '1f949',
            uc: '1f949',
            isCanonical: !0
        },
        ':third_place_medal:': {
            unicode: ['1f949'],
            fname: '1f949',
            uc: '1f949',
            isCanonical: !1
        },
        ':second_place:': {
            unicode: ['1f948'],
            fname: '1f948',
            uc: '1f948',
            isCanonical: !0
        },
        ':second_place_medal:': {
            unicode: ['1f948'],
            fname: '1f948',
            uc: '1f948',
            isCanonical: !1
        },
        ':first_place:': {
            unicode: ['1f947'],
            fname: '1f947',
            uc: '1f947',
            isCanonical: !0
        },
        ':first_place_medal:': {
            unicode: ['1f947'],
            fname: '1f947',
            uc: '1f947',
            isCanonical: !1
        },
        ':fencer:': {
            unicode: ['1f93a'],
            fname: '1f93a',
            uc: '1f93a',
            isCanonical: !0
        },
        ':fencing:': {
            unicode: ['1f93a'],
            fname: '1f93a',
            uc: '1f93a',
            isCanonical: !1
        },
        ':goal:': {
            unicode: ['1f945'],
            fname: '1f945',
            uc: '1f945',
            isCanonical: !0
        },
        ':goal_net:': {
            unicode: ['1f945'],
            fname: '1f945',
            uc: '1f945',
            isCanonical: !1
        },
        ':handball:': {
            unicode: ['1f93e'],
            fname: '1f93e',
            uc: '1f93e',
            isCanonical: !0
        },
        ':regional_indicator_z:': {
            unicode: ['1f1ff'],
            fname: '1f1ff',
            uc: '1f1ff',
            isCanonical: !0
        },
        ':water_polo:': {
            unicode: ['1f93d'],
            fname: '1f93d',
            uc: '1f93d',
            isCanonical: !0
        },
        ':martial_arts_uniform:': {
            unicode: ['1f94b'],
            fname: '1f94b',
            uc: '1f94b',
            isCanonical: !0
        },
        ':karate_uniform:': {
            unicode: ['1f94b'],
            fname: '1f94b',
            uc: '1f94b',
            isCanonical: !1
        },
        ':boxing_glove:': {
            unicode: ['1f94a'],
            fname: '1f94a',
            uc: '1f94a',
            isCanonical: !0
        },
        ':boxing_gloves:': {
            unicode: ['1f94a'],
            fname: '1f94a',
            uc: '1f94a',
            isCanonical: !1
        },
        ':wrestlers:': {
            unicode: ['1f93c'],
            fname: '1f93c',
            uc: '1f93c',
            isCanonical: !0
        },
        ':wrestling:': {
            unicode: ['1f93c'],
            fname: '1f93c',
            uc: '1f93c',
            isCanonical: !1
        },
        ':juggling:': {
            unicode: ['1f939'],
            fname: '1f939',
            uc: '1f939',
            isCanonical: !0
        },
        ':juggler:': {
            unicode: ['1f939'],
            fname: '1f939',
            uc: '1f939',
            isCanonical: !1
        },
        ':cartwheel:': {
            unicode: ['1f938'],
            fname: '1f938',
            uc: '1f938',
            isCanonical: !0
        },
        ':person_doing_cartwheel:': {
            unicode: ['1f938'],
            fname: '1f938',
            uc: '1f938',
            isCanonical: !1
        },
        ':canoe:': {
            unicode: ['1f6f6'],
            fname: '1f6f6',
            uc: '1f6f6',
            isCanonical: !0
        },
        ':kayak:': {
            unicode: ['1f6f6'],
            fname: '1f6f6',
            uc: '1f6f6',
            isCanonical: !1
        },
        ':motor_scooter:': {
            unicode: ['1f6f5'],
            fname: '1f6f5',
            uc: '1f6f5',
            isCanonical: !0
        },
        ':motorbike:': {
            unicode: ['1f6f5'],
            fname: '1f6f5',
            uc: '1f6f5',
            isCanonical: !1
        },
        ':scooter:': {
            unicode: ['1f6f4'],
            fname: '1f6f4',
            uc: '1f6f4',
            isCanonical: !0
        },
        ':shopping_cart:': {
            unicode: ['1f6d2'],
            fname: '1f6d2',
            uc: '1f6d2',
            isCanonical: !0
        },
        ':shopping_trolley:': {
            unicode: ['1f6d2'],
            fname: '1f6d2',
            uc: '1f6d2',
            isCanonical: !1
        },
        ':black_joker:': {
            unicode: ['1f0cf'],
            fname: '1f0cf',
            uc: '1f0cf',
            isCanonical: !0
        },
        ':a:': {
            unicode: ['1f170'],
            fname: '1f170',
            uc: '1f170',
            isCanonical: !0
        },
        ':b:': {
            unicode: ['1f171'],
            fname: '1f171',
            uc: '1f171',
            isCanonical: !0
        },
        ':o2:': {
            unicode: ['1f17e'],
            fname: '1f17e',
            uc: '1f17e',
            isCanonical: !0
        },
        ':octagonal_sign:': {
            unicode: ['1f6d1'],
            fname: '1f6d1',
            uc: '1f6d1',
            isCanonical: !0
        },
        ':stop_sign:': {
            unicode: ['1f6d1'],
            fname: '1f6d1',
            uc: '1f6d1',
            isCanonical: !1
        },
        ':ab:': {
            unicode: ['1f18e'],
            fname: '1f18e',
            uc: '1f18e',
            isCanonical: !0
        },
        ':cl:': {
            unicode: ['1f191'],
            fname: '1f191',
            uc: '1f191',
            isCanonical: !0
        },
        ':regional_indicator_y:': {
            unicode: ['1f1fe'],
            fname: '1f1fe',
            uc: '1f1fe',
            isCanonical: !0
        },
        ':cool:': {
            unicode: ['1f192'],
            fname: '1f192',
            uc: '1f192',
            isCanonical: !0
        },
        ':free:': {
            unicode: ['1f193'],
            fname: '1f193',
            uc: '1f193',
            isCanonical: !0
        },
        ':id:': {
            unicode: ['1f194'],
            fname: '1f194',
            uc: '1f194',
            isCanonical: !0
        },
        ':new:': {
            unicode: ['1f195'],
            fname: '1f195',
            uc: '1f195',
            isCanonical: !0
        },
        ':ng:': {
            unicode: ['1f196'],
            fname: '1f196',
            uc: '1f196',
            isCanonical: !0
        },
        ':ok:': {
            unicode: ['1f197'],
            fname: '1f197',
            uc: '1f197',
            isCanonical: !0
        },
        ':sos:': {
            unicode: ['1f198'],
            fname: '1f198',
            uc: '1f198',
            isCanonical: !0
        },
        ':spoon:': {
            unicode: ['1f944'],
            fname: '1f944',
            uc: '1f944',
            isCanonical: !0
        },
        ':up:': {
            unicode: ['1f199'],
            fname: '1f199',
            uc: '1f199',
            isCanonical: !0
        },
        ':vs:': {
            unicode: ['1f19a'],
            fname: '1f19a',
            uc: '1f19a',
            isCanonical: !0
        },
        ':champagne_glass:': {
            unicode: ['1f942'],
            fname: '1f942',
            uc: '1f942',
            isCanonical: !0
        },
        ':clinking_glass:': {
            unicode: ['1f942'],
            fname: '1f942',
            uc: '1f942',
            isCanonical: !1
        },
        ':tumbler_glass:': {
            unicode: ['1f943'],
            fname: '1f943',
            uc: '1f943',
            isCanonical: !0
        },
        ':whisky:': {
            unicode: ['1f943'],
            fname: '1f943',
            uc: '1f943',
            isCanonical: !1
        },
        ':koko:': {
            unicode: ['1f201'],
            fname: '1f201',
            uc: '1f201',
            isCanonical: !0
        },
        ':stuffed_flatbread:': {
            unicode: ['1f959'],
            fname: '1f959',
            uc: '1f959',
            isCanonical: !0
        },
        ':stuffed_pita:': {
            unicode: ['1f959'],
            fname: '1f959',
            uc: '1f959',
            isCanonical: !1
        },
        ':u7981:': {
            unicode: ['1f232'],
            fname: '1f232',
            uc: '1f232',
            isCanonical: !0
        },
        ':u7a7a:': {
            unicode: ['1f233'],
            fname: '1f233',
            uc: '1f233',
            isCanonical: !0
        },
        ':u5408:': {
            unicode: ['1f234'],
            fname: '1f234',
            uc: '1f234',
            isCanonical: !0
        },
        ':u6e80:': {
            unicode: ['1f235'],
            fname: '1f235',
            uc: '1f235',
            isCanonical: !0
        },
        ':u6709:': {
            unicode: ['1f236'],
            fname: '1f236',
            uc: '1f236',
            isCanonical: !0
        },
        ':shallow_pan_of_food:': {
            unicode: ['1f958'],
            fname: '1f958',
            uc: '1f958',
            isCanonical: !0
        },
        ':paella:': {
            unicode: ['1f958'],
            fname: '1f958',
            uc: '1f958',
            isCanonical: !1
        },
        ':u7533:': {
            unicode: ['1f238'],
            fname: '1f238',
            uc: '1f238',
            isCanonical: !0
        },
        ':u5272:': {
            unicode: ['1f239'],
            fname: '1f239',
            uc: '1f239',
            isCanonical: !0
        },
        ':salad:': {
            unicode: ['1f957'],
            fname: '1f957',
            uc: '1f957',
            isCanonical: !0
        },
        ':green_salad:': {
            unicode: ['1f957'],
            fname: '1f957',
            uc: '1f957',
            isCanonical: !1
        },
        ':u55b6:': {
            unicode: ['1f23a'],
            fname: '1f23a',
            uc: '1f23a',
            isCanonical: !0
        },
        ':ideograph_advantage:': {
            unicode: ['1f250'],
            fname: '1f250',
            uc: '1f250',
            isCanonical: !0
        },
        ':accept:': {
            unicode: ['1f251'],
            fname: '1f251',
            uc: '1f251',
            isCanonical: !0
        },
        ':cyclone:': {
            unicode: ['1f300'],
            fname: '1f300',
            uc: '1f300',
            isCanonical: !0
        },
        ':french_bread:': {
            unicode: ['1f956'],
            fname: '1f956',
            uc: '1f956',
            isCanonical: !0
        },
        ':baguette_bread:': {
            unicode: ['1f956'],
            fname: '1f956',
            uc: '1f956',
            isCanonical: !1
        },
        ':foggy:': {
            unicode: ['1f301'],
            fname: '1f301',
            uc: '1f301',
            isCanonical: !0
        },
        ':closed_umbrella:': {
            unicode: ['1f302'],
            fname: '1f302',
            uc: '1f302',
            isCanonical: !0
        },
        ':night_with_stars:': {
            unicode: ['1f303'],
            fname: '1f303',
            uc: '1f303',
            isCanonical: !0
        },
        ':sunrise_over_mountains:': {
            unicode: ['1f304'],
            fname: '1f304',
            uc: '1f304',
            isCanonical: !0
        },
        ':sunrise:': {
            unicode: ['1f305'],
            fname: '1f305',
            uc: '1f305',
            isCanonical: !0
        },
        ':city_dusk:': {
            unicode: ['1f306'],
            fname: '1f306',
            uc: '1f306',
            isCanonical: !0
        },
        ':carrot:': {
            unicode: ['1f955'],
            fname: '1f955',
            uc: '1f955',
            isCanonical: !0
        },
        ':city_sunset:': {
            unicode: ['1f307'],
            fname: '1f307',
            uc: '1f307',
            isCanonical: !0
        },
        ':city_sunrise:': {
            unicode: ['1f307'],
            fname: '1f307',
            uc: '1f307',
            isCanonical: !1
        },
        ':rainbow:': {
            unicode: ['1f308'],
            fname: '1f308',
            uc: '1f308',
            isCanonical: !0
        },
        ':potato:': {
            unicode: ['1f954'],
            fname: '1f954',
            uc: '1f954',
            isCanonical: !0
        },
        ':bridge_at_night:': {
            unicode: ['1f309'],
            fname: '1f309',
            uc: '1f309',
            isCanonical: !0
        },
        ':ocean:': {
            unicode: ['1f30a'],
            fname: '1f30a',
            uc: '1f30a',
            isCanonical: !0
        },
        ':volcano:': {
            unicode: ['1f30b'],
            fname: '1f30b',
            uc: '1f30b',
            isCanonical: !0
        },
        ':milky_way:': {
            unicode: ['1f30c'],
            fname: '1f30c',
            uc: '1f30c',
            isCanonical: !0
        },
        ':earth_asia:': {
            unicode: ['1f30f'],
            fname: '1f30f',
            uc: '1f30f',
            isCanonical: !0
        },
        ':new_moon:': {
            unicode: ['1f311'],
            fname: '1f311',
            uc: '1f311',
            isCanonical: !0
        },
        ':bacon:': {
            unicode: ['1f953'],
            fname: '1f953',
            uc: '1f953',
            isCanonical: !0
        },
        ':first_quarter_moon:': {
            unicode: ['1f313'],
            fname: '1f313',
            uc: '1f313',
            isCanonical: !0
        },
        ':waxing_gibbous_moon:': {
            unicode: ['1f314'],
            fname: '1f314',
            uc: '1f314',
            isCanonical: !0
        },
        ':full_moon:': {
            unicode: ['1f315'],
            fname: '1f315',
            uc: '1f315',
            isCanonical: !0
        },
        ':crescent_moon:': {
            unicode: ['1f319'],
            fname: '1f319',
            uc: '1f319',
            isCanonical: !0
        },
        ':first_quarter_moon_with_face:': {
            unicode: ['1f31b'],
            fname: '1f31b',
            uc: '1f31b',
            isCanonical: !0
        },
        ':star2:': {
            unicode: ['1f31f'],
            fname: '1f31f',
            uc: '1f31f',
            isCanonical: !0
        },
        ':cucumber:': {
            unicode: ['1f952'],
            fname: '1f952',
            uc: '1f952',
            isCanonical: !0
        },
        ':stars:': {
            unicode: ['1f320'],
            fname: '1f320',
            uc: '1f320',
            isCanonical: !0
        },
        ':chestnut:': {
            unicode: ['1f330'],
            fname: '1f330',
            uc: '1f330',
            isCanonical: !0
        },
        ':avocado:': {
            unicode: ['1f951'],
            fname: '1f951',
            uc: '1f951',
            isCanonical: !0
        },
        ':seedling:': {
            unicode: ['1f331'],
            fname: '1f331',
            uc: '1f331',
            isCanonical: !0
        },
        ':palm_tree:': {
            unicode: ['1f334'],
            fname: '1f334',
            uc: '1f334',
            isCanonical: !0
        },
        ':cactus:': {
            unicode: ['1f335'],
            fname: '1f335',
            uc: '1f335',
            isCanonical: !0
        },
        ':tulip:': {
            unicode: ['1f337'],
            fname: '1f337',
            uc: '1f337',
            isCanonical: !0
        },
        ':cherry_blossom:': {
            unicode: ['1f338'],
            fname: '1f338',
            uc: '1f338',
            isCanonical: !0
        },
        ':rose:': {
            unicode: ['1f339'],
            fname: '1f339',
            uc: '1f339',
            isCanonical: !0
        },
        ':hibiscus:': {
            unicode: ['1f33a'],
            fname: '1f33a',
            uc: '1f33a',
            isCanonical: !0
        },
        ':sunflower:': {
            unicode: ['1f33b'],
            fname: '1f33b',
            uc: '1f33b',
            isCanonical: !0
        },
        ':blossom:': {
            unicode: ['1f33c'],
            fname: '1f33c',
            uc: '1f33c',
            isCanonical: !0
        },
        ':corn:': {
            unicode: ['1f33d'],
            fname: '1f33d',
            uc: '1f33d',
            isCanonical: !0
        },
        ':croissant:': {
            unicode: ['1f950'],
            fname: '1f950',
            uc: '1f950',
            isCanonical: !0
        },
        ':ear_of_rice:': {
            unicode: ['1f33e'],
            fname: '1f33e',
            uc: '1f33e',
            isCanonical: !0
        },
        ':herb:': {
            unicode: ['1f33f'],
            fname: '1f33f',
            uc: '1f33f',
            isCanonical: !0
        },
        ':four_leaf_clover:': {
            unicode: ['1f340'],
            fname: '1f340',
            uc: '1f340',
            isCanonical: !0
        },
        ':maple_leaf:': {
            unicode: ['1f341'],
            fname: '1f341',
            uc: '1f341',
            isCanonical: !0
        },
        ':fallen_leaf:': {
            unicode: ['1f342'],
            fname: '1f342',
            uc: '1f342',
            isCanonical: !0
        },
        ':leaves:': {
            unicode: ['1f343'],
            fname: '1f343',
            uc: '1f343',
            isCanonical: !0
        },
        ':mushroom:': {
            unicode: ['1f344'],
            fname: '1f344',
            uc: '1f344',
            isCanonical: !0
        },
        ':tomato:': {
            unicode: ['1f345'],
            fname: '1f345',
            uc: '1f345',
            isCanonical: !0
        },
        ':eggplant:': {
            unicode: ['1f346'],
            fname: '1f346',
            uc: '1f346',
            isCanonical: !0
        },
        ':grapes:': {
            unicode: ['1f347'],
            fname: '1f347',
            uc: '1f347',
            isCanonical: !0
        },
        ':melon:': {
            unicode: ['1f348'],
            fname: '1f348',
            uc: '1f348',
            isCanonical: !0
        },
        ':watermelon:': {
            unicode: ['1f349'],
            fname: '1f349',
            uc: '1f349',
            isCanonical: !0
        },
        ':tangerine:': {
            unicode: ['1f34a'],
            fname: '1f34a',
            uc: '1f34a',
            isCanonical: !0
        },
        ':wilted_rose:': {
            unicode: ['1f940'],
            fname: '1f940',
            uc: '1f940',
            isCanonical: !0
        },
        ':wilted_flower:': {
            unicode: ['1f940'],
            fname: '1f940',
            uc: '1f940',
            isCanonical: !1
        },
        ':banana:': {
            unicode: ['1f34c'],
            fname: '1f34c',
            uc: '1f34c',
            isCanonical: !0
        },
        ':pineapple:': {
            unicode: ['1f34d'],
            fname: '1f34d',
            uc: '1f34d',
            isCanonical: !0
        },
        ':apple:': {
            unicode: ['1f34e'],
            fname: '1f34e',
            uc: '1f34e',
            isCanonical: !0
        },
        ':green_apple:': {
            unicode: ['1f34f'],
            fname: '1f34f',
            uc: '1f34f',
            isCanonical: !0
        },
        ':peach:': {
            unicode: ['1f351'],
            fname: '1f351',
            uc: '1f351',
            isCanonical: !0
        },
        ':cherries:': {
            unicode: ['1f352'],
            fname: '1f352',
            uc: '1f352',
            isCanonical: !0
        },
        ':strawberry:': {
            unicode: ['1f353'],
            fname: '1f353',
            uc: '1f353',
            isCanonical: !0
        },
        ':rhino:': {
            unicode: ['1f98f'],
            fname: '1f98f',
            uc: '1f98f',
            isCanonical: !0
        },
        ':rhinoceros:': {
            unicode: ['1f98f'],
            fname: '1f98f',
            uc: '1f98f',
            isCanonical: !1
        },
        ':hamburger:': {
            unicode: ['1f354'],
            fname: '1f354',
            uc: '1f354',
            isCanonical: !0
        },
        ':pizza:': {
            unicode: ['1f355'],
            fname: '1f355',
            uc: '1f355',
            isCanonical: !0
        },
        ':meat_on_bone:': {
            unicode: ['1f356'],
            fname: '1f356',
            uc: '1f356',
            isCanonical: !0
        },
        ':lizard:': {
            unicode: ['1f98e'],
            fname: '1f98e',
            uc: '1f98e',
            isCanonical: !0
        },
        ':poultry_leg:': {
            unicode: ['1f357'],
            fname: '1f357',
            uc: '1f357',
            isCanonical: !0
        },
        ':rice_cracker:': {
            unicode: ['1f358'],
            fname: '1f358',
            uc: '1f358',
            isCanonical: !0
        },
        ':rice_ball:': {
            unicode: ['1f359'],
            fname: '1f359',
            uc: '1f359',
            isCanonical: !0
        },
        ':gorilla:': {
            unicode: ['1f98d'],
            fname: '1f98d',
            uc: '1f98d',
            isCanonical: !0
        },
        ':rice:': {
            unicode: ['1f35a'],
            fname: '1f35a',
            uc: '1f35a',
            isCanonical: !0
        },
        ':curry:': {
            unicode: ['1f35b'],
            fname: '1f35b',
            uc: '1f35b',
            isCanonical: !0
        },
        ':deer:': {
            unicode: ['1f98c'],
            fname: '1f98c',
            uc: '1f98c',
            isCanonical: !0
        },
        ':ramen:': {
            unicode: ['1f35c'],
            fname: '1f35c',
            uc: '1f35c',
            isCanonical: !0
        },
        ':spaghetti:': {
            unicode: ['1f35d'],
            fname: '1f35d',
            uc: '1f35d',
            isCanonical: !0
        },
        ':bread:': {
            unicode: ['1f35e'],
            fname: '1f35e',
            uc: '1f35e',
            isCanonical: !0
        },
        ':fries:': {
            unicode: ['1f35f'],
            fname: '1f35f',
            uc: '1f35f',
            isCanonical: !0
        },
        ':butterfly:': {
            unicode: ['1f98b'],
            fname: '1f98b',
            uc: '1f98b',
            isCanonical: !0
        },
        ':sweet_potato:': {
            unicode: ['1f360'],
            fname: '1f360',
            uc: '1f360',
            isCanonical: !0
        },
        ':dango:': {
            unicode: ['1f361'],
            fname: '1f361',
            uc: '1f361',
            isCanonical: !0
        },
        ':fox:': {
            unicode: ['1f98a'],
            fname: '1f98a',
            uc: '1f98a',
            isCanonical: !0
        },
        ':fox_face:': {
            unicode: ['1f98a'],
            fname: '1f98a',
            uc: '1f98a',
            isCanonical: !1
        },
        ':oden:': {
            unicode: ['1f362'],
            fname: '1f362',
            uc: '1f362',
            isCanonical: !0
        },
        ':sushi:': {
            unicode: ['1f363'],
            fname: '1f363',
            uc: '1f363',
            isCanonical: !0
        },
        ':owl:': {
            unicode: ['1f989'],
            fname: '1f989',
            uc: '1f989',
            isCanonical: !0
        },
        ':fried_shrimp:': {
            unicode: ['1f364'],
            fname: '1f364',
            uc: '1f364',
            isCanonical: !0
        },
        ':fish_cake:': {
            unicode: ['1f365'],
            fname: '1f365',
            uc: '1f365',
            isCanonical: !0
        },
        ':shark:': {
            unicode: ['1f988'],
            fname: '1f988',
            uc: '1f988',
            isCanonical: !0
        },
        ':icecream:': {
            unicode: ['1f366'],
            fname: '1f366',
            uc: '1f366',
            isCanonical: !0
        },
        ':bat:': {
            unicode: ['1f987'],
            fname: '1f987',
            uc: '1f987',
            isCanonical: !0
        },
        ':shaved_ice:': {
            unicode: ['1f367'],
            fname: '1f367',
            uc: '1f367',
            isCanonical: !0
        },
        ':regional_indicator_x:': {
            unicode: ['1f1fd'],
            fname: '1f1fd',
            uc: '1f1fd',
            isCanonical: !0
        },
        ':ice_cream:': {
            unicode: ['1f368'],
            fname: '1f368',
            uc: '1f368',
            isCanonical: !0
        },
        ':duck:': {
            unicode: ['1f986'],
            fname: '1f986',
            uc: '1f986',
            isCanonical: !0
        },
        ':doughnut:': {
            unicode: ['1f369'],
            fname: '1f369',
            uc: '1f369',
            isCanonical: !0
        },
        ':eagle:': {
            unicode: ['1f985'],
            fname: '1f985',
            uc: '1f985',
            isCanonical: !0
        },
        ':cookie:': {
            unicode: ['1f36a'],
            fname: '1f36a',
            uc: '1f36a',
            isCanonical: !0
        },
        ':black_heart:': {
            unicode: ['1f5a4'],
            fname: '1f5a4',
            uc: '1f5a4',
            isCanonical: !0
        },
        ':chocolate_bar:': {
            unicode: ['1f36b'],
            fname: '1f36b',
            uc: '1f36b',
            isCanonical: !0
        },
        ':candy:': {
            unicode: ['1f36c'],
            fname: '1f36c',
            uc: '1f36c',
            isCanonical: !0
        },
        ':lollipop:': {
            unicode: ['1f36d'],
            fname: '1f36d',
            uc: '1f36d',
            isCanonical: !0
        },
        ':custard:': {
            unicode: ['1f36e'],
            fname: '1f36e',
            uc: '1f36e',
            isCanonical: !0
        },
        ':pudding:': {
            unicode: ['1f36e'],
            fname: '1f36e',
            uc: '1f36e',
            isCanonical: !1
        },
        ':flan:': {
            unicode: ['1f36e'],
            fname: '1f36e',
            uc: '1f36e',
            isCanonical: !1
        },
        ':honey_pot:': {
            unicode: ['1f36f'],
            fname: '1f36f',
            uc: '1f36f',
            isCanonical: !0
        },
        ':fingers_crossed:': {
            unicode: ['1f91e'],
            fname: '1f91e',
            uc: '1f91e',
            isCanonical: !0
        },
        ':hand_with_index_and_middle_finger_crossed:': {
            unicode: ['1f91e'],
            fname: '1f91e',
            uc: '1f91e',
            isCanonical: !1
        },
        ':cake:': {
            unicode: ['1f370'],
            fname: '1f370',
            uc: '1f370',
            isCanonical: !0
        },
        ':bento:': {
            unicode: ['1f371'],
            fname: '1f371',
            uc: '1f371',
            isCanonical: !0
        },
        ':stew:': {
            unicode: ['1f372'],
            fname: '1f372',
            uc: '1f372',
            isCanonical: !0
        },
        ':handshake:': {
            unicode: ['1f91d'],
            fname: '1f91d',
            uc: '1f91d',
            isCanonical: !0
        },
        ':shaking_hands:': {
            unicode: ['1f91d'],
            fname: '1f91d',
            uc: '1f91d',
            isCanonical: !1
        },
        ':cooking:': {
            unicode: ['1f373'],
            fname: '1f373',
            uc: '1f373',
            isCanonical: !0
        },
        ':fork_and_knife:': {
            unicode: ['1f374'],
            fname: '1f374',
            uc: '1f374',
            isCanonical: !0
        },
        ':tea:': {
            unicode: ['1f375'],
            fname: '1f375',
            uc: '1f375',
            isCanonical: !0
        },
        ':sake:': {
            unicode: ['1f376'],
            fname: '1f376',
            uc: '1f376',
            isCanonical: !0
        },
        ':wine_glass:': {
            unicode: ['1f377'],
            fname: '1f377',
            uc: '1f377',
            isCanonical: !0
        },
        ':cocktail:': {
            unicode: ['1f378'],
            fname: '1f378',
            uc: '1f378',
            isCanonical: !0
        },
        ':tropical_drink:': {
            unicode: ['1f379'],
            fname: '1f379',
            uc: '1f379',
            isCanonical: !0
        },
        ':beer:': {
            unicode: ['1f37a'],
            fname: '1f37a',
            uc: '1f37a',
            isCanonical: !0
        },
        ':beers:': {
            unicode: ['1f37b'],
            fname: '1f37b',
            uc: '1f37b',
            isCanonical: !0
        },
        ':ribbon:': {
            unicode: ['1f380'],
            fname: '1f380',
            uc: '1f380',
            isCanonical: !0
        },
        ':gift:': {
            unicode: ['1f381'],
            fname: '1f381',
            uc: '1f381',
            isCanonical: !0
        },
        ':birthday:': {
            unicode: ['1f382'],
            fname: '1f382',
            uc: '1f382',
            isCanonical: !0
        },
        ':jack_o_lantern:': {
            unicode: ['1f383'],
            fname: '1f383',
            uc: '1f383',
            isCanonical: !0
        },
        ':left_facing_fist:': {
            unicode: ['1f91b'],
            fname: '1f91b',
            uc: '1f91b',
            isCanonical: !0
        },
        ':left_fist:': {
            unicode: ['1f91b'],
            fname: '1f91b',
            uc: '1f91b',
            isCanonical: !1
        },
        ':right_facing_fist:': {
            unicode: ['1f91c'],
            fname: '1f91c',
            uc: '1f91c',
            isCanonical: !0
        },
        ':right_fist:': {
            unicode: ['1f91c'],
            fname: '1f91c',
            uc: '1f91c',
            isCanonical: !1
        },
        ':christmas_tree:': {
            unicode: ['1f384'],
            fname: '1f384',
            uc: '1f384',
            isCanonical: !0
        },
        ':santa:': {
            unicode: ['1f385'],
            fname: '1f385',
            uc: '1f385',
            isCanonical: !0
        },
        ':fireworks:': {
            unicode: ['1f386'],
            fname: '1f386',
            uc: '1f386',
            isCanonical: !0
        },
        ':raised_back_of_hand:': {
            unicode: ['1f91a'],
            fname: '1f91a',
            uc: '1f91a',
            isCanonical: !0
        },
        ':back_of_hand:': {
            unicode: ['1f91a'],
            fname: '1f91a',
            uc: '1f91a',
            isCanonical: !1
        },
        ':sparkler:': {
            unicode: ['1f387'],
            fname: '1f387',
            uc: '1f387',
            isCanonical: !0
        },
        ':balloon:': {
            unicode: ['1f388'],
            fname: '1f388',
            uc: '1f388',
            isCanonical: !0
        },
        ':tada:': {
            unicode: ['1f389'],
            fname: '1f389',
            uc: '1f389',
            isCanonical: !0
        },
        ':confetti_ball:': {
            unicode: ['1f38a'],
            fname: '1f38a',
            uc: '1f38a',
            isCanonical: !0
        },
        ':tanabata_tree:': {
            unicode: ['1f38b'],
            fname: '1f38b',
            uc: '1f38b',
            isCanonical: !0
        },
        ':crossed_flags:': {
            unicode: ['1f38c'],
            fname: '1f38c',
            uc: '1f38c',
            isCanonical: !0
        },
        ':call_me:': {
            unicode: ['1f919'],
            fname: '1f919',
            uc: '1f919',
            isCanonical: !0
        },
        ':call_me_hand:': {
            unicode: ['1f919'],
            fname: '1f919',
            uc: '1f919',
            isCanonical: !1
        },
        ':bamboo:': {
            unicode: ['1f38d'],
            fname: '1f38d',
            uc: '1f38d',
            isCanonical: !0
        },
        ':man_dancing:': {
            unicode: ['1f57a'],
            fname: '1f57a',
            uc: '1f57a',
            isCanonical: !0
        },
        ':male_dancer:': {
            unicode: ['1f57a'],
            fname: '1f57a',
            uc: '1f57a',
            isCanonical: !1
        },
        ':dolls:': {
            unicode: ['1f38e'],
            fname: '1f38e',
            uc: '1f38e',
            isCanonical: !0
        },
        ':selfie:': {
            unicode: ['1f933'],
            fname: '1f933',
            uc: '1f933',
            isCanonical: !0
        },
        ':flags:': {
            unicode: ['1f38f'],
            fname: '1f38f',
            uc: '1f38f',
            isCanonical: !0
        },
        ':pregnant_woman:': {
            unicode: ['1f930'],
            fname: '1f930',
            uc: '1f930',
            isCanonical: !0
        },
        ':expecting_woman:': {
            unicode: ['1f930'],
            fname: '1f930',
            uc: '1f930',
            isCanonical: !1
        },
        ':wind_chime:': {
            unicode: ['1f390'],
            fname: '1f390',
            uc: '1f390',
            isCanonical: !0
        },
        ':face_palm:': {
            unicode: ['1f926'],
            fname: '1f926',
            uc: '1f926',
            isCanonical: !0
        },
        ':facepalm:': {
            unicode: ['1f926'],
            fname: '1f926',
            uc: '1f926',
            isCanonical: !1
        },
        ':shrug:': {
            unicode: ['1f937'],
            fname: '1f937',
            uc: '1f937',
            isCanonical: !0
        },
        ':rice_scene:': {
            unicode: ['1f391'],
            fname: '1f391',
            uc: '1f391',
            isCanonical: !0
        },
        ':school_satchel:': {
            unicode: ['1f392'],
            fname: '1f392',
            uc: '1f392',
            isCanonical: !0
        },
        ':mortar_board:': {
            unicode: ['1f393'],
            fname: '1f393',
            uc: '1f393',
            isCanonical: !0
        },
        ':carousel_horse:': {
            unicode: ['1f3a0'],
            fname: '1f3a0',
            uc: '1f3a0',
            isCanonical: !0
        },
        ':ferris_wheel:': {
            unicode: ['1f3a1'],
            fname: '1f3a1',
            uc: '1f3a1',
            isCanonical: !0
        },
        ':roller_coaster:': {
            unicode: ['1f3a2'],
            fname: '1f3a2',
            uc: '1f3a2',
            isCanonical: !0
        },
        ':fishing_pole_and_fish:': {
            unicode: ['1f3a3'],
            fname: '1f3a3',
            uc: '1f3a3',
            isCanonical: !0
        },
        ':microphone:': {
            unicode: ['1f3a4'],
            fname: '1f3a4',
            uc: '1f3a4',
            isCanonical: !0
        },
        ':movie_camera:': {
            unicode: ['1f3a5'],
            fname: '1f3a5',
            uc: '1f3a5',
            isCanonical: !0
        },
        ':cinema:': {
            unicode: ['1f3a6'],
            fname: '1f3a6',
            uc: '1f3a6',
            isCanonical: !0
        },
        ':headphones:': {
            unicode: ['1f3a7'],
            fname: '1f3a7',
            uc: '1f3a7',
            isCanonical: !0
        },
        ':mrs_claus:': {
            unicode: ['1f936'],
            fname: '1f936',
            uc: '1f936',
            isCanonical: !0
        },
        ':mother_christmas:': {
            unicode: ['1f936'],
            fname: '1f936',
            uc: '1f936',
            isCanonical: !1
        },
        ':art:': {
            unicode: ['1f3a8'],
            fname: '1f3a8',
            uc: '1f3a8',
            isCanonical: !0
        },
        ':man_in_tuxedo:': {
            unicode: ['1f935'],
            fname: '1f935',
            uc: '1f935',
            isCanonical: !0
        },
        ':tophat:': {
            unicode: ['1f3a9'],
            fname: '1f3a9',
            uc: '1f3a9',
            isCanonical: !0
        },
        ':circus_tent:': {
            unicode: ['1f3aa'],
            fname: '1f3aa',
            uc: '1f3aa',
            isCanonical: !0
        },
        ':prince:': {
            unicode: ['1f934'],
            fname: '1f934',
            uc: '1f934',
            isCanonical: !0
        },
        ':ticket:': {
            unicode: ['1f3ab'],
            fname: '1f3ab',
            uc: '1f3ab',
            isCanonical: !0
        },
        ':clapper:': {
            unicode: ['1f3ac'],
            fname: '1f3ac',
            uc: '1f3ac',
            isCanonical: !0
        },
        ':performing_arts:': {
            unicode: ['1f3ad'],
            fname: '1f3ad',
            uc: '1f3ad',
            isCanonical: !0
        },
        ':sneezing_face:': {
            unicode: ['1f927'],
            fname: '1f927',
            uc: '1f927',
            isCanonical: !0
        },
        ':sneeze:': {
            unicode: ['1f927'],
            fname: '1f927',
            uc: '1f927',
            isCanonical: !1
        },
        ':video_game:': {
            unicode: ['1f3ae'],
            fname: '1f3ae',
            uc: '1f3ae',
            isCanonical: !0
        },
        ':dart:': {
            unicode: ['1f3af'],
            fname: '1f3af',
            uc: '1f3af',
            isCanonical: !0
        },
        ':slot_machine:': {
            unicode: ['1f3b0'],
            fname: '1f3b0',
            uc: '1f3b0',
            isCanonical: !0
        },
        ':8ball:': {
            unicode: ['1f3b1'],
            fname: '1f3b1',
            uc: '1f3b1',
            isCanonical: !0
        },
        ':game_die:': {
            unicode: ['1f3b2'],
            fname: '1f3b2',
            uc: '1f3b2',
            isCanonical: !0
        },
        ':bowling:': {
            unicode: ['1f3b3'],
            fname: '1f3b3',
            uc: '1f3b3',
            isCanonical: !0
        },
        ':flower_playing_cards:': {
            unicode: ['1f3b4'],
            fname: '1f3b4',
            uc: '1f3b4',
            isCanonical: !0
        },
        ':lying_face:': {
            unicode: ['1f925'],
            fname: '1f925',
            uc: '1f925',
            isCanonical: !0
        },
        ':liar:': {
            unicode: ['1f925'],
            fname: '1f925',
            uc: '1f925',
            isCanonical: !1
        },
        ':musical_note:': {
            unicode: ['1f3b5'],
            fname: '1f3b5',
            uc: '1f3b5',
            isCanonical: !0
        },
        ':notes:': {
            unicode: ['1f3b6'],
            fname: '1f3b6',
            uc: '1f3b6',
            isCanonical: !0
        },
        ':saxophone:': {
            unicode: ['1f3b7'],
            fname: '1f3b7',
            uc: '1f3b7',
            isCanonical: !0
        },
        ':drooling_face:': {
            unicode: ['1f924'],
            fname: '1f924',
            uc: '1f924',
            isCanonical: !0
        },
        ':drool:': {
            unicode: ['1f924'],
            fname: '1f924',
            uc: '1f924',
            isCanonical: !1
        },
        ':guitar:': {
            unicode: ['1f3b8'],
            fname: '1f3b8',
            uc: '1f3b8',
            isCanonical: !0
        },
        ':musical_keyboard:': {
            unicode: ['1f3b9'],
            fname: '1f3b9',
            uc: '1f3b9',
            isCanonical: !0
        },
        ':trumpet:': {
            unicode: ['1f3ba'],
            fname: '1f3ba',
            uc: '1f3ba',
            isCanonical: !0
        },
        ':rofl:': {
            unicode: ['1f923'],
            fname: '1f923',
            uc: '1f923',
            isCanonical: !0
        },
        ':rolling_on_the_floor_laughing:': {
            unicode: ['1f923'],
            fname: '1f923',
            uc: '1f923',
            isCanonical: !1
        },
        ':violin:': {
            unicode: ['1f3bb'],
            fname: '1f3bb',
            uc: '1f3bb',
            isCanonical: !0
        },
        ':musical_score:': {
            unicode: ['1f3bc'],
            fname: '1f3bc',
            uc: '1f3bc',
            isCanonical: !0
        },
        ':running_shirt_with_sash:': {
            unicode: ['1f3bd'],
            fname: '1f3bd',
            uc: '1f3bd',
            isCanonical: !0
        },
        ':nauseated_face:': {
            unicode: ['1f922'],
            fname: '1f922',
            uc: '1f922',
            isCanonical: !0
        },
        ':sick:': {
            unicode: ['1f922'],
            fname: '1f922',
            uc: '1f922',
            isCanonical: !1
        },
        ':tennis:': {
            unicode: ['1f3be'],
            fname: '1f3be',
            uc: '1f3be',
            isCanonical: !0
        },
        ':ski:': {
            unicode: ['1f3bf'],
            fname: '1f3bf',
            uc: '1f3bf',
            isCanonical: !0
        },
        ':basketball:': {
            unicode: ['1f3c0'],
            fname: '1f3c0',
            uc: '1f3c0',
            isCanonical: !0
        },
        ':checkered_flag:': {
            unicode: ['1f3c1'],
            fname: '1f3c1',
            uc: '1f3c1',
            isCanonical: !0
        },
        ':clown:': {
            unicode: ['1f921'],
            fname: '1f921',
            uc: '1f921',
            isCanonical: !0
        },
        ':clown_face:': {
            unicode: ['1f921'],
            fname: '1f921',
            uc: '1f921',
            isCanonical: !1
        },
        ':snowboarder:': {
            unicode: ['1f3c2'],
            fname: '1f3c2',
            uc: '1f3c2',
            isCanonical: !0
        },
        ':runner:': {
            unicode: ['1f3c3'],
            fname: '1f3c3',
            uc: '1f3c3',
            isCanonical: !0
        },
        ':surfer:': {
            unicode: ['1f3c4'],
            fname: '1f3c4',
            uc: '1f3c4',
            isCanonical: !0
        },
        ':trophy:': {
            unicode: ['1f3c6'],
            fname: '1f3c6',
            uc: '1f3c6',
            isCanonical: !0
        },
        ':football:': {
            unicode: ['1f3c8'],
            fname: '1f3c8',
            uc: '1f3c8',
            isCanonical: !0
        },
        ':swimmer:': {
            unicode: ['1f3ca'],
            fname: '1f3ca',
            uc: '1f3ca',
            isCanonical: !0
        },
        ':house:': {
            unicode: ['1f3e0'],
            fname: '1f3e0',
            uc: '1f3e0',
            isCanonical: !0
        },
        ':house_with_garden:': {
            unicode: ['1f3e1'],
            fname: '1f3e1',
            uc: '1f3e1',
            isCanonical: !0
        },
        ':office:': {
            unicode: ['1f3e2'],
            fname: '1f3e2',
            uc: '1f3e2',
            isCanonical: !0
        },
        ':post_office:': {
            unicode: ['1f3e3'],
            fname: '1f3e3',
            uc: '1f3e3',
            isCanonical: !0
        },
        ':hospital:': {
            unicode: ['1f3e5'],
            fname: '1f3e5',
            uc: '1f3e5',
            isCanonical: !0
        },
        ':bank:': {
            unicode: ['1f3e6'],
            fname: '1f3e6',
            uc: '1f3e6',
            isCanonical: !0
        },
        ':atm:': {
            unicode: ['1f3e7'],
            fname: '1f3e7',
            uc: '1f3e7',
            isCanonical: !0
        },
        ':hotel:': {
            unicode: ['1f3e8'],
            fname: '1f3e8',
            uc: '1f3e8',
            isCanonical: !0
        },
        ':love_hotel:': {
            unicode: ['1f3e9'],
            fname: '1f3e9',
            uc: '1f3e9',
            isCanonical: !0
        },
        ':convenience_store:': {
            unicode: ['1f3ea'],
            fname: '1f3ea',
            uc: '1f3ea',
            isCanonical: !0
        },
        ':school:': {
            unicode: ['1f3eb'],
            fname: '1f3eb',
            uc: '1f3eb',
            isCanonical: !0
        },
        ':department_store:': {
            unicode: ['1f3ec'],
            fname: '1f3ec',
            uc: '1f3ec',
            isCanonical: !0
        },
        ':cowboy:': {
            unicode: ['1f920'],
            fname: '1f920',
            uc: '1f920',
            isCanonical: !0
        },
        ':face_with_cowboy_hat:': {
            unicode: ['1f920'],
            fname: '1f920',
            uc: '1f920',
            isCanonical: !1
        },
        ':factory:': {
            unicode: ['1f3ed'],
            fname: '1f3ed',
            uc: '1f3ed',
            isCanonical: !0
        },
        ':izakaya_lantern:': {
            unicode: ['1f3ee'],
            fname: '1f3ee',
            uc: '1f3ee',
            isCanonical: !0
        },
        ':japanese_castle:': {
            unicode: ['1f3ef'],
            fname: '1f3ef',
            uc: '1f3ef',
            isCanonical: !0
        },
        ':european_castle:': {
            unicode: ['1f3f0'],
            fname: '1f3f0',
            uc: '1f3f0',
            isCanonical: !0
        },
        ':snail:': {
            unicode: ['1f40c'],
            fname: '1f40c',
            uc: '1f40c',
            isCanonical: !0
        },
        ':snake:': {
            unicode: ['1f40d'],
            fname: '1f40d',
            uc: '1f40d',
            isCanonical: !0
        },
        ':racehorse:': {
            unicode: ['1f40e'],
            fname: '1f40e',
            uc: '1f40e',
            isCanonical: !0
        },
        ':sheep:': {
            unicode: ['1f411'],
            fname: '1f411',
            uc: '1f411',
            isCanonical: !0
        },
        ':monkey:': {
            unicode: ['1f412'],
            fname: '1f412',
            uc: '1f412',
            isCanonical: !0
        },
        ':chicken:': {
            unicode: ['1f414'],
            fname: '1f414',
            uc: '1f414',
            isCanonical: !0
        },
        ':boar:': {
            unicode: ['1f417'],
            fname: '1f417',
            uc: '1f417',
            isCanonical: !0
        },
        ':elephant:': {
            unicode: ['1f418'],
            fname: '1f418',
            uc: '1f418',
            isCanonical: !0
        },
        ':octopus:': {
            unicode: ['1f419'],
            fname: '1f419',
            uc: '1f419',
            isCanonical: !0
        },
        ':shell:': {
            unicode: ['1f41a'],
            fname: '1f41a',
            uc: '1f41a',
            isCanonical: !0
        },
        ':bug:': {
            unicode: ['1f41b'],
            fname: '1f41b',
            uc: '1f41b',
            isCanonical: !0
        },
        ':ant:': {
            unicode: ['1f41c'],
            fname: '1f41c',
            uc: '1f41c',
            isCanonical: !0
        },
        ':bee:': {
            unicode: ['1f41d'],
            fname: '1f41d',
            uc: '1f41d',
            isCanonical: !0
        },
        ':beetle:': {
            unicode: ['1f41e'],
            fname: '1f41e',
            uc: '1f41e',
            isCanonical: !0
        },
        ':fish:': {
            unicode: ['1f41f'],
            fname: '1f41f',
            uc: '1f41f',
            isCanonical: !0
        },
        ':tropical_fish:': {
            unicode: ['1f420'],
            fname: '1f420',
            uc: '1f420',
            isCanonical: !0
        },
        ':blowfish:': {
            unicode: ['1f421'],
            fname: '1f421',
            uc: '1f421',
            isCanonical: !0
        },
        ':turtle:': {
            unicode: ['1f422'],
            fname: '1f422',
            uc: '1f422',
            isCanonical: !0
        },
        ':hatching_chick:': {
            unicode: ['1f423'],
            fname: '1f423',
            uc: '1f423',
            isCanonical: !0
        },
        ':baby_chick:': {
            unicode: ['1f424'],
            fname: '1f424',
            uc: '1f424',
            isCanonical: !0
        },
        ':hatched_chick:': {
            unicode: ['1f425'],
            fname: '1f425',
            uc: '1f425',
            isCanonical: !0
        },
        ':bird:': {
            unicode: ['1f426'],
            fname: '1f426',
            uc: '1f426',
            isCanonical: !0
        },
        ':penguin:': {
            unicode: ['1f427'],
            fname: '1f427',
            uc: '1f427',
            isCanonical: !0
        },
        ':koala:': {
            unicode: ['1f428'],
            fname: '1f428',
            uc: '1f428',
            isCanonical: !0
        },
        ':poodle:': {
            unicode: ['1f429'],
            fname: '1f429',
            uc: '1f429',
            isCanonical: !0
        },
        ':camel:': {
            unicode: ['1f42b'],
            fname: '1f42b',
            uc: '1f42b',
            isCanonical: !0
        },
        ':dolphin:': {
            unicode: ['1f42c'],
            fname: '1f42c',
            uc: '1f42c',
            isCanonical: !0
        },
        ':mouse:': {
            unicode: ['1f42d'],
            fname: '1f42d',
            uc: '1f42d',
            isCanonical: !0
        },
        ':cow:': {
            unicode: ['1f42e'],
            fname: '1f42e',
            uc: '1f42e',
            isCanonical: !0
        },
        ':tiger:': {
            unicode: ['1f42f'],
            fname: '1f42f',
            uc: '1f42f',
            isCanonical: !0
        },
        ':rabbit:': {
            unicode: ['1f430'],
            fname: '1f430',
            uc: '1f430',
            isCanonical: !0
        },
        ':cat:': {
            unicode: ['1f431'],
            fname: '1f431',
            uc: '1f431',
            isCanonical: !0
        },
        ':dragon_face:': {
            unicode: ['1f432'],
            fname: '1f432',
            uc: '1f432',
            isCanonical: !0
        },
        ':whale:': {
            unicode: ['1f433'],
            fname: '1f433',
            uc: '1f433',
            isCanonical: !0
        },
        ':horse:': {
            unicode: ['1f434'],
            fname: '1f434',
            uc: '1f434',
            isCanonical: !0
        },
        ':monkey_face:': {
            unicode: ['1f435'],
            fname: '1f435',
            uc: '1f435',
            isCanonical: !0
        },
        ':dog:': {
            unicode: ['1f436'],
            fname: '1f436',
            uc: '1f436',
            isCanonical: !0
        },
        ':pig:': {
            unicode: ['1f437'],
            fname: '1f437',
            uc: '1f437',
            isCanonical: !0
        },
        ':frog:': {
            unicode: ['1f438'],
            fname: '1f438',
            uc: '1f438',
            isCanonical: !0
        },
        ':hamster:': {
            unicode: ['1f439'],
            fname: '1f439',
            uc: '1f439',
            isCanonical: !0
        },
        ':wolf:': {
            unicode: ['1f43a'],
            fname: '1f43a',
            uc: '1f43a',
            isCanonical: !0
        },
        ':bear:': {
            unicode: ['1f43b'],
            fname: '1f43b',
            uc: '1f43b',
            isCanonical: !0
        },
        ':panda_face:': {
            unicode: ['1f43c'],
            fname: '1f43c',
            uc: '1f43c',
            isCanonical: !0
        },
        ':pig_nose:': {
            unicode: ['1f43d'],
            fname: '1f43d',
            uc: '1f43d',
            isCanonical: !0
        },
        ':feet:': {
            unicode: ['1f43e'],
            fname: '1f43e',
            uc: '1f43e',
            isCanonical: !0
        },
        ':paw_prints:': {
            unicode: ['1f43e'],
            fname: '1f43e',
            uc: '1f43e',
            isCanonical: !1
        },
        ':eyes:': {
            unicode: ['1f440'],
            fname: '1f440',
            uc: '1f440',
            isCanonical: !0
        },
        ':ear:': {
            unicode: ['1f442'],
            fname: '1f442',
            uc: '1f442',
            isCanonical: !0
        },
        ':nose:': {
            unicode: ['1f443'],
            fname: '1f443',
            uc: '1f443',
            isCanonical: !0
        },
        ':lips:': {
            unicode: ['1f444'],
            fname: '1f444',
            uc: '1f444',
            isCanonical: !0
        },
        ':tongue:': {
            unicode: ['1f445'],
            fname: '1f445',
            uc: '1f445',
            isCanonical: !0
        },
        ':point_up_2:': {
            unicode: ['1f446'],
            fname: '1f446',
            uc: '1f446',
            isCanonical: !0
        },
        ':point_down:': {
            unicode: ['1f447'],
            fname: '1f447',
            uc: '1f447',
            isCanonical: !0
        },
        ':point_left:': {
            unicode: ['1f448'],
            fname: '1f448',
            uc: '1f448',
            isCanonical: !0
        },
        ':point_right:': {
            unicode: ['1f449'],
            fname: '1f449',
            uc: '1f449',
            isCanonical: !0
        },
        ':punch:': {
            unicode: ['1f44a'],
            fname: '1f44a',
            uc: '1f44a',
            isCanonical: !0
        },
        ':wave:': {
            unicode: ['1f44b'],
            fname: '1f44b',
            uc: '1f44b',
            isCanonical: !0
        },
        ':ok_hand:': {
            unicode: ['1f44c'],
            fname: '1f44c',
            uc: '1f44c',
            isCanonical: !0
        },
        ':thumbsup:': {
            unicode: ['1f44d'],
            fname: '1f44d',
            uc: '1f44d',
            isCanonical: !0
        },
        ':+1:': {
            unicode: ['1f44d'],
            fname: '1f44d',
            uc: '1f44d',
            isCanonical: !1
        },
        ':thumbup:': {
            unicode: ['1f44d'],
            fname: '1f44d',
            uc: '1f44d',
            isCanonical: !1
        },
        ':thumbsdown:': {
            unicode: ['1f44e'],
            fname: '1f44e',
            uc: '1f44e',
            isCanonical: !0
        },
        ':-1:': {
            unicode: ['1f44e'],
            fname: '1f44e',
            uc: '1f44e',
            isCanonical: !1
        },
        ':thumbdown:': {
            unicode: ['1f44e'],
            fname: '1f44e',
            uc: '1f44e',
            isCanonical: !1
        },
        ':clap:': {
            unicode: ['1f44f'],
            fname: '1f44f',
            uc: '1f44f',
            isCanonical: !0
        },
        ':open_hands:': {
            unicode: ['1f450'],
            fname: '1f450',
            uc: '1f450',
            isCanonical: !0
        },
        ':crown:': {
            unicode: ['1f451'],
            fname: '1f451',
            uc: '1f451',
            isCanonical: !0
        },
        ':womans_hat:': {
            unicode: ['1f452'],
            fname: '1f452',
            uc: '1f452',
            isCanonical: !0
        },
        ':eyeglasses:': {
            unicode: ['1f453'],
            fname: '1f453',
            uc: '1f453',
            isCanonical: !0
        },
        ':necktie:': {
            unicode: ['1f454'],
            fname: '1f454',
            uc: '1f454',
            isCanonical: !0
        },
        ':shirt:': {
            unicode: ['1f455'],
            fname: '1f455',
            uc: '1f455',
            isCanonical: !0
        },
        ':jeans:': {
            unicode: ['1f456'],
            fname: '1f456',
            uc: '1f456',
            isCanonical: !0
        },
        ':dress:': {
            unicode: ['1f457'],
            fname: '1f457',
            uc: '1f457',
            isCanonical: !0
        },
        ':kimono:': {
            unicode: ['1f458'],
            fname: '1f458',
            uc: '1f458',
            isCanonical: !0
        },
        ':bikini:': {
            unicode: ['1f459'],
            fname: '1f459',
            uc: '1f459',
            isCanonical: !0
        },
        ':womans_clothes:': {
            unicode: ['1f45a'],
            fname: '1f45a',
            uc: '1f45a',
            isCanonical: !0
        },
        ':purse:': {
            unicode: ['1f45b'],
            fname: '1f45b',
            uc: '1f45b',
            isCanonical: !0
        },
        ':handbag:': {
            unicode: ['1f45c'],
            fname: '1f45c',
            uc: '1f45c',
            isCanonical: !0
        },
        ':pouch:': {
            unicode: ['1f45d'],
            fname: '1f45d',
            uc: '1f45d',
            isCanonical: !0
        },
        ':mans_shoe:': {
            unicode: ['1f45e'],
            fname: '1f45e',
            uc: '1f45e',
            isCanonical: !0
        },
        ':athletic_shoe:': {
            unicode: ['1f45f'],
            fname: '1f45f',
            uc: '1f45f',
            isCanonical: !0
        },
        ':high_heel:': {
            unicode: ['1f460'],
            fname: '1f460',
            uc: '1f460',
            isCanonical: !0
        },
        ':sandal:': {
            unicode: ['1f461'],
            fname: '1f461',
            uc: '1f461',
            isCanonical: !0
        },
        ':boot:': {
            unicode: ['1f462'],
            fname: '1f462',
            uc: '1f462',
            isCanonical: !0
        },
        ':footprints:': {
            unicode: ['1f463'],
            fname: '1f463',
            uc: '1f463',
            isCanonical: !0
        },
        ':bust_in_silhouette:': {
            unicode: ['1f464'],
            fname: '1f464',
            uc: '1f464',
            isCanonical: !0
        },
        ':boy:': {
            unicode: ['1f466'],
            fname: '1f466',
            uc: '1f466',
            isCanonical: !0
        },
        ':girl:': {
            unicode: ['1f467'],
            fname: '1f467',
            uc: '1f467',
            isCanonical: !0
        },
        ':man:': {
            unicode: ['1f468'],
            fname: '1f468',
            uc: '1f468',
            isCanonical: !0
        },
        ':woman:': {
            unicode: ['1f469'],
            fname: '1f469',
            uc: '1f469',
            isCanonical: !0
        },
        ':family:': {
            unicode: ['1f46a'],
            fname: '1f46a',
            uc: '1f46a',
            isCanonical: !0
        },
        ':couple:': {
            unicode: ['1f46b'],
            fname: '1f46b',
            uc: '1f46b',
            isCanonical: !0
        },
        ':cop:': {
            unicode: ['1f46e'],
            fname: '1f46e',
            uc: '1f46e',
            isCanonical: !0
        },
        ':dancers:': {
            unicode: ['1f46f'],
            fname: '1f46f',
            uc: '1f46f',
            isCanonical: !0
        },
        ':bride_with_veil:': {
            unicode: ['1f470'],
            fname: '1f470',
            uc: '1f470',
            isCanonical: !0
        },
        ':person_with_blond_hair:': {
            unicode: ['1f471'],
            fname: '1f471',
            uc: '1f471',
            isCanonical: !0
        },
        ':man_with_gua_pi_mao:': {
            unicode: ['1f472'],
            fname: '1f472',
            uc: '1f472',
            isCanonical: !0
        },
        ':man_with_turban:': {
            unicode: ['1f473'],
            fname: '1f473',
            uc: '1f473',
            isCanonical: !0
        },
        ':older_man:': {
            unicode: ['1f474'],
            fname: '1f474',
            uc: '1f474',
            isCanonical: !0
        },
        ':older_woman:': {
            unicode: ['1f475'],
            fname: '1f475',
            uc: '1f475',
            isCanonical: !0
        },
        ':grandma:': {
            unicode: ['1f475'],
            fname: '1f475',
            uc: '1f475',
            isCanonical: !1
        },
        ':baby:': {
            unicode: ['1f476'],
            fname: '1f476',
            uc: '1f476',
            isCanonical: !0
        },
        ':construction_worker:': {
            unicode: ['1f477'],
            fname: '1f477',
            uc: '1f477',
            isCanonical: !0
        },
        ':princess:': {
            unicode: ['1f478'],
            fname: '1f478',
            uc: '1f478',
            isCanonical: !0
        },
        ':japanese_ogre:': {
            unicode: ['1f479'],
            fname: '1f479',
            uc: '1f479',
            isCanonical: !0
        },
        ':japanese_goblin:': {
            unicode: ['1f47a'],
            fname: '1f47a',
            uc: '1f47a',
            isCanonical: !0
        },
        ':ghost:': {
            unicode: ['1f47b'],
            fname: '1f47b',
            uc: '1f47b',
            isCanonical: !0
        },
        ':angel:': {
            unicode: ['1f47c'],
            fname: '1f47c',
            uc: '1f47c',
            isCanonical: !0
        },
        ':alien:': {
            unicode: ['1f47d'],
            fname: '1f47d',
            uc: '1f47d',
            isCanonical: !0
        },
        ':space_invader:': {
            unicode: ['1f47e'],
            fname: '1f47e',
            uc: '1f47e',
            isCanonical: !0
        },
        ':imp:': {
            unicode: ['1f47f'],
            fname: '1f47f',
            uc: '1f47f',
            isCanonical: !0
        },
        ':skull:': {
            unicode: ['1f480'],
            fname: '1f480',
            uc: '1f480',
            isCanonical: !0
        },
        ':skeleton:': {
            unicode: ['1f480'],
            fname: '1f480',
            uc: '1f480',
            isCanonical: !1
        },
        ':card_index:': {
            unicode: ['1f4c7'],
            fname: '1f4c7',
            uc: '1f4c7',
            isCanonical: !0
        },
        ':information_desk_person:': {
            unicode: ['1f481'],
            fname: '1f481',
            uc: '1f481',
            isCanonical: !0
        },
        ':guardsman:': {
            unicode: ['1f482'],
            fname: '1f482',
            uc: '1f482',
            isCanonical: !0
        },
        ':dancer:': {
            unicode: ['1f483'],
            fname: '1f483',
            uc: '1f483',
            isCanonical: !0
        },
        ':lipstick:': {
            unicode: ['1f484'],
            fname: '1f484',
            uc: '1f484',
            isCanonical: !0
        },
        ':nail_care:': {
            unicode: ['1f485'],
            fname: '1f485',
            uc: '1f485',
            isCanonical: !0
        },
        ':ledger:': {
            unicode: ['1f4d2'],
            fname: '1f4d2',
            uc: '1f4d2',
            isCanonical: !0
        },
        ':massage:': {
            unicode: ['1f486'],
            fname: '1f486',
            uc: '1f486',
            isCanonical: !0
        },
        ':notebook:': {
            unicode: ['1f4d3'],
            fname: '1f4d3',
            uc: '1f4d3',
            isCanonical: !0
        },
        ':haircut:': {
            unicode: ['1f487'],
            fname: '1f487',
            uc: '1f487',
            isCanonical: !0
        },
        ':notebook_with_decorative_cover:': {
            unicode: ['1f4d4'],
            fname: '1f4d4',
            uc: '1f4d4',
            isCanonical: !0
        },
        ':barber:': {
            unicode: ['1f488'],
            fname: '1f488',
            uc: '1f488',
            isCanonical: !0
        },
        ':closed_book:': {
            unicode: ['1f4d5'],
            fname: '1f4d5',
            uc: '1f4d5',
            isCanonical: !0
        },
        ':syringe:': {
            unicode: ['1f489'],
            fname: '1f489',
            uc: '1f489',
            isCanonical: !0
        },
        ':book:': {
            unicode: ['1f4d6'],
            fname: '1f4d6',
            uc: '1f4d6',
            isCanonical: !0
        },
        ':pill:': {
            unicode: ['1f48a'],
            fname: '1f48a',
            uc: '1f48a',
            isCanonical: !0
        },
        ':green_book:': {
            unicode: ['1f4d7'],
            fname: '1f4d7',
            uc: '1f4d7',
            isCanonical: !0
        },
        ':kiss:': {
            unicode: ['1f48b'],
            fname: '1f48b',
            uc: '1f48b',
            isCanonical: !0
        },
        ':blue_book:': {
            unicode: ['1f4d8'],
            fname: '1f4d8',
            uc: '1f4d8',
            isCanonical: !0
        },
        ':love_letter:': {
            unicode: ['1f48c'],
            fname: '1f48c',
            uc: '1f48c',
            isCanonical: !0
        },
        ':orange_book:': {
            unicode: ['1f4d9'],
            fname: '1f4d9',
            uc: '1f4d9',
            isCanonical: !0
        },
        ':ring:': {
            unicode: ['1f48d'],
            fname: '1f48d',
            uc: '1f48d',
            isCanonical: !0
        },
        ':books:': {
            unicode: ['1f4da'],
            fname: '1f4da',
            uc: '1f4da',
            isCanonical: !0
        },
        ':gem:': {
            unicode: ['1f48e'],
            fname: '1f48e',
            uc: '1f48e',
            isCanonical: !0
        },
        ':name_badge:': {
            unicode: ['1f4db'],
            fname: '1f4db',
            uc: '1f4db',
            isCanonical: !0
        },
        ':couplekiss:': {
            unicode: ['1f48f'],
            fname: '1f48f',
            uc: '1f48f',
            isCanonical: !0
        },
        ':scroll:': {
            unicode: ['1f4dc'],
            fname: '1f4dc',
            uc: '1f4dc',
            isCanonical: !0
        },
        ':bouquet:': {
            unicode: ['1f490'],
            fname: '1f490',
            uc: '1f490',
            isCanonical: !0
        },
        ':pencil:': {
            unicode: ['1f4dd'],
            fname: '1f4dd',
            uc: '1f4dd',
            isCanonical: !0
        },
        ':couple_with_heart:': {
            unicode: ['1f491'],
            fname: '1f491',
            uc: '1f491',
            isCanonical: !0
        },
        ':telephone_receiver:': {
            unicode: ['1f4de'],
            fname: '1f4de',
            uc: '1f4de',
            isCanonical: !0
        },
        ':wedding:': {
            unicode: ['1f492'],
            fname: '1f492',
            uc: '1f492',
            isCanonical: !0
        },
        ':pager:': {
            unicode: ['1f4df'],
            fname: '1f4df',
            uc: '1f4df',
            isCanonical: !0
        },
        ':fax:': {
            unicode: ['1f4e0'],
            fname: '1f4e0',
            uc: '1f4e0',
            isCanonical: !0
        },
        ':heartbeat:': {
            unicode: ['1f493'],
            fname: '1f493',
            uc: '1f493',
            isCanonical: !0
        },
        ':satellite:': {
            unicode: ['1f4e1'],
            fname: '1f4e1',
            uc: '1f4e1',
            isCanonical: !0
        },
        ':loudspeaker:': {
            unicode: ['1f4e2'],
            fname: '1f4e2',
            uc: '1f4e2',
            isCanonical: !0
        },
        ':broken_heart:': {
            unicode: ['1f494'],
            fname: '1f494',
            uc: '1f494',
            isCanonical: !0
        },
        ':mega:': {
            unicode: ['1f4e3'],
            fname: '1f4e3',
            uc: '1f4e3',
            isCanonical: !0
        },
        ':outbox_tray:': {
            unicode: ['1f4e4'],
            fname: '1f4e4',
            uc: '1f4e4',
            isCanonical: !0
        },
        ':two_hearts:': {
            unicode: ['1f495'],
            fname: '1f495',
            uc: '1f495',
            isCanonical: !0
        },
        ':inbox_tray:': {
            unicode: ['1f4e5'],
            fname: '1f4e5',
            uc: '1f4e5',
            isCanonical: !0
        },
        ':package:': {
            unicode: ['1f4e6'],
            fname: '1f4e6',
            uc: '1f4e6',
            isCanonical: !0
        },
        ':sparkling_heart:': {
            unicode: ['1f496'],
            fname: '1f496',
            uc: '1f496',
            isCanonical: !0
        },
        ':e-mail:': {
            unicode: ['1f4e7'],
            fname: '1f4e7',
            uc: '1f4e7',
            isCanonical: !0
        },
        ':email:': {
            unicode: ['1f4e7'],
            fname: '1f4e7',
            uc: '1f4e7',
            isCanonical: !1
        },
        ':incoming_envelope:': {
            unicode: ['1f4e8'],
            fname: '1f4e8',
            uc: '1f4e8',
            isCanonical: !0
        },
        ':heartpulse:': {
            unicode: ['1f497'],
            fname: '1f497',
            uc: '1f497',
            isCanonical: !0
        },
        ':envelope_with_arrow:': {
            unicode: ['1f4e9'],
            fname: '1f4e9',
            uc: '1f4e9',
            isCanonical: !0
        },
        ':mailbox_closed:': {
            unicode: ['1f4ea'],
            fname: '1f4ea',
            uc: '1f4ea',
            isCanonical: !0
        },
        ':cupid:': {
            unicode: ['1f498'],
            fname: '1f498',
            uc: '1f498',
            isCanonical: !0
        },
        ':mailbox:': {
            unicode: ['1f4eb'],
            fname: '1f4eb',
            uc: '1f4eb',
            isCanonical: !0
        },
        ':postbox:': {
            unicode: ['1f4ee'],
            fname: '1f4ee',
            uc: '1f4ee',
            isCanonical: !0
        },
        ':blue_heart:': {
            unicode: ['1f499'],
            fname: '1f499',
            uc: '1f499',
            isCanonical: !0
        },
        ':newspaper:': {
            unicode: ['1f4f0'],
            fname: '1f4f0',
            uc: '1f4f0',
            isCanonical: !0
        },
        ':iphone:': {
            unicode: ['1f4f1'],
            fname: '1f4f1',
            uc: '1f4f1',
            isCanonical: !0
        },
        ':green_heart:': {
            unicode: ['1f49a'],
            fname: '1f49a',
            uc: '1f49a',
            isCanonical: !0
        },
        ':calling:': {
            unicode: ['1f4f2'],
            fname: '1f4f2',
            uc: '1f4f2',
            isCanonical: !0
        },
        ':vibration_mode:': {
            unicode: ['1f4f3'],
            fname: '1f4f3',
            uc: '1f4f3',
            isCanonical: !0
        },
        ':yellow_heart:': {
            unicode: ['1f49b'],
            fname: '1f49b',
            uc: '1f49b',
            isCanonical: !0
        },
        ':mobile_phone_off:': {
            unicode: ['1f4f4'],
            fname: '1f4f4',
            uc: '1f4f4',
            isCanonical: !0
        },
        ':signal_strength:': {
            unicode: ['1f4f6'],
            fname: '1f4f6',
            uc: '1f4f6',
            isCanonical: !0
        },
        ':purple_heart:': {
            unicode: ['1f49c'],
            fname: '1f49c',
            uc: '1f49c',
            isCanonical: !0
        },
        ':camera:': {
            unicode: ['1f4f7'],
            fname: '1f4f7',
            uc: '1f4f7',
            isCanonical: !0
        },
        ':video_camera:': {
            unicode: ['1f4f9'],
            fname: '1f4f9',
            uc: '1f4f9',
            isCanonical: !0
        },
        ':gift_heart:': {
            unicode: ['1f49d'],
            fname: '1f49d',
            uc: '1f49d',
            isCanonical: !0
        },
        ':tv:': {
            unicode: ['1f4fa'],
            fname: '1f4fa',
            uc: '1f4fa',
            isCanonical: !0
        },
        ':radio:': {
            unicode: ['1f4fb'],
            fname: '1f4fb',
            uc: '1f4fb',
            isCanonical: !0
        },
        ':revolving_hearts:': {
            unicode: ['1f49e'],
            fname: '1f49e',
            uc: '1f49e',
            isCanonical: !0
        },
        ':vhs:': {
            unicode: ['1f4fc'],
            fname: '1f4fc',
            uc: '1f4fc',
            isCanonical: !0
        },
        ':arrows_clockwise:': {
            unicode: ['1f503'],
            fname: '1f503',
            uc: '1f503',
            isCanonical: !0
        },
        ':heart_decoration:': {
            unicode: ['1f49f'],
            fname: '1f49f',
            uc: '1f49f',
            isCanonical: !0
        },
        ':loud_sound:': {
            unicode: ['1f50a'],
            fname: '1f50a',
            uc: '1f50a',
            isCanonical: !0
        },
        ':battery:': {
            unicode: ['1f50b'],
            fname: '1f50b',
            uc: '1f50b',
            isCanonical: !0
        },
        ':diamond_shape_with_a_dot_inside:': {
            unicode: ['1f4a0'],
            fname: '1f4a0',
            uc: '1f4a0',
            isCanonical: !0
        },
        ':electric_plug:': {
            unicode: ['1f50c'],
            fname: '1f50c',
            uc: '1f50c',
            isCanonical: !0
        },
        ':mag:': {
            unicode: ['1f50d'],
            fname: '1f50d',
            uc: '1f50d',
            isCanonical: !0
        },
        ':bulb:': {
            unicode: ['1f4a1'],
            fname: '1f4a1',
            uc: '1f4a1',
            isCanonical: !0
        },
        ':mag_right:': {
            unicode: ['1f50e'],
            fname: '1f50e',
            uc: '1f50e',
            isCanonical: !0
        },
        ':lock_with_ink_pen:': {
            unicode: ['1f50f'],
            fname: '1f50f',
            uc: '1f50f',
            isCanonical: !0
        },
        ':anger:': {
            unicode: ['1f4a2'],
            fname: '1f4a2',
            uc: '1f4a2',
            isCanonical: !0
        },
        ':closed_lock_with_key:': {
            unicode: ['1f510'],
            fname: '1f510',
            uc: '1f510',
            isCanonical: !0
        },
        ':key:': {
            unicode: ['1f511'],
            fname: '1f511',
            uc: '1f511',
            isCanonical: !0
        },
        ':bomb:': {
            unicode: ['1f4a3'],
            fname: '1f4a3',
            uc: '1f4a3',
            isCanonical: !0
        },
        ':lock:': {
            unicode: ['1f512'],
            fname: '1f512',
            uc: '1f512',
            isCanonical: !0
        },
        ':unlock:': {
            unicode: ['1f513'],
            fname: '1f513',
            uc: '1f513',
            isCanonical: !0
        },
        ':zzz:': {
            unicode: ['1f4a4'],
            fname: '1f4a4',
            uc: '1f4a4',
            isCanonical: !0
        },
        ':bell:': {
            unicode: ['1f514'],
            fname: '1f514',
            uc: '1f514',
            isCanonical: !0
        },
        ':bookmark:': {
            unicode: ['1f516'],
            fname: '1f516',
            uc: '1f516',
            isCanonical: !0
        },
        ':boom:': {
            unicode: ['1f4a5'],
            fname: '1f4a5',
            uc: '1f4a5',
            isCanonical: !0
        },
        ':link:': {
            unicode: ['1f517'],
            fname: '1f517',
            uc: '1f517',
            isCanonical: !0
        },
        ':radio_button:': {
            unicode: ['1f518'],
            fname: '1f518',
            uc: '1f518',
            isCanonical: !0
        },
        ':sweat_drops:': {
            unicode: ['1f4a6'],
            fname: '1f4a6',
            uc: '1f4a6',
            isCanonical: !0
        },
        ':back:': {
            unicode: ['1f519'],
            fname: '1f519',
            uc: '1f519',
            isCanonical: !0
        },
        ':end:': {
            unicode: ['1f51a'],
            fname: '1f51a',
            uc: '1f51a',
            isCanonical: !0
        },
        ':droplet:': {
            unicode: ['1f4a7'],
            fname: '1f4a7',
            uc: '1f4a7',
            isCanonical: !0
        },
        ':on:': {
            unicode: ['1f51b'],
            fname: '1f51b',
            uc: '1f51b',
            isCanonical: !0
        },
        ':soon:': {
            unicode: ['1f51c'],
            fname: '1f51c',
            uc: '1f51c',
            isCanonical: !0
        },
        ':dash:': {
            unicode: ['1f4a8'],
            fname: '1f4a8',
            uc: '1f4a8',
            isCanonical: !0
        },
        ':top:': {
            unicode: ['1f51d'],
            fname: '1f51d',
            uc: '1f51d',
            isCanonical: !0
        },
        ':underage:': {
            unicode: ['1f51e'],
            fname: '1f51e',
            uc: '1f51e',
            isCanonical: !0
        },
        ':poop:': {
            unicode: ['1f4a9'],
            fname: '1f4a9',
            uc: '1f4a9',
            isCanonical: !0
        },
        ':shit:': {
            unicode: ['1f4a9'],
            fname: '1f4a9',
            uc: '1f4a9',
            isCanonical: !1
        },
        ':hankey:': {
            unicode: ['1f4a9'],
            fname: '1f4a9',
            uc: '1f4a9',
            isCanonical: !1
        },
        ':poo:': {
            unicode: ['1f4a9'],
            fname: '1f4a9',
            uc: '1f4a9',
            isCanonical: !1
        },
        ':keycap_ten:': {
            unicode: ['1f51f'],
            fname: '1f51f',
            uc: '1f51f',
            isCanonical: !0
        },
        ':muscle:': {
            unicode: ['1f4aa'],
            fname: '1f4aa',
            uc: '1f4aa',
            isCanonical: !0
        },
        ':capital_abcd:': {
            unicode: ['1f520'],
            fname: '1f520',
            uc: '1f520',
            isCanonical: !0
        },
        ':abcd:': {
            unicode: ['1f521'],
            fname: '1f521',
            uc: '1f521',
            isCanonical: !0
        },
        ':dizzy:': {
            unicode: ['1f4ab'],
            fname: '1f4ab',
            uc: '1f4ab',
            isCanonical: !0
        },
        ':1234:': {
            unicode: ['1f522'],
            fname: '1f522',
            uc: '1f522',
            isCanonical: !0
        },
        ':symbols:': {
            unicode: ['1f523'],
            fname: '1f523',
            uc: '1f523',
            isCanonical: !0
        },
        ':speech_balloon:': {
            unicode: ['1f4ac'],
            fname: '1f4ac',
            uc: '1f4ac',
            isCanonical: !0
        },
        ':abc:': {
            unicode: ['1f524'],
            fname: '1f524',
            uc: '1f524',
            isCanonical: !0
        },
        ':fire:': {
            unicode: ['1f525'],
            fname: '1f525',
            uc: '1f525',
            isCanonical: !0
        },
        ':flame:': {
            unicode: ['1f525'],
            fname: '1f525',
            uc: '1f525',
            isCanonical: !1
        },
        ':white_flower:': {
            unicode: ['1f4ae'],
            fname: '1f4ae',
            uc: '1f4ae',
            isCanonical: !0
        },
        ':flashlight:': {
            unicode: ['1f526'],
            fname: '1f526',
            uc: '1f526',
            isCanonical: !0
        },
        ':wrench:': {
            unicode: ['1f527'],
            fname: '1f527',
            uc: '1f527',
            isCanonical: !0
        },
        ':100:': {
            unicode: ['1f4af'],
            fname: '1f4af',
            uc: '1f4af',
            isCanonical: !0
        },
        ':hammer:': {
            unicode: ['1f528'],
            fname: '1f528',
            uc: '1f528',
            isCanonical: !0
        },
        ':nut_and_bolt:': {
            unicode: ['1f529'],
            fname: '1f529',
            uc: '1f529',
            isCanonical: !0
        },
        ':moneybag:': {
            unicode: ['1f4b0'],
            fname: '1f4b0',
            uc: '1f4b0',
            isCanonical: !0
        },
        ':knife:': {
            unicode: ['1f52a'],
            fname: '1f52a',
            uc: '1f52a',
            isCanonical: !0
        },
        ':gun:': {
            unicode: ['1f52b'],
            fname: '1f52b',
            uc: '1f52b',
            isCanonical: !0
        },
        ':currency_exchange:': {
            unicode: ['1f4b1'],
            fname: '1f4b1',
            uc: '1f4b1',
            isCanonical: !0
        },
        ':crystal_ball:': {
            unicode: ['1f52e'],
            fname: '1f52e',
            uc: '1f52e',
            isCanonical: !0
        },
        ':heavy_dollar_sign:': {
            unicode: ['1f4b2'],
            fname: '1f4b2',
            uc: '1f4b2',
            isCanonical: !0
        },
        ':six_pointed_star:': {
            unicode: ['1f52f'],
            fname: '1f52f',
            uc: '1f52f',
            isCanonical: !0
        },
        ':credit_card:': {
            unicode: ['1f4b3'],
            fname: '1f4b3',
            uc: '1f4b3',
            isCanonical: !0
        },
        ':beginner:': {
            unicode: ['1f530'],
            fname: '1f530',
            uc: '1f530',
            isCanonical: !0
        },
        ':trident:': {
            unicode: ['1f531'],
            fname: '1f531',
            uc: '1f531',
            isCanonical: !0
        },
        ':yen:': {
            unicode: ['1f4b4'],
            fname: '1f4b4',
            uc: '1f4b4',
            isCanonical: !0
        },
        ':black_square_button:': {
            unicode: ['1f532'],
            fname: '1f532',
            uc: '1f532',
            isCanonical: !0
        },
        ':white_square_button:': {
            unicode: ['1f533'],
            fname: '1f533',
            uc: '1f533',
            isCanonical: !0
        },
        ':dollar:': {
            unicode: ['1f4b5'],
            fname: '1f4b5',
            uc: '1f4b5',
            isCanonical: !0
        },
        ':red_circle:': {
            unicode: ['1f534'],
            fname: '1f534',
            uc: '1f534',
            isCanonical: !0
        },
        ':blue_circle:': {
            unicode: ['1f535'],
            fname: '1f535',
            uc: '1f535',
            isCanonical: !0
        },
        ':money_with_wings:': {
            unicode: ['1f4b8'],
            fname: '1f4b8',
            uc: '1f4b8',
            isCanonical: !0
        },
        ':large_orange_diamond:': {
            unicode: ['1f536'],
            fname: '1f536',
            uc: '1f536',
            isCanonical: !0
        },
        ':large_blue_diamond:': {
            unicode: ['1f537'],
            fname: '1f537',
            uc: '1f537',
            isCanonical: !0
        },
        ':chart:': {
            unicode: ['1f4b9'],
            fname: '1f4b9',
            uc: '1f4b9',
            isCanonical: !0
        },
        ':small_orange_diamond:': {
            unicode: ['1f538'],
            fname: '1f538',
            uc: '1f538',
            isCanonical: !0
        },
        ':small_blue_diamond:': {
            unicode: ['1f539'],
            fname: '1f539',
            uc: '1f539',
            isCanonical: !0
        },
        ':seat:': {
            unicode: ['1f4ba'],
            fname: '1f4ba',
            uc: '1f4ba',
            isCanonical: !0
        },
        ':small_red_triangle:': {
            unicode: ['1f53a'],
            fname: '1f53a',
            uc: '1f53a',
            isCanonical: !0
        },
        ':small_red_triangle_down:': {
            unicode: ['1f53b'],
            fname: '1f53b',
            uc: '1f53b',
            isCanonical: !0
        },
        ':computer:': {
            unicode: ['1f4bb'],
            fname: '1f4bb',
            uc: '1f4bb',
            isCanonical: !0
        },
        ':arrow_up_small:': {
            unicode: ['1f53c'],
            fname: '1f53c',
            uc: '1f53c',
            isCanonical: !0
        },
        ':briefcase:': {
            unicode: ['1f4bc'],
            fname: '1f4bc',
            uc: '1f4bc',
            isCanonical: !0
        },
        ':arrow_down_small:': {
            unicode: ['1f53d'],
            fname: '1f53d',
            uc: '1f53d',
            isCanonical: !0
        },
        ':clock1:': {
            unicode: ['1f550'],
            fname: '1f550',
            uc: '1f550',
            isCanonical: !0
        },
        ':minidisc:': {
            unicode: ['1f4bd'],
            fname: '1f4bd',
            uc: '1f4bd',
            isCanonical: !0
        },
        ':clock2:': {
            unicode: ['1f551'],
            fname: '1f551',
            uc: '1f551',
            isCanonical: !0
        },
        ':floppy_disk:': {
            unicode: ['1f4be'],
            fname: '1f4be',
            uc: '1f4be',
            isCanonical: !0
        },
        ':clock3:': {
            unicode: ['1f552'],
            fname: '1f552',
            uc: '1f552',
            isCanonical: !0
        },
        ':cd:': {
            unicode: ['1f4bf'],
            fname: '1f4bf',
            uc: '1f4bf',
            isCanonical: !0
        },
        ':clock4:': {
            unicode: ['1f553'],
            fname: '1f553',
            uc: '1f553',
            isCanonical: !0
        },
        ':dvd:': {
            unicode: ['1f4c0'],
            fname: '1f4c0',
            uc: '1f4c0',
            isCanonical: !0
        },
        ':clock5:': {
            unicode: ['1f554'],
            fname: '1f554',
            uc: '1f554',
            isCanonical: !0
        },
        ':clock6:': {
            unicode: ['1f555'],
            fname: '1f555',
            uc: '1f555',
            isCanonical: !0
        },
        ':file_folder:': {
            unicode: ['1f4c1'],
            fname: '1f4c1',
            uc: '1f4c1',
            isCanonical: !0
        },
        ':clock7:': {
            unicode: ['1f556'],
            fname: '1f556',
            uc: '1f556',
            isCanonical: !0
        },
        ':clock8:': {
            unicode: ['1f557'],
            fname: '1f557',
            uc: '1f557',
            isCanonical: !0
        },
        ':open_file_folder:': {
            unicode: ['1f4c2'],
            fname: '1f4c2',
            uc: '1f4c2',
            isCanonical: !0
        },
        ':clock9:': {
            unicode: ['1f558'],
            fname: '1f558',
            uc: '1f558',
            isCanonical: !0
        },
        ':clock10:': {
            unicode: ['1f559'],
            fname: '1f559',
            uc: '1f559',
            isCanonical: !0
        },
        ':page_with_curl:': {
            unicode: ['1f4c3'],
            fname: '1f4c3',
            uc: '1f4c3',
            isCanonical: !0
        },
        ':clock11:': {
            unicode: ['1f55a'],
            fname: '1f55a',
            uc: '1f55a',
            isCanonical: !0
        },
        ':clock12:': {
            unicode: ['1f55b'],
            fname: '1f55b',
            uc: '1f55b',
            isCanonical: !0
        },
        ':page_facing_up:': {
            unicode: ['1f4c4'],
            fname: '1f4c4',
            uc: '1f4c4',
            isCanonical: !0
        },
        ':mount_fuji:': {
            unicode: ['1f5fb'],
            fname: '1f5fb',
            uc: '1f5fb',
            isCanonical: !0
        },
        ':tokyo_tower:': {
            unicode: ['1f5fc'],
            fname: '1f5fc',
            uc: '1f5fc',
            isCanonical: !0
        },
        ':date:': {
            unicode: ['1f4c5'],
            fname: '1f4c5',
            uc: '1f4c5',
            isCanonical: !0
        },
        ':statue_of_liberty:': {
            unicode: ['1f5fd'],
            fname: '1f5fd',
            uc: '1f5fd',
            isCanonical: !0
        },
        ':japan:': {
            unicode: ['1f5fe'],
            fname: '1f5fe',
            uc: '1f5fe',
            isCanonical: !0
        },
        ':calendar:': {
            unicode: ['1f4c6'],
            fname: '1f4c6',
            uc: '1f4c6',
            isCanonical: !0
        },
        ':moyai:': {
            unicode: ['1f5ff'],
            fname: '1f5ff',
            uc: '1f5ff',
            isCanonical: !0
        },
        ':grin:': {
            unicode: ['1f601'],
            fname: '1f601',
            uc: '1f601',
            isCanonical: !0
        },
        ':joy:': {
            unicode: ['1f602'],
            fname: '1f602',
            uc: '1f602',
            isCanonical: !0
        },
        ':smiley:': {
            unicode: ['1f603'],
            fname: '1f603',
            uc: '1f603',
            isCanonical: !0
        },
        ':chart_with_upwards_trend:': {
            unicode: ['1f4c8'],
            fname: '1f4c8',
            uc: '1f4c8',
            isCanonical: !0
        },
        ':smile:': {
            unicode: ['1f604'],
            fname: '1f604',
            uc: '1f604',
            isCanonical: !0
        },
        ':sweat_smile:': {
            unicode: ['1f605'],
            fname: '1f605',
            uc: '1f605',
            isCanonical: !0
        },
        ':chart_with_downwards_trend:': {
            unicode: ['1f4c9'],
            fname: '1f4c9',
            uc: '1f4c9',
            isCanonical: !0
        },
        ':laughing:': {
            unicode: ['1f606'],
            fname: '1f606',
            uc: '1f606',
            isCanonical: !0
        },
        ':satisfied:': {
            unicode: ['1f606'],
            fname: '1f606',
            uc: '1f606',
            isCanonical: !1
        },
        ':wink:': {
            unicode: ['1f609'],
            fname: '1f609',
            uc: '1f609',
            isCanonical: !0
        },
        ':bar_chart:': {
            unicode: ['1f4ca'],
            fname: '1f4ca',
            uc: '1f4ca',
            isCanonical: !0
        },
        ':blush:': {
            unicode: ['1f60a'],
            fname: '1f60a',
            uc: '1f60a',
            isCanonical: !0
        },
        ':yum:': {
            unicode: ['1f60b'],
            fname: '1f60b',
            uc: '1f60b',
            isCanonical: !0
        },
        ':clipboard:': {
            unicode: ['1f4cb'],
            fname: '1f4cb',
            uc: '1f4cb',
            isCanonical: !0
        },
        ':relieved:': {
            unicode: ['1f60c'],
            fname: '1f60c',
            uc: '1f60c',
            isCanonical: !0
        },
        ':heart_eyes:': {
            unicode: ['1f60d'],
            fname: '1f60d',
            uc: '1f60d',
            isCanonical: !0
        },
        ':pushpin:': {
            unicode: ['1f4cc'],
            fname: '1f4cc',
            uc: '1f4cc',
            isCanonical: !0
        },
        ':smirk:': {
            unicode: ['1f60f'],
            fname: '1f60f',
            uc: '1f60f',
            isCanonical: !0
        },
        ':unamused:': {
            unicode: ['1f612'],
            fname: '1f612',
            uc: '1f612',
            isCanonical: !0
        },
        ':round_pushpin:': {
            unicode: ['1f4cd'],
            fname: '1f4cd',
            uc: '1f4cd',
            isCanonical: !0
        },
        ':sweat:': {
            unicode: ['1f613'],
            fname: '1f613',
            uc: '1f613',
            isCanonical: !0
        },
        ':pensive:': {
            unicode: ['1f614'],
            fname: '1f614',
            uc: '1f614',
            isCanonical: !0
        },
        ':paperclip:': {
            unicode: ['1f4ce'],
            fname: '1f4ce',
            uc: '1f4ce',
            isCanonical: !0
        },
        ':confounded:': {
            unicode: ['1f616'],
            fname: '1f616',
            uc: '1f616',
            isCanonical: !0
        },
        ':kissing_heart:': {
            unicode: ['1f618'],
            fname: '1f618',
            uc: '1f618',
            isCanonical: !0
        },
        ':straight_ruler:': {
            unicode: ['1f4cf'],
            fname: '1f4cf',
            uc: '1f4cf',
            isCanonical: !0
        },
        ':kissing_closed_eyes:': {
            unicode: ['1f61a'],
            fname: '1f61a',
            uc: '1f61a',
            isCanonical: !0
        },
        ':stuck_out_tongue_winking_eye:': {
            unicode: ['1f61c'],
            fname: '1f61c',
            uc: '1f61c',
            isCanonical: !0
        },
        ':triangular_ruler:': {
            unicode: ['1f4d0'],
            fname: '1f4d0',
            uc: '1f4d0',
            isCanonical: !0
        },
        ':stuck_out_tongue_closed_eyes:': {
            unicode: ['1f61d'],
            fname: '1f61d',
            uc: '1f61d',
            isCanonical: !0
        },
        ':disappointed:': {
            unicode: ['1f61e'],
            fname: '1f61e',
            uc: '1f61e',
            isCanonical: !0
        },
        ':bookmark_tabs:': {
            unicode: ['1f4d1'],
            fname: '1f4d1',
            uc: '1f4d1',
            isCanonical: !0
        },
        ':angry:': {
            unicode: ['1f620'],
            fname: '1f620',
            uc: '1f620',
            isCanonical: !0
        },
        ':rage:': {
            unicode: ['1f621'],
            fname: '1f621',
            uc: '1f621',
            isCanonical: !0
        },
        ':cry:': {
            unicode: ['1f622'],
            fname: '1f622',
            uc: '1f622',
            isCanonical: !0
        },
        ':persevere:': {
            unicode: ['1f623'],
            fname: '1f623',
            uc: '1f623',
            isCanonical: !0
        },
        ':triumph:': {
            unicode: ['1f624'],
            fname: '1f624',
            uc: '1f624',
            isCanonical: !0
        },
        ':disappointed_relieved:': {
            unicode: ['1f625'],
            fname: '1f625',
            uc: '1f625',
            isCanonical: !0
        },
        ':fearful:': {
            unicode: ['1f628'],
            fname: '1f628',
            uc: '1f628',
            isCanonical: !0
        },
        ':weary:': {
            unicode: ['1f629'],
            fname: '1f629',
            uc: '1f629',
            isCanonical: !0
        },
        ':sleepy:': {
            unicode: ['1f62a'],
            fname: '1f62a',
            uc: '1f62a',
            isCanonical: !0
        },
        ':tired_face:': {
            unicode: ['1f62b'],
            fname: '1f62b',
            uc: '1f62b',
            isCanonical: !0
        },
        ':sob:': {
            unicode: ['1f62d'],
            fname: '1f62d',
            uc: '1f62d',
            isCanonical: !0
        },
        ':cold_sweat:': {
            unicode: ['1f630'],
            fname: '1f630',
            uc: '1f630',
            isCanonical: !0
        },
        ':scream:': {
            unicode: ['1f631'],
            fname: '1f631',
            uc: '1f631',
            isCanonical: !0
        },
        ':astonished:': {
            unicode: ['1f632'],
            fname: '1f632',
            uc: '1f632',
            isCanonical: !0
        },
        ':flushed:': {
            unicode: ['1f633'],
            fname: '1f633',
            uc: '1f633',
            isCanonical: !0
        },
        ':dizzy_face:': {
            unicode: ['1f635'],
            fname: '1f635',
            uc: '1f635',
            isCanonical: !0
        },
        ':mask:': {
            unicode: ['1f637'],
            fname: '1f637',
            uc: '1f637',
            isCanonical: !0
        },
        ':smile_cat:': {
            unicode: ['1f638'],
            fname: '1f638',
            uc: '1f638',
            isCanonical: !0
        },
        ':joy_cat:': {
            unicode: ['1f639'],
            fname: '1f639',
            uc: '1f639',
            isCanonical: !0
        },
        ':smiley_cat:': {
            unicode: ['1f63a'],
            fname: '1f63a',
            uc: '1f63a',
            isCanonical: !0
        },
        ':heart_eyes_cat:': {
            unicode: ['1f63b'],
            fname: '1f63b',
            uc: '1f63b',
            isCanonical: !0
        },
        ':smirk_cat:': {
            unicode: ['1f63c'],
            fname: '1f63c',
            uc: '1f63c',
            isCanonical: !0
        },
        ':kissing_cat:': {
            unicode: ['1f63d'],
            fname: '1f63d',
            uc: '1f63d',
            isCanonical: !0
        },
        ':pouting_cat:': {
            unicode: ['1f63e'],
            fname: '1f63e',
            uc: '1f63e',
            isCanonical: !0
        },
        ':crying_cat_face:': {
            unicode: ['1f63f'],
            fname: '1f63f',
            uc: '1f63f',
            isCanonical: !0
        },
        ':scream_cat:': {
            unicode: ['1f640'],
            fname: '1f640',
            uc: '1f640',
            isCanonical: !0
        },
        ':no_good:': {
            unicode: ['1f645'],
            fname: '1f645',
            uc: '1f645',
            isCanonical: !0
        },
        ':ok_woman:': {
            unicode: ['1f646'],
            fname: '1f646',
            uc: '1f646',
            isCanonical: !0
        },
        ':bow:': {
            unicode: ['1f647'],
            fname: '1f647',
            uc: '1f647',
            isCanonical: !0
        },
        ':see_no_evil:': {
            unicode: ['1f648'],
            fname: '1f648',
            uc: '1f648',
            isCanonical: !0
        },
        ':hear_no_evil:': {
            unicode: ['1f649'],
            fname: '1f649',
            uc: '1f649',
            isCanonical: !0
        },
        ':speak_no_evil:': {
            unicode: ['1f64a'],
            fname: '1f64a',
            uc: '1f64a',
            isCanonical: !0
        },
        ':raising_hand:': {
            unicode: ['1f64b'],
            fname: '1f64b',
            uc: '1f64b',
            isCanonical: !0
        },
        ':raised_hands:': {
            unicode: ['1f64c'],
            fname: '1f64c',
            uc: '1f64c',
            isCanonical: !0
        },
        ':person_frowning:': {
            unicode: ['1f64d'],
            fname: '1f64d',
            uc: '1f64d',
            isCanonical: !0
        },
        ':person_with_pouting_face:': {
            unicode: ['1f64e'],
            fname: '1f64e',
            uc: '1f64e',
            isCanonical: !0
        },
        ':pray:': {
            unicode: ['1f64f'],
            fname: '1f64f',
            uc: '1f64f',
            isCanonical: !0
        },
        ':rocket:': {
            unicode: ['1f680'],
            fname: '1f680',
            uc: '1f680',
            isCanonical: !0
        },
        ':railway_car:': {
            unicode: ['1f683'],
            fname: '1f683',
            uc: '1f683',
            isCanonical: !0
        },
        ':bullettrain_side:': {
            unicode: ['1f684'],
            fname: '1f684',
            uc: '1f684',
            isCanonical: !0
        },
        ':bullettrain_front:': {
            unicode: ['1f685'],
            fname: '1f685',
            uc: '1f685',
            isCanonical: !0
        },
        ':metro:': {
            unicode: ['1f687'],
            fname: '1f687',
            uc: '1f687',
            isCanonical: !0
        },
        ':station:': {
            unicode: ['1f689'],
            fname: '1f689',
            uc: '1f689',
            isCanonical: !0
        },
        ':bus:': {
            unicode: ['1f68c'],
            fname: '1f68c',
            uc: '1f68c',
            isCanonical: !0
        },
        ':busstop:': {
            unicode: ['1f68f'],
            fname: '1f68f',
            uc: '1f68f',
            isCanonical: !0
        },
        ':ambulance:': {
            unicode: ['1f691'],
            fname: '1f691',
            uc: '1f691',
            isCanonical: !0
        },
        ':fire_engine:': {
            unicode: ['1f692'],
            fname: '1f692',
            uc: '1f692',
            isCanonical: !0
        },
        ':police_car:': {
            unicode: ['1f693'],
            fname: '1f693',
            uc: '1f693',
            isCanonical: !0
        },
        ':taxi:': {
            unicode: ['1f695'],
            fname: '1f695',
            uc: '1f695',
            isCanonical: !0
        },
        ':red_car:': {
            unicode: ['1f697'],
            fname: '1f697',
            uc: '1f697',
            isCanonical: !0
        },
        ':blue_car:': {
            unicode: ['1f699'],
            fname: '1f699',
            uc: '1f699',
            isCanonical: !0
        },
        ':truck:': {
            unicode: ['1f69a'],
            fname: '1f69a',
            uc: '1f69a',
            isCanonical: !0
        },
        ':ship:': {
            unicode: ['1f6a2'],
            fname: '1f6a2',
            uc: '1f6a2',
            isCanonical: !0
        },
        ':speedboat:': {
            unicode: ['1f6a4'],
            fname: '1f6a4',
            uc: '1f6a4',
            isCanonical: !0
        },
        ':traffic_light:': {
            unicode: ['1f6a5'],
            fname: '1f6a5',
            uc: '1f6a5',
            isCanonical: !0
        },
        ':construction:': {
            unicode: ['1f6a7'],
            fname: '1f6a7',
            uc: '1f6a7',
            isCanonical: !0
        },
        ':rotating_light:': {
            unicode: ['1f6a8'],
            fname: '1f6a8',
            uc: '1f6a8',
            isCanonical: !0
        },
        ':triangular_flag_on_post:': {
            unicode: ['1f6a9'],
            fname: '1f6a9',
            uc: '1f6a9',
            isCanonical: !0
        },
        ':door:': {
            unicode: ['1f6aa'],
            fname: '1f6aa',
            uc: '1f6aa',
            isCanonical: !0
        },
        ':no_entry_sign:': {
            unicode: ['1f6ab'],
            fname: '1f6ab',
            uc: '1f6ab',
            isCanonical: !0
        },
        ':smoking:': {
            unicode: ['1f6ac'],
            fname: '1f6ac',
            uc: '1f6ac',
            isCanonical: !0
        },
        ':no_smoking:': {
            unicode: ['1f6ad'],
            fname: '1f6ad',
            uc: '1f6ad',
            isCanonical: !0
        },
        ':bike:': {
            unicode: ['1f6b2'],
            fname: '1f6b2',
            uc: '1f6b2',
            isCanonical: !0
        },
        ':walking:': {
            unicode: ['1f6b6'],
            fname: '1f6b6',
            uc: '1f6b6',
            isCanonical: !0
        },
        ':mens:': {
            unicode: ['1f6b9'],
            fname: '1f6b9',
            uc: '1f6b9',
            isCanonical: !0
        },
        ':womens:': {
            unicode: ['1f6ba'],
            fname: '1f6ba',
            uc: '1f6ba',
            isCanonical: !0
        },
        ':restroom:': {
            unicode: ['1f6bb'],
            fname: '1f6bb',
            uc: '1f6bb',
            isCanonical: !0
        },
        ':baby_symbol:': {
            unicode: ['1f6bc'],
            fname: '1f6bc',
            uc: '1f6bc',
            isCanonical: !0
        },
        ':toilet:': {
            unicode: ['1f6bd'],
            fname: '1f6bd',
            uc: '1f6bd',
            isCanonical: !0
        },
        ':wc:': {
            unicode: ['1f6be'],
            fname: '1f6be',
            uc: '1f6be',
            isCanonical: !0
        },
        ':bath:': {
            unicode: ['1f6c0'],
            fname: '1f6c0',
            uc: '1f6c0',
            isCanonical: !0
        },
        ':metal:': {
            unicode: ['1f918'],
            fname: '1f918',
            uc: '1f918',
            isCanonical: !0
        },
        ':sign_of_the_horns:': {
            unicode: ['1f918'],
            fname: '1f918',
            uc: '1f918',
            isCanonical: !1
        },
        ':grinning:': {
            unicode: ['1f600'],
            fname: '1f600',
            uc: '1f600',
            isCanonical: !0
        },
        ':innocent:': {
            unicode: ['1f607'],
            fname: '1f607',
            uc: '1f607',
            isCanonical: !0
        },
        ':smiling_imp:': {
            unicode: ['1f608'],
            fname: '1f608',
            uc: '1f608',
            isCanonical: !0
        },
        ':sunglasses:': {
            unicode: ['1f60e'],
            fname: '1f60e',
            uc: '1f60e',
            isCanonical: !0
        },
        ':neutral_face:': {
            unicode: ['1f610'],
            fname: '1f610',
            uc: '1f610',
            isCanonical: !0
        },
        ':expressionless:': {
            unicode: ['1f611'],
            fname: '1f611',
            uc: '1f611',
            isCanonical: !0
        },
        ':confused:': {
            unicode: ['1f615'],
            fname: '1f615',
            uc: '1f615',
            isCanonical: !0
        },
        ':kissing:': {
            unicode: ['1f617'],
            fname: '1f617',
            uc: '1f617',
            isCanonical: !0
        },
        ':kissing_smiling_eyes:': {
            unicode: ['1f619'],
            fname: '1f619',
            uc: '1f619',
            isCanonical: !0
        },
        ':stuck_out_tongue:': {
            unicode: ['1f61b'],
            fname: '1f61b',
            uc: '1f61b',
            isCanonical: !0
        },
        ':worried:': {
            unicode: ['1f61f'],
            fname: '1f61f',
            uc: '1f61f',
            isCanonical: !0
        },
        ':frowning:': {
            unicode: ['1f626'],
            fname: '1f626',
            uc: '1f626',
            isCanonical: !0
        },
        ':anguished:': {
            unicode: ['1f627'],
            fname: '1f627',
            uc: '1f627',
            isCanonical: !0
        },
        ':grimacing:': {
            unicode: ['1f62c'],
            fname: '1f62c',
            uc: '1f62c',
            isCanonical: !0
        },
        ':open_mouth:': {
            unicode: ['1f62e'],
            fname: '1f62e',
            uc: '1f62e',
            isCanonical: !0
        },
        ':hushed:': {
            unicode: ['1f62f'],
            fname: '1f62f',
            uc: '1f62f',
            isCanonical: !0
        },
        ':sleeping:': {
            unicode: ['1f634'],
            fname: '1f634',
            uc: '1f634',
            isCanonical: !0
        },
        ':no_mouth:': {
            unicode: ['1f636'],
            fname: '1f636',
            uc: '1f636',
            isCanonical: !0
        },
        ':helicopter:': {
            unicode: ['1f681'],
            fname: '1f681',
            uc: '1f681',
            isCanonical: !0
        },
        ':steam_locomotive:': {
            unicode: ['1f682'],
            fname: '1f682',
            uc: '1f682',
            isCanonical: !0
        },
        ':train2:': {
            unicode: ['1f686'],
            fname: '1f686',
            uc: '1f686',
            isCanonical: !0
        },
        ':light_rail:': {
            unicode: ['1f688'],
            fname: '1f688',
            uc: '1f688',
            isCanonical: !0
        },
        ':tram:': {
            unicode: ['1f68a'],
            fname: '1f68a',
            uc: '1f68a',
            isCanonical: !0
        },
        ':oncoming_bus:': {
            unicode: ['1f68d'],
            fname: '1f68d',
            uc: '1f68d',
            isCanonical: !0
        },
        ':trolleybus:': {
            unicode: ['1f68e'],
            fname: '1f68e',
            uc: '1f68e',
            isCanonical: !0
        },
        ':minibus:': {
            unicode: ['1f690'],
            fname: '1f690',
            uc: '1f690',
            isCanonical: !0
        },
        ':oncoming_police_car:': {
            unicode: ['1f694'],
            fname: '1f694',
            uc: '1f694',
            isCanonical: !0
        },
        ':oncoming_taxi:': {
            unicode: ['1f696'],
            fname: '1f696',
            uc: '1f696',
            isCanonical: !0
        },
        ':oncoming_automobile:': {
            unicode: ['1f698'],
            fname: '1f698',
            uc: '1f698',
            isCanonical: !0
        },
        ':articulated_lorry:': {
            unicode: ['1f69b'],
            fname: '1f69b',
            uc: '1f69b',
            isCanonical: !0
        },
        ':tractor:': {
            unicode: ['1f69c'],
            fname: '1f69c',
            uc: '1f69c',
            isCanonical: !0
        },
        ':monorail:': {
            unicode: ['1f69d'],
            fname: '1f69d',
            uc: '1f69d',
            isCanonical: !0
        },
        ':mountain_railway:': {
            unicode: ['1f69e'],
            fname: '1f69e',
            uc: '1f69e',
            isCanonical: !0
        },
        ':suspension_railway:': {
            unicode: ['1f69f'],
            fname: '1f69f',
            uc: '1f69f',
            isCanonical: !0
        },
        ':mountain_cableway:': {
            unicode: ['1f6a0'],
            fname: '1f6a0',
            uc: '1f6a0',
            isCanonical: !0
        },
        ':aerial_tramway:': {
            unicode: ['1f6a1'],
            fname: '1f6a1',
            uc: '1f6a1',
            isCanonical: !0
        },
        ':rowboat:': {
            unicode: ['1f6a3'],
            fname: '1f6a3',
            uc: '1f6a3',
            isCanonical: !0
        },
        ':vertical_traffic_light:': {
            unicode: ['1f6a6'],
            fname: '1f6a6',
            uc: '1f6a6',
            isCanonical: !0
        },
        ':put_litter_in_its_place:': {
            unicode: ['1f6ae'],
            fname: '1f6ae',
            uc: '1f6ae',
            isCanonical: !0
        },
        ':do_not_litter:': {
            unicode: ['1f6af'],
            fname: '1f6af',
            uc: '1f6af',
            isCanonical: !0
        },
        ':potable_water:': {
            unicode: ['1f6b0'],
            fname: '1f6b0',
            uc: '1f6b0',
            isCanonical: !0
        },
        ':non-potable_water:': {
            unicode: ['1f6b1'],
            fname: '1f6b1',
            uc: '1f6b1',
            isCanonical: !0
        },
        ':no_bicycles:': {
            unicode: ['1f6b3'],
            fname: '1f6b3',
            uc: '1f6b3',
            isCanonical: !0
        },
        ':bicyclist:': {
            unicode: ['1f6b4'],
            fname: '1f6b4',
            uc: '1f6b4',
            isCanonical: !0
        },
        ':mountain_bicyclist:': {
            unicode: ['1f6b5'],
            fname: '1f6b5',
            uc: '1f6b5',
            isCanonical: !0
        },
        ':no_pedestrians:': {
            unicode: ['1f6b7'],
            fname: '1f6b7',
            uc: '1f6b7',
            isCanonical: !0
        },
        ':children_crossing:': {
            unicode: ['1f6b8'],
            fname: '1f6b8',
            uc: '1f6b8',
            isCanonical: !0
        },
        ':shower:': {
            unicode: ['1f6bf'],
            fname: '1f6bf',
            uc: '1f6bf',
            isCanonical: !0
        },
        ':bathtub:': {
            unicode: ['1f6c1'],
            fname: '1f6c1',
            uc: '1f6c1',
            isCanonical: !0
        },
        ':passport_control:': {
            unicode: ['1f6c2'],
            fname: '1f6c2',
            uc: '1f6c2',
            isCanonical: !0
        },
        ':customs:': {
            unicode: ['1f6c3'],
            fname: '1f6c3',
            uc: '1f6c3',
            isCanonical: !0
        },
        ':baggage_claim:': {
            unicode: ['1f6c4'],
            fname: '1f6c4',
            uc: '1f6c4',
            isCanonical: !0
        },
        ':left_luggage:': {
            unicode: ['1f6c5'],
            fname: '1f6c5',
            uc: '1f6c5',
            isCanonical: !0
        },
        ':earth_africa:': {
            unicode: ['1f30d'],
            fname: '1f30d',
            uc: '1f30d',
            isCanonical: !0
        },
        ':earth_americas:': {
            unicode: ['1f30e'],
            fname: '1f30e',
            uc: '1f30e',
            isCanonical: !0
        },
        ':globe_with_meridians:': {
            unicode: ['1f310'],
            fname: '1f310',
            uc: '1f310',
            isCanonical: !0
        },
        ':waxing_crescent_moon:': {
            unicode: ['1f312'],
            fname: '1f312',
            uc: '1f312',
            isCanonical: !0
        },
        ':waning_gibbous_moon:': {
            unicode: ['1f316'],
            fname: '1f316',
            uc: '1f316',
            isCanonical: !0
        },
        ':last_quarter_moon:': {
            unicode: ['1f317'],
            fname: '1f317',
            uc: '1f317',
            isCanonical: !0
        },
        ':waning_crescent_moon:': {
            unicode: ['1f318'],
            fname: '1f318',
            uc: '1f318',
            isCanonical: !0
        },
        ':new_moon_with_face:': {
            unicode: ['1f31a'],
            fname: '1f31a',
            uc: '1f31a',
            isCanonical: !0
        },
        ':last_quarter_moon_with_face:': {
            unicode: ['1f31c'],
            fname: '1f31c',
            uc: '1f31c',
            isCanonical: !0
        },
        ':full_moon_with_face:': {
            unicode: ['1f31d'],
            fname: '1f31d',
            uc: '1f31d',
            isCanonical: !0
        },
        ':sun_with_face:': {
            unicode: ['1f31e'],
            fname: '1f31e',
            uc: '1f31e',
            isCanonical: !0
        },
        ':evergreen_tree:': {
            unicode: ['1f332'],
            fname: '1f332',
            uc: '1f332',
            isCanonical: !0
        },
        ':deciduous_tree:': {
            unicode: ['1f333'],
            fname: '1f333',
            uc: '1f333',
            isCanonical: !0
        },
        ':lemon:': {
            unicode: ['1f34b'],
            fname: '1f34b',
            uc: '1f34b',
            isCanonical: !0
        },
        ':pear:': {
            unicode: ['1f350'],
            fname: '1f350',
            uc: '1f350',
            isCanonical: !0
        },
        ':baby_bottle:': {
            unicode: ['1f37c'],
            fname: '1f37c',
            uc: '1f37c',
            isCanonical: !0
        },
        ':horse_racing:': {
            unicode: ['1f3c7'],
            fname: '1f3c7',
            uc: '1f3c7',
            isCanonical: !0
        },
        ':rugby_football:': {
            unicode: ['1f3c9'],
            fname: '1f3c9',
            uc: '1f3c9',
            isCanonical: !0
        },
        ':european_post_office:': {
            unicode: ['1f3e4'],
            fname: '1f3e4',
            uc: '1f3e4',
            isCanonical: !0
        },
        ':rat:': {
            unicode: ['1f400'],
            fname: '1f400',
            uc: '1f400',
            isCanonical: !0
        },
        ':mouse2:': {
            unicode: ['1f401'],
            fname: '1f401',
            uc: '1f401',
            isCanonical: !0
        },
        ':ox:': {
            unicode: ['1f402'],
            fname: '1f402',
            uc: '1f402',
            isCanonical: !0
        },
        ':water_buffalo:': {
            unicode: ['1f403'],
            fname: '1f403',
            uc: '1f403',
            isCanonical: !0
        },
        ':cow2:': {
            unicode: ['1f404'],
            fname: '1f404',
            uc: '1f404',
            isCanonical: !0
        },
        ':tiger2:': {
            unicode: ['1f405'],
            fname: '1f405',
            uc: '1f405',
            isCanonical: !0
        },
        ':leopard:': {
            unicode: ['1f406'],
            fname: '1f406',
            uc: '1f406',
            isCanonical: !0
        },
        ':rabbit2:': {
            unicode: ['1f407'],
            fname: '1f407',
            uc: '1f407',
            isCanonical: !0
        },
        ':cat2:': {
            unicode: ['1f408'],
            fname: '1f408',
            uc: '1f408',
            isCanonical: !0
        },
        ':dragon:': {
            unicode: ['1f409'],
            fname: '1f409',
            uc: '1f409',
            isCanonical: !0
        },
        ':crocodile:': {
            unicode: ['1f40a'],
            fname: '1f40a',
            uc: '1f40a',
            isCanonical: !0
        },
        ':whale2:': {
            unicode: ['1f40b'],
            fname: '1f40b',
            uc: '1f40b',
            isCanonical: !0
        },
        ':ram:': {
            unicode: ['1f40f'],
            fname: '1f40f',
            uc: '1f40f',
            isCanonical: !0
        },
        ':goat:': {
            unicode: ['1f410'],
            fname: '1f410',
            uc: '1f410',
            isCanonical: !0
        },
        ':rooster:': {
            unicode: ['1f413'],
            fname: '1f413',
            uc: '1f413',
            isCanonical: !0
        },
        ':dog2:': {
            unicode: ['1f415'],
            fname: '1f415',
            uc: '1f415',
            isCanonical: !0
        },
        ':pig2:': {
            unicode: ['1f416'],
            fname: '1f416',
            uc: '1f416',
            isCanonical: !0
        },
        ':dromedary_camel:': {
            unicode: ['1f42a'],
            fname: '1f42a',
            uc: '1f42a',
            isCanonical: !0
        },
        ':busts_in_silhouette:': {
            unicode: ['1f465'],
            fname: '1f465',
            uc: '1f465',
            isCanonical: !0
        },
        ':two_men_holding_hands:': {
            unicode: ['1f46c'],
            fname: '1f46c',
            uc: '1f46c',
            isCanonical: !0
        },
        ':two_women_holding_hands:': {
            unicode: ['1f46d'],
            fname: '1f46d',
            uc: '1f46d',
            isCanonical: !0
        },
        ':thought_balloon:': {
            unicode: ['1f4ad'],
            fname: '1f4ad',
            uc: '1f4ad',
            isCanonical: !0
        },
        ':euro:': {
            unicode: ['1f4b6'],
            fname: '1f4b6',
            uc: '1f4b6',
            isCanonical: !0
        },
        ':pound:': {
            unicode: ['1f4b7'],
            fname: '1f4b7',
            uc: '1f4b7',
            isCanonical: !0
        },
        ':mailbox_with_mail:': {
            unicode: ['1f4ec'],
            fname: '1f4ec',
            uc: '1f4ec',
            isCanonical: !0
        },
        ':mailbox_with_no_mail:': {
            unicode: ['1f4ed'],
            fname: '1f4ed',
            uc: '1f4ed',
            isCanonical: !0
        },
        ':postal_horn:': {
            unicode: ['1f4ef'],
            fname: '1f4ef',
            uc: '1f4ef',
            isCanonical: !0
        },
        ':no_mobile_phones:': {
            unicode: ['1f4f5'],
            fname: '1f4f5',
            uc: '1f4f5',
            isCanonical: !0
        },
        ':twisted_rightwards_arrows:': {
            unicode: ['1f500'],
            fname: '1f500',
            uc: '1f500',
            isCanonical: !0
        },
        ':repeat:': {
            unicode: ['1f501'],
            fname: '1f501',
            uc: '1f501',
            isCanonical: !0
        },
        ':repeat_one:': {
            unicode: ['1f502'],
            fname: '1f502',
            uc: '1f502',
            isCanonical: !0
        },
        ':arrows_counterclockwise:': {
            unicode: ['1f504'],
            fname: '1f504',
            uc: '1f504',
            isCanonical: !0
        },
        ':low_brightness:': {
            unicode: ['1f505'],
            fname: '1f505',
            uc: '1f505',
            isCanonical: !0
        },
        ':high_brightness:': {
            unicode: ['1f506'],
            fname: '1f506',
            uc: '1f506',
            isCanonical: !0
        },
        ':mute:': {
            unicode: ['1f507'],
            fname: '1f507',
            uc: '1f507',
            isCanonical: !0
        },
        ':sound:': {
            unicode: ['1f509'],
            fname: '1f509',
            uc: '1f509',
            isCanonical: !0
        },
        ':no_bell:': {
            unicode: ['1f515'],
            fname: '1f515',
            uc: '1f515',
            isCanonical: !0
        },
        ':microscope:': {
            unicode: ['1f52c'],
            fname: '1f52c',
            uc: '1f52c',
            isCanonical: !0
        },
        ':telescope:': {
            unicode: ['1f52d'],
            fname: '1f52d',
            uc: '1f52d',
            isCanonical: !0
        },
        ':clock130:': {
            unicode: ['1f55c'],
            fname: '1f55c',
            uc: '1f55c',
            isCanonical: !0
        },
        ':clock230:': {
            unicode: ['1f55d'],
            fname: '1f55d',
            uc: '1f55d',
            isCanonical: !0
        },
        ':clock330:': {
            unicode: ['1f55e'],
            fname: '1f55e',
            uc: '1f55e',
            isCanonical: !0
        },
        ':clock430:': {
            unicode: ['1f55f'],
            fname: '1f55f',
            uc: '1f55f',
            isCanonical: !0
        },
        ':clock530:': {
            unicode: ['1f560'],
            fname: '1f560',
            uc: '1f560',
            isCanonical: !0
        },
        ':clock630:': {
            unicode: ['1f561'],
            fname: '1f561',
            uc: '1f561',
            isCanonical: !0
        },
        ':clock730:': {
            unicode: ['1f562'],
            fname: '1f562',
            uc: '1f562',
            isCanonical: !0
        },
        ':clock830:': {
            unicode: ['1f563'],
            fname: '1f563',
            uc: '1f563',
            isCanonical: !0
        },
        ':clock930:': {
            unicode: ['1f564'],
            fname: '1f564',
            uc: '1f564',
            isCanonical: !0
        },
        ':clock1030:': {
            unicode: ['1f565'],
            fname: '1f565',
            uc: '1f565',
            isCanonical: !0
        },
        ':clock1130:': {
            unicode: ['1f566'],
            fname: '1f566',
            uc: '1f566',
            isCanonical: !0
        },
        ':clock1230:': {
            unicode: ['1f567'],
            fname: '1f567',
            uc: '1f567',
            isCanonical: !0
        },
        ':speaker:': {
            unicode: ['1f508'],
            fname: '1f508',
            uc: '1f508',
            isCanonical: !0
        },
        ':train:': {
            unicode: ['1f68b'],
            fname: '1f68b',
            uc: '1f68b',
            isCanonical: !0
        },
        ':medal:': {
            unicode: ['1f3c5'],
            fname: '1f3c5',
            uc: '1f3c5',
            isCanonical: !0
        },
        ':sports_medal:': {
            unicode: ['1f3c5'],
            fname: '1f3c5',
            uc: '1f3c5',
            isCanonical: !1
        },
        ':flag_black:': {
            unicode: ['1f3f4'],
            fname: '1f3f4',
            uc: '1f3f4',
            isCanonical: !0
        },
        ':waving_black_flag:': {
            unicode: ['1f3f4'],
            fname: '1f3f4',
            uc: '1f3f4',
            isCanonical: !1
        },
        ':camera_with_flash:': {
            unicode: ['1f4f8'],
            fname: '1f4f8',
            uc: '1f4f8',
            isCanonical: !0
        },
        ':sleeping_accommodation:': {
            unicode: ['1f6cc'],
            fname: '1f6cc',
            uc: '1f6cc',
            isCanonical: !0
        },
        ':middle_finger:': {
            unicode: ['1f595'],
            fname: '1f595',
            uc: '1f595',
            isCanonical: !0
        },
        ':reversed_hand_with_middle_finger_extended:': {
            unicode: ['1f595'],
            fname: '1f595',
            uc: '1f595',
            isCanonical: !1
        },
        ':vulcan:': {
            unicode: ['1f596'],
            fname: '1f596',
            uc: '1f596',
            isCanonical: !0
        },
        ':raised_hand_with_part_between_middle_and_ring_fingers:': {
            unicode: ['1f596'],
            fname: '1f596',
            uc: '1f596',
            isCanonical: !1
        },
        ':slight_frown:': {
            unicode: ['1f641'],
            fname: '1f641',
            uc: '1f641',
            isCanonical: !0
        },
        ':slightly_frowning_face:': {
            unicode: ['1f641'],
            fname: '1f641',
            uc: '1f641',
            isCanonical: !1
        },
        ':slight_smile:': {
            unicode: ['1f642'],
            fname: '1f642',
            uc: '1f642',
            isCanonical: !0
        },
        ':slightly_smiling_face:': {
            unicode: ['1f642'],
            fname: '1f642',
            uc: '1f642',
            isCanonical: !1
        },
        ':airplane_departure:': {
            unicode: ['1f6eb'],
            fname: '1f6eb',
            uc: '1f6eb',
            isCanonical: !0
        },
        ':airplane_arriving:': {
            unicode: ['1f6ec'],
            fname: '1f6ec',
            uc: '1f6ec',
            isCanonical: !0
        },
        ':tone1:': {
            unicode: ['1f3fb'],
            fname: '1f3fb',
            uc: '1f3fb',
            isCanonical: !0
        },
        ':tone2:': {
            unicode: ['1f3fc'],
            fname: '1f3fc',
            uc: '1f3fc',
            isCanonical: !0
        },
        ':tone3:': {
            unicode: ['1f3fd'],
            fname: '1f3fd',
            uc: '1f3fd',
            isCanonical: !0
        },
        ':tone4:': {
            unicode: ['1f3fe'],
            fname: '1f3fe',
            uc: '1f3fe',
            isCanonical: !0
        },
        ':tone5:': {
            unicode: ['1f3ff'],
            fname: '1f3ff',
            uc: '1f3ff',
            isCanonical: !0
        },
        ':upside_down:': {
            unicode: ['1f643'],
            fname: '1f643',
            uc: '1f643',
            isCanonical: !0
        },
        ':upside_down_face:': {
            unicode: ['1f643'],
            fname: '1f643',
            uc: '1f643',
            isCanonical: !1
        },
        ':money_mouth:': {
            unicode: ['1f911'],
            fname: '1f911',
            uc: '1f911',
            isCanonical: !0
        },
        ':money_mouth_face:': {
            unicode: ['1f911'],
            fname: '1f911',
            uc: '1f911',
            isCanonical: !1
        },
        ':nerd:': {
            unicode: ['1f913'],
            fname: '1f913',
            uc: '1f913',
            isCanonical: !0
        },
        ':nerd_face:': {
            unicode: ['1f913'],
            fname: '1f913',
            uc: '1f913',
            isCanonical: !1
        },
        ':hugging:': {
            unicode: ['1f917'],
            fname: '1f917',
            uc: '1f917',
            isCanonical: !0
        },
        ':hugging_face:': {
            unicode: ['1f917'],
            fname: '1f917',
            uc: '1f917',
            isCanonical: !1
        },
        ':rolling_eyes:': {
            unicode: ['1f644'],
            fname: '1f644',
            uc: '1f644',
            isCanonical: !0
        },
        ':face_with_rolling_eyes:': {
            unicode: ['1f644'],
            fname: '1f644',
            uc: '1f644',
            isCanonical: !1
        },
        ':thinking:': {
            unicode: ['1f914'],
            fname: '1f914',
            uc: '1f914',
            isCanonical: !0
        },
        ':thinking_face:': {
            unicode: ['1f914'],
            fname: '1f914',
            uc: '1f914',
            isCanonical: !1
        },
        ':zipper_mouth:': {
            unicode: ['1f910'],
            fname: '1f910',
            uc: '1f910',
            isCanonical: !0
        },
        ':zipper_mouth_face:': {
            unicode: ['1f910'],
            fname: '1f910',
            uc: '1f910',
            isCanonical: !1
        },
        ':thermometer_face:': {
            unicode: ['1f912'],
            fname: '1f912',
            uc: '1f912',
            isCanonical: !0
        },
        ':face_with_thermometer:': {
            unicode: ['1f912'],
            fname: '1f912',
            uc: '1f912',
            isCanonical: !1
        },
        ':head_bandage:': {
            unicode: ['1f915'],
            fname: '1f915',
            uc: '1f915',
            isCanonical: !0
        },
        ':face_with_head_bandage:': {
            unicode: ['1f915'],
            fname: '1f915',
            uc: '1f915',
            isCanonical: !1
        },
        ':robot:': {
            unicode: ['1f916'],
            fname: '1f916',
            uc: '1f916',
            isCanonical: !0
        },
        ':robot_face:': {
            unicode: ['1f916'],
            fname: '1f916',
            uc: '1f916',
            isCanonical: !1
        },
        ':lion_face:': {
            unicode: ['1f981'],
            fname: '1f981',
            uc: '1f981',
            isCanonical: !0
        },
        ':lion:': {
            unicode: ['1f981'],
            fname: '1f981',
            uc: '1f981',
            isCanonical: !1
        },
        ':unicorn:': {
            unicode: ['1f984'],
            fname: '1f984',
            uc: '1f984',
            isCanonical: !0
        },
        ':unicorn_face:': {
            unicode: ['1f984'],
            fname: '1f984',
            uc: '1f984',
            isCanonical: !1
        },
        ':scorpion:': {
            unicode: ['1f982'],
            fname: '1f982',
            uc: '1f982',
            isCanonical: !0
        },
        ':crab:': {
            unicode: ['1f980'],
            fname: '1f980',
            uc: '1f980',
            isCanonical: !0
        },
        ':turkey:': {
            unicode: ['1f983'],
            fname: '1f983',
            uc: '1f983',
            isCanonical: !0
        },
        ':cheese:': {
            unicode: ['1f9c0'],
            fname: '1f9c0',
            uc: '1f9c0',
            isCanonical: !0
        },
        ':cheese_wedge:': {
            unicode: ['1f9c0'],
            fname: '1f9c0',
            uc: '1f9c0',
            isCanonical: !1
        },
        ':hotdog:': {
            unicode: ['1f32d'],
            fname: '1f32d',
            uc: '1f32d',
            isCanonical: !0
        },
        ':hot_dog:': {
            unicode: ['1f32d'],
            fname: '1f32d',
            uc: '1f32d',
            isCanonical: !1
        },
        ':taco:': {
            unicode: ['1f32e'],
            fname: '1f32e',
            uc: '1f32e',
            isCanonical: !0
        },
        ':burrito:': {
            unicode: ['1f32f'],
            fname: '1f32f',
            uc: '1f32f',
            isCanonical: !0
        },
        ':popcorn:': {
            unicode: ['1f37f'],
            fname: '1f37f',
            uc: '1f37f',
            isCanonical: !0
        },
        ':champagne:': {
            unicode: ['1f37e'],
            fname: '1f37e',
            uc: '1f37e',
            isCanonical: !0
        },
        ':bottle_with_popping_cork:': {
            unicode: ['1f37e'],
            fname: '1f37e',
            uc: '1f37e',
            isCanonical: !1
        },
        ':bow_and_arrow:': {
            unicode: ['1f3f9'],
            fname: '1f3f9',
            uc: '1f3f9',
            isCanonical: !0
        },
        ':archery:': {
            unicode: ['1f3f9'],
            fname: '1f3f9',
            uc: '1f3f9',
            isCanonical: !1
        },
        ':amphora:': {
            unicode: ['1f3fa'],
            fname: '1f3fa',
            uc: '1f3fa',
            isCanonical: !0
        },
        ':place_of_worship:': {
            unicode: ['1f6d0'],
            fname: '1f6d0',
            uc: '1f6d0',
            isCanonical: !0
        },
        ':worship_symbol:': {
            unicode: ['1f6d0'],
            fname: '1f6d0',
            uc: '1f6d0',
            isCanonical: !1
        },
        ':kaaba:': {
            unicode: ['1f54b'],
            fname: '1f54b',
            uc: '1f54b',
            isCanonical: !0
        },
        ':mosque:': {
            unicode: ['1f54c'],
            fname: '1f54c',
            uc: '1f54c',
            isCanonical: !0
        },
        ':synagogue:': {
            unicode: ['1f54d'],
            fname: '1f54d',
            uc: '1f54d',
            isCanonical: !0
        },
        ':menorah:': {
            unicode: ['1f54e'],
            fname: '1f54e',
            uc: '1f54e',
            isCanonical: !0
        },
        ':prayer_beads:': {
            unicode: ['1f4ff'],
            fname: '1f4ff',
            uc: '1f4ff',
            isCanonical: !0
        },
        ':cricket:': {
            unicode: ['1f3cf'],
            fname: '1f3cf',
            uc: '1f3cf',
            isCanonical: !0
        },
        ':cricket_bat_ball:': {
            unicode: ['1f3cf'],
            fname: '1f3cf',
            uc: '1f3cf',
            isCanonical: !1
        },
        ':volleyball:': {
            unicode: ['1f3d0'],
            fname: '1f3d0',
            uc: '1f3d0',
            isCanonical: !0
        },
        ':field_hockey:': {
            unicode: ['1f3d1'],
            fname: '1f3d1',
            uc: '1f3d1',
            isCanonical: !0
        },
        ':hockey:': {
            unicode: ['1f3d2'],
            fname: '1f3d2',
            uc: '1f3d2',
            isCanonical: !0
        },
        ':ping_pong:': {
            unicode: ['1f3d3'],
            fname: '1f3d3',
            uc: '1f3d3',
            isCanonical: !0
        },
        ':table_tennis:': {
            unicode: ['1f3d3'],
            fname: '1f3d3',
            uc: '1f3d3',
            isCanonical: !1
        },
        ':badminton:': {
            unicode: ['1f3f8'],
            fname: '1f3f8',
            uc: '1f3f8',
            isCanonical: !0
        },
        ':drum:': {
            unicode: ['1f941'],
            fname: '1f941',
            uc: '1f941',
            isCanonical: !0
        },
        ':drum_with_drumsticks:': {
            unicode: ['1f941'],
            fname: '1f941',
            uc: '1f941',
            isCanonical: !1
        },
        ':shrimp:': {
            unicode: ['1f990'],
            fname: '1f990',
            uc: '1f990',
            isCanonical: !0
        },
        ':squid:': {
            unicode: ['1f991'],
            fname: '1f991',
            uc: '1f991',
            isCanonical: !0
        },
        ':egg:': {
            unicode: ['1f95a'],
            fname: '1f95a',
            uc: '1f95a',
            isCanonical: !0
        },
        ':milk:': {
            unicode: ['1f95b'],
            fname: '1f95b',
            uc: '1f95b',
            isCanonical: !0
        },
        ':glass_of_milk:': {
            unicode: ['1f95b'],
            fname: '1f95b',
            uc: '1f95b',
            isCanonical: !1
        },
        ':peanuts:': {
            unicode: ['1f95c'],
            fname: '1f95c',
            uc: '1f95c',
            isCanonical: !0
        },
        ':shelled_peanut:': {
            unicode: ['1f95c'],
            fname: '1f95c',
            uc: '1f95c',
            isCanonical: !1
        },
        ':kiwi:': {
            unicode: ['1f95d'],
            fname: '1f95d',
            uc: '1f95d',
            isCanonical: !0
        },
        ':kiwifruit:': {
            unicode: ['1f95d'],
            fname: '1f95d',
            uc: '1f95d',
            isCanonical: !1
        },
        ':pancakes:': {
            unicode: ['1f95e'],
            fname: '1f95e',
            uc: '1f95e',
            isCanonical: !0
        },
        ':regional_indicator_w:': {
            unicode: ['1f1fc'],
            fname: '1f1fc',
            uc: '1f1fc',
            isCanonical: !0
        },
        ':regional_indicator_v:': {
            unicode: ['1f1fb'],
            fname: '1f1fb',
            uc: '1f1fb',
            isCanonical: !0
        },
        ':regional_indicator_u:': {
            unicode: ['1f1fa'],
            fname: '1f1fa',
            uc: '1f1fa',
            isCanonical: !0
        },
        ':regional_indicator_t:': {
            unicode: ['1f1f9'],
            fname: '1f1f9',
            uc: '1f1f9',
            isCanonical: !0
        },
        ':regional_indicator_s:': {
            unicode: ['1f1f8'],
            fname: '1f1f8',
            uc: '1f1f8',
            isCanonical: !0
        },
        ':regional_indicator_r:': {
            unicode: ['1f1f7'],
            fname: '1f1f7',
            uc: '1f1f7',
            isCanonical: !0
        },
        ':regional_indicator_q:': {
            unicode: ['1f1f6'],
            fname: '1f1f6',
            uc: '1f1f6',
            isCanonical: !0
        },
        ':regional_indicator_p:': {
            unicode: ['1f1f5'],
            fname: '1f1f5',
            uc: '1f1f5',
            isCanonical: !0
        },
        ':regional_indicator_o:': {
            unicode: ['1f1f4'],
            fname: '1f1f4',
            uc: '1f1f4',
            isCanonical: !0
        },
        ':regional_indicator_n:': {
            unicode: ['1f1f3'],
            fname: '1f1f3',
            uc: '1f1f3',
            isCanonical: !0
        },
        ':regional_indicator_m:': {
            unicode: ['1f1f2'],
            fname: '1f1f2',
            uc: '1f1f2',
            isCanonical: !0
        },
        ':regional_indicator_l:': {
            unicode: ['1f1f1'],
            fname: '1f1f1',
            uc: '1f1f1',
            isCanonical: !0
        },
        ':regional_indicator_k:': {
            unicode: ['1f1f0'],
            fname: '1f1f0',
            uc: '1f1f0',
            isCanonical: !0
        },
        ':regional_indicator_j:': {
            unicode: ['1f1ef'],
            fname: '1f1ef',
            uc: '1f1ef',
            isCanonical: !0
        },
        ':regional_indicator_i:': {
            unicode: ['1f1ee'],
            fname: '1f1ee',
            uc: '1f1ee',
            isCanonical: !0
        },
        ':regional_indicator_h:': {
            unicode: ['1f1ed'],
            fname: '1f1ed',
            uc: '1f1ed',
            isCanonical: !0
        },
        ':regional_indicator_g:': {
            unicode: ['1f1ec'],
            fname: '1f1ec',
            uc: '1f1ec',
            isCanonical: !0
        },
        ':regional_indicator_f:': {
            unicode: ['1f1eb'],
            fname: '1f1eb',
            uc: '1f1eb',
            isCanonical: !0
        },
        ':regional_indicator_e:': {
            unicode: ['1f1ea'],
            fname: '1f1ea',
            uc: '1f1ea',
            isCanonical: !0
        },
        ':regional_indicator_d:': {
            unicode: ['1f1e9'],
            fname: '1f1e9',
            uc: '1f1e9',
            isCanonical: !0
        },
        ':regional_indicator_c:': {
            unicode: ['1f1e8'],
            fname: '1f1e8',
            uc: '1f1e8',
            isCanonical: !0
        },
        ':regional_indicator_b:': {
            unicode: ['1f1e7'],
            fname: '1f1e7',
            uc: '1f1e7',
            isCanonical: !0
        },
        ':regional_indicator_a:': {
            unicode: ['1f1e6'],
            fname: '1f1e6',
            uc: '1f1e6',
            isCanonical: !0
        },
        ':fast_forward:': {
            unicode: ['23e9'],
            fname: '23e9',
            uc: '23e9',
            isCanonical: !0
        },
        ':rewind:': {
            unicode: ['23ea'],
            fname: '23ea',
            uc: '23ea',
            isCanonical: !0
        },
        ':arrow_double_up:': {
            unicode: ['23eb'],
            fname: '23eb',
            uc: '23eb',
            isCanonical: !0
        },
        ':arrow_double_down:': {
            unicode: ['23ec'],
            fname: '23ec',
            uc: '23ec',
            isCanonical: !0
        },
        ':alarm_clock:': {
            unicode: ['23f0'],
            fname: '23f0',
            uc: '23f0',
            isCanonical: !0
        },
        ':hourglass_flowing_sand:': {
            unicode: ['23f3'],
            fname: '23f3',
            uc: '23f3',
            isCanonical: !0
        },
        ':ophiuchus:': {
            unicode: ['26ce'],
            fname: '26ce',
            uc: '26ce',
            isCanonical: !0
        },
        ':white_check_mark:': {
            unicode: ['2705'],
            fname: '2705',
            uc: '2705',
            isCanonical: !0
        },
        ':fist:': {
            unicode: ['270a'],
            fname: '270a',
            uc: '270a',
            isCanonical: !0
        },
        ':raised_hand:': {
            unicode: ['270b'],
            fname: '270b',
            uc: '270b',
            isCanonical: !0
        },
        ':sparkles:': {
            unicode: ['2728'],
            fname: '2728',
            uc: '2728',
            isCanonical: !0
        },
        ':x:': {
            unicode: ['274c'],
            fname: '274c',
            uc: '274c',
            isCanonical: !0
        },
        ':negative_squared_cross_mark:': {
            unicode: ['274e'],
            fname: '274e',
            uc: '274e',
            isCanonical: !0
        },
        ':question:': {
            unicode: ['2753'],
            fname: '2753',
            uc: '2753',
            isCanonical: !0
        },
        ':grey_question:': {
            unicode: ['2754'],
            fname: '2754',
            uc: '2754',
            isCanonical: !0
        },
        ':grey_exclamation:': {
            unicode: ['2755'],
            fname: '2755',
            uc: '2755',
            isCanonical: !0
        },
        ':heavy_plus_sign:': {
            unicode: ['2795'],
            fname: '2795',
            uc: '2795',
            isCanonical: !0
        },
        ':heavy_minus_sign:': {
            unicode: ['2796'],
            fname: '2796',
            uc: '2796',
            isCanonical: !0
        },
        ':heavy_division_sign:': {
            unicode: ['2797'],
            fname: '2797',
            uc: '2797',
            isCanonical: !0
        },
        ':curly_loop:': {
            unicode: ['27b0'],
            fname: '27b0',
            uc: '27b0',
            isCanonical: !0
        },
        ':loop:': {
            unicode: ['27bf'],
            fname: '27bf',
            uc: '27bf',
            isCanonical: !0
        }
    };
    var b,
        c = [];
    for (b in a.emojioneList)
        a.emojioneList.hasOwnProperty(b) && c.push(b.replace(/[+]/g, '\\$&'));
    (a.shortnames = c.join('|')),
        (a.asciiList = {
            '<3': '2764',
            '</3': '1f494',
            ":')": '1f602',
            ":'-)": '1f602',
            ':D': '1f603',
            ':-D': '1f603',
            '=D': '1f603',
            ':)': '1f642',
            ':-)': '1f642',
            '=]': '1f642',
            '=)': '1f642',
            ':]': '1f642',
            "':)": '1f605',
            "':-)": '1f605',
            "'=)": '1f605',
            "':D": '1f605',
            "':-D": '1f605',
            "'=D": '1f605',
            '>:)': '1f606',
            '>;)': '1f606',
            '>:-)': '1f606',
            '>=)': '1f606',
            ';)': '1f609',
            ';-)': '1f609',
            '*-)': '1f609',
            '*)': '1f609',
            ';-]': '1f609',
            ';]': '1f609',
            ';D': '1f609',
            ';^)': '1f609',
            "':(": '1f613',
            "':-(": '1f613',
            "'=(": '1f613',
            ':*': '1f618',
            ':-*': '1f618',
            '=*': '1f618',
            ':^*': '1f618',
            '>:P': '1f61c',
            'X-P': '1f61c',
            'x-p': '1f61c',
            '>:[': '1f61e',
            ':-(': '1f61e',
            ':(': '1f61e',
            ':-[': '1f61e',
            ':[': '1f61e',
            '=(': '1f61e',
            '>:(': '1f620',
            '>:-(': '1f620',
            ':@': '1f620',
            ":'(": '1f622',
            ":'-(": '1f622',
            ';(': '1f622',
            ';-(': '1f622',
            '>.<': '1f623',
            'D:': '1f628',
            ':$': '1f633',
            '=$': '1f633',
            '#-)': '1f635',
            '#)': '1f635',
            '%-)': '1f635',
            '%)': '1f635',
            'X)': '1f635',
            'X-)': '1f635',
            '*\\0/*': '1f646',
            '\\0/': '1f646',
            '*\\O/*': '1f646',
            '\\O/': '1f646',
            'O:-)': '1f607',
            '0:-3': '1f607',
            '0:3': '1f607',
            '0:-)': '1f607',
            '0:)': '1f607',
            '0;^)': '1f607',
            'O:)': '1f607',
            'O;-)': '1f607',
            'O=)': '1f607',
            '0;-)': '1f607',
            'O:-3': '1f607',
            'O:3': '1f607',
            'B-)': '1f60e',
            'B)': '1f60e',
            '8)': '1f60e',
            '8-)': '1f60e',
            'B-D': '1f60e',
            '8-D': '1f60e',
            '-_-': '1f611',
            '-__-': '1f611',
            '-___-': '1f611',
            '>:\\': '1f615',
            '>:/': '1f615',
            ':-/': '1f615',
            ':-.': '1f615',
            ':/': '1f615',
            ':\\': '1f615',
            '=/': '1f615',
            '=\\': '1f615',
            ':L': '1f615',
            '=L': '1f615',
            ':P': '1f61b',
            ':-P': '1f61b',
            '=P': '1f61b',
            ':-p': '1f61b',
            ':p': '1f61b',
            '=p': '1f61b',
            ':-Þ': '1f61b',
            ':Þ': '1f61b',
            ':þ': '1f61b',
            ':-þ': '1f61b',
            ':-b': '1f61b',
            ':b': '1f61b',
            'd:': '1f61b',
            ':-O': '1f62e',
            ':O': '1f62e',
            ':-o': '1f62e',
            ':o': '1f62e',
            O_O: '1f62e',
            '>:O': '1f62e',
            ':-X': '1f636',
            ':X': '1f636',
            ':-#': '1f636',
            ':#': '1f636',
            '=X': '1f636',
            '=x': '1f636',
            ':x': '1f636',
            ':-x': '1f636',
            '=#': '1f636'
        }),
        (a.asciiRegexp =
            "(\\<3|&lt;3|\\<\\/3|&lt;\\/3|\\:'\\)|\\:'\\-\\)|\\:D|\\:\\-D|\\=D|\\:\\)|\\:\\-\\)|\\=\\]|\\=\\)|\\:\\]|'\\:\\)|'\\:\\-\\)|'\\=\\)|'\\:D|'\\:\\-D|'\\=D|\\>\\:\\)|&gt;\\:\\)|\\>;\\)|&gt;;\\)|\\>\\:\\-\\)|&gt;\\:\\-\\)|\\>\\=\\)|&gt;\\=\\)|;\\)|;\\-\\)|\\*\\-\\)|\\*\\)|;\\-\\]|;\\]|;D|;\\^\\)|'\\:\\(|'\\:\\-\\(|'\\=\\(|\\:\\*|\\:\\-\\*|\\=\\*|\\:\\^\\*|\\>\\:P|&gt;\\:P|X\\-P|x\\-p|\\>\\:\\[|&gt;\\:\\[|\\:\\-\\(|\\:\\(|\\:\\-\\[|\\:\\[|\\=\\(|\\>\\:\\(|&gt;\\:\\(|\\>\\:\\-\\(|&gt;\\:\\-\\(|\\:@|\\:'\\(|\\:'\\-\\(|;\\(|;\\-\\(|\\>\\.\\<|&gt;\\.&lt;|D\\:|\\:\\$|\\=\\$|#\\-\\)|#\\)|%\\-\\)|%\\)|X\\)|X\\-\\)|\\*\\\\0\\/\\*|\\\\0\\/|\\*\\\\O\\/\\*|\\\\O\\/|O\\:\\-\\)|0\\:\\-3|0\\:3|0\\:\\-\\)|0\\:\\)|0;\\^\\)|O\\:\\-\\)|O\\:\\)|O;\\-\\)|O\\=\\)|0;\\-\\)|O\\:\\-3|O\\:3|B\\-\\)|B\\)|8\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\-__\\-|\\-___\\-|\\>\\:\\\\|&gt;\\:\\\\|\\>\\:\\/|&gt;\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\:\\-P|\\=P|\\:\\-p|\\:p|\\=p|\\:\\-Þ|\\:\\-&THORN;|\\:Þ|\\:&THORN;|\\:þ|\\:&thorn;|\\:\\-þ|\\:\\-&thorn;|\\:\\-b|\\:b|d\\:|\\:\\-O|\\:O|\\:\\-o|\\:o|O_O|\\>\\:O|&gt;\\:O|\\:\\-X|\\:X|\\:\\-#|\\:#|\\=X|\\=x|\\:x|\\:\\-x|\\=#)"),
        (a.unicodeRegexp =
            '(\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC68|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC68|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u2764\\uD83D\\uDC8B\\uD83D\\uDC69|\\uD83D\\uDC68\\u2764\\uD83D\\uDC8B\\uD83D\\uDC68|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67|\\uD83C\\uDFF3\\uFE0F\\u200D\\uD83C\\uDF08|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67|\\uD83D\\uDC68\\u2764\\uD83D\\uDC68|\\uD83D\\uDC41\\u200D\\uD83D\\uDDE8|\\uD83D\\uDC69\\u2764\\uD83D\\uDC69|\\uD83D\\uDC41\\uD83D\\uDDE8|\\uD83C\\uDDE6\\uD83C\\uDDE8|\\uD83C\\uDDE6\\uD83C\\uDDE9|\\uD83C\\uDDE6\\uD83C\\uDDEA|\\uD83C\\uDDE6\\uD83C\\uDDEB|\\uD83C\\uDDE6\\uD83C\\uDDEC|\\uD83C\\uDDE6\\uD83C\\uDDEE|\\uD83C\\uDDE6\\uD83C\\uDDF1|\\uD83C\\uDDE6\\uD83C\\uDDF2|\\uD83C\\uDDE6\\uD83C\\uDDF4|\\uD83C\\uDDE6\\uD83C\\uDDF6|\\uD83C\\uDDE6\\uD83C\\uDDF7|\\uD83C\\uDDE6\\uD83C\\uDDF8|\\uD83E\\uDD3E\\uD83C\\uDFFF|\\uD83E\\uDD3E\\uD83C\\uDFFE|\\uD83E\\uDD3E\\uD83C\\uDFFD|\\uD83E\\uDD3E\\uD83C\\uDFFC|\\uD83E\\uDD3E\\uD83C\\uDFFB|\\uD83E\\uDD3D\\uD83C\\uDFFF|\\uD83E\\uDD3D\\uD83C\\uDFFE|\\uD83E\\uDD3D\\uD83C\\uDFFD|\\uD83E\\uDD3D\\uD83C\\uDFFC|\\uD83E\\uDD3D\\uD83C\\uDFFB|\\uD83E\\uDD3C\\uD83C\\uDFFF|\\uD83E\\uDD3C\\uD83C\\uDFFE|\\uD83E\\uDD3C\\uD83C\\uDFFD|\\uD83E\\uDD3C\\uD83C\\uDFFC|\\uD83E\\uDD3C\\uD83C\\uDFFB|\\uD83E\\uDD39\\uD83C\\uDFFF|\\uD83E\\uDD39\\uD83C\\uDFFE|\\uD83E\\uDD39\\uD83C\\uDFFD|\\uD83E\\uDD39\\uD83C\\uDFFC|\\uD83E\\uDD39\\uD83C\\uDFFB|\\uD83E\\uDD38\\uD83C\\uDFFF|\\uD83E\\uDD38\\uD83C\\uDFFE|\\uD83E\\uDD38\\uD83C\\uDFFD|\\uD83E\\uDD38\\uD83C\\uDFFC|\\uD83E\\uDD38\\uD83C\\uDFFB|\\uD83E\\uDD37\\uD83C\\uDFFF|\\uD83E\\uDD37\\uD83C\\uDFFE|\\uD83E\\uDD37\\uD83C\\uDFFD|\\uD83E\\uDD37\\uD83C\\uDFFC|\\uD83E\\uDD37\\uD83C\\uDFFB|\\uD83E\\uDD36\\uD83C\\uDFFF|\\uD83E\\uDD36\\uD83C\\uDFFE|\\uD83E\\uDD36\\uD83C\\uDFFD|\\uD83E\\uDD36\\uD83C\\uDFFC|\\uD83E\\uDD36\\uD83C\\uDFFB|\\uD83E\\uDD35\\uD83C\\uDFFF|\\uD83E\\uDD35\\uD83C\\uDFFE|\\uD83E\\uDD35\\uD83C\\uDFFD|\\uD83E\\uDD35\\uD83C\\uDFFC|\\uD83E\\uDD35\\uD83C\\uDFFB|\\uD83E\\uDD34\\uD83C\\uDFFF|\\uD83E\\uDD34\\uD83C\\uDFFE|\\uD83E\\uDD34\\uD83C\\uDFFD|\\uD83E\\uDD34\\uD83C\\uDFFC|\\uD83E\\uDD34\\uD83C\\uDFFB|\\uD83E\\uDD33\\uD83C\\uDFFF|\\uD83E\\uDD33\\uD83C\\uDFFE|\\uD83E\\uDD33\\uD83C\\uDFFD|\\uD83E\\uDD33\\uD83C\\uDFFC|\\uD83E\\uDD33\\uD83C\\uDFFB|\\uD83E\\uDD30\\uD83C\\uDFFF|\\uD83E\\uDD30\\uD83C\\uDFFE|\\uD83E\\uDD30\\uD83C\\uDFFD|\\uD83E\\uDD30\\uD83C\\uDFFC|\\uD83E\\uDD30\\uD83C\\uDFFB|\\uD83E\\uDD26\\uD83C\\uDFFF|\\uD83E\\uDD26\\uD83C\\uDFFE|\\uD83E\\uDD26\\uD83C\\uDFFD|\\uD83E\\uDD26\\uD83C\\uDFFC|\\uD83E\\uDD26\\uD83C\\uDFFB|\\uD83E\\uDD1E\\uD83C\\uDFFF|\\uD83E\\uDD1E\\uD83C\\uDFFE|\\uD83E\\uDD1E\\uD83C\\uDFFD|\\uD83E\\uDD1E\\uD83C\\uDFFC|\\uD83E\\uDD1E\\uD83C\\uDFFB|\\uD83E\\uDD1D\\uD83C\\uDFFF|\\uD83E\\uDD1D\\uD83C\\uDFFE|\\uD83E\\uDD1D\\uD83C\\uDFFD|\\uD83E\\uDD1D\\uD83C\\uDFFC|\\uD83E\\uDD1D\\uD83C\\uDFFB|\\uD83E\\uDD1C\\uD83C\\uDFFF|\\uD83E\\uDD1C\\uD83C\\uDFFE|\\uD83E\\uDD1C\\uD83C\\uDFFD|\\uD83E\\uDD1C\\uD83C\\uDFFC|\\uD83E\\uDD1C\\uD83C\\uDFFB|\\uD83E\\uDD1B\\uD83C\\uDFFF|\\uD83E\\uDD1B\\uD83C\\uDFFE|\\uD83E\\uDD1B\\uD83C\\uDFFD|\\uD83E\\uDD1B\\uD83C\\uDFFC|\\uD83E\\uDD1B\\uD83C\\uDFFB|\\uD83E\\uDD1A\\uD83C\\uDFFF|\\uD83E\\uDD1A\\uD83C\\uDFFE|\\uD83E\\uDD1A\\uD83C\\uDFFD|\\uD83E\\uDD1A\\uD83C\\uDFFC|\\uD83E\\uDD1A\\uD83C\\uDFFB|\\uD83E\\uDD19\\uD83C\\uDFFF|\\uD83E\\uDD19\\uD83C\\uDFFE|\\uD83E\\uDD19\\uD83C\\uDFFD|\\uD83E\\uDD19\\uD83C\\uDFFC|\\uD83E\\uDD19\\uD83C\\uDFFB|\\uD83E\\uDD18\\uD83C\\uDFFF|\\uD83E\\uDD18\\uD83C\\uDFFE|\\uD83E\\uDD18\\uD83C\\uDFFD|\\uD83E\\uDD18\\uD83C\\uDFFC|\\uD83E\\uDD18\\uD83C\\uDFFB|\\uD83D\\uDEC0\\uD83C\\uDFFF|\\uD83D\\uDEC0\\uD83C\\uDFFE|\\uD83D\\uDEC0\\uD83C\\uDFFD|\\uD83D\\uDEC0\\uD83C\\uDFFC|\\uD83D\\uDEC0\\uD83C\\uDFFB|\\uD83D\\uDEB6\\uD83C\\uDFFF|\\uD83D\\uDEB6\\uD83C\\uDFFE|\\uD83D\\uDEB6\\uD83C\\uDFFD|\\uD83D\\uDEB6\\uD83C\\uDFFC|\\uD83D\\uDEB6\\uD83C\\uDFFB|\\uD83D\\uDEB5\\uD83C\\uDFFF|\\uD83D\\uDEB5\\uD83C\\uDFFE|\\uD83D\\uDEB5\\uD83C\\uDFFD|\\uD83D\\uDEB5\\uD83C\\uDFFC|\\uD83D\\uDEB5\\uD83C\\uDFFB|\\uD83D\\uDEB4\\uD83C\\uDFFF|\\uD83D\\uDEB4\\uD83C\\uDFFE|\\uD83D\\uDEB4\\uD83C\\uDFFD|\\uD83D\\uDEB4\\uD83C\\uDFFC|\\uD83D\\uDEB4\\uD83C\\uDFFB|\\uD83D\\uDEA3\\uD83C\\uDFFF|\\uD83D\\uDEA3\\uD83C\\uDFFE|\\uD83D\\uDEA3\\uD83C\\uDFFD|\\uD83D\\uDEA3\\uD83C\\uDFFC|\\uD83D\\uDEA3\\uD83C\\uDFFB|\\uD83D\\uDE4F\\uD83C\\uDFFF|\\uD83D\\uDE4F\\uD83C\\uDFFE|\\uD83D\\uDE4F\\uD83C\\uDFFD|\\uD83D\\uDE4F\\uD83C\\uDFFC|\\uD83D\\uDE4F\\uD83C\\uDFFB|\\uD83D\\uDE4E\\uD83C\\uDFFF|\\uD83D\\uDE4E\\uD83C\\uDFFE|\\uD83D\\uDE4E\\uD83C\\uDFFD|\\uD83D\\uDE4E\\uD83C\\uDFFC|\\uD83D\\uDE4E\\uD83C\\uDFFB|\\uD83D\\uDE4D\\uD83C\\uDFFF|\\uD83D\\uDE4D\\uD83C\\uDFFE|\\uD83D\\uDE4D\\uD83C\\uDFFD|\\uD83D\\uDE4D\\uD83C\\uDFFC|\\uD83D\\uDE4D\\uD83C\\uDFFB|\\uD83D\\uDE4C\\uD83C\\uDFFF|\\uD83D\\uDE4C\\uD83C\\uDFFE|\\uD83D\\uDE4C\\uD83C\\uDFFD|\\uD83D\\uDE4C\\uD83C\\uDFFC|\\uD83D\\uDE4C\\uD83C\\uDFFB|\\uD83D\\uDE4B\\uD83C\\uDFFF|\\uD83D\\uDE4B\\uD83C\\uDFFE|\\uD83D\\uDE4B\\uD83C\\uDFFD|\\uD83D\\uDE4B\\uD83C\\uDFFC|\\uD83D\\uDE4B\\uD83C\\uDFFB|\\uD83D\\uDE47\\uD83C\\uDFFF|\\uD83D\\uDE47\\uD83C\\uDFFE|\\uD83D\\uDE47\\uD83C\\uDFFD|\\uD83D\\uDE47\\uD83C\\uDFFC|\\uD83D\\uDE47\\uD83C\\uDFFB|\\uD83D\\uDE46\\uD83C\\uDFFF|\\uD83D\\uDE46\\uD83C\\uDFFE|\\uD83D\\uDE46\\uD83C\\uDFFD|\\uD83D\\uDE46\\uD83C\\uDFFC|\\uD83D\\uDE46\\uD83C\\uDFFB|\\uD83D\\uDE45\\uD83C\\uDFFF|\\uD83D\\uDE45\\uD83C\\uDFFE|\\uD83D\\uDE45\\uD83C\\uDFFD|\\uD83D\\uDE45\\uD83C\\uDFFC|\\uD83D\\uDE45\\uD83C\\uDFFB|\\uD83D\\uDD96\\uD83C\\uDFFF|\\uD83D\\uDD96\\uD83C\\uDFFE|\\uD83D\\uDD96\\uD83C\\uDFFD|\\uD83D\\uDD96\\uD83C\\uDFFC|\\uD83D\\uDD96\\uD83C\\uDFFB|\\uD83D\\uDD95\\uD83C\\uDFFF|\\uD83D\\uDD95\\uD83C\\uDFFE|\\uD83D\\uDD95\\uD83C\\uDFFD|\\uD83D\\uDD95\\uD83C\\uDFFC|\\uD83D\\uDD95\\uD83C\\uDFFB|\\uD83D\\uDD90\\uD83C\\uDFFF|\\uD83D\\uDD90\\uD83C\\uDFFE|\\uD83D\\uDD90\\uD83C\\uDFFD|\\uD83D\\uDD90\\uD83C\\uDFFC|\\uD83D\\uDD90\\uD83C\\uDFFB|\\uD83D\\uDD7A\\uD83C\\uDFFF|\\uD83D\\uDD7A\\uD83C\\uDFFE|\\uD83D\\uDD7A\\uD83C\\uDFFD|\\uD83D\\uDD7A\\uD83C\\uDFFC|\\uD83D\\uDD7A\\uD83C\\uDFFB|\\uD83D\\uDD75\\uD83C\\uDFFF|\\uD83D\\uDD75\\uD83C\\uDFFE|\\uD83D\\uDD75\\uD83C\\uDFFD|\\uD83D\\uDD75\\uD83C\\uDFFC|\\uD83D\\uDD75\\uD83C\\uDFFB|\\uD83D\\uDCAA\\uD83C\\uDFFF|\\uD83D\\uDCAA\\uD83C\\uDFFE|\\uD83D\\uDCAA\\uD83C\\uDFFD|\\uD83D\\uDCAA\\uD83C\\uDFFC|\\uD83D\\uDCAA\\uD83C\\uDFFB|\\uD83D\\uDC87\\uD83C\\uDFFF|\\uD83D\\uDC87\\uD83C\\uDFFE|\\uD83D\\uDC87\\uD83C\\uDFFD|\\uD83D\\uDC87\\uD83C\\uDFFC|\\uD83D\\uDC87\\uD83C\\uDFFB|\\uD83D\\uDC86\\uD83C\\uDFFF|\\uD83D\\uDC86\\uD83C\\uDFFE|\\uD83D\\uDC86\\uD83C\\uDFFD|\\uD83D\\uDC86\\uD83C\\uDFFC|\\uD83D\\uDC86\\uD83C\\uDFFB|\\uD83D\\uDC85\\uD83C\\uDFFF|\\uD83D\\uDC85\\uD83C\\uDFFE|\\uD83D\\uDC85\\uD83C\\uDFFD|\\uD83D\\uDC85\\uD83C\\uDFFC|\\uD83D\\uDC85\\uD83C\\uDFFB|\\uD83D\\uDC83\\uD83C\\uDFFF|\\uD83D\\uDC83\\uD83C\\uDFFE|\\uD83D\\uDC83\\uD83C\\uDFFD|\\uD83D\\uDC83\\uD83C\\uDFFC|\\uD83D\\uDC83\\uD83C\\uDFFB|\\uD83D\\uDC82\\uD83C\\uDFFF|\\uD83D\\uDC82\\uD83C\\uDFFE|\\uD83D\\uDC82\\uD83C\\uDFFD|\\uD83D\\uDC82\\uD83C\\uDFFC|\\uD83D\\uDC82\\uD83C\\uDFFB|\\uD83D\\uDC81\\uD83C\\uDFFF|\\uD83D\\uDC81\\uD83C\\uDFFE|\\uD83D\\uDC81\\uD83C\\uDFFD|\\uD83D\\uDC81\\uD83C\\uDFFC|\\uD83D\\uDC81\\uD83C\\uDFFB|\\uD83D\\uDC7C\\uD83C\\uDFFF|\\uD83D\\uDC7C\\uD83C\\uDFFE|\\uD83D\\uDC7C\\uD83C\\uDFFD|\\uD83D\\uDC7C\\uD83C\\uDFFC|\\uD83D\\uDC7C\\uD83C\\uDFFB|\\uD83D\\uDC78\\uD83C\\uDFFF|\\uD83D\\uDC78\\uD83C\\uDFFE|\\uD83D\\uDC78\\uD83C\\uDFFD|\\uD83D\\uDC78\\uD83C\\uDFFC|\\uD83D\\uDC78\\uD83C\\uDFFB|\\uD83D\\uDC77\\uD83C\\uDFFF|\\uD83D\\uDC77\\uD83C\\uDFFE|\\uD83D\\uDC77\\uD83C\\uDFFD|\\uD83D\\uDC77\\uD83C\\uDFFC|\\uD83D\\uDC77\\uD83C\\uDFFB|\\uD83D\\uDC76\\uD83C\\uDFFF|\\uD83D\\uDC76\\uD83C\\uDFFE|\\uD83D\\uDC76\\uD83C\\uDFFD|\\uD83D\\uDC76\\uD83C\\uDFFC|\\uD83D\\uDC76\\uD83C\\uDFFB|\\uD83D\\uDC75\\uD83C\\uDFFF|\\uD83D\\uDC75\\uD83C\\uDFFE|\\uD83D\\uDC75\\uD83C\\uDFFD|\\uD83D\\uDC75\\uD83C\\uDFFC|\\uD83D\\uDC75\\uD83C\\uDFFB|\\uD83D\\uDC74\\uD83C\\uDFFF|\\uD83D\\uDC74\\uD83C\\uDFFE|\\uD83D\\uDC74\\uD83C\\uDFFD|\\uD83D\\uDC74\\uD83C\\uDFFC|\\uD83D\\uDC74\\uD83C\\uDFFB|\\uD83D\\uDC73\\uD83C\\uDFFF|\\uD83D\\uDC73\\uD83C\\uDFFE|\\uD83D\\uDC73\\uD83C\\uDFFD|\\uD83D\\uDC73\\uD83C\\uDFFC|\\uD83D\\uDC73\\uD83C\\uDFFB|\\uD83D\\uDC72\\uD83C\\uDFFF|\\uD83D\\uDC72\\uD83C\\uDFFE|\\uD83D\\uDC72\\uD83C\\uDFFD|\\uD83D\\uDC72\\uD83C\\uDFFC|\\uD83D\\uDC72\\uD83C\\uDFFB|\\uD83D\\uDC71\\uD83C\\uDFFF|\\uD83D\\uDC71\\uD83C\\uDFFE|\\uD83D\\uDC71\\uD83C\\uDFFD|\\uD83D\\uDC71\\uD83C\\uDFFC|\\uD83D\\uDC71\\uD83C\\uDFFB|\\uD83D\\uDC70\\uD83C\\uDFFF|\\uD83D\\uDC70\\uD83C\\uDFFE|\\uD83D\\uDC70\\uD83C\\uDFFD|\\uD83D\\uDC70\\uD83C\\uDFFC|\\uD83D\\uDC70\\uD83C\\uDFFB|\\uD83D\\uDC6E\\uD83C\\uDFFF|\\uD83D\\uDC6E\\uD83C\\uDFFE|\\uD83D\\uDC6E\\uD83C\\uDFFD|\\uD83D\\uDC6E\\uD83C\\uDFFC|\\uD83D\\uDC6E\\uD83C\\uDFFB|\\uD83D\\uDC69\\uD83C\\uDFFF|\\uD83D\\uDC69\\uD83C\\uDFFE|\\uD83D\\uDC69\\uD83C\\uDFFD|\\uD83D\\uDC69\\uD83C\\uDFFC|\\uD83D\\uDC69\\uD83C\\uDFFB|\\uD83D\\uDC68\\uD83C\\uDFFF|\\uD83D\\uDC68\\uD83C\\uDFFE|\\uD83D\\uDC68\\uD83C\\uDFFD|\\uD83D\\uDC68\\uD83C\\uDFFC|\\uD83D\\uDC68\\uD83C\\uDFFB|\\uD83D\\uDC67\\uD83C\\uDFFF|\\uD83D\\uDC67\\uD83C\\uDFFE|\\uD83D\\uDC67\\uD83C\\uDFFD|\\uD83D\\uDC67\\uD83C\\uDFFC|\\uD83D\\uDC67\\uD83C\\uDFFB|\\uD83D\\uDC66\\uD83C\\uDFFF|\\uD83D\\uDC66\\uD83C\\uDFFE|\\uD83D\\uDC66\\uD83C\\uDFFD|\\uD83D\\uDC66\\uD83C\\uDFFC|\\uD83D\\uDC66\\uD83C\\uDFFB|\\uD83D\\uDC50\\uD83C\\uDFFF|\\uD83D\\uDC50\\uD83C\\uDFFE|\\uD83D\\uDC50\\uD83C\\uDFFD|\\uD83D\\uDC50\\uD83C\\uDFFC|\\uD83D\\uDC50\\uD83C\\uDFFB|\\uD83D\\uDC4F\\uD83C\\uDFFF|\\uD83D\\uDC4F\\uD83C\\uDFFE|\\uD83D\\uDC4F\\uD83C\\uDFFD|\\uD83D\\uDC4F\\uD83C\\uDFFC|\\uD83D\\uDC4F\\uD83C\\uDFFB|\\uD83D\\uDC4E\\uD83C\\uDFFF|\\uD83D\\uDC4E\\uD83C\\uDFFE|\\uD83D\\uDC4E\\uD83C\\uDFFD|\\uD83D\\uDC4E\\uD83C\\uDFFC|\\uD83D\\uDC4E\\uD83C\\uDFFB|\\uD83D\\uDC4D\\uD83C\\uDFFF|\\uD83D\\uDC4D\\uD83C\\uDFFE|\\uD83D\\uDC4D\\uD83C\\uDFFD|\\uD83D\\uDC4D\\uD83C\\uDFFC|\\uD83D\\uDC4D\\uD83C\\uDFFB|\\uD83D\\uDC4C\\uD83C\\uDFFF|\\uD83D\\uDC4C\\uD83C\\uDFFE|\\uD83D\\uDC4C\\uD83C\\uDFFD|\\uD83D\\uDC4C\\uD83C\\uDFFC|\\uD83D\\uDC4C\\uD83C\\uDFFB|\\uD83D\\uDC4B\\uD83C\\uDFFF|\\uD83D\\uDC4B\\uD83C\\uDFFE|\\uD83D\\uDC4B\\uD83C\\uDFFD|\\uD83D\\uDC4B\\uD83C\\uDFFC|\\uD83D\\uDC4B\\uD83C\\uDFFB|\\uD83D\\uDC4A\\uD83C\\uDFFF|\\uD83D\\uDC4A\\uD83C\\uDFFE|\\uD83D\\uDC4A\\uD83C\\uDFFD|\\uD83D\\uDC4A\\uD83C\\uDFFC|\\uD83D\\uDC4A\\uD83C\\uDFFB|\\uD83D\\uDC49\\uD83C\\uDFFF|\\uD83D\\uDC49\\uD83C\\uDFFE|\\uD83D\\uDC49\\uD83C\\uDFFD|\\uD83D\\uDC49\\uD83C\\uDFFC|\\uD83D\\uDC49\\uD83C\\uDFFB|\\uD83D\\uDC48\\uD83C\\uDFFF|\\uD83D\\uDC48\\uD83C\\uDFFE|\\uD83D\\uDC48\\uD83C\\uDFFD|\\uD83D\\uDC48\\uD83C\\uDFFC|\\uD83D\\uDC48\\uD83C\\uDFFB|\\uD83D\\uDC47\\uD83C\\uDFFF|\\uD83D\\uDC47\\uD83C\\uDFFE|\\uD83D\\uDC47\\uD83C\\uDFFD|\\uD83D\\uDC47\\uD83C\\uDFFC|\\uD83D\\uDC47\\uD83C\\uDFFB|\\uD83D\\uDC46\\uD83C\\uDFFF|\\uD83D\\uDC46\\uD83C\\uDFFE|\\uD83D\\uDC46\\uD83C\\uDFFD|\\uD83D\\uDC46\\uD83C\\uDFFC|\\uD83D\\uDC46\\uD83C\\uDFFB|\\uD83D\\uDC43\\uD83C\\uDFFF|\\uD83D\\uDC43\\uD83C\\uDFFE|\\uD83D\\uDC43\\uD83C\\uDFFD|\\uD83D\\uDC43\\uD83C\\uDFFC|\\uD83D\\uDC43\\uD83C\\uDFFB|\\uD83D\\uDC42\\uD83C\\uDFFF|\\uD83D\\uDC42\\uD83C\\uDFFE|\\uD83D\\uDC42\\uD83C\\uDFFD|\\uD83D\\uDC42\\uD83C\\uDFFC|\\uD83D\\uDC42\\uD83C\\uDFFB|\\uD83C\\uDFCB\\uD83C\\uDFFF|\\uD83C\\uDFCB\\uD83C\\uDFFE|\\uD83C\\uDFF3\\uD83C\\uDF08|\\uD83C\\uDFCB\\uD83C\\uDFFC|\\uD83C\\uDFCB\\uD83C\\uDFFB|\\uD83C\\uDFCA\\uD83C\\uDFFF|\\uD83C\\uDFCA\\uD83C\\uDFFE|\\uD83C\\uDFCA\\uD83C\\uDFFD|\\uD83C\\uDFCA\\uD83C\\uDFFC|\\uD83C\\uDFCA\\uD83C\\uDFFB|\\uD83C\\uDFC7\\uD83C\\uDFFF|\\uD83C\\uDFC7\\uD83C\\uDFFE|\\uD83C\\uDFC7\\uD83C\\uDFFD|\\uD83C\\uDFC7\\uD83C\\uDFFC|\\uD83C\\uDFC7\\uD83C\\uDFFB|\\uD83C\\uDFC4\\uD83C\\uDFFF|\\uD83C\\uDFCB\\uD83C\\uDFFD|\\uD83C\\uDFC4\\uD83C\\uDFFD|\\uD83C\\uDFC4\\uD83C\\uDFFC|\\uD83C\\uDFC4\\uD83C\\uDFFB|\\uD83C\\uDFC3\\uD83C\\uDFFF|\\uD83C\\uDFC3\\uD83C\\uDFFE|\\uD83C\\uDFC3\\uD83C\\uDFFD|\\uD83C\\uDFC3\\uD83C\\uDFFC|\\uD83C\\uDFC3\\uD83C\\uDFFB|\\uD83C\\uDF85\\uD83C\\uDFFF|\\uD83C\\uDF85\\uD83C\\uDFFE|\\uD83C\\uDF85\\uD83C\\uDFFD|\\uD83C\\uDF85\\uD83C\\uDFFC|\\uD83C\\uDF85\\uD83C\\uDFFB|\\uD83C\\uDDFF\\uD83C\\uDDFC|\\uD83C\\uDDFF\\uD83C\\uDDF2|\\uD83C\\uDDFF\\uD83C\\uDDE6|\\uD83C\\uDDFE\\uD83C\\uDDF9|\\uD83C\\uDDFE\\uD83C\\uDDEA|\\uD83C\\uDDFD\\uD83C\\uDDF0|\\uD83C\\uDDFC\\uD83C\\uDDF8|\\uD83C\\uDDFC\\uD83C\\uDDEB|\\uD83C\\uDDFB\\uD83C\\uDDFA|\\uD83C\\uDDFB\\uD83C\\uDDF3|\\uD83C\\uDDFB\\uD83C\\uDDEE|\\uD83C\\uDDFB\\uD83C\\uDDEC|\\uD83C\\uDDFB\\uD83C\\uDDEA|\\uD83C\\uDDFB\\uD83C\\uDDE8|\\uD83C\\uDDFB\\uD83C\\uDDE6|\\uD83C\\uDDFA\\uD83C\\uDDFF|\\uD83C\\uDDFA\\uD83C\\uDDFE|\\uD83C\\uDDFA\\uD83C\\uDDF8|\\uD83C\\uDDFA\\uD83C\\uDDF2|\\uD83C\\uDDFA\\uD83C\\uDDEC|\\uD83C\\uDDFA\\uD83C\\uDDE6|\\uD83C\\uDDF9\\uD83C\\uDDFF|\\uD83C\\uDDF9\\uD83C\\uDDFC|\\uD83C\\uDDF9\\uD83C\\uDDFB|\\uD83C\\uDDF9\\uD83C\\uDDF9|\\uD83C\\uDDF9\\uD83C\\uDDF7|\\uD83C\\uDDF9\\uD83C\\uDDF4|\\uD83C\\uDDF9\\uD83C\\uDDF3|\\uD83C\\uDDF9\\uD83C\\uDDF2|\\uD83C\\uDDF9\\uD83C\\uDDF1|\\uD83C\\uDDF9\\uD83C\\uDDF0|\\uD83C\\uDDF9\\uD83C\\uDDEF|\\uD83C\\uDDF9\\uD83C\\uDDED|\\uD83C\\uDDF9\\uD83C\\uDDEC|\\uD83C\\uDDF9\\uD83C\\uDDEB|\\uD83C\\uDDF9\\uD83C\\uDDE9|\\uD83C\\uDDF9\\uD83C\\uDDE8|\\uD83C\\uDDF9\\uD83C\\uDDE6|\\uD83C\\uDDF8\\uD83C\\uDDFF|\\uD83C\\uDDF8\\uD83C\\uDDFE|\\uD83C\\uDDF8\\uD83C\\uDDFD|\\uD83C\\uDDF8\\uD83C\\uDDFB|\\uD83C\\uDDF8\\uD83C\\uDDF9|\\uD83C\\uDDF8\\uD83C\\uDDF8|\\uD83C\\uDDF8\\uD83C\\uDDF7|\\uD83C\\uDDF8\\uD83C\\uDDF4|\\uD83C\\uDDF8\\uD83C\\uDDF3|\\uD83C\\uDDF8\\uD83C\\uDDF2|\\uD83C\\uDDF8\\uD83C\\uDDF1|\\uD83C\\uDDF8\\uD83C\\uDDF0|\\uD83C\\uDDF8\\uD83C\\uDDEF|\\uD83C\\uDDF8\\uD83C\\uDDEE|\\uD83C\\uDDF8\\uD83C\\uDDED|\\uD83C\\uDDF8\\uD83C\\uDDEC|\\uD83C\\uDDF8\\uD83C\\uDDEA|\\uD83C\\uDDF8\\uD83C\\uDDE9|\\uD83C\\uDDF8\\uD83C\\uDDE8|\\uD83C\\uDDF8\\uD83C\\uDDE7|\\uD83C\\uDDF8\\uD83C\\uDDE6|\\uD83C\\uDDF7\\uD83C\\uDDFC|\\uD83C\\uDDF7\\uD83C\\uDDFA|\\uD83C\\uDDF7\\uD83C\\uDDF8|\\uD83C\\uDDF7\\uD83C\\uDDF4|\\uD83C\\uDDF7\\uD83C\\uDDEA|\\uD83C\\uDDF6\\uD83C\\uDDE6|\\uD83C\\uDDF5\\uD83C\\uDDFE|\\uD83C\\uDDF5\\uD83C\\uDDFC|\\uD83C\\uDDF5\\uD83C\\uDDF9|\\uD83C\\uDDF5\\uD83C\\uDDF8|\\uD83C\\uDDF5\\uD83C\\uDDF7|\\uD83C\\uDDF5\\uD83C\\uDDF3|\\uD83C\\uDDF5\\uD83C\\uDDF2|\\uD83C\\uDDF5\\uD83C\\uDDF1|\\uD83C\\uDDF5\\uD83C\\uDDF0|\\uD83C\\uDDF5\\uD83C\\uDDED|\\uD83C\\uDDF5\\uD83C\\uDDEC|\\uD83C\\uDDF5\\uD83C\\uDDEB|\\uD83C\\uDDF5\\uD83C\\uDDEA|\\uD83C\\uDDF5\\uD83C\\uDDE6|\\uD83C\\uDDF4\\uD83C\\uDDF2|\\uD83C\\uDDF3\\uD83C\\uDDFF|\\uD83C\\uDDF3\\uD83C\\uDDFA|\\uD83C\\uDDF3\\uD83C\\uDDF7|\\uD83C\\uDDF3\\uD83C\\uDDF5|\\uD83C\\uDDF3\\uD83C\\uDDF4|\\uD83C\\uDDF3\\uD83C\\uDDF1|\\uD83C\\uDDF3\\uD83C\\uDDEE|\\uD83C\\uDDF3\\uD83C\\uDDEC|\\uD83C\\uDDF3\\uD83C\\uDDEB|\\uD83C\\uDDF3\\uD83C\\uDDEA|\\uD83C\\uDDF3\\uD83C\\uDDE8|\\uD83C\\uDDF3\\uD83C\\uDDE6|\\uD83C\\uDDF2\\uD83C\\uDDFF|\\uD83C\\uDDF2\\uD83C\\uDDFE|\\uD83C\\uDDF2\\uD83C\\uDDFD|\\uD83C\\uDDF2\\uD83C\\uDDFC|\\uD83C\\uDDF2\\uD83C\\uDDFB|\\uD83C\\uDDF2\\uD83C\\uDDFA|\\uD83C\\uDDF2\\uD83C\\uDDF9|\\uD83C\\uDDF2\\uD83C\\uDDF8|\\uD83C\\uDDF2\\uD83C\\uDDF7|\\uD83C\\uDDF2\\uD83C\\uDDF6|\\uD83C\\uDDF2\\uD83C\\uDDF5|\\uD83C\\uDDF2\\uD83C\\uDDF4|\\uD83C\\uDDF2\\uD83C\\uDDF3|\\uD83C\\uDDF2\\uD83C\\uDDF2|\\uD83C\\uDDF2\\uD83C\\uDDF1|\\uD83C\\uDDF2\\uD83C\\uDDF0|\\uD83C\\uDDF2\\uD83C\\uDDED|\\uD83C\\uDDF2\\uD83C\\uDDEC|\\uD83C\\uDDF2\\uD83C\\uDDEB|\\uD83C\\uDDF2\\uD83C\\uDDEA|\\uD83C\\uDDF2\\uD83C\\uDDE9|\\uD83C\\uDDF2\\uD83C\\uDDE8|\\uD83C\\uDDF2\\uD83C\\uDDE6|\\uD83C\\uDDF1\\uD83C\\uDDFE|\\uD83C\\uDDF1\\uD83C\\uDDFB|\\uD83C\\uDDF1\\uD83C\\uDDFA|\\uD83C\\uDDF1\\uD83C\\uDDF9|\\uD83C\\uDDF1\\uD83C\\uDDF8|\\uD83C\\uDDF1\\uD83C\\uDDF7|\\uD83C\\uDDF1\\uD83C\\uDDF0|\\uD83C\\uDDF1\\uD83C\\uDDEE|\\uD83C\\uDDF1\\uD83C\\uDDE8|\\uD83C\\uDDF1\\uD83C\\uDDE7|\\uD83C\\uDDF1\\uD83C\\uDDE6|\\uD83C\\uDDF0\\uD83C\\uDDFF|\\uD83C\\uDDF0\\uD83C\\uDDFE|\\uD83C\\uDDF0\\uD83C\\uDDFC|\\uD83C\\uDDF0\\uD83C\\uDDF7|\\uD83C\\uDDF0\\uD83C\\uDDF5|\\uD83C\\uDDF0\\uD83C\\uDDF3|\\uD83C\\uDDF0\\uD83C\\uDDF2|\\uD83C\\uDDF0\\uD83C\\uDDEE|\\uD83C\\uDDF0\\uD83C\\uDDED|\\uD83C\\uDDF0\\uD83C\\uDDEC|\\uD83C\\uDDF0\\uD83C\\uDDEA|\\uD83C\\uDDEF\\uD83C\\uDDF5|\\uD83C\\uDDEF\\uD83C\\uDDF4|\\uD83C\\uDDEF\\uD83C\\uDDF2|\\uD83C\\uDDEF\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDF9|\\uD83C\\uDDEE\\uD83C\\uDDF8|\\uD83C\\uDDEE\\uD83C\\uDDF7|\\uD83C\\uDDEE\\uD83C\\uDDF6|\\uD83C\\uDDEE\\uD83C\\uDDF4|\\uD83C\\uDDEE\\uD83C\\uDDF3|\\uD83C\\uDDEE\\uD83C\\uDDF2|\\uD83C\\uDDEE\\uD83C\\uDDF1|\\uD83C\\uDDEE\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDE9|\\uD83C\\uDDEE\\uD83C\\uDDE8|\\uD83C\\uDDED\\uD83C\\uDDFA|\\uD83C\\uDDED\\uD83C\\uDDF9|\\uD83C\\uDDED\\uD83C\\uDDF7|\\uD83C\\uDDED\\uD83C\\uDDF3|\\uD83C\\uDDED\\uD83C\\uDDF2|\\uD83C\\uDDED\\uD83C\\uDDF0|\\uD83C\\uDDEC\\uD83C\\uDDFE|\\uD83C\\uDDEC\\uD83C\\uDDFC|\\uD83C\\uDDEC\\uD83C\\uDDFA|\\uD83C\\uDDEC\\uD83C\\uDDF9|\\uD83C\\uDDEC\\uD83C\\uDDF8|\\uD83C\\uDDEC\\uD83C\\uDDF7|\\uD83C\\uDDEC\\uD83C\\uDDF6|\\uD83C\\uDDEC\\uD83C\\uDDF5|\\uD83C\\uDDEC\\uD83C\\uDDF3|\\uD83C\\uDDEC\\uD83C\\uDDF2|\\uD83C\\uDDEC\\uD83C\\uDDF1|\\uD83C\\uDDEC\\uD83C\\uDDEE|\\uD83C\\uDDEC\\uD83C\\uDDED|\\uD83C\\uDDEC\\uD83C\\uDDEC|\\uD83C\\uDDEC\\uD83C\\uDDEB|\\uD83C\\uDDEC\\uD83C\\uDDEA|\\uD83C\\uDDEC\\uD83C\\uDDE9|\\uD83C\\uDDEC\\uD83C\\uDDE7|\\uD83C\\uDDEC\\uD83C\\uDDE6|\\uD83C\\uDDEB\\uD83C\\uDDF7|\\uD83C\\uDDEB\\uD83C\\uDDF4|\\uD83C\\uDDEB\\uD83C\\uDDF2|\\uD83C\\uDDEB\\uD83C\\uDDF0|\\uD83C\\uDDEB\\uD83C\\uDDEF|\\uD83C\\uDDEB\\uD83C\\uDDEE|\\uD83C\\uDDEA\\uD83C\\uDDFA|\\uD83C\\uDDEA\\uD83C\\uDDF9|\\uD83C\\uDDEA\\uD83C\\uDDF8|\\uD83C\\uDDEA\\uD83C\\uDDF7|\\uD83C\\uDDEA\\uD83C\\uDDED|\\uD83C\\uDDEA\\uD83C\\uDDEC|\\uD83C\\uDDEA\\uD83C\\uDDEA|\\uD83C\\uDDEA\\uD83C\\uDDE8|\\uD83C\\uDDEA\\uD83C\\uDDE6|\\uD83C\\uDDE9\\uD83C\\uDDFF|\\uD83C\\uDDE9\\uD83C\\uDDF4|\\uD83C\\uDDE9\\uD83C\\uDDF2|\\uD83C\\uDDE9\\uD83C\\uDDF0|\\uD83C\\uDDE9\\uD83C\\uDDEF|\\uD83C\\uDDE9\\uD83C\\uDDEC|\\uD83C\\uDDE9\\uD83C\\uDDEA|\\uD83C\\uDDE8\\uD83C\\uDDFF|\\uD83C\\uDDE8\\uD83C\\uDDFE|\\uD83C\\uDDE8\\uD83C\\uDDFD|\\uD83C\\uDDE8\\uD83C\\uDDFC|\\uD83C\\uDDE8\\uD83C\\uDDFB|\\uD83C\\uDDE8\\uD83C\\uDDFA|\\uD83C\\uDDE8\\uD83C\\uDDF7|\\uD83C\\uDDE8\\uD83C\\uDDF5|\\uD83C\\uDDE8\\uD83C\\uDDF4|\\uD83C\\uDDE8\\uD83C\\uDDF3|\\uD83C\\uDDE8\\uD83C\\uDDF2|\\uD83C\\uDDE8\\uD83C\\uDDF1|\\uD83C\\uDDE8\\uD83C\\uDDF0|\\uD83C\\uDDE8\\uD83C\\uDDEE|\\uD83C\\uDDE8\\uD83C\\uDDED|\\uD83C\\uDDE8\\uD83C\\uDDEC|\\uD83C\\uDDE8\\uD83C\\uDDEB|\\uD83C\\uDDE8\\uD83C\\uDDE9|\\uD83C\\uDDE8\\uD83C\\uDDE8|\\uD83C\\uDDE8\\uD83C\\uDDE6|\\uD83C\\uDDE7\\uD83C\\uDDFF|\\uD83C\\uDDE7\\uD83C\\uDDFE|\\uD83C\\uDDE7\\uD83C\\uDDFC|\\uD83C\\uDDE7\\uD83C\\uDDFB|\\uD83C\\uDDE7\\uD83C\\uDDF9|\\uD83C\\uDDE7\\uD83C\\uDDF8|\\uD83C\\uDDE7\\uD83C\\uDDF7|\\uD83C\\uDDE7\\uD83C\\uDDF6|\\uD83C\\uDDE7\\uD83C\\uDDF4|\\uD83C\\uDDE7\\uD83C\\uDDF3|\\uD83C\\uDDE7\\uD83C\\uDDF2|\\uD83C\\uDDE7\\uD83C\\uDDF1|\\uD83C\\uDDE7\\uD83C\\uDDEF|\\uD83C\\uDDE7\\uD83C\\uDDEE|\\uD83C\\uDDE7\\uD83C\\uDDED|\\uD83C\\uDDE7\\uD83C\\uDDEC|\\uD83C\\uDDE7\\uD83C\\uDDEB|\\uD83C\\uDDE7\\uD83C\\uDDEA|\\uD83C\\uDDE7\\uD83C\\uDDE9|\\uD83C\\uDDE7\\uD83C\\uDDE7|\\uD83C\\uDDE7\\uD83C\\uDDE6|\\uD83C\\uDDE6\\uD83C\\uDDFF|\\uD83C\\uDDE6\\uD83C\\uDDFD|\\uD83C\\uDDE6\\uD83C\\uDDFC|\\uD83C\\uDDE6\\uD83C\\uDDFA|\\uD83C\\uDDE6\\uD83C\\uDDF9|\\uD83C\\uDFC4\\uD83C\\uDFFE|\\uD83D\\uDDE3\\uFE0F|\\u26F9\\uD83C\\uDFFF|\\u26F9\\uD83C\\uDFFE|\\u26F9\\uD83C\\uDFFD|\\u26F9\\uD83C\\uDFFC|\\u26F9\\uD83C\\uDFFB|\\u270D\\uD83C\\uDFFF|\\u270D\\uD83C\\uDFFE|\\u270D\\uD83C\\uDFFD|\\u270D\\uD83C\\uDFFC|\\u270D\\uD83C\\uDFFB|\\uD83C\\uDC04\\uFE0F|\\uD83C\\uDD7F\\uFE0F|\\uD83C\\uDE02\\uFE0F|\\uD83C\\uDE1A\\uFE0F|\\uD83C\\uDE2F\\uFE0F|\\uD83C\\uDE37\\uFE0F|\\uD83C\\uDF9E\\uFE0F|\\uD83C\\uDF9F\\uFE0F|\\uD83C\\uDFCB\\uFE0F|\\uD83C\\uDFCC\\uFE0F|\\uD83C\\uDFCD\\uFE0F|\\uD83C\\uDFCE\\uFE0F|\\uD83C\\uDF96\\uFE0F|\\uD83C\\uDF97\\uFE0F|\\uD83C\\uDF36\\uFE0F|\\uD83C\\uDF27\\uFE0F|\\uD83C\\uDF28\\uFE0F|\\uD83C\\uDF29\\uFE0F|\\uD83C\\uDF2A\\uFE0F|\\uD83C\\uDF2B\\uFE0F|\\uD83C\\uDF2C\\uFE0F|\\uD83D\\uDC3F\\uFE0F|\\uD83D\\uDD77\\uFE0F|\\uD83D\\uDD78\\uFE0F|\\uD83C\\uDF21\\uFE0F|\\uD83C\\uDF99\\uFE0F|\\uD83C\\uDF9A\\uFE0F|\\uD83C\\uDF9B\\uFE0F|\\uD83C\\uDFF3\\uFE0F|\\uD83C\\uDFF5\\uFE0F|\\uD83C\\uDFF7\\uFE0F|\\uD83D\\uDCFD\\uFE0F|\\uD83D\\uDD49\\uFE0F|\\uD83D\\uDD4A\\uFE0F|\\uD83D\\uDD6F\\uFE0F|\\uD83D\\uDD70\\uFE0F|\\uD83D\\uDD73\\uFE0F|\\uD83D\\uDD76\\uFE0F|\\uD83D\\uDD79\\uFE0F|\\uD83D\\uDD87\\uFE0F|\\uD83D\\uDD8A\\uFE0F|\\uD83D\\uDD8B\\uFE0F|\\uD83D\\uDD8C\\uFE0F|\\uD83D\\uDD8D\\uFE0F|\\uD83D\\uDDA5\\uFE0F|\\uD83D\\uDDA8\\uFE0F|\\uD83D\\uDDB2\\uFE0F|\\uD83D\\uDDBC\\uFE0F|\\uD83D\\uDDC2\\uFE0F|\\uD83D\\uDDC3\\uFE0F|\\uD83D\\uDDC4\\uFE0F|\\uD83D\\uDDD1\\uFE0F|\\uD83D\\uDDD2\\uFE0F|\\uD83D\\uDDD3\\uFE0F|\\uD83D\\uDDDC\\uFE0F|\\uD83D\\uDDDD\\uFE0F|\\uD83D\\uDDDE\\uFE0F|\\uD83D\\uDDE1\\uFE0F|\\u270B\\uD83C\\uDFFF|\\uD83D\\uDDE8\\uFE0F|\\uD83D\\uDDEF\\uFE0F|\\uD83D\\uDDF3\\uFE0F|\\uD83D\\uDDFA\\uFE0F|\\uD83D\\uDEE0\\uFE0F|\\uD83D\\uDEE1\\uFE0F|\\uD83D\\uDEE2\\uFE0F|\\uD83D\\uDEF0\\uFE0F|\\uD83C\\uDF7D\\uFE0F|\\uD83D\\uDC41\\uFE0F|\\uD83D\\uDD74\\uFE0F|\\uD83D\\uDD75\\uFE0F|\\uD83D\\uDD90\\uFE0F|\\uD83C\\uDFD4\\uFE0F|\\uD83C\\uDFD5\\uFE0F|\\uD83C\\uDFD6\\uFE0F|\\uD83C\\uDFD7\\uFE0F|\\uD83C\\uDFD8\\uFE0F|\\uD83C\\uDFD9\\uFE0F|\\uD83C\\uDFDA\\uFE0F|\\uD83C\\uDFDB\\uFE0F|\\uD83C\\uDFDC\\uFE0F|\\uD83C\\uDFDD\\uFE0F|\\uD83C\\uDFDE\\uFE0F|\\uD83C\\uDFDF\\uFE0F|\\uD83D\\uDECB\\uFE0F|\\uD83D\\uDECD\\uFE0F|\\uD83D\\uDECE\\uFE0F|\\uD83D\\uDECF\\uFE0F|\\uD83D\\uDEE3\\uFE0F|\\uD83D\\uDEE4\\uFE0F|\\uD83D\\uDEE5\\uFE0F|\\uD83D\\uDEE9\\uFE0F|\\uD83D\\uDEF3\\uFE0F|\\uD83C\\uDF24\\uFE0F|\\uD83C\\uDF25\\uFE0F|\\uD83C\\uDF26\\uFE0F|\\uD83D\\uDDB1\\uFE0F|\\u261D\\uD83C\\uDFFB|\\u261D\\uD83C\\uDFFC|\\u261D\\uD83C\\uDFFD|\\u261D\\uD83C\\uDFFE|\\u261D\\uD83C\\uDFFF|\\u270C\\uD83C\\uDFFB|\\u270C\\uD83C\\uDFFC|\\u270C\\uD83C\\uDFFD|\\u270C\\uD83C\\uDFFE|\\u270C\\uD83C\\uDFFF|\\u270A\\uD83C\\uDFFB|\\u270A\\uD83C\\uDFFC|\\u270A\\uD83C\\uDFFD|\\u270A\\uD83C\\uDFFE|\\u270A\\uD83C\\uDFFF|\\u270B\\uD83C\\uDFFB|\\u270B\\uD83C\\uDFFC|\\u270B\\uD83C\\uDFFD|\\u270B\\uD83C\\uDFFE|\\4\\uFE0F\\u20E3|\\9\\uFE0F\\u20E3|\\0\\uFE0F\\u20E3|\\1\\uFE0F\\u20E3|\\2\\uFE0F\\u20E3|\\3\\uFE0F\\u20E3|\\#\\uFE0F\\u20E3|\\5\\uFE0F\\u20E3|\\6\\uFE0F\\u20E3|\\7\\uFE0F\\u20E3|\\8\\uFE0F\\u20E3|\\*\\uFE0F\\u20E3|\\uD83D\\uDDE1|\\uD83D\\uDD77|\\uD83D\\uDDE3|\\uD83D\\uDEE4|\\uD83D\\uDDE8|\\uD83D\\uDD78|\\uD83D\\uDDEF|\\uD83C\\uDE37|\\uD83D\\uDDF3|\\uD83C\\uDF21|\\uD83D\\uDDFA|\\uD83D\\uDDB1|\\uD83D\\uDEE0|\\uD83C\\uDF99|\\uD83D\\uDEE1|\\uD83C\\uDF9E|\\uD83D\\uDEE2|\\uD83C\\uDF9A|\\uD83D\\uDEF0|\\uD83D\\uDEE3|\\uD83C\\uDF7D|\\uD83C\\uDF9B|\\uD83D\\uDC41|\\uD83C\\uDF9F|\\uD83D\\uDD74|\\uD83C\\uDFF3|\\uD83D\\uDD75|\\uD83D\\uDEF3|\\uD83D\\uDD90|\\uD83C\\uDFF5|\\uD83C\\uDFD4|\\uD83C\\uDFCB|\\uD83C\\uDFD5|\\uD83C\\uDFF7|\\uD83C\\uDFD6|\\uD83D\\uDECF|\\uD83C\\uDFD7|\\uD83D\\uDCFD|\\uD83C\\uDFD8|\\uD83C\\uDFCC|\\uD83C\\uDFD9|\\uD83D\\uDD49|\\uD83C\\uDFDA|\\uD83C\\uDF25|\\uD83C\\uDFDB|\\uD83D\\uDD4A|\\uD83C\\uDFDC|\\uD83C\\uDFCD|\\uD83C\\uDFDD|\\uD83D\\uDD6F|\\uD83C\\uDFDE|\\uD83D\\uDECE|\\uD83C\\uDFDF|\\uD83D\\uDD70|\\uD83D\\uDECB|\\uD83C\\uDFCE|\\uD83D\\uDECD|\\uD83D\\uDD73|\\uD83D\\uDECE|\\uD83D\\uDEE9|\\uD83D\\uDECF|\\uD83D\\uDD76|\\uD83D\\uDEE3|\\uD83C\\uDF96|\\uD83D\\uDEE4|\\uD83D\\uDD79|\\uD83D\\uDEE5|\\uD83D\\uDECD|\\uD83D\\uDEE9|\\uD83D\\uDD87|\\uD83D\\uDEF3|\\uD83C\\uDF97|\\uD83C\\uDF24|\\uD83D\\uDD8A|\\uD83C\\uDF25|\\uD83C\\uDC04|\\uD83C\\uDF26|\\uD83D\\uDD8B|\\uD83D\\uDDB1|\\uD83C\\uDF36|\\uD83D\\uDD8C|\\uD83C\\uDF26|\\uD83D\\uDD8D|\\uD83C\\uDF27|\\uD83D\\uDDA5|\\uD83C\\uDD7F|\\uD83D\\uDDA8|\\uD83C\\uDF28|\\uD83D\\uDDB2|\\uD83D\\uDECB|\\uD83D\\uDDBC|\\uD83C\\uDF29|\\uD83D\\uDDC2|\\uD83C\\uDE02|\\uD83D\\uDDC3|\\uD83C\\uDF2A|\\uD83D\\uDDC4|\\uD83D\\uDEE5|\\uD83D\\uDDD1|\\uD83C\\uDF2B|\\uD83D\\uDDD2|\\uD83C\\uDE1A|\\uD83D\\uDDD3|\\uD83C\\uDF2C|\\uD83D\\uDDDC|\\uD83C\\uDF24|\\uD83D\\uDDDD|\\uD83D\\uDC3F|\\uD83D\\uDDDE|\\u00A9\\uFE0F|\\uD83C\\uDFDF|\\u00AE\\uFE0F|\\uD83C\\uDFDE|\\u203C\\uFE0F|\\uD83C\\uDFDD|\\u2049\\uFE0F|\\uD83C\\uDFDC|\\u2122\\uFE0F|\\uD83C\\uDFDB|\\u2139\\uFE0F|\\uD83C\\uDFDA|\\u2194\\uFE0F|\\uD83C\\uDFD9|\\u2195\\uFE0F|\\uD83C\\uDFD8|\\u2196\\uFE0F|\\uD83C\\uDFD7|\\u2197\\uFE0F|\\uD83C\\uDFD6|\\u2198\\uFE0F|\\uD83C\\uDFD5|\\u2199\\uFE0F|\\uD83C\\uDFD4|\\u21A9\\uFE0F|\\uD83D\\uDD90|\\u21AA\\uFE0F|\\uD83D\\uDD75|\\u231A\\uFE0F|\\uD83D\\uDD74|\\u231B\\uFE0F|\\uD83D\\uDC41|\\u24C2\\uFE0F|\\uD83C\\uDF7D|\\u25AA\\uFE0F|\\uD83D\\uDEF0|\\u25AB\\uFE0F|\\uD83D\\uDEE2|\\u25B6\\uFE0F|\\uD83D\\uDEE1|\\u25C0\\uFE0F|\\uD83D\\uDEE0|\\u25FB\\uFE0F|\\uD83D\\uDDFA|\\u25FC\\uFE0F|\\uD83D\\uDDF3|\\u25FD\\uFE0F|\\uD83D\\uDDEF|\\u25FE\\uFE0F|\\uD83D\\uDDE8|\\u2600\\uFE0F|\\uD83D\\uDDE3|\\u2601\\uFE0F|\\uD83D\\uDDE1|\\u260E\\uFE0F|\\uD83D\\uDDDE|\\u2611\\uFE0F|\\uD83D\\uDDDD|\\u2614\\uFE0F|\\uD83D\\uDDDC|\\u2615\\uFE0F|\\uD83D\\uDDD3|\\u261D\\uFE0F|\\uD83D\\uDDD2|\\u263A\\uFE0F|\\uD83D\\uDDD1|\\u2648\\uFE0F|\\uD83D\\uDDC4|\\u2649\\uFE0F|\\uD83D\\uDDC3|\\u264A\\uFE0F|\\uD83D\\uDDC2|\\u264B\\uFE0F|\\uD83D\\uDDBC|\\u264C\\uFE0F|\\uD83D\\uDDB2|\\u264D\\uFE0F|\\uD83D\\uDDA8|\\u264E\\uFE0F|\\uD83D\\uDDA5|\\u264F\\uFE0F|\\uD83D\\uDD8D|\\u2650\\uFE0F|\\uD83D\\uDD8C|\\u2651\\uFE0F|\\uD83D\\uDD8B|\\u2652\\uFE0F|\\uD83D\\uDD8A|\\u2653\\uFE0F|\\uD83D\\uDD87|\\u2660\\uFE0F|\\uD83D\\uDD79|\\u2663\\uFE0F|\\uD83D\\uDD76|\\u2665\\uFE0F|\\uD83D\\uDD73|\\u2666\\uFE0F|\\uD83D\\uDD70|\\u2668\\uFE0F|\\uD83D\\uDD6F|\\u267B\\uFE0F|\\uD83D\\uDD4A|\\u267F\\uFE0F|\\uD83D\\uDD49|\\u2693\\uFE0F|\\uD83D\\uDCFD|\\u26A0\\uFE0F|\\uD83C\\uDFF7|\\u26A1\\uFE0F|\\uD83C\\uDFF5|\\u26AA\\uFE0F|\\uD83C\\uDFF3|\\u26AB\\uFE0F|\\uD83C\\uDF9B|\\u26BD\\uFE0F|\\uD83C\\uDF9A|\\u26BE\\uFE0F|\\uD83C\\uDF99|\\u26C4\\uFE0F|\\uD83C\\uDF21|\\u26C5\\uFE0F|\\uD83D\\uDD78|\\u26D4\\uFE0F|\\uD83D\\uDD77|\\u26EA\\uFE0F|\\uD83D\\uDC3F|\\uD83C\\uDE2F|\\uD83C\\uDF2C|\\u26F3\\uFE0F|\\uD83C\\uDF2B|\\u26F5\\uFE0F|\\uD83C\\uDF2A|\\u26FA\\uFE0F|\\uD83C\\uDF29|\\u26FD\\uFE0F|\\uD83C\\uDF28|\\u2702\\uFE0F|\\uD83C\\uDF27|\\u2708\\uFE0F|\\uD83C\\uDF36|\\u2709\\uFE0F|\\uD83C\\uDF97|\\u270C\\uFE0F|\\uD83C\\uDF96|\\u270F\\uFE0F|\\uD83C\\uDFCE|\\u2712\\uFE0F|\\uD83C\\uDFCD|\\u2714\\uFE0F|\\uD83C\\uDFCC|\\u2716\\uFE0F|\\uD83C\\uDFCB|\\u2733\\uFE0F|\\uD83C\\uDF9F|\\u2734\\uFE0F|\\uD83C\\uDF9E|\\u2744\\uFE0F|\\uD83C\\uDE37|\\u2747\\uFE0F|\\uD83C\\uDE2F|\\u2757\\uFE0F|\\uD83C\\uDE1A|\\u2764\\uFE0F|\\uD83C\\uDE02|\\u27A1\\uFE0F|\\uD83C\\uDD7F|\\u2934\\uFE0F|\\uD83C\\uDC04|\\u2935\\uFE0F|\\uD83C\\uDDE6|\\u2B05\\uFE0F|\\uD83C\\uDDE7|\\u2B06\\uFE0F|\\uD83C\\uDDE8|\\u2B07\\uFE0F|\\uD83C\\uDDE9|\\u2B1B\\uFE0F|\\uD83C\\uDDEA|\\u2B1C\\uFE0F|\\uD83C\\uDDEB|\\u2B50\\uFE0F|\\uD83C\\uDDEC|\\u2B55\\uFE0F|\\uD83C\\uDDED|\\u3030\\uFE0F|\\uD83C\\uDDEE|\\u303D\\uFE0F|\\uD83C\\uDDEF|\\u3297\\uFE0F|\\uD83C\\uDDF0|\\u3299\\uFE0F|\\uD83C\\uDDF1|\\u271D\\uFE0F|\\uD83C\\uDDF2|\\u2328\\uFE0F|\\uD83C\\uDDF3|\\u270D\\uFE0F|\\uD83C\\uDDF4|\\u23CF\\uFE0F|\\uD83C\\uDDF5|\\u23ED\\uFE0F|\\uD83C\\uDDF6|\\u23EE\\uFE0F|\\uD83C\\uDDF7|\\u23EF\\uFE0F|\\uD83C\\uDDF8|\\u23F1\\uFE0F|\\uD83C\\uDDF9|\\u23F2\\uFE0F|\\uD83C\\uDDFA|\\u23F8\\uFE0F|\\uD83C\\uDDFB|\\u23F9\\uFE0F|\\uD83C\\uDDFC|\\u23FA\\uFE0F|\\uD83E\\uDD5E|\\u2602\\uFE0F|\\uD83E\\uDD5D|\\u2603\\uFE0F|\\uD83E\\uDD5C|\\u2604\\uFE0F|\\uD83E\\uDD5B|\\u2618\\uFE0F|\\uD83E\\uDD5A|\\u2620\\uFE0F|\\uD83E\\uDD91|\\u2622\\uFE0F|\\uD83E\\uDD90|\\u2623\\uFE0F|\\uD83E\\uDD41|\\u2626\\uFE0F|\\uD83C\\uDFF8|\\u262A\\uFE0F|\\uD83C\\uDFD3|\\u262E\\uFE0F|\\uD83C\\uDFD2|\\u262F\\uFE0F|\\uD83C\\uDFD1|\\u2638\\uFE0F|\\uD83C\\uDFD0|\\u2639\\uFE0F|\\uD83C\\uDFCF|\\u2692\\uFE0F|\\uD83D\\uDCFF|\\u2694\\uFE0F|\\uD83D\\uDD4E|\\u2696\\uFE0F|\\uD83D\\uDD4D|\\u2697\\uFE0F|\\uD83D\\uDD4C|\\u2699\\uFE0F|\\uD83D\\uDD4B|\\u269B\\uFE0F|\\uD83D\\uDED0|\\u269C\\uFE0F|\\uD83C\\uDFFA|\\u26B0\\uFE0F|\\uD83C\\uDFF9|\\u26B1\\uFE0F|\\uD83C\\uDF7E|\\u26C8\\uFE0F|\\uD83C\\uDF7F|\\u26CF\\uFE0F|\\uD83C\\uDF2F|\\u26D1\\uFE0F|\\uD83C\\uDF2E|\\u26D3\\uFE0F|\\uD83C\\uDF2D|\\u26E9\\uFE0F|\\uD83E\\uDDC0|\\u26F0\\uFE0F|\\uD83E\\uDD83|\\u26F1\\uFE0F|\\uD83E\\uDD80|\\u26F4\\uFE0F|\\uD83E\\uDD82|\\u26F7\\uFE0F|\\uD83E\\uDD84|\\u26F8\\uFE0F|\\uD83E\\uDD81|\\u26F9\\uFE0F|\\uD83E\\uDD16|\\u2721\\uFE0F|\\uD83E\\uDD15|\\u2763\\uFE0F|\\uD83E\\uDD12|\\uD83E\\uDD49|\\uD83E\\uDD48|\\uD83E\\uDD47|\\uD83E\\uDD3A|\\uD83E\\uDD45|\\uD83E\\uDD3E|\\uD83C\\uDDFF|\\uD83E\\uDD3D|\\uD83E\\uDD4B|\\uD83E\\uDD4A|\\uD83E\\uDD3C|\\uD83E\\uDD39|\\uD83E\\uDD38|\\uD83D\\uDEF6|\\uD83D\\uDEF5|\\uD83D\\uDEF4|\\uD83D\\uDED2|\\uD83C\\uDCCF|\\uD83C\\uDD70|\\uD83C\\uDD71|\\uD83C\\uDD7E|\\uD83D\\uDED1|\\uD83C\\uDD8E|\\uD83C\\uDD91|\\uD83C\\uDDFE|\\uD83C\\uDD92|\\uD83C\\uDD93|\\uD83C\\uDD94|\\uD83C\\uDD95|\\uD83C\\uDD96|\\uD83C\\uDD97|\\uD83C\\uDD98|\\uD83E\\uDD44|\\uD83C\\uDD99|\\uD83C\\uDD9A|\\uD83E\\uDD42|\\uD83E\\uDD43|\\uD83C\\uDE01|\\uD83E\\uDD59|\\uD83C\\uDE32|\\uD83C\\uDE33|\\uD83C\\uDE34|\\uD83C\\uDE35|\\uD83C\\uDE36|\\uD83E\\uDD58|\\uD83C\\uDE38|\\uD83C\\uDE39|\\uD83E\\uDD57|\\uD83C\\uDE3A|\\uD83C\\uDE50|\\uD83C\\uDE51|\\uD83C\\uDF00|\\uD83E\\uDD56|\\uD83C\\uDF01|\\uD83C\\uDF02|\\uD83C\\uDF03|\\uD83C\\uDF04|\\uD83C\\uDF05|\\uD83C\\uDF06|\\uD83E\\uDD55|\\uD83C\\uDF07|\\uD83C\\uDF08|\\uD83E\\uDD54|\\uD83C\\uDF09|\\uD83C\\uDF0A|\\uD83C\\uDF0B|\\uD83C\\uDF0C|\\uD83C\\uDF0F|\\uD83C\\uDF11|\\uD83E\\uDD53|\\uD83C\\uDF13|\\uD83C\\uDF14|\\uD83C\\uDF15|\\uD83C\\uDF19|\\uD83C\\uDF1B|\\uD83C\\uDF1F|\\uD83E\\uDD52|\\uD83C\\uDF20|\\uD83C\\uDF30|\\uD83E\\uDD51|\\uD83C\\uDF31|\\uD83C\\uDF34|\\uD83C\\uDF35|\\uD83C\\uDF37|\\uD83C\\uDF38|\\uD83C\\uDF39|\\uD83C\\uDF3A|\\uD83C\\uDF3B|\\uD83C\\uDF3C|\\uD83C\\uDF3D|\\uD83E\\uDD50|\\uD83C\\uDF3E|\\uD83C\\uDF3F|\\uD83C\\uDF40|\\uD83C\\uDF41|\\uD83C\\uDF42|\\uD83C\\uDF43|\\uD83C\\uDF44|\\uD83C\\uDF45|\\uD83C\\uDF46|\\uD83C\\uDF47|\\uD83C\\uDF48|\\uD83C\\uDF49|\\uD83C\\uDF4A|\\uD83E\\uDD40|\\uD83C\\uDF4C|\\uD83C\\uDF4D|\\uD83C\\uDF4E|\\uD83C\\uDF4F|\\uD83C\\uDF51|\\uD83C\\uDF52|\\uD83C\\uDF53|\\uD83E\\uDD8F|\\uD83C\\uDF54|\\uD83C\\uDF55|\\uD83C\\uDF56|\\uD83E\\uDD8E|\\uD83C\\uDF57|\\uD83C\\uDF58|\\uD83C\\uDF59|\\uD83E\\uDD8D|\\uD83C\\uDF5A|\\uD83C\\uDF5B|\\uD83E\\uDD8C|\\uD83C\\uDF5C|\\uD83C\\uDF5D|\\uD83C\\uDF5E|\\uD83C\\uDF5F|\\uD83E\\uDD8B|\\uD83C\\uDF60|\\uD83C\\uDF61|\\uD83E\\uDD8A|\\uD83C\\uDF62|\\uD83C\\uDF63|\\uD83E\\uDD89|\\uD83C\\uDF64|\\uD83C\\uDF65|\\uD83E\\uDD88|\\uD83C\\uDF66|\\uD83E\\uDD87|\\uD83C\\uDF67|\\uD83C\\uDDFD|\\uD83C\\uDF68|\\uD83E\\uDD86|\\uD83C\\uDF69|\\uD83E\\uDD85|\\uD83C\\uDF6A|\\uD83D\\uDDA4|\\uD83C\\uDF6B|\\uD83C\\uDF6C|\\uD83C\\uDF6D|\\uD83C\\uDF6E|\\uD83C\\uDF6F|\\uD83E\\uDD1E|\\uD83C\\uDF70|\\uD83C\\uDF71|\\uD83C\\uDF72|\\uD83E\\uDD1D|\\uD83C\\uDF73|\\uD83C\\uDF74|\\uD83C\\uDF75|\\uD83C\\uDF76|\\uD83C\\uDF77|\\uD83C\\uDF78|\\uD83C\\uDF79|\\uD83C\\uDF7A|\\uD83C\\uDF7B|\\uD83C\\uDF80|\\uD83C\\uDF81|\\uD83C\\uDF82|\\uD83C\\uDF83|\\uD83E\\uDD1B|\\uD83E\\uDD1C|\\uD83C\\uDF84|\\uD83C\\uDF85|\\uD83C\\uDF86|\\uD83E\\uDD1A|\\uD83C\\uDF87|\\uD83C\\uDF88|\\uD83C\\uDF89|\\uD83C\\uDF8A|\\uD83C\\uDF8B|\\uD83C\\uDF8C|\\uD83E\\uDD19|\\uD83C\\uDF8D|\\uD83D\\uDD7A|\\uD83C\\uDF8E|\\uD83E\\uDD33|\\uD83C\\uDF8F|\\uD83E\\uDD30|\\uD83C\\uDF90|\\uD83E\\uDD26|\\uD83E\\uDD37|\\uD83C\\uDF91|\\uD83C\\uDF92|\\uD83C\\uDF93|\\uD83C\\uDFA0|\\uD83C\\uDFA1|\\uD83C\\uDFA2|\\uD83C\\uDFA3|\\uD83C\\uDFA4|\\uD83C\\uDFA5|\\uD83C\\uDFA6|\\uD83C\\uDFA7|\\uD83E\\uDD36|\\uD83C\\uDFA8|\\uD83E\\uDD35|\\uD83C\\uDFA9|\\uD83C\\uDFAA|\\uD83E\\uDD34|\\uD83C\\uDFAB|\\uD83C\\uDFAC|\\uD83C\\uDFAD|\\uD83E\\uDD27|\\uD83C\\uDFAE|\\uD83C\\uDFAF|\\uD83C\\uDFB0|\\uD83C\\uDFB1|\\uD83C\\uDFB2|\\uD83C\\uDFB3|\\uD83C\\uDFB4|\\uD83E\\uDD25|\\uD83C\\uDFB5|\\uD83C\\uDFB6|\\uD83C\\uDFB7|\\uD83E\\uDD24|\\uD83C\\uDFB8|\\uD83C\\uDFB9|\\uD83C\\uDFBA|\\uD83E\\uDD23|\\uD83C\\uDFBB|\\uD83C\\uDFBC|\\uD83C\\uDFBD|\\uD83E\\uDD22|\\uD83C\\uDFBE|\\uD83C\\uDFBF|\\uD83C\\uDFC0|\\uD83C\\uDFC1|\\uD83E\\uDD21|\\uD83C\\uDFC2|\\uD83C\\uDFC3|\\uD83C\\uDFC4|\\uD83C\\uDFC6|\\uD83C\\uDFC8|\\uD83C\\uDFCA|\\uD83C\\uDFE0|\\uD83C\\uDFE1|\\uD83C\\uDFE2|\\uD83C\\uDFE3|\\uD83C\\uDFE5|\\uD83C\\uDFE6|\\uD83C\\uDFE7|\\uD83C\\uDFE8|\\uD83C\\uDFE9|\\uD83C\\uDFEA|\\uD83C\\uDFEB|\\uD83C\\uDFEC|\\uD83E\\uDD20|\\uD83C\\uDFED|\\uD83C\\uDFEE|\\uD83C\\uDFEF|\\uD83C\\uDFF0|\\uD83D\\uDC0C|\\uD83D\\uDC0D|\\uD83D\\uDC0E|\\uD83D\\uDC11|\\uD83D\\uDC12|\\uD83D\\uDC14|\\uD83D\\uDC17|\\uD83D\\uDC18|\\uD83D\\uDC19|\\uD83D\\uDC1A|\\uD83D\\uDC1B|\\uD83D\\uDC1C|\\uD83D\\uDC1D|\\uD83D\\uDC1E|\\uD83D\\uDC1F|\\uD83D\\uDC20|\\uD83D\\uDC21|\\uD83D\\uDC22|\\uD83D\\uDC23|\\uD83D\\uDC24|\\uD83D\\uDC25|\\uD83D\\uDC26|\\uD83D\\uDC27|\\uD83D\\uDC28|\\uD83D\\uDC29|\\uD83D\\uDC2B|\\uD83D\\uDC2C|\\uD83D\\uDC2D|\\uD83D\\uDC2E|\\uD83D\\uDC2F|\\uD83D\\uDC30|\\uD83D\\uDC31|\\uD83D\\uDC32|\\uD83D\\uDC33|\\uD83D\\uDC34|\\uD83D\\uDC35|\\uD83D\\uDC36|\\uD83D\\uDC37|\\uD83D\\uDC38|\\uD83D\\uDC39|\\uD83D\\uDC3A|\\uD83D\\uDC3B|\\uD83D\\uDC3C|\\uD83D\\uDC3D|\\uD83D\\uDC3E|\\uD83D\\uDC40|\\uD83D\\uDC42|\\uD83D\\uDC43|\\uD83D\\uDC44|\\uD83D\\uDC45|\\uD83D\\uDC46|\\uD83D\\uDC47|\\uD83D\\uDC48|\\uD83D\\uDC49|\\uD83D\\uDC4A|\\uD83D\\uDC4B|\\uD83D\\uDC4C|\\uD83D\\uDC4D|\\uD83D\\uDC4E|\\uD83D\\uDC4F|\\uD83D\\uDC50|\\uD83D\\uDC51|\\uD83D\\uDC52|\\uD83D\\uDC53|\\uD83D\\uDC54|\\uD83D\\uDC55|\\uD83D\\uDC56|\\uD83D\\uDC57|\\uD83D\\uDC58|\\uD83D\\uDC59|\\uD83D\\uDC5A|\\uD83D\\uDC5B|\\uD83D\\uDC5C|\\uD83D\\uDC5D|\\uD83D\\uDC5E|\\uD83D\\uDC5F|\\uD83D\\uDC60|\\uD83D\\uDC61|\\uD83D\\uDC62|\\uD83D\\uDC63|\\uD83D\\uDC64|\\uD83D\\uDC66|\\uD83D\\uDC67|\\uD83D\\uDC68|\\uD83D\\uDC69|\\uD83D\\uDC6A|\\uD83D\\uDC6B|\\uD83D\\uDC6E|\\uD83D\\uDC6F|\\uD83D\\uDC70|\\uD83D\\uDC71|\\uD83D\\uDC72|\\uD83D\\uDC73|\\uD83D\\uDC74|\\uD83D\\uDC75|\\uD83D\\uDC76|\\uD83D\\uDC77|\\uD83D\\uDC78|\\uD83D\\uDC79|\\uD83D\\uDC7A|\\uD83D\\uDC7B|\\uD83D\\uDC7C|\\uD83D\\uDC7D|\\uD83D\\uDC7E|\\uD83D\\uDC7F|\\uD83D\\uDC80|\\uD83D\\uDCC7|\\uD83D\\uDC81|\\uD83D\\uDC82|\\uD83D\\uDC83|\\uD83D\\uDC84|\\uD83D\\uDC85|\\uD83D\\uDCD2|\\uD83D\\uDC86|\\uD83D\\uDCD3|\\uD83D\\uDC87|\\uD83D\\uDCD4|\\uD83D\\uDC88|\\uD83D\\uDCD5|\\uD83D\\uDC89|\\uD83D\\uDCD6|\\uD83D\\uDC8A|\\uD83D\\uDCD7|\\uD83D\\uDC8B|\\uD83D\\uDCD8|\\uD83D\\uDC8C|\\uD83D\\uDCD9|\\uD83D\\uDC8D|\\uD83D\\uDCDA|\\uD83D\\uDC8E|\\uD83D\\uDCDB|\\uD83D\\uDC8F|\\uD83D\\uDCDC|\\uD83D\\uDC90|\\uD83D\\uDCDD|\\uD83D\\uDC91|\\uD83D\\uDCDE|\\uD83D\\uDC92|\\uD83D\\uDCDF|\\uD83D\\uDCE0|\\uD83D\\uDC93|\\uD83D\\uDCE1|\\uD83D\\uDCE2|\\uD83D\\uDC94|\\uD83D\\uDCE3|\\uD83D\\uDCE4|\\uD83D\\uDC95|\\uD83D\\uDCE5|\\uD83D\\uDCE6|\\uD83D\\uDC96|\\uD83D\\uDCE7|\\uD83D\\uDCE8|\\uD83D\\uDC97|\\uD83D\\uDCE9|\\uD83D\\uDCEA|\\uD83D\\uDC98|\\uD83D\\uDCEB|\\uD83D\\uDCEE|\\uD83D\\uDC99|\\uD83D\\uDCF0|\\uD83D\\uDCF1|\\uD83D\\uDC9A|\\uD83D\\uDCF2|\\uD83D\\uDCF3|\\uD83D\\uDC9B|\\uD83D\\uDCF4|\\uD83D\\uDCF6|\\uD83D\\uDC9C|\\uD83D\\uDCF7|\\uD83D\\uDCF9|\\uD83D\\uDC9D|\\uD83D\\uDCFA|\\uD83D\\uDCFB|\\uD83D\\uDC9E|\\uD83D\\uDCFC|\\uD83D\\uDD03|\\uD83D\\uDC9F|\\uD83D\\uDD0A|\\uD83D\\uDD0B|\\uD83D\\uDCA0|\\uD83D\\uDD0C|\\uD83D\\uDD0D|\\uD83D\\uDCA1|\\uD83D\\uDD0E|\\uD83D\\uDD0F|\\uD83D\\uDCA2|\\uD83D\\uDD10|\\uD83D\\uDD11|\\uD83D\\uDCA3|\\uD83D\\uDD12|\\uD83D\\uDD13|\\uD83D\\uDCA4|\\uD83D\\uDD14|\\uD83D\\uDD16|\\uD83D\\uDCA5|\\uD83D\\uDD17|\\uD83D\\uDD18|\\uD83D\\uDCA6|\\uD83D\\uDD19|\\uD83D\\uDD1A|\\uD83D\\uDCA7|\\uD83D\\uDD1B|\\uD83D\\uDD1C|\\uD83D\\uDCA8|\\uD83D\\uDD1D|\\uD83D\\uDD1E|\\uD83D\\uDCA9|\\uD83D\\uDD1F|\\uD83D\\uDCAA|\\uD83D\\uDD20|\\uD83D\\uDD21|\\uD83D\\uDCAB|\\uD83D\\uDD22|\\uD83D\\uDD23|\\uD83D\\uDCAC|\\uD83D\\uDD24|\\uD83D\\uDD25|\\uD83D\\uDCAE|\\uD83D\\uDD26|\\uD83D\\uDD27|\\uD83D\\uDCAF|\\uD83D\\uDD28|\\uD83D\\uDD29|\\uD83D\\uDCB0|\\uD83D\\uDD2A|\\uD83D\\uDD2B|\\uD83D\\uDCB1|\\uD83D\\uDD2E|\\uD83D\\uDCB2|\\uD83D\\uDD2F|\\uD83D\\uDCB3|\\uD83D\\uDD30|\\uD83D\\uDD31|\\uD83D\\uDCB4|\\uD83D\\uDD32|\\uD83D\\uDD33|\\uD83D\\uDCB5|\\uD83D\\uDD34|\\uD83D\\uDD35|\\uD83D\\uDCB8|\\uD83D\\uDD36|\\uD83D\\uDD37|\\uD83D\\uDCB9|\\uD83D\\uDD38|\\uD83D\\uDD39|\\uD83D\\uDCBA|\\uD83D\\uDD3A|\\uD83D\\uDD3B|\\uD83D\\uDCBB|\\uD83D\\uDD3C|\\uD83D\\uDCBC|\\uD83D\\uDD3D|\\uD83D\\uDD50|\\uD83D\\uDCBD|\\uD83D\\uDD51|\\uD83D\\uDCBE|\\uD83D\\uDD52|\\uD83D\\uDCBF|\\uD83D\\uDD53|\\uD83D\\uDCC0|\\uD83D\\uDD54|\\uD83D\\uDD55|\\uD83D\\uDCC1|\\uD83D\\uDD56|\\uD83D\\uDD57|\\uD83D\\uDCC2|\\uD83D\\uDD58|\\uD83D\\uDD59|\\uD83D\\uDCC3|\\uD83D\\uDD5A|\\uD83D\\uDD5B|\\uD83D\\uDCC4|\\uD83D\\uDDFB|\\uD83D\\uDDFC|\\uD83D\\uDCC5|\\uD83D\\uDDFD|\\uD83D\\uDDFE|\\uD83D\\uDCC6|\\uD83D\\uDDFF|\\uD83D\\uDE01|\\uD83D\\uDE02|\\uD83D\\uDE03|\\uD83D\\uDCC8|\\uD83D\\uDE04|\\uD83D\\uDE05|\\uD83D\\uDCC9|\\uD83D\\uDE06|\\uD83D\\uDE09|\\uD83D\\uDCCA|\\uD83D\\uDE0A|\\uD83D\\uDE0B|\\uD83D\\uDCCB|\\uD83D\\uDE0C|\\uD83D\\uDE0D|\\uD83D\\uDCCC|\\uD83D\\uDE0F|\\uD83D\\uDE12|\\uD83D\\uDCCD|\\uD83D\\uDE13|\\uD83D\\uDE14|\\uD83D\\uDCCE|\\uD83D\\uDE16|\\uD83D\\uDE18|\\uD83D\\uDCCF|\\uD83D\\uDE1A|\\uD83D\\uDE1C|\\uD83D\\uDCD0|\\uD83D\\uDE1D|\\uD83D\\uDE1E|\\uD83D\\uDCD1|\\uD83D\\uDE20|\\uD83D\\uDE21|\\uD83D\\uDE22|\\uD83D\\uDE23|\\uD83D\\uDE24|\\uD83D\\uDE25|\\uD83D\\uDE28|\\uD83D\\uDE29|\\uD83D\\uDE2A|\\uD83D\\uDE2B|\\uD83D\\uDE2D|\\uD83D\\uDE30|\\uD83D\\uDE31|\\uD83D\\uDE32|\\uD83D\\uDE33|\\uD83D\\uDE35|\\uD83D\\uDE37|\\uD83D\\uDE38|\\uD83D\\uDE39|\\uD83D\\uDE3A|\\uD83D\\uDE3B|\\uD83D\\uDE3C|\\uD83D\\uDE3D|\\uD83D\\uDE3E|\\uD83D\\uDE3F|\\uD83D\\uDE40|\\uD83D\\uDE45|\\uD83D\\uDE46|\\uD83D\\uDE47|\\uD83D\\uDE48|\\uD83D\\uDE49|\\uD83D\\uDE4A|\\uD83D\\uDE4B|\\uD83D\\uDE4C|\\uD83D\\uDE4D|\\uD83D\\uDE4E|\\uD83D\\uDE4F|\\uD83D\\uDE80|\\uD83D\\uDE83|\\uD83D\\uDE84|\\uD83D\\uDE85|\\uD83D\\uDE87|\\uD83D\\uDE89|\\uD83D\\uDE8C|\\uD83D\\uDE8F|\\uD83D\\uDE91|\\uD83D\\uDE92|\\uD83D\\uDE93|\\uD83D\\uDE95|\\uD83D\\uDE97|\\uD83D\\uDE99|\\uD83D\\uDE9A|\\uD83D\\uDEA2|\\uD83D\\uDEA4|\\uD83D\\uDEA5|\\uD83D\\uDEA7|\\uD83D\\uDEA8|\\uD83D\\uDEA9|\\uD83D\\uDEAA|\\uD83D\\uDEAB|\\uD83D\\uDEAC|\\uD83D\\uDEAD|\\uD83D\\uDEB2|\\uD83D\\uDEB6|\\uD83D\\uDEB9|\\uD83D\\uDEBA|\\uD83D\\uDEBB|\\uD83D\\uDEBC|\\uD83D\\uDEBD|\\uD83D\\uDEBE|\\uD83D\\uDEC0|\\uD83E\\uDD18|\\uD83D\\uDE00|\\uD83D\\uDE07|\\uD83D\\uDE08|\\uD83D\\uDE0E|\\uD83D\\uDE10|\\uD83D\\uDE11|\\uD83D\\uDE15|\\uD83D\\uDE17|\\uD83D\\uDE19|\\uD83D\\uDE1B|\\uD83D\\uDE1F|\\uD83D\\uDE26|\\uD83D\\uDE27|\\uD83D\\uDE2C|\\uD83D\\uDE2E|\\uD83D\\uDE2F|\\uD83D\\uDE34|\\uD83D\\uDE36|\\uD83D\\uDE81|\\uD83D\\uDE82|\\uD83D\\uDE86|\\uD83D\\uDE88|\\uD83D\\uDE8A|\\uD83D\\uDE8D|\\uD83D\\uDE8E|\\uD83D\\uDE90|\\uD83D\\uDE94|\\uD83D\\uDE96|\\uD83D\\uDE98|\\uD83D\\uDE9B|\\uD83D\\uDE9C|\\uD83D\\uDE9D|\\uD83D\\uDE9E|\\uD83D\\uDE9F|\\uD83D\\uDEA0|\\uD83D\\uDEA1|\\uD83D\\uDEA3|\\uD83D\\uDEA6|\\uD83D\\uDEAE|\\uD83D\\uDEAF|\\uD83D\\uDEB0|\\uD83D\\uDEB1|\\uD83D\\uDEB3|\\uD83D\\uDEB4|\\uD83D\\uDEB5|\\uD83D\\uDEB7|\\uD83D\\uDEB8|\\uD83D\\uDEBF|\\uD83D\\uDEC1|\\uD83D\\uDEC2|\\uD83D\\uDEC3|\\uD83D\\uDEC4|\\uD83D\\uDEC5|\\uD83C\\uDF0D|\\uD83C\\uDF0E|\\uD83C\\uDF10|\\uD83C\\uDF12|\\uD83C\\uDF16|\\uD83C\\uDF17|\\uD83C\\uDF18|\\uD83C\\uDF1A|\\uD83C\\uDF1C|\\uD83C\\uDF1D|\\uD83C\\uDF1E|\\uD83C\\uDF32|\\uD83C\\uDF33|\\uD83C\\uDF4B|\\uD83C\\uDF50|\\uD83C\\uDF7C|\\uD83C\\uDFC7|\\uD83C\\uDFC9|\\uD83C\\uDFE4|\\uD83D\\uDC00|\\uD83D\\uDC01|\\uD83D\\uDC02|\\uD83D\\uDC03|\\uD83D\\uDC04|\\uD83D\\uDC05|\\uD83D\\uDC06|\\uD83D\\uDC07|\\uD83D\\uDC08|\\uD83D\\uDC09|\\uD83D\\uDC0A|\\uD83D\\uDC0B|\\uD83D\\uDC0F|\\uD83D\\uDC10|\\uD83D\\uDC13|\\uD83D\\uDC15|\\uD83D\\uDC16|\\uD83D\\uDC2A|\\uD83D\\uDC65|\\uD83D\\uDC6C|\\uD83D\\uDC6D|\\uD83D\\uDCAD|\\uD83D\\uDCB6|\\uD83D\\uDCB7|\\uD83D\\uDCEC|\\uD83D\\uDCED|\\uD83D\\uDCEF|\\uD83D\\uDCF5|\\uD83D\\uDD00|\\uD83D\\uDD01|\\uD83D\\uDD02|\\uD83D\\uDD04|\\uD83D\\uDD05|\\uD83D\\uDD06|\\uD83D\\uDD07|\\uD83D\\uDD09|\\uD83D\\uDD15|\\uD83D\\uDD2C|\\uD83D\\uDD2D|\\uD83D\\uDD5C|\\uD83D\\uDD5D|\\uD83D\\uDD5E|\\uD83D\\uDD5F|\\uD83D\\uDD60|\\uD83D\\uDD61|\\uD83D\\uDD62|\\uD83D\\uDD63|\\uD83D\\uDD64|\\uD83D\\uDD65|\\uD83D\\uDD66|\\uD83D\\uDD67|\\uD83D\\uDD08|\\uD83D\\uDE8B|\\uD83C\\uDFC5|\\uD83C\\uDFF4|\\uD83D\\uDCF8|\\uD83D\\uDECC|\\uD83D\\uDD95|\\uD83D\\uDD96|\\uD83D\\uDE41|\\uD83D\\uDE42|\\uD83D\\uDEEB|\\uD83D\\uDEEC|\\uD83C\\uDFFB|\\uD83C\\uDFFC|\\uD83C\\uDFFD|\\uD83C\\uDFFE|\\uD83C\\uDFFF|\\uD83D\\uDE43|\\uD83E\\uDD11|\\uD83E\\uDD13|\\uD83E\\uDD17|\\uD83D\\uDE44|\\uD83E\\uDD14|\\uD83E\\uDD10|\\u26F2\\uFE0F|\\#\\u20E3|\\9\\u20E3|\\8\\u20E3|\\7\\u20E3|\\6\\u20E3|\\*\\u20E3|\\4\\u20E3|\\3\\u20E3|\\2\\u20E3|\\1\\u20E3|\\0\\u20E3|\\5\\u20E3|\\u26B1|\\u26B0|\\u269C|\\u269B|\\u2699|\\u2697|\\u2696|\\u2694|\\u2692|\\u2639|\\u2638|\\u262F|\\u262E|\\u262A|\\u2626|\\u2623|\\u2622|\\u2620|\\u2618|\\u2604|\\u2603|\\u2602|\\u23FA|\\u23F9|\\u23F8|\\u23F2|\\u23F1|\\u23EF|\\u23EE|\\u23ED|\\u23CF|\\u270D|\\u2328|\\u271D|\\u3299|\\u3297|\\u303D|\\u3030|\\u2B55|\\u2B50|\\u2B1C|\\u2B1B|\\u2B07|\\u2B06|\\u2B05|\\u2935|\\u23E9|\\u23EA|\\u23EB|\\u23EC|\\u23F0|\\u23F3|\\u26CE|\\u2705|\\u270A|\\u270B|\\u2728|\\u274C|\\u274E|\\u2753|\\u2754|\\u2755|\\u2795|\\u2796|\\u2797|\\u27B0|\\u27BF|\\u00A9|\\u00AE|\\u203C|\\u2049|\\u2122|\\u2139|\\u2194|\\u2195|\\u2196|\\u2197|\\u2198|\\u2199|\\u21A9|\\u21AA|\\u231A|\\u231B|\\u24C2|\\u25AA|\\u25AB|\\u25B6|\\u25C0|\\u25FB|\\u25FC|\\u25FD|\\u25FE|\\u2600|\\u2601|\\u260E|\\u2611|\\u2614|\\u2615|\\u261D|\\u263A|\\u2648|\\u2649|\\u264A|\\u264B|\\u264C|\\u264D|\\u264E|\\u264F|\\u2650|\\u2651|\\u2652|\\u2653|\\u2660|\\u2663|\\u2665|\\u2666|\\u2668|\\u267B|\\u267F|\\u2693|\\u26A0|\\u26A1|\\u26AA|\\u26AB|\\u26BD|\\u26BE|\\u26C4|\\u26C5|\\u26D4|\\u26EA|\\u26F2|\\u26F3|\\u26F5|\\u26FA|\\u26FD|\\u2702|\\u2708|\\u2709|\\u270C|\\u270F|\\u2712|\\u2714|\\u2716|\\u2733|\\u2734|\\u2744|\\u2747|\\u2721|\\u2764|\\u27A1|\\u2934|\\u2935|\\u2B05|\\u2B06|\\u2B07|\\u2B1B|\\u2B1C|\\u2B50|\\u2B55|\\u3030|\\u303D|\\u3297|\\u3299|\\u2934|\\u27A1|\\u2764|\\u2757|\\u2747|\\u2744|\\u2734|\\u2733|\\u2716|\\u2714|\\u2712|\\u270F|\\u270C|\\u2709|\\u2708|\\u2702|\\u26FD|\\u26FA|\\u26F5|\\u26F3|\\u26F2|\\u26EA|\\u26D4|\\u26C5|\\u26C4|\\u26BE|\\u26BD|\\u26AB|\\u26AA|\\u26A1|\\u26A0|\\u2693|\\u271D|\\u267F|\\u267B|\\u2668|\\u2666|\\u2665|\\u2663|\\u2660|\\u2653|\\u2652|\\u2651|\\u2650|\\u264F|\\u264E|\\u264D|\\u2328|\\u264C|\\u264B|\\u264A|\\u2649|\\u2648|\\u263A|\\u261D|\\u2615|\\u2614|\\u2611|\\u260E|\\u2601|\\u2600|\\u25FE|\\u25FD|\\u25FC|\\u25FB|\\u25C0|\\u25B6|\\u25AB|\\u25AA|\\u24C2|\\u231B|\\u231A|\\u21AA|\\u270D|\\u21A9|\\u2199|\\u2198|\\u2197|\\u2196|\\u2195|\\u2194|\\u2139|\\u2122|\\u2049|\\u203C|\\u00AE|\\u00A9|\\u2763|\\u26F9|\\u26F8|\\u26F7|\\u26F4|\\u26F1|\\u26F0|\\u26E9|\\u26D3|\\u23CF|\\u23ED|\\u23EE|\\u23EF|\\u23F1|\\u23F2|\\u23F8|\\u23F9|\\u23FA|\\u2602|\\u2603|\\u2604|\\u2618|\\u2620|\\u2622|\\u2623|\\u2626|\\u262A|\\u262E|\\u262F|\\u2638|\\u2639|\\u2692|\\u2694|\\u2696|\\u2697|\\u2699|\\u269B|\\u269C|\\u26B0|\\u26B1|\\u26C8|\\u26CF|\\u26D1|\\u26D3|\\u26E9|\\u26F0|\\u26F1|\\u26F4|\\u26F7|\\u26F8|\\u26F9|\\u2721|\\u2763|\\u26D1|\\u26CF|\\u26C8|\\u2757)'),
        (a.jsEscapeMap = {
            '👩‍❤️‍💋‍👩': '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
            '👩❤💋👩': '1f469-2764-1f48b-1f469',
            '👨‍❤️‍💋‍👨': '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
            '👨❤💋👨': '1f468-2764-1f48b-1f468',
            '👨‍👨‍👦‍👦': '1f468-200d-1f468-200d-1f466-200d-1f466',
            '👨👨👦👦': '1f468-1f468-1f466-1f466',
            '👨‍👨‍👧‍👦': '1f468-200d-1f468-200d-1f467-200d-1f466',
            '👨👨👧👦': '1f468-1f468-1f467-1f466',
            '👨‍👨‍👧‍👧': '1f468-200d-1f468-200d-1f467-200d-1f467',
            '👨👨👧👧': '1f468-1f468-1f467-1f467',
            '👨‍👩‍👦‍👦': '1f468-200d-1f469-200d-1f466-200d-1f466',
            '👨👩👦👦': '1f468-1f469-1f466-1f466',
            '👨‍👩‍👧‍👦': '1f468-200d-1f469-200d-1f467-200d-1f466',
            '👨👩👧👦': '1f468-1f469-1f467-1f466',
            '👨‍👩‍👧‍👧': '1f468-200d-1f469-200d-1f467-200d-1f467',
            '👨👩👧👧': '1f468-1f469-1f467-1f467',
            '👩‍👩‍👦‍👦': '1f469-200d-1f469-200d-1f466-200d-1f466',
            '👩👩👦👦': '1f469-1f469-1f466-1f466',
            '👩‍👩‍👧‍👦': '1f469-200d-1f469-200d-1f467-200d-1f466',
            '👩👩👧👦': '1f469-1f469-1f467-1f466',
            '👩‍👩‍👧‍👧': '1f469-200d-1f469-200d-1f467-200d-1f467',
            '👩👩👧👧': '1f469-1f469-1f467-1f467',
            '👩‍❤️‍👩': '1f469-200d-2764-fe0f-200d-1f469',
            '👩❤👩': '1f469-2764-1f469',
            '👨‍❤️‍👨': '1f468-200d-2764-fe0f-200d-1f468',
            '👨❤👨': '1f468-2764-1f468',
            '👨‍👨‍👦': '1f468-200d-1f468-200d-1f466',
            '👨👨👦': '1f468-1f468-1f466',
            '👨‍👨‍👧': '1f468-200d-1f468-200d-1f467',
            '👨👨👧': '1f468-1f468-1f467',
            '👨‍👩‍👧': '1f468-200d-1f469-200d-1f467',
            '👨👩👧': '1f468-1f469-1f467',
            '👩‍👩‍👦': '1f469-200d-1f469-200d-1f466',
            '👩👩👦': '1f469-1f469-1f466',
            '👩‍👩‍👧': '1f469-200d-1f469-200d-1f467',
            '👩👩👧': '1f469-1f469-1f467',
            '🏳️‍🌈': '1f3f3-fe0f-200d-1f308',
            '🏳🌈': '1f3f3-1f308',
            '👁‍🗨': '1f441-200d-1f5e8',
            '👁🗨': '1f441-1f5e8',
            '#️⃣': '0023-fe0f-20e3',
            '#⃣': '0023-20e3',
            '0️⃣': '0030-fe0f-20e3',
            '0⃣': '0030-20e3',
            '1️⃣': '0031-fe0f-20e3',
            '1⃣': '0031-20e3',
            '2️⃣': '0032-fe0f-20e3',
            '2⃣': '0032-20e3',
            '3️⃣': '0033-fe0f-20e3',
            '3⃣': '0033-20e3',
            '4️⃣': '0034-fe0f-20e3',
            '4⃣': '0034-20e3',
            '5️⃣': '0035-fe0f-20e3',
            '5⃣': '0035-20e3',
            '6️⃣': '0036-fe0f-20e3',
            '6⃣': '0036-20e3',
            '7️⃣': '0037-fe0f-20e3',
            '7⃣': '0037-20e3',
            '8️⃣': '0038-fe0f-20e3',
            '8⃣': '0038-20e3',
            '9️⃣': '0039-fe0f-20e3',
            '9⃣': '0039-20e3',
            '*️⃣': '002a-fe0f-20e3',
            '*⃣': '002a-20e3',
            '🤾🏿': '1f93e-1f3ff',
            '🤾🏾': '1f93e-1f3fe',
            '🤾🏽': '1f93e-1f3fd',
            '🤾🏼': '1f93e-1f3fc',
            '🤾🏻': '1f93e-1f3fb',
            '🤽🏿': '1f93d-1f3ff',
            '🤽🏾': '1f93d-1f3fe',
            '🤽🏽': '1f93d-1f3fd',
            '🤽🏼': '1f93d-1f3fc',
            '🤽🏻': '1f93d-1f3fb',
            '🤼🏿': '1f93c-1f3ff',
            '🤼🏾': '1f93c-1f3fe',
            '🤼🏽': '1f93c-1f3fd',
            '🤼🏼': '1f93c-1f3fc',
            '🤼🏻': '1f93c-1f3fb',
            '🤹🏿': '1f939-1f3ff',
            '🤹🏾': '1f939-1f3fe',
            '🤹🏽': '1f939-1f3fd',
            '🤹🏼': '1f939-1f3fc',
            '🤹🏻': '1f939-1f3fb',
            '🤸🏿': '1f938-1f3ff',
            '🤸🏾': '1f938-1f3fe',
            '🤸🏽': '1f938-1f3fd',
            '🤸🏼': '1f938-1f3fc',
            '🤸🏻': '1f938-1f3fb',
            '🤷🏿': '1f937-1f3ff',
            '🤷🏾': '1f937-1f3fe',
            '🤷🏽': '1f937-1f3fd',
            '🤷🏼': '1f937-1f3fc',
            '🤷🏻': '1f937-1f3fb',
            '🤶🏿': '1f936-1f3ff',
            '🤶🏾': '1f936-1f3fe',
            '🤶🏽': '1f936-1f3fd',
            '🤶🏼': '1f936-1f3fc',
            '🤶🏻': '1f936-1f3fb',
            '🤵🏿': '1f935-1f3ff',
            '🤵🏾': '1f935-1f3fe',
            '🤵🏽': '1f935-1f3fd',
            '🤵🏼': '1f935-1f3fc',
            '🤵🏻': '1f935-1f3fb',
            '🤴🏿': '1f934-1f3ff',
            '🤴🏾': '1f934-1f3fe',
            '🤴🏽': '1f934-1f3fd',
            '🤴🏼': '1f934-1f3fc',
            '🤴🏻': '1f934-1f3fb',
            '🤳🏿': '1f933-1f3ff',
            '🤳🏾': '1f933-1f3fe',
            '🤳🏽': '1f933-1f3fd',
            '🤳🏼': '1f933-1f3fc',
            '🤳🏻': '1f933-1f3fb',
            '🤰🏿': '1f930-1f3ff',
            '🤰🏾': '1f930-1f3fe',
            '🤰🏽': '1f930-1f3fd',
            '🤰🏼': '1f930-1f3fc',
            '🤰🏻': '1f930-1f3fb',
            '🤦🏿': '1f926-1f3ff',
            '🤦🏾': '1f926-1f3fe',
            '🤦🏽': '1f926-1f3fd',
            '🤦🏼': '1f926-1f3fc',
            '🤦🏻': '1f926-1f3fb',
            '🤞🏿': '1f91e-1f3ff',
            '🤞🏾': '1f91e-1f3fe',
            '🤞🏽': '1f91e-1f3fd',
            '🤞🏼': '1f91e-1f3fc',
            '🤞🏻': '1f91e-1f3fb',
            '🤝🏿': '1f91d-1f3ff',
            '🤝🏾': '1f91d-1f3fe',
            '🤝🏽': '1f91d-1f3fd',
            '🤝🏼': '1f91d-1f3fc',
            '🤝🏻': '1f91d-1f3fb',
            '🤜🏿': '1f91c-1f3ff',
            '🤜🏾': '1f91c-1f3fe',
            '🤜🏽': '1f91c-1f3fd',
            '🤜🏼': '1f91c-1f3fc',
            '🤜🏻': '1f91c-1f3fb',
            '🤛🏿': '1f91b-1f3ff',
            '🤛🏾': '1f91b-1f3fe',
            '🤛🏽': '1f91b-1f3fd',
            '🤛🏼': '1f91b-1f3fc',
            '🤛🏻': '1f91b-1f3fb',
            '🤚🏿': '1f91a-1f3ff',
            '🤚🏾': '1f91a-1f3fe',
            '🤚🏽': '1f91a-1f3fd',
            '🤚🏼': '1f91a-1f3fc',
            '🤚🏻': '1f91a-1f3fb',
            '🤙🏿': '1f919-1f3ff',
            '🤙🏾': '1f919-1f3fe',
            '🤙🏽': '1f919-1f3fd',
            '🤙🏼': '1f919-1f3fc',
            '🤙🏻': '1f919-1f3fb',
            '🤘🏿': '1f918-1f3ff',
            '🤘🏾': '1f918-1f3fe',
            '🤘🏽': '1f918-1f3fd',
            '🤘🏼': '1f918-1f3fc',
            '🤘🏻': '1f918-1f3fb',
            '🛀🏿': '1f6c0-1f3ff',
            '🛀🏾': '1f6c0-1f3fe',
            '🛀🏽': '1f6c0-1f3fd',
            '🛀🏼': '1f6c0-1f3fc',
            '🛀🏻': '1f6c0-1f3fb',
            '🚶🏿': '1f6b6-1f3ff',
            '🚶🏾': '1f6b6-1f3fe',
            '🚶🏽': '1f6b6-1f3fd',
            '🚶🏼': '1f6b6-1f3fc',
            '🚶🏻': '1f6b6-1f3fb',
            '🚵🏿': '1f6b5-1f3ff',
            '🚵🏾': '1f6b5-1f3fe',
            '🚵🏽': '1f6b5-1f3fd',
            '🚵🏼': '1f6b5-1f3fc',
            '🚵🏻': '1f6b5-1f3fb',
            '🚴🏿': '1f6b4-1f3ff',
            '🚴🏾': '1f6b4-1f3fe',
            '🚴🏽': '1f6b4-1f3fd',
            '🚴🏼': '1f6b4-1f3fc',
            '🚴🏻': '1f6b4-1f3fb',
            '🚣🏿': '1f6a3-1f3ff',
            '🚣🏾': '1f6a3-1f3fe',
            '🚣🏽': '1f6a3-1f3fd',
            '🚣🏼': '1f6a3-1f3fc',
            '🚣🏻': '1f6a3-1f3fb',
            '🙏🏿': '1f64f-1f3ff',
            '🙏🏾': '1f64f-1f3fe',
            '🙏🏽': '1f64f-1f3fd',
            '🙏🏼': '1f64f-1f3fc',
            '🙏🏻': '1f64f-1f3fb',
            '🙎🏿': '1f64e-1f3ff',
            '🙎🏾': '1f64e-1f3fe',
            '🙎🏽': '1f64e-1f3fd',
            '🙎🏼': '1f64e-1f3fc',
            '🙎🏻': '1f64e-1f3fb',
            '🙍🏿': '1f64d-1f3ff',
            '🙍🏾': '1f64d-1f3fe',
            '🙍🏽': '1f64d-1f3fd',
            '🙍🏼': '1f64d-1f3fc',
            '🙍🏻': '1f64d-1f3fb',
            '🙌🏿': '1f64c-1f3ff',
            '🙌🏾': '1f64c-1f3fe',
            '🙌🏽': '1f64c-1f3fd',
            '🙌🏼': '1f64c-1f3fc',
            '🙌🏻': '1f64c-1f3fb',
            '🙋🏿': '1f64b-1f3ff',
            '🙋🏾': '1f64b-1f3fe',
            '🙋🏽': '1f64b-1f3fd',
            '🙋🏼': '1f64b-1f3fc',
            '🙋🏻': '1f64b-1f3fb',
            '🙇🏿': '1f647-1f3ff',
            '🙇🏾': '1f647-1f3fe',
            '🙇🏽': '1f647-1f3fd',
            '🙇🏼': '1f647-1f3fc',
            '🙇🏻': '1f647-1f3fb',
            '🙆🏿': '1f646-1f3ff',
            '🙆🏾': '1f646-1f3fe',
            '🙆🏽': '1f646-1f3fd',
            '🙆🏼': '1f646-1f3fc',
            '🙆🏻': '1f646-1f3fb',
            '🙅🏿': '1f645-1f3ff',
            '🙅🏾': '1f645-1f3fe',
            '🙅🏽': '1f645-1f3fd',
            '🙅🏼': '1f645-1f3fc',
            '🙅🏻': '1f645-1f3fb',
            '🖖🏿': '1f596-1f3ff',
            '🖖🏾': '1f596-1f3fe',
            '🖖🏽': '1f596-1f3fd',
            '🖖🏼': '1f596-1f3fc',
            '🖖🏻': '1f596-1f3fb',
            '🖕🏿': '1f595-1f3ff',
            '🖕🏾': '1f595-1f3fe',
            '🖕🏽': '1f595-1f3fd',
            '🖕🏼': '1f595-1f3fc',
            '🖕🏻': '1f595-1f3fb',
            '🖐🏿': '1f590-1f3ff',
            '🖐🏾': '1f590-1f3fe',
            '🖐🏽': '1f590-1f3fd',
            '🖐🏼': '1f590-1f3fc',
            '🖐🏻': '1f590-1f3fb',
            '🕺🏿': '1f57a-1f3ff',
            '🕺🏾': '1f57a-1f3fe',
            '🕺🏽': '1f57a-1f3fd',
            '🕺🏼': '1f57a-1f3fc',
            '🕺🏻': '1f57a-1f3fb',
            '🕵🏿': '1f575-1f3ff',
            '🕵🏾': '1f575-1f3fe',
            '🕵🏽': '1f575-1f3fd',
            '🕵🏼': '1f575-1f3fc',
            '🕵🏻': '1f575-1f3fb',
            '💪🏿': '1f4aa-1f3ff',
            '💪🏾': '1f4aa-1f3fe',
            '💪🏽': '1f4aa-1f3fd',
            '💪🏼': '1f4aa-1f3fc',
            '💪🏻': '1f4aa-1f3fb',
            '💇🏿': '1f487-1f3ff',
            '💇🏾': '1f487-1f3fe',
            '💇🏽': '1f487-1f3fd',
            '💇🏼': '1f487-1f3fc',
            '💇🏻': '1f487-1f3fb',
            '💆🏿': '1f486-1f3ff',
            '💆🏾': '1f486-1f3fe',
            '💆🏽': '1f486-1f3fd',
            '💆🏼': '1f486-1f3fc',
            '💆🏻': '1f486-1f3fb',
            '💅🏿': '1f485-1f3ff',
            '💅🏾': '1f485-1f3fe',
            '💅🏽': '1f485-1f3fd',
            '💅🏼': '1f485-1f3fc',
            '💅🏻': '1f485-1f3fb',
            '💃🏿': '1f483-1f3ff',
            '💃🏾': '1f483-1f3fe',
            '💃🏽': '1f483-1f3fd',
            '💃🏼': '1f483-1f3fc',
            '💃🏻': '1f483-1f3fb',
            '💂🏿': '1f482-1f3ff',
            '💂🏾': '1f482-1f3fe',
            '💂🏽': '1f482-1f3fd',
            '💂🏼': '1f482-1f3fc',
            '💂🏻': '1f482-1f3fb',
            '💁🏿': '1f481-1f3ff',
            '💁🏾': '1f481-1f3fe',
            '💁🏽': '1f481-1f3fd',
            '💁🏼': '1f481-1f3fc',
            '💁🏻': '1f481-1f3fb',
            '👼🏿': '1f47c-1f3ff',
            '👼🏾': '1f47c-1f3fe',
            '👼🏽': '1f47c-1f3fd',
            '👼🏼': '1f47c-1f3fc',
            '👼🏻': '1f47c-1f3fb',
            '👸🏿': '1f478-1f3ff',
            '👸🏾': '1f478-1f3fe',
            '👸🏽': '1f478-1f3fd',
            '👸🏼': '1f478-1f3fc',
            '👸🏻': '1f478-1f3fb',
            '👷🏿': '1f477-1f3ff',
            '👷🏾': '1f477-1f3fe',
            '👷🏽': '1f477-1f3fd',
            '👷🏼': '1f477-1f3fc',
            '👷🏻': '1f477-1f3fb',
            '👶🏿': '1f476-1f3ff',
            '👶🏾': '1f476-1f3fe',
            '👶🏽': '1f476-1f3fd',
            '👶🏼': '1f476-1f3fc',
            '👶🏻': '1f476-1f3fb',
            '👵🏿': '1f475-1f3ff',
            '👵🏾': '1f475-1f3fe',
            '👵🏽': '1f475-1f3fd',
            '👵🏼': '1f475-1f3fc',
            '👵🏻': '1f475-1f3fb',
            '👴🏿': '1f474-1f3ff',
            '👴🏾': '1f474-1f3fe',
            '👴🏽': '1f474-1f3fd',
            '👴🏼': '1f474-1f3fc',
            '👴🏻': '1f474-1f3fb',
            '👳🏿': '1f473-1f3ff',
            '👳🏾': '1f473-1f3fe',
            '👳🏽': '1f473-1f3fd',
            '👳🏼': '1f473-1f3fc',
            '👳🏻': '1f473-1f3fb',
            '👲🏿': '1f472-1f3ff',
            '👲🏾': '1f472-1f3fe',
            '👲🏽': '1f472-1f3fd',
            '👲🏼': '1f472-1f3fc',
            '👲🏻': '1f472-1f3fb',
            '👱🏿': '1f471-1f3ff',
            '👱🏾': '1f471-1f3fe',
            '👱🏽': '1f471-1f3fd',
            '👱🏼': '1f471-1f3fc',
            '👱🏻': '1f471-1f3fb',
            '👰🏿': '1f470-1f3ff',
            '👰🏾': '1f470-1f3fe',
            '👰🏽': '1f470-1f3fd',
            '👰🏼': '1f470-1f3fc',
            '👰🏻': '1f470-1f3fb',
            '👮🏿': '1f46e-1f3ff',
            '👮🏾': '1f46e-1f3fe',
            '👮🏽': '1f46e-1f3fd',
            '👮🏼': '1f46e-1f3fc',
            '👮🏻': '1f46e-1f3fb',
            '👩🏿': '1f469-1f3ff',
            '👩🏾': '1f469-1f3fe',
            '👩🏽': '1f469-1f3fd',
            '👩🏼': '1f469-1f3fc',
            '👩🏻': '1f469-1f3fb',
            '👨🏿': '1f468-1f3ff',
            '👨🏾': '1f468-1f3fe',
            '👨🏽': '1f468-1f3fd',
            '👨🏼': '1f468-1f3fc',
            '👨🏻': '1f468-1f3fb',
            '👧🏿': '1f467-1f3ff',
            '👧🏾': '1f467-1f3fe',
            '👧🏽': '1f467-1f3fd',
            '👧🏼': '1f467-1f3fc',
            '👧🏻': '1f467-1f3fb',
            '👦🏿': '1f466-1f3ff',
            '👦🏾': '1f466-1f3fe',
            '👦🏽': '1f466-1f3fd',
            '👦🏼': '1f466-1f3fc',
            '👦🏻': '1f466-1f3fb',
            '👐🏿': '1f450-1f3ff',
            '👐🏾': '1f450-1f3fe',
            '👐🏽': '1f450-1f3fd',
            '👐🏼': '1f450-1f3fc',
            '👐🏻': '1f450-1f3fb',
            '👏🏿': '1f44f-1f3ff',
            '👏🏾': '1f44f-1f3fe',
            '👏🏽': '1f44f-1f3fd',
            '👏🏼': '1f44f-1f3fc',
            '👏🏻': '1f44f-1f3fb',
            '👎🏿': '1f44e-1f3ff',
            '👎🏾': '1f44e-1f3fe',
            '👎🏽': '1f44e-1f3fd',
            '👎🏼': '1f44e-1f3fc',
            '👎🏻': '1f44e-1f3fb',
            '👍🏿': '1f44d-1f3ff',
            '👍🏾': '1f44d-1f3fe',
            '👍🏽': '1f44d-1f3fd',
            '👍🏼': '1f44d-1f3fc',
            '👍🏻': '1f44d-1f3fb',
            '👌🏿': '1f44c-1f3ff',
            '👌🏾': '1f44c-1f3fe',
            '👌🏽': '1f44c-1f3fd',
            '👌🏼': '1f44c-1f3fc',
            '👌🏻': '1f44c-1f3fb',
            '👋🏿': '1f44b-1f3ff',
            '👋🏾': '1f44b-1f3fe',
            '👋🏽': '1f44b-1f3fd',
            '👋🏼': '1f44b-1f3fc',
            '👋🏻': '1f44b-1f3fb',
            '👊🏿': '1f44a-1f3ff',
            '👊🏾': '1f44a-1f3fe',
            '👊🏽': '1f44a-1f3fd',
            '👊🏼': '1f44a-1f3fc',
            '👊🏻': '1f44a-1f3fb',
            '👉🏿': '1f449-1f3ff',
            '👉🏾': '1f449-1f3fe',
            '👉🏽': '1f449-1f3fd',
            '👉🏼': '1f449-1f3fc',
            '👉🏻': '1f449-1f3fb',
            '👈🏿': '1f448-1f3ff',
            '👈🏾': '1f448-1f3fe',
            '👈🏽': '1f448-1f3fd',
            '👈🏼': '1f448-1f3fc',
            '👈🏻': '1f448-1f3fb',
            '👇🏿': '1f447-1f3ff',
            '👇🏾': '1f447-1f3fe',
            '👇🏽': '1f447-1f3fd',
            '👇🏼': '1f447-1f3fc',
            '👇🏻': '1f447-1f3fb',
            '👆🏿': '1f446-1f3ff',
            '👆🏾': '1f446-1f3fe',
            '👆🏽': '1f446-1f3fd',
            '👆🏼': '1f446-1f3fc',
            '👆🏻': '1f446-1f3fb',
            '👃🏿': '1f443-1f3ff',
            '👃🏾': '1f443-1f3fe',
            '👃🏽': '1f443-1f3fd',
            '👃🏼': '1f443-1f3fc',
            '👃🏻': '1f443-1f3fb',
            '👂🏿': '1f442-1f3ff',
            '👂🏾': '1f442-1f3fe',
            '👂🏽': '1f442-1f3fd',
            '👂🏼': '1f442-1f3fc',
            '👂🏻': '1f442-1f3fb',
            '🏋🏿': '1f3cb-1f3ff',
            '🏋🏾': '1f3cb-1f3fe',
            '🏋🏽': '1f3cb-1f3fd',
            '🏋🏼': '1f3cb-1f3fc',
            '🏋🏻': '1f3cb-1f3fb',
            '🏊🏿': '1f3ca-1f3ff',
            '🏊🏾': '1f3ca-1f3fe',
            '🏊🏽': '1f3ca-1f3fd',
            '🏊🏼': '1f3ca-1f3fc',
            '🏊🏻': '1f3ca-1f3fb',
            '🏇🏿': '1f3c7-1f3ff',
            '🏇🏾': '1f3c7-1f3fe',
            '🏇🏽': '1f3c7-1f3fd',
            '🏇🏼': '1f3c7-1f3fc',
            '🏇🏻': '1f3c7-1f3fb',
            '🏄🏿': '1f3c4-1f3ff',
            '🏄🏾': '1f3c4-1f3fe',
            '🏄🏽': '1f3c4-1f3fd',
            '🏄🏼': '1f3c4-1f3fc',
            '🏄🏻': '1f3c4-1f3fb',
            '🏃🏿': '1f3c3-1f3ff',
            '🏃🏾': '1f3c3-1f3fe',
            '🏃🏽': '1f3c3-1f3fd',
            '🏃🏼': '1f3c3-1f3fc',
            '🏃🏻': '1f3c3-1f3fb',
            '🎅🏿': '1f385-1f3ff',
            '🎅🏾': '1f385-1f3fe',
            '🎅🏽': '1f385-1f3fd',
            '🎅🏼': '1f385-1f3fc',
            '🎅🏻': '1f385-1f3fb',
            '🇿🇼': '1f1ff-1f1fc',
            '🇿🇲': '1f1ff-1f1f2',
            '🇿🇦': '1f1ff-1f1e6',
            '🇾🇹': '1f1fe-1f1f9',
            '🇾🇪': '1f1fe-1f1ea',
            '🇽🇰': '1f1fd-1f1f0',
            '🇼🇸': '1f1fc-1f1f8',
            '🇼🇫': '1f1fc-1f1eb',
            '🇻🇺': '1f1fb-1f1fa',
            '🇻🇳': '1f1fb-1f1f3',
            '🇻🇮': '1f1fb-1f1ee',
            '🇻🇬': '1f1fb-1f1ec',
            '🇻🇪': '1f1fb-1f1ea',
            '🇻🇨': '1f1fb-1f1e8',
            '🇻🇦': '1f1fb-1f1e6',
            '🇺🇿': '1f1fa-1f1ff',
            '🇺🇾': '1f1fa-1f1fe',
            '🇺🇸': '1f1fa-1f1f8',
            '🇺🇲': '1f1fa-1f1f2',
            '🇺🇬': '1f1fa-1f1ec',
            '🇺🇦': '1f1fa-1f1e6',
            '🇹🇿': '1f1f9-1f1ff',
            '🇹🇼': '1f1f9-1f1fc',
            '🇹🇻': '1f1f9-1f1fb',
            '🇹🇹': '1f1f9-1f1f9',
            '🇹🇷': '1f1f9-1f1f7',
            '🇹🇴': '1f1f9-1f1f4',
            '🇹🇳': '1f1f9-1f1f3',
            '🇹🇲': '1f1f9-1f1f2',
            '🇹🇱': '1f1f9-1f1f1',
            '🇹🇰': '1f1f9-1f1f0',
            '🇹🇯': '1f1f9-1f1ef',
            '🇹🇭': '1f1f9-1f1ed',
            '🇹🇬': '1f1f9-1f1ec',
            '🇹🇫': '1f1f9-1f1eb',
            '🇹🇩': '1f1f9-1f1e9',
            '🇹🇨': '1f1f9-1f1e8',
            '🇹🇦': '1f1f9-1f1e6',
            '🇸🇿': '1f1f8-1f1ff',
            '🇸🇾': '1f1f8-1f1fe',
            '🇸🇽': '1f1f8-1f1fd',
            '🇸🇻': '1f1f8-1f1fb',
            '🇸🇹': '1f1f8-1f1f9',
            '🇸🇸': '1f1f8-1f1f8',
            '🇸🇷': '1f1f8-1f1f7',
            '🇸🇴': '1f1f8-1f1f4',
            '🇸🇳': '1f1f8-1f1f3',
            '🇸🇲': '1f1f8-1f1f2',
            '🇸🇱': '1f1f8-1f1f1',
            '🇸🇰': '1f1f8-1f1f0',
            '🇸🇯': '1f1f8-1f1ef',
            '🇸🇮': '1f1f8-1f1ee',
            '🇸🇭': '1f1f8-1f1ed',
            '🇸🇬': '1f1f8-1f1ec',
            '🇸🇪': '1f1f8-1f1ea',
            '🇸🇩': '1f1f8-1f1e9',
            '🇸🇨': '1f1f8-1f1e8',
            '🇸🇧': '1f1f8-1f1e7',
            '🇸🇦': '1f1f8-1f1e6',
            '🇷🇼': '1f1f7-1f1fc',
            '🇷🇺': '1f1f7-1f1fa',
            '🇷🇸': '1f1f7-1f1f8',
            '🇷🇴': '1f1f7-1f1f4',
            '🇷🇪': '1f1f7-1f1ea',
            '🇶🇦': '1f1f6-1f1e6',
            '🇵🇾': '1f1f5-1f1fe',
            '🇵🇼': '1f1f5-1f1fc',
            '🇵🇹': '1f1f5-1f1f9',
            '🇵🇸': '1f1f5-1f1f8',
            '🇵🇷': '1f1f5-1f1f7',
            '🇵🇳': '1f1f5-1f1f3',
            '🇵🇲': '1f1f5-1f1f2',
            '🇵🇱': '1f1f5-1f1f1',
            '🇵🇰': '1f1f5-1f1f0',
            '🇵🇭': '1f1f5-1f1ed',
            '🇵🇬': '1f1f5-1f1ec',
            '🇵🇫': '1f1f5-1f1eb',
            '🇵🇪': '1f1f5-1f1ea',
            '🇵🇦': '1f1f5-1f1e6',
            '🇴🇲': '1f1f4-1f1f2',
            '🇳🇿': '1f1f3-1f1ff',
            '🇳🇺': '1f1f3-1f1fa',
            '🇳🇷': '1f1f3-1f1f7',
            '🇳🇵': '1f1f3-1f1f5',
            '🇳🇴': '1f1f3-1f1f4',
            '🇳🇱': '1f1f3-1f1f1',
            '🇳🇮': '1f1f3-1f1ee',
            '🇳🇬': '1f1f3-1f1ec',
            '🇳🇫': '1f1f3-1f1eb',
            '🇳🇪': '1f1f3-1f1ea',
            '🇳🇨': '1f1f3-1f1e8',
            '🇳🇦': '1f1f3-1f1e6',
            '🇲🇿': '1f1f2-1f1ff',
            '🇲🇾': '1f1f2-1f1fe',
            '🇲🇽': '1f1f2-1f1fd',
            '🇲🇼': '1f1f2-1f1fc',
            '🇲🇻': '1f1f2-1f1fb',
            '🇲🇺': '1f1f2-1f1fa',
            '🇲🇹': '1f1f2-1f1f9',
            '🇲🇸': '1f1f2-1f1f8',
            '🇲🇷': '1f1f2-1f1f7',
            '🇲🇶': '1f1f2-1f1f6',
            '🇲🇵': '1f1f2-1f1f5',
            '🇲🇴': '1f1f2-1f1f4',
            '🇲🇳': '1f1f2-1f1f3',
            '🇲🇲': '1f1f2-1f1f2',
            '🇲🇱': '1f1f2-1f1f1',
            '🇲🇰': '1f1f2-1f1f0',
            '🇲🇭': '1f1f2-1f1ed',
            '🇲🇬': '1f1f2-1f1ec',
            '🇲🇫': '1f1f2-1f1eb',
            '🇲🇪': '1f1f2-1f1ea',
            '🇲🇩': '1f1f2-1f1e9',
            '🇲🇨': '1f1f2-1f1e8',
            '🇲🇦': '1f1f2-1f1e6',
            '🇱🇾': '1f1f1-1f1fe',
            '🇱🇻': '1f1f1-1f1fb',
            '🇱🇺': '1f1f1-1f1fa',
            '🇱🇹': '1f1f1-1f1f9',
            '🇱🇸': '1f1f1-1f1f8',
            '🇱🇷': '1f1f1-1f1f7',
            '🇱🇰': '1f1f1-1f1f0',
            '🇱🇮': '1f1f1-1f1ee',
            '🇱🇨': '1f1f1-1f1e8',
            '🇱🇧': '1f1f1-1f1e7',
            '🇱🇦': '1f1f1-1f1e6',
            '🇰🇿': '1f1f0-1f1ff',
            '🇰🇾': '1f1f0-1f1fe',
            '🇰🇼': '1f1f0-1f1fc',
            '🇰🇷': '1f1f0-1f1f7',
            '🇰🇵': '1f1f0-1f1f5',
            '🇰🇳': '1f1f0-1f1f3',
            '🇰🇲': '1f1f0-1f1f2',
            '🇰🇮': '1f1f0-1f1ee',
            '🇰🇭': '1f1f0-1f1ed',
            '🇰🇬': '1f1f0-1f1ec',
            '🇰🇪': '1f1f0-1f1ea',
            '🇯🇵': '1f1ef-1f1f5',
            '🇯🇴': '1f1ef-1f1f4',
            '🇯🇲': '1f1ef-1f1f2',
            '🇯🇪': '1f1ef-1f1ea',
            '🇮🇹': '1f1ee-1f1f9',
            '🇮🇸': '1f1ee-1f1f8',
            '🇮🇷': '1f1ee-1f1f7',
            '🇮🇶': '1f1ee-1f1f6',
            '🇮🇴': '1f1ee-1f1f4',
            '🇮🇳': '1f1ee-1f1f3',
            '🇮🇲': '1f1ee-1f1f2',
            '🇮🇱': '1f1ee-1f1f1',
            '🇮🇪': '1f1ee-1f1ea',
            '🇮🇩': '1f1ee-1f1e9',
            '🇮🇨': '1f1ee-1f1e8',
            '🇭🇺': '1f1ed-1f1fa',
            '🇭🇹': '1f1ed-1f1f9',
            '🇭🇷': '1f1ed-1f1f7',
            '🇭🇳': '1f1ed-1f1f3',
            '🇭🇲': '1f1ed-1f1f2',
            '🇭🇰': '1f1ed-1f1f0',
            '🇬🇾': '1f1ec-1f1fe',
            '🇬🇼': '1f1ec-1f1fc',
            '🇬🇺': '1f1ec-1f1fa',
            '🇬🇹': '1f1ec-1f1f9',
            '🇬🇸': '1f1ec-1f1f8',
            '🇬🇷': '1f1ec-1f1f7',
            '🇬🇶': '1f1ec-1f1f6',
            '🇬🇵': '1f1ec-1f1f5',
            '🇬🇳': '1f1ec-1f1f3',
            '🇬🇲': '1f1ec-1f1f2',
            '🇬🇱': '1f1ec-1f1f1',
            '🇬🇮': '1f1ec-1f1ee',
            '🇬🇭': '1f1ec-1f1ed',
            '🇬🇬': '1f1ec-1f1ec',
            '🇬🇫': '1f1ec-1f1eb',
            '🇬🇪': '1f1ec-1f1ea',
            '🇬🇩': '1f1ec-1f1e9',
            '🇬🇧': '1f1ec-1f1e7',
            '🇬🇦': '1f1ec-1f1e6',
            '🇫🇷': '1f1eb-1f1f7',
            '🇫🇴': '1f1eb-1f1f4',
            '🇫🇲': '1f1eb-1f1f2',
            '🇫🇰': '1f1eb-1f1f0',
            '🇫🇯': '1f1eb-1f1ef',
            '🇫🇮': '1f1eb-1f1ee',
            '🇪🇺': '1f1ea-1f1fa',
            '🇪🇹': '1f1ea-1f1f9',
            '🇪🇸': '1f1ea-1f1f8',
            '🇪🇷': '1f1ea-1f1f7',
            '🇪🇭': '1f1ea-1f1ed',
            '🇪🇬': '1f1ea-1f1ec',
            '🇪🇪': '1f1ea-1f1ea',
            '🇪🇨': '1f1ea-1f1e8',
            '🇪🇦': '1f1ea-1f1e6',
            '🇩🇿': '1f1e9-1f1ff',
            '🇩🇴': '1f1e9-1f1f4',
            '🇩🇲': '1f1e9-1f1f2',
            '🇩🇰': '1f1e9-1f1f0',
            '🇩🇯': '1f1e9-1f1ef',
            '🇩🇬': '1f1e9-1f1ec',
            '🇩🇪': '1f1e9-1f1ea',
            '🇨🇿': '1f1e8-1f1ff',
            '🇨🇾': '1f1e8-1f1fe',
            '🇨🇽': '1f1e8-1f1fd',
            '🇨🇼': '1f1e8-1f1fc',
            '🇨🇻': '1f1e8-1f1fb',
            '🇨🇺': '1f1e8-1f1fa',
            '🇨🇷': '1f1e8-1f1f7',
            '🇨🇵': '1f1e8-1f1f5',
            '🇨🇴': '1f1e8-1f1f4',
            '🇨🇳': '1f1e8-1f1f3',
            '🇨🇲': '1f1e8-1f1f2',
            '🇨🇱': '1f1e8-1f1f1',
            '🇨🇰': '1f1e8-1f1f0',
            '🇨🇮': '1f1e8-1f1ee',
            '🇨🇭': '1f1e8-1f1ed',
            '🇨🇬': '1f1e8-1f1ec',
            '🇨🇫': '1f1e8-1f1eb',
            '🇨🇩': '1f1e8-1f1e9',
            '🇨🇨': '1f1e8-1f1e8',
            '🇨🇦': '1f1e8-1f1e6',
            '🇧🇿': '1f1e7-1f1ff',
            '🇧🇾': '1f1e7-1f1fe',
            '🇧🇼': '1f1e7-1f1fc',
            '🇧🇻': '1f1e7-1f1fb',
            '🇧🇹': '1f1e7-1f1f9',
            '🇧🇸': '1f1e7-1f1f8',
            '🇧🇷': '1f1e7-1f1f7',
            '🇧🇶': '1f1e7-1f1f6',
            '🇧🇴': '1f1e7-1f1f4',
            '🇧🇳': '1f1e7-1f1f3',
            '🇧🇲': '1f1e7-1f1f2',
            '🇧🇱': '1f1e7-1f1f1',
            '🇧🇯': '1f1e7-1f1ef',
            '🇧🇮': '1f1e7-1f1ee',
            '🇧🇭': '1f1e7-1f1ed',
            '🇧🇬': '1f1e7-1f1ec',
            '🇧🇫': '1f1e7-1f1eb',
            '🇧🇪': '1f1e7-1f1ea',
            '🇧🇩': '1f1e7-1f1e9',
            '🇧🇧': '1f1e7-1f1e7',
            '🇧🇦': '1f1e7-1f1e6',
            '🇦🇿': '1f1e6-1f1ff',
            '🇦🇽': '1f1e6-1f1fd',
            '🇦🇼': '1f1e6-1f1fc',
            '🇦🇺': '1f1e6-1f1fa',
            '🇦🇹': '1f1e6-1f1f9',
            '🇦🇸': '1f1e6-1f1f8',
            '🇦🇷': '1f1e6-1f1f7',
            '🇦🇶': '1f1e6-1f1f6',
            '🇦🇴': '1f1e6-1f1f4',
            '🇦🇲': '1f1e6-1f1f2',
            '🇦🇱': '1f1e6-1f1f1',
            '🇦🇮': '1f1e6-1f1ee',
            '🇦🇬': '1f1e6-1f1ec',
            '🇦🇫': '1f1e6-1f1eb',
            '🇦🇪': '1f1e6-1f1ea',
            '🇦🇩': '1f1e6-1f1e9',
            '🇦🇨': '1f1e6-1f1e8',
            '🀄️': '1f004-fe0f',
            '🀄': '1f004',
            '🅿️': '1f17f-fe0f',
            '🅿': '1f17f',
            '🈂️': '1f202-fe0f',
            '🈂': '1f202',
            '🈚️': '1f21a-fe0f',
            '🈚': '1f21a',
            '🈯️': '1f22f-fe0f',
            '🈯': '1f22f',
            '🈷️': '1f237-fe0f',
            '🈷': '1f237',
            '🎞️': '1f39e-fe0f',
            '🎞': '1f39e',
            '🎟️': '1f39f-fe0f',
            '🎟': '1f39f',
            '🏋️': '1f3cb-fe0f',
            '🏋': '1f3cb',
            '🏌️': '1f3cc-fe0f',
            '🏌': '1f3cc',
            '🏍️': '1f3cd-fe0f',
            '🏍': '1f3cd',
            '🏎️': '1f3ce-fe0f',
            '🏎': '1f3ce',
            '🎖️': '1f396-fe0f',
            '🎖': '1f396',
            '🎗️': '1f397-fe0f',
            '🎗': '1f397',
            '🌶️': '1f336-fe0f',
            '🌶': '1f336',
            '🌧️': '1f327-fe0f',
            '🌧': '1f327',
            '🌨️': '1f328-fe0f',
            '🌨': '1f328',
            '🌩️': '1f329-fe0f',
            '🌩': '1f329',
            '🌪️': '1f32a-fe0f',
            '🌪': '1f32a',
            '🌫️': '1f32b-fe0f',
            '🌫': '1f32b',
            '🌬️': '1f32c-fe0f',
            '🌬': '1f32c',
            '🐿️': '1f43f-fe0f',
            '🐿': '1f43f',
            '🕷️': '1f577-fe0f',
            '🕷': '1f577',
            '🕸️': '1f578-fe0f',
            '🕸': '1f578',
            '🌡️': '1f321-fe0f',
            '🌡': '1f321',
            '🎙️': '1f399-fe0f',
            '🎙': '1f399',
            '🎚️': '1f39a-fe0f',
            '🎚': '1f39a',
            '🎛️': '1f39b-fe0f',
            '🎛': '1f39b',
            '🏳️': '1f3f3-fe0f',
            '🏳': '1f3f3',
            '🏵️': '1f3f5-fe0f',
            '🏵': '1f3f5',
            '🏷️': '1f3f7-fe0f',
            '🏷': '1f3f7',
            '📽️': '1f4fd-fe0f',
            '📽': '1f4fd',
            '🕉️': '1f549-fe0f',
            '🕉': '1f549',
            '🕊️': '1f54a-fe0f',
            '🕊': '1f54a',
            '🕯️': '1f56f-fe0f',
            '🕯': '1f56f',
            '🕰️': '1f570-fe0f',
            '🕰': '1f570',
            '🕳️': '1f573-fe0f',
            '🕳': '1f573',
            '🕶️': '1f576-fe0f',
            '🕶': '1f576',
            '🕹️': '1f579-fe0f',
            '🕹': '1f579',
            '🖇️': '1f587-fe0f',
            '🖇': '1f587',
            '🖊️': '1f58a-fe0f',
            '🖊': '1f58a',
            '🖋️': '1f58b-fe0f',
            '🖋': '1f58b',
            '🖌️': '1f58c-fe0f',
            '🖌': '1f58c',
            '🖍️': '1f58d-fe0f',
            '🖍': '1f58d',
            '🖥️': '1f5a5-fe0f',
            '🖥': '1f5a5',
            '🖨️': '1f5a8-fe0f',
            '🖨': '1f5a8',
            '🖲️': '1f5b2-fe0f',
            '🖲': '1f5b2',
            '🖼️': '1f5bc-fe0f',
            '🖼': '1f5bc',
            '🗂️': '1f5c2-fe0f',
            '🗂': '1f5c2',
            '🗃️': '1f5c3-fe0f',
            '🗃': '1f5c3',
            '🗄️': '1f5c4-fe0f',
            '🗄': '1f5c4',
            '🗑️': '1f5d1-fe0f',
            '🗑': '1f5d1',
            '🗒️': '1f5d2-fe0f',
            '🗒': '1f5d2',
            '🗓️': '1f5d3-fe0f',
            '🗓': '1f5d3',
            '🗜️': '1f5dc-fe0f',
            '🗜': '1f5dc',
            '🗝️': '1f5dd-fe0f',
            '🗝': '1f5dd',
            '🗞️': '1f5de-fe0f',
            '🗞': '1f5de',
            '🗡️': '1f5e1-fe0f',
            '🗡': '1f5e1',
            '🗣️': '1f5e3-fe0f',
            '🗣': '1f5e3',
            '🗨️': '1f5e8-fe0f',
            '🗨': '1f5e8',
            '🗯️': '1f5ef-fe0f',
            '🗯': '1f5ef',
            '🗳️': '1f5f3-fe0f',
            '🗳': '1f5f3',
            '🗺️': '1f5fa-fe0f',
            '🗺': '1f5fa',
            '🛠️': '1f6e0-fe0f',
            '🛠': '1f6e0',
            '🛡️': '1f6e1-fe0f',
            '🛡': '1f6e1',
            '🛢️': '1f6e2-fe0f',
            '🛢': '1f6e2',
            '🛰️': '1f6f0-fe0f',
            '🛰': '1f6f0',
            '🍽️': '1f37d-fe0f',
            '🍽': '1f37d',
            '👁️': '1f441-fe0f',
            '👁': '1f441',
            '🕴️': '1f574-fe0f',
            '🕴': '1f574',
            '🕵️': '1f575-fe0f',
            '🕵': '1f575',
            '🖐️': '1f590-fe0f',
            '🖐': '1f590',
            '🏔️': '1f3d4-fe0f',
            '🏔': '1f3d4',
            '🏕️': '1f3d5-fe0f',
            '🏕': '1f3d5',
            '🏖️': '1f3d6-fe0f',
            '🏖': '1f3d6',
            '🏗️': '1f3d7-fe0f',
            '🏗': '1f3d7',
            '🏘️': '1f3d8-fe0f',
            '🏘': '1f3d8',
            '🏙️': '1f3d9-fe0f',
            '🏙': '1f3d9',
            '🏚️': '1f3da-fe0f',
            '🏚': '1f3da',
            '🏛️': '1f3db-fe0f',
            '🏛': '1f3db',
            '🏜️': '1f3dc-fe0f',
            '🏜': '1f3dc',
            '🏝️': '1f3dd-fe0f',
            '🏝': '1f3dd',
            '🏞️': '1f3de-fe0f',
            '🏞': '1f3de',
            '🏟️': '1f3df-fe0f',
            '🏟': '1f3df',
            '🛋️': '1f6cb-fe0f',
            '🛋': '1f6cb',
            '🛍️': '1f6cd-fe0f',
            '🛍': '1f6cd',
            '🛎️': '1f6ce-fe0f',
            '🛎': '1f6ce',
            '🛏️': '1f6cf-fe0f',
            '🛏': '1f6cf',
            '🛣️': '1f6e3-fe0f',
            '🛣': '1f6e3',
            '🛤️': '1f6e4-fe0f',
            '🛤': '1f6e4',
            '🛥️': '1f6e5-fe0f',
            '🛥': '1f6e5',
            '🛩️': '1f6e9-fe0f',
            '🛩': '1f6e9',
            '🛳️': '1f6f3-fe0f',
            '🛳': '1f6f3',
            '🌤️': '1f324-fe0f',
            '🌤': '1f324',
            '🌥️': '1f325-fe0f',
            '🌥': '1f325',
            '🌦️': '1f326-fe0f',
            '🌦': '1f326',
            '🖱️': '1f5b1-fe0f',
            '🖱': '1f5b1',
            '☝🏻': '261d-1f3fb',
            '☝🏼': '261d-1f3fc',
            '☝🏽': '261d-1f3fd',
            '☝🏾': '261d-1f3fe',
            '☝🏿': '261d-1f3ff',
            '✌🏻': '270c-1f3fb',
            '✌🏼': '270c-1f3fc',
            '✌🏽': '270c-1f3fd',
            '✌🏾': '270c-1f3fe',
            '✌🏿': '270c-1f3ff',
            '✊🏻': '270a-1f3fb',
            '✊🏼': '270a-1f3fc',
            '✊🏽': '270a-1f3fd',
            '✊🏾': '270a-1f3fe',
            '✊🏿': '270a-1f3ff',
            '✋🏻': '270b-1f3fb',
            '✋🏼': '270b-1f3fc',
            '✋🏽': '270b-1f3fd',
            '✋🏾': '270b-1f3fe',
            '✋🏿': '270b-1f3ff',
            '✍🏻': '270d-1f3fb',
            '✍🏼': '270d-1f3fc',
            '✍🏽': '270d-1f3fd',
            '✍🏾': '270d-1f3fe',
            '✍🏿': '270d-1f3ff',
            '⛹🏻': '26f9-1f3fb',
            '⛹🏼': '26f9-1f3fc',
            '⛹🏽': '26f9-1f3fd',
            '⛹🏾': '26f9-1f3fe',
            '⛹🏿': '26f9-1f3ff',
            '©️': '00a9-fe0f',
            '©': '00a9',
            '®️': '00ae-fe0f',
            '®': '00ae',
            '‼️': '203c-fe0f',
            '‼': '203c',
            '⁉️': '2049-fe0f',
            '⁉': '2049',
            '™️': '2122-fe0f',
            '™': '2122',
            ℹ️: '2139-fe0f',
            ℹ: '2139',
            '↔️': '2194-fe0f',
            '↔': '2194',
            '↕️': '2195-fe0f',
            '↕': '2195',
            '↖️': '2196-fe0f',
            '↖': '2196',
            '↗️': '2197-fe0f',
            '↗': '2197',
            '↘️': '2198-fe0f',
            '↘': '2198',
            '↙️': '2199-fe0f',
            '↙': '2199',
            '↩️': '21a9-fe0f',
            '↩': '21a9',
            '↪️': '21aa-fe0f',
            '↪': '21aa',
            '⌚️': '231a-fe0f',
            '⌚': '231a',
            '⌛️': '231b-fe0f',
            '⌛': '231b',
            'Ⓜ️': '24c2-fe0f',
            'Ⓜ': '24c2',
            '▪️': '25aa-fe0f',
            '▪': '25aa',
            '▫️': '25ab-fe0f',
            '▫': '25ab',
            '▶️': '25b6-fe0f',
            '▶': '25b6',
            '◀️': '25c0-fe0f',
            '◀': '25c0',
            '◻️': '25fb-fe0f',
            '◻': '25fb',
            '◼️': '25fc-fe0f',
            '◼': '25fc',
            '◽️': '25fd-fe0f',
            '◽': '25fd',
            '◾️': '25fe-fe0f',
            '◾': '25fe',
            '☀️': '2600-fe0f',
            '☀': '2600',
            '☁️': '2601-fe0f',
            '☁': '2601',
            '☎️': '260e-fe0f',
            '☎': '260e',
            '☑️': '2611-fe0f',
            '☑': '2611',
            '☔️': '2614-fe0f',
            '☔': '2614',
            '☕️': '2615-fe0f',
            '☕': '2615',
            '☝️': '261d-fe0f',
            '☝': '261d',
            '☺️': '263a-fe0f',
            '☺': '263a',
            '♈️': '2648-fe0f',
            '♈': '2648',
            '♉️': '2649-fe0f',
            '♉': '2649',
            '♊️': '264a-fe0f',
            '♊': '264a',
            '♋️': '264b-fe0f',
            '♋': '264b',
            '♌️': '264c-fe0f',
            '♌': '264c',
            '♍️': '264d-fe0f',
            '♍': '264d',
            '♎️': '264e-fe0f',
            '♎': '264e',
            '♏️': '264f-fe0f',
            '♏': '264f',
            '♐️': '2650-fe0f',
            '♐': '2650',
            '♑️': '2651-fe0f',
            '♑': '2651',
            '♒️': '2652-fe0f',
            '♒': '2652',
            '♓️': '2653-fe0f',
            '♓': '2653',
            '♠️': '2660-fe0f',
            '♠': '2660',
            '♣️': '2663-fe0f',
            '♣': '2663',
            '♥️': '2665-fe0f',
            '♥': '2665',
            '♦️': '2666-fe0f',
            '♦': '2666',
            '♨️': '2668-fe0f',
            '♨': '2668',
            '♻️': '267b-fe0f',
            '♻': '267b',
            '♿️': '267f-fe0f',
            '♿': '267f',
            '⚓️': '2693-fe0f',
            '⚓': '2693',
            '⚠️': '26a0-fe0f',
            '⚠': '26a0',
            '⚡️': '26a1-fe0f',
            '⚡': '26a1',
            '⚪️': '26aa-fe0f',
            '⚪': '26aa',
            '⚫️': '26ab-fe0f',
            '⚫': '26ab',
            '⚽️': '26bd-fe0f',
            '⚽': '26bd',
            '⚾️': '26be-fe0f',
            '⚾': '26be',
            '⛄️': '26c4-fe0f',
            '⛄': '26c4',
            '⛅️': '26c5-fe0f',
            '⛅': '26c5',
            '⛔️': '26d4-fe0f',
            '⛔': '26d4',
            '⛪️': '26ea-fe0f',
            '⛪': '26ea',
            '⛲️': '26f2-fe0f',
            '⛲': '26f2',
            '⛳️': '26f3-fe0f',
            '⛳': '26f3',
            '⛵️': '26f5-fe0f',
            '⛵': '26f5',
            '⛺️': '26fa-fe0f',
            '⛺': '26fa',
            '⛽️': '26fd-fe0f',
            '⛽': '26fd',
            '✂️': '2702-fe0f',
            '✂': '2702',
            '✈️': '2708-fe0f',
            '✈': '2708',
            '✉️': '2709-fe0f',
            '✉': '2709',
            '✌️': '270c-fe0f',
            '✌': '270c',
            '✏️': '270f-fe0f',
            '✏': '270f',
            '✒️': '2712-fe0f',
            '✒': '2712',
            '✔️': '2714-fe0f',
            '✔': '2714',
            '✖️': '2716-fe0f',
            '✖': '2716',
            '✳️': '2733-fe0f',
            '✳': '2733',
            '✴️': '2734-fe0f',
            '✴': '2734',
            '❄️': '2744-fe0f',
            '❄': '2744',
            '❇️': '2747-fe0f',
            '❇': '2747',
            '❗️': '2757-fe0f',
            '❗': '2757',
            '❤️': '2764-fe0f',
            '❤': '2764',
            '➡️': '27a1-fe0f',
            '➡': '27a1',
            '⤴️': '2934-fe0f',
            '⤴': '2934',
            '⤵️': '2935-fe0f',
            '⤵': '2935',
            '⬅️': '2b05-fe0f',
            '⬅': '2b05',
            '⬆️': '2b06-fe0f',
            '⬆': '2b06',
            '⬇️': '2b07-fe0f',
            '⬇': '2b07',
            '⬛️': '2b1b-fe0f',
            '⬛': '2b1b',
            '⬜️': '2b1c-fe0f',
            '⬜': '2b1c',
            '⭐️': '2b50-fe0f',
            '⭐': '2b50',
            '⭕️': '2b55-fe0f',
            '⭕': '2b55',
            '〰️': '3030-fe0f',
            '〰': '3030',
            '〽️': '303d-fe0f',
            '〽': '303d',
            '㊗️': '3297-fe0f',
            '㊗': '3297',
            '㊙️': '3299-fe0f',
            '㊙': '3299',
            '✝️': '271d-fe0f',
            '✝': '271d',
            '⌨️': '2328-fe0f',
            '⌨': '2328',
            '✍️': '270d-fe0f',
            '✍': '270d',
            '⏏️': '23cf-fe0f',
            '⏏': '23cf',
            '⏭️': '23ed-fe0f',
            '⏭': '23ed',
            '⏮️': '23ee-fe0f',
            '⏮': '23ee',
            '⏯️': '23ef-fe0f',
            '⏯': '23ef',
            '⏱️': '23f1-fe0f',
            '⏱': '23f1',
            '⏲️': '23f2-fe0f',
            '⏲': '23f2',
            '⏸️': '23f8-fe0f',
            '⏸': '23f8',
            '⏹️': '23f9-fe0f',
            '⏹': '23f9',
            '⏺️': '23fa-fe0f',
            '⏺': '23fa',
            '☂️': '2602-fe0f',
            '☂': '2602',
            '☃️': '2603-fe0f',
            '☃': '2603',
            '☄️': '2604-fe0f',
            '☄': '2604',
            '☘️': '2618-fe0f',
            '☘': '2618',
            '☠️': '2620-fe0f',
            '☠': '2620',
            '☢️': '2622-fe0f',
            '☢': '2622',
            '☣️': '2623-fe0f',
            '☣': '2623',
            '☦️': '2626-fe0f',
            '☦': '2626',
            '☪️': '262a-fe0f',
            '☪': '262a',
            '☮️': '262e-fe0f',
            '☮': '262e',
            '☯️': '262f-fe0f',
            '☯': '262f',
            '☸️': '2638-fe0f',
            '☸': '2638',
            '☹️': '2639-fe0f',
            '☹': '2639',
            '⚒️': '2692-fe0f',
            '⚒': '2692',
            '⚔️': '2694-fe0f',
            '⚔': '2694',
            '⚖️': '2696-fe0f',
            '⚖': '2696',
            '⚗️': '2697-fe0f',
            '⚗': '2697',
            '⚙️': '2699-fe0f',
            '⚙': '2699',
            '⚛️': '269b-fe0f',
            '⚛': '269b',
            '⚜️': '269c-fe0f',
            '⚜': '269c',
            '⚰️': '26b0-fe0f',
            '⚰': '26b0',
            '⚱️': '26b1-fe0f',
            '⚱': '26b1',
            '⛈️': '26c8-fe0f',
            '⛈': '26c8',
            '⛏️': '26cf-fe0f',
            '⛏': '26cf',
            '⛑️': '26d1-fe0f',
            '⛑': '26d1',
            '⛓️': '26d3-fe0f',
            '⛓': '26d3',
            '⛩️': '26e9-fe0f',
            '⛩': '26e9',
            '⛰️': '26f0-fe0f',
            '⛰': '26f0',
            '⛱️': '26f1-fe0f',
            '⛱': '26f1',
            '⛴️': '26f4-fe0f',
            '⛴': '26f4',
            '⛷️': '26f7-fe0f',
            '⛷': '26f7',
            '⛸️': '26f8-fe0f',
            '⛸': '26f8',
            '⛹️': '26f9-fe0f',
            '⛹': '26f9',
            '✡️': '2721-fe0f',
            '✡': '2721',
            '❣️': '2763-fe0f',
            '❣': '2763',
            '🥉': '1f949',
            '🥈': '1f948',
            '🥇': '1f947',
            '🤺': '1f93a',
            '🥅': '1f945',
            '🤾': '1f93e',
            '🇿': '1f1ff',
            '🤽': '1f93d',
            '🥋': '1f94b',
            '🥊': '1f94a',
            '🤼': '1f93c',
            '🤹': '1f939',
            '🤸': '1f938',
            '🛶': '1f6f6',
            '🛵': '1f6f5',
            '🛴': '1f6f4',
            '🛒': '1f6d2',
            '🃏': '1f0cf',
            '🅰': '1f170',
            '🅱': '1f171',
            '🅾': '1f17e',
            '🛑': '1f6d1',
            '🆎': '1f18e',
            '🆑': '1f191',
            '🇾': '1f1fe',
            '🆒': '1f192',
            '🆓': '1f193',
            '🆔': '1f194',
            '🆕': '1f195',
            '🆖': '1f196',
            '🆗': '1f197',
            '🆘': '1f198',
            '🥄': '1f944',
            '🆙': '1f199',
            '🆚': '1f19a',
            '🥂': '1f942',
            '🥃': '1f943',
            '🈁': '1f201',
            '🥙': '1f959',
            '🈲': '1f232',
            '🈳': '1f233',
            '🈴': '1f234',
            '🈵': '1f235',
            '🈶': '1f236',
            '🥘': '1f958',
            '🈸': '1f238',
            '🈹': '1f239',
            '🥗': '1f957',
            '🈺': '1f23a',
            '🉐': '1f250',
            '🉑': '1f251',
            '🌀': '1f300',
            '🥖': '1f956',
            '🌁': '1f301',
            '🌂': '1f302',
            '🌃': '1f303',
            '🌄': '1f304',
            '🌅': '1f305',
            '🌆': '1f306',
            '🥕': '1f955',
            '🌇': '1f307',
            '🌈': '1f308',
            '🥔': '1f954',
            '🌉': '1f309',
            '🌊': '1f30a',
            '🌋': '1f30b',
            '🌌': '1f30c',
            '🌏': '1f30f',
            '🌑': '1f311',
            '🥓': '1f953',
            '🌓': '1f313',
            '🌔': '1f314',
            '🌕': '1f315',
            '🌙': '1f319',
            '🌛': '1f31b',
            '🌟': '1f31f',
            '🥒': '1f952',
            '🌠': '1f320',
            '🌰': '1f330',
            '🥑': '1f951',
            '🌱': '1f331',
            '🌴': '1f334',
            '🌵': '1f335',
            '🌷': '1f337',
            '🌸': '1f338',
            '🌹': '1f339',
            '🌺': '1f33a',
            '🌻': '1f33b',
            '🌼': '1f33c',
            '🌽': '1f33d',
            '🥐': '1f950',
            '🌾': '1f33e',
            '🌿': '1f33f',
            '🍀': '1f340',
            '🍁': '1f341',
            '🍂': '1f342',
            '🍃': '1f343',
            '🍄': '1f344',
            '🍅': '1f345',
            '🍆': '1f346',
            '🍇': '1f347',
            '🍈': '1f348',
            '🍉': '1f349',
            '🍊': '1f34a',
            '🥀': '1f940',
            '🍌': '1f34c',
            '🍍': '1f34d',
            '🍎': '1f34e',
            '🍏': '1f34f',
            '🍑': '1f351',
            '🍒': '1f352',
            '🍓': '1f353',
            '🦏': '1f98f',
            '🍔': '1f354',
            '🍕': '1f355',
            '🍖': '1f356',
            '🦎': '1f98e',
            '🍗': '1f357',
            '🍘': '1f358',
            '🍙': '1f359',
            '🦍': '1f98d',
            '🍚': '1f35a',
            '🍛': '1f35b',
            '🦌': '1f98c',
            '🍜': '1f35c',
            '🍝': '1f35d',
            '🍞': '1f35e',
            '🍟': '1f35f',
            '🦋': '1f98b',
            '🍠': '1f360',
            '🍡': '1f361',
            '🦊': '1f98a',
            '🍢': '1f362',
            '🍣': '1f363',
            '🦉': '1f989',
            '🍤': '1f364',
            '🍥': '1f365',
            '🦈': '1f988',
            '🍦': '1f366',
            '🦇': '1f987',
            '🍧': '1f367',
            '🇽': '1f1fd',
            '🍨': '1f368',
            '🦆': '1f986',
            '🍩': '1f369',
            '🦅': '1f985',
            '🍪': '1f36a',
            '🖤': '1f5a4',
            '🍫': '1f36b',
            '🍬': '1f36c',
            '🍭': '1f36d',
            '🍮': '1f36e',
            '🍯': '1f36f',
            '🤞': '1f91e',
            '🍰': '1f370',
            '🍱': '1f371',
            '🍲': '1f372',
            '🤝': '1f91d',
            '🍳': '1f373',
            '🍴': '1f374',
            '🍵': '1f375',
            '🍶': '1f376',
            '🍷': '1f377',
            '🍸': '1f378',
            '🍹': '1f379',
            '🍺': '1f37a',
            '🍻': '1f37b',
            '🎀': '1f380',
            '🎁': '1f381',
            '🎂': '1f382',
            '🎃': '1f383',
            '🤛': '1f91b',
            '🤜': '1f91c',
            '🎄': '1f384',
            '🎅': '1f385',
            '🎆': '1f386',
            '🤚': '1f91a',
            '🎇': '1f387',
            '🎈': '1f388',
            '🎉': '1f389',
            '🎊': '1f38a',
            '🎋': '1f38b',
            '🎌': '1f38c',
            '🤙': '1f919',
            '🎍': '1f38d',
            '🕺': '1f57a',
            '🎎': '1f38e',
            '🤳': '1f933',
            '🎏': '1f38f',
            '🤰': '1f930',
            '🎐': '1f390',
            '🤦': '1f926',
            '🤷': '1f937',
            '🎑': '1f391',
            '🎒': '1f392',
            '🎓': '1f393',
            '🎠': '1f3a0',
            '🎡': '1f3a1',
            '🎢': '1f3a2',
            '🎣': '1f3a3',
            '🎤': '1f3a4',
            '🎥': '1f3a5',
            '🎦': '1f3a6',
            '🎧': '1f3a7',
            '🤶': '1f936',
            '🎨': '1f3a8',
            '🤵': '1f935',
            '🎩': '1f3a9',
            '🎪': '1f3aa',
            '🤴': '1f934',
            '🎫': '1f3ab',
            '🎬': '1f3ac',
            '🎭': '1f3ad',
            '🤧': '1f927',
            '🎮': '1f3ae',
            '🎯': '1f3af',
            '🎰': '1f3b0',
            '🎱': '1f3b1',
            '🎲': '1f3b2',
            '🎳': '1f3b3',
            '🎴': '1f3b4',
            '🤥': '1f925',
            '🎵': '1f3b5',
            '🎶': '1f3b6',
            '🎷': '1f3b7',
            '🤤': '1f924',
            '🎸': '1f3b8',
            '🎹': '1f3b9',
            '🎺': '1f3ba',
            '🤣': '1f923',
            '🎻': '1f3bb',
            '🎼': '1f3bc',
            '🎽': '1f3bd',
            '🤢': '1f922',
            '🎾': '1f3be',
            '🎿': '1f3bf',
            '🏀': '1f3c0',
            '🏁': '1f3c1',
            '🤡': '1f921',
            '🏂': '1f3c2',
            '🏃': '1f3c3',
            '🏄': '1f3c4',
            '🏆': '1f3c6',
            '🏈': '1f3c8',
            '🏊': '1f3ca',
            '🏠': '1f3e0',
            '🏡': '1f3e1',
            '🏢': '1f3e2',
            '🏣': '1f3e3',
            '🏥': '1f3e5',
            '🏦': '1f3e6',
            '🏧': '1f3e7',
            '🏨': '1f3e8',
            '🏩': '1f3e9',
            '🏪': '1f3ea',
            '🏫': '1f3eb',
            '🏬': '1f3ec',
            '🤠': '1f920',
            '🏭': '1f3ed',
            '🏮': '1f3ee',
            '🏯': '1f3ef',
            '🏰': '1f3f0',
            '🐌': '1f40c',
            '🐍': '1f40d',
            '🐎': '1f40e',
            '🐑': '1f411',
            '🐒': '1f412',
            '🐔': '1f414',
            '🐗': '1f417',
            '🐘': '1f418',
            '🐙': '1f419',
            '🐚': '1f41a',
            '🐛': '1f41b',
            '🐜': '1f41c',
            '🐝': '1f41d',
            '🐞': '1f41e',
            '🐟': '1f41f',
            '🐠': '1f420',
            '🐡': '1f421',
            '🐢': '1f422',
            '🐣': '1f423',
            '🐤': '1f424',
            '🐥': '1f425',
            '🐦': '1f426',
            '🐧': '1f427',
            '🐨': '1f428',
            '🐩': '1f429',
            '🐫': '1f42b',
            '🐬': '1f42c',
            '🐭': '1f42d',
            '🐮': '1f42e',
            '🐯': '1f42f',
            '🐰': '1f430',
            '🐱': '1f431',
            '🐲': '1f432',
            '🐳': '1f433',
            '🐴': '1f434',
            '🐵': '1f435',
            '🐶': '1f436',
            '🐷': '1f437',
            '🐸': '1f438',
            '🐹': '1f439',
            '🐺': '1f43a',
            '🐻': '1f43b',
            '🐼': '1f43c',
            '🐽': '1f43d',
            '🐾': '1f43e',
            '👀': '1f440',
            '👂': '1f442',
            '👃': '1f443',
            '👄': '1f444',
            '👅': '1f445',
            '👆': '1f446',
            '👇': '1f447',
            '👈': '1f448',
            '👉': '1f449',
            '👊': '1f44a',
            '👋': '1f44b',
            '👌': '1f44c',
            '👍': '1f44d',
            '👎': '1f44e',
            '👏': '1f44f',
            '👐': '1f450',
            '👑': '1f451',
            '👒': '1f452',
            '👓': '1f453',
            '👔': '1f454',
            '👕': '1f455',
            '👖': '1f456',
            '👗': '1f457',
            '👘': '1f458',
            '👙': '1f459',
            '👚': '1f45a',
            '👛': '1f45b',
            '👜': '1f45c',
            '👝': '1f45d',
            '👞': '1f45e',
            '👟': '1f45f',
            '👠': '1f460',
            '👡': '1f461',
            '👢': '1f462',
            '👣': '1f463',
            '👤': '1f464',
            '👦': '1f466',
            '👧': '1f467',
            '👨': '1f468',
            '👩': '1f469',
            '👪': '1f46a',
            '👫': '1f46b',
            '👮': '1f46e',
            '👯': '1f46f',
            '👰': '1f470',
            '👱': '1f471',
            '👲': '1f472',
            '👳': '1f473',
            '👴': '1f474',
            '👵': '1f475',
            '👶': '1f476',
            '👷': '1f477',
            '👸': '1f478',
            '👹': '1f479',
            '👺': '1f47a',
            '👻': '1f47b',
            '👼': '1f47c',
            '👽': '1f47d',
            '👾': '1f47e',
            '👿': '1f47f',
            '💀': '1f480',
            '📇': '1f4c7',
            '💁': '1f481',
            '💂': '1f482',
            '💃': '1f483',
            '💄': '1f484',
            '💅': '1f485',
            '📒': '1f4d2',
            '💆': '1f486',
            '📓': '1f4d3',
            '💇': '1f487',
            '📔': '1f4d4',
            '💈': '1f488',
            '📕': '1f4d5',
            '💉': '1f489',
            '📖': '1f4d6',
            '💊': '1f48a',
            '📗': '1f4d7',
            '💋': '1f48b',
            '📘': '1f4d8',
            '💌': '1f48c',
            '📙': '1f4d9',
            '💍': '1f48d',
            '📚': '1f4da',
            '💎': '1f48e',
            '📛': '1f4db',
            '💏': '1f48f',
            '📜': '1f4dc',
            '💐': '1f490',
            '📝': '1f4dd',
            '💑': '1f491',
            '📞': '1f4de',
            '💒': '1f492',
            '📟': '1f4df',
            '📠': '1f4e0',
            '💓': '1f493',
            '📡': '1f4e1',
            '📢': '1f4e2',
            '💔': '1f494',
            '📣': '1f4e3',
            '📤': '1f4e4',
            '💕': '1f495',
            '📥': '1f4e5',
            '📦': '1f4e6',
            '💖': '1f496',
            '📧': '1f4e7',
            '📨': '1f4e8',
            '💗': '1f497',
            '📩': '1f4e9',
            '📪': '1f4ea',
            '💘': '1f498',
            '📫': '1f4eb',
            '📮': '1f4ee',
            '💙': '1f499',
            '📰': '1f4f0',
            '📱': '1f4f1',
            '💚': '1f49a',
            '📲': '1f4f2',
            '📳': '1f4f3',
            '💛': '1f49b',
            '📴': '1f4f4',
            '📶': '1f4f6',
            '💜': '1f49c',
            '📷': '1f4f7',
            '📹': '1f4f9',
            '💝': '1f49d',
            '📺': '1f4fa',
            '📻': '1f4fb',
            '💞': '1f49e',
            '📼': '1f4fc',
            '🔃': '1f503',
            '💟': '1f49f',
            '🔊': '1f50a',
            '🔋': '1f50b',
            '💠': '1f4a0',
            '🔌': '1f50c',
            '🔍': '1f50d',
            '💡': '1f4a1',
            '🔎': '1f50e',
            '🔏': '1f50f',
            '💢': '1f4a2',
            '🔐': '1f510',
            '🔑': '1f511',
            '💣': '1f4a3',
            '🔒': '1f512',
            '🔓': '1f513',
            '💤': '1f4a4',
            '🔔': '1f514',
            '🔖': '1f516',
            '💥': '1f4a5',
            '🔗': '1f517',
            '🔘': '1f518',
            '💦': '1f4a6',
            '🔙': '1f519',
            '🔚': '1f51a',
            '💧': '1f4a7',
            '🔛': '1f51b',
            '🔜': '1f51c',
            '💨': '1f4a8',
            '🔝': '1f51d',
            '🔞': '1f51e',
            '💩': '1f4a9',
            '🔟': '1f51f',
            '💪': '1f4aa',
            '🔠': '1f520',
            '🔡': '1f521',
            '💫': '1f4ab',
            '🔢': '1f522',
            '🔣': '1f523',
            '💬': '1f4ac',
            '🔤': '1f524',
            '🔥': '1f525',
            '💮': '1f4ae',
            '🔦': '1f526',
            '🔧': '1f527',
            '💯': '1f4af',
            '🔨': '1f528',
            '🔩': '1f529',
            '💰': '1f4b0',
            '🔪': '1f52a',
            '🔫': '1f52b',
            '💱': '1f4b1',
            '🔮': '1f52e',
            '💲': '1f4b2',
            '🔯': '1f52f',
            '💳': '1f4b3',
            '🔰': '1f530',
            '🔱': '1f531',
            '💴': '1f4b4',
            '🔲': '1f532',
            '🔳': '1f533',
            '💵': '1f4b5',
            '🔴': '1f534',
            '🔵': '1f535',
            '💸': '1f4b8',
            '🔶': '1f536',
            '🔷': '1f537',
            '💹': '1f4b9',
            '🔸': '1f538',
            '🔹': '1f539',
            '💺': '1f4ba',
            '🔺': '1f53a',
            '🔻': '1f53b',
            '💻': '1f4bb',
            '🔼': '1f53c',
            '💼': '1f4bc',
            '🔽': '1f53d',
            '🕐': '1f550',
            '💽': '1f4bd',
            '🕑': '1f551',
            '💾': '1f4be',
            '🕒': '1f552',
            '💿': '1f4bf',
            '🕓': '1f553',
            '📀': '1f4c0',
            '🕔': '1f554',
            '🕕': '1f555',
            '📁': '1f4c1',
            '🕖': '1f556',
            '🕗': '1f557',
            '📂': '1f4c2',
            '🕘': '1f558',
            '🕙': '1f559',
            '📃': '1f4c3',
            '🕚': '1f55a',
            '🕛': '1f55b',
            '📄': '1f4c4',
            '🗻': '1f5fb',
            '🗼': '1f5fc',
            '📅': '1f4c5',
            '🗽': '1f5fd',
            '🗾': '1f5fe',
            '📆': '1f4c6',
            '🗿': '1f5ff',
            '😁': '1f601',
            '😂': '1f602',
            '😃': '1f603',
            '📈': '1f4c8',
            '😄': '1f604',
            '😅': '1f605',
            '📉': '1f4c9',
            '😆': '1f606',
            '😉': '1f609',
            '📊': '1f4ca',
            '😊': '1f60a',
            '😋': '1f60b',
            '📋': '1f4cb',
            '😌': '1f60c',
            '😍': '1f60d',
            '📌': '1f4cc',
            '😏': '1f60f',
            '😒': '1f612',
            '📍': '1f4cd',
            '😓': '1f613',
            '😔': '1f614',
            '📎': '1f4ce',
            '😖': '1f616',
            '😘': '1f618',
            '📏': '1f4cf',
            '😚': '1f61a',
            '😜': '1f61c',
            '📐': '1f4d0',
            '😝': '1f61d',
            '😞': '1f61e',
            '📑': '1f4d1',
            '😠': '1f620',
            '😡': '1f621',
            '😢': '1f622',
            '😣': '1f623',
            '😤': '1f624',
            '😥': '1f625',
            '😨': '1f628',
            '😩': '1f629',
            '😪': '1f62a',
            '😫': '1f62b',
            '😭': '1f62d',
            '😰': '1f630',
            '😱': '1f631',
            '😲': '1f632',
            '😳': '1f633',
            '😵': '1f635',
            '😷': '1f637',
            '😸': '1f638',
            '😹': '1f639',
            '😺': '1f63a',
            '😻': '1f63b',
            '😼': '1f63c',
            '😽': '1f63d',
            '😾': '1f63e',
            '😿': '1f63f',
            '🙀': '1f640',
            '🙅': '1f645',
            '🙆': '1f646',
            '🙇': '1f647',
            '🙈': '1f648',
            '🙉': '1f649',
            '🙊': '1f64a',
            '🙋': '1f64b',
            '🙌': '1f64c',
            '🙍': '1f64d',
            '🙎': '1f64e',
            '🙏': '1f64f',
            '🚀': '1f680',
            '🚃': '1f683',
            '🚄': '1f684',
            '🚅': '1f685',
            '🚇': '1f687',
            '🚉': '1f689',
            '🚌': '1f68c',
            '🚏': '1f68f',
            '🚑': '1f691',
            '🚒': '1f692',
            '🚓': '1f693',
            '🚕': '1f695',
            '🚗': '1f697',
            '🚙': '1f699',
            '🚚': '1f69a',
            '🚢': '1f6a2',
            '🚤': '1f6a4',
            '🚥': '1f6a5',
            '🚧': '1f6a7',
            '🚨': '1f6a8',
            '🚩': '1f6a9',
            '🚪': '1f6aa',
            '🚫': '1f6ab',
            '🚬': '1f6ac',
            '🚭': '1f6ad',
            '🚲': '1f6b2',
            '🚶': '1f6b6',
            '🚹': '1f6b9',
            '🚺': '1f6ba',
            '🚻': '1f6bb',
            '🚼': '1f6bc',
            '🚽': '1f6bd',
            '🚾': '1f6be',
            '🛀': '1f6c0',
            '🤘': '1f918',
            '😀': '1f600',
            '😇': '1f607',
            '😈': '1f608',
            '😎': '1f60e',
            '😐': '1f610',
            '😑': '1f611',
            '😕': '1f615',
            '😗': '1f617',
            '😙': '1f619',
            '😛': '1f61b',
            '😟': '1f61f',
            '😦': '1f626',
            '😧': '1f627',
            '😬': '1f62c',
            '😮': '1f62e',
            '😯': '1f62f',
            '😴': '1f634',
            '😶': '1f636',
            '🚁': '1f681',
            '🚂': '1f682',
            '🚆': '1f686',
            '🚈': '1f688',
            '🚊': '1f68a',
            '🚍': '1f68d',
            '🚎': '1f68e',
            '🚐': '1f690',
            '🚔': '1f694',
            '🚖': '1f696',
            '🚘': '1f698',
            '🚛': '1f69b',
            '🚜': '1f69c',
            '🚝': '1f69d',
            '🚞': '1f69e',
            '🚟': '1f69f',
            '🚠': '1f6a0',
            '🚡': '1f6a1',
            '🚣': '1f6a3',
            '🚦': '1f6a6',
            '🚮': '1f6ae',
            '🚯': '1f6af',
            '🚰': '1f6b0',
            '🚱': '1f6b1',
            '🚳': '1f6b3',
            '🚴': '1f6b4',
            '🚵': '1f6b5',
            '🚷': '1f6b7',
            '🚸': '1f6b8',
            '🚿': '1f6bf',
            '🛁': '1f6c1',
            '🛂': '1f6c2',
            '🛃': '1f6c3',
            '🛄': '1f6c4',
            '🛅': '1f6c5',
            '🌍': '1f30d',
            '🌎': '1f30e',
            '🌐': '1f310',
            '🌒': '1f312',
            '🌖': '1f316',
            '🌗': '1f317',
            '🌘': '1f318',
            '🌚': '1f31a',
            '🌜': '1f31c',
            '🌝': '1f31d',
            '🌞': '1f31e',
            '🌲': '1f332',
            '🌳': '1f333',
            '🍋': '1f34b',
            '🍐': '1f350',
            '🍼': '1f37c',
            '🏇': '1f3c7',
            '🏉': '1f3c9',
            '🏤': '1f3e4',
            '🐀': '1f400',
            '🐁': '1f401',
            '🐂': '1f402',
            '🐃': '1f403',
            '🐄': '1f404',
            '🐅': '1f405',
            '🐆': '1f406',
            '🐇': '1f407',
            '🐈': '1f408',
            '🐉': '1f409',
            '🐊': '1f40a',
            '🐋': '1f40b',
            '🐏': '1f40f',
            '🐐': '1f410',
            '🐓': '1f413',
            '🐕': '1f415',
            '🐖': '1f416',
            '🐪': '1f42a',
            '👥': '1f465',
            '👬': '1f46c',
            '👭': '1f46d',
            '💭': '1f4ad',
            '💶': '1f4b6',
            '💷': '1f4b7',
            '📬': '1f4ec',
            '📭': '1f4ed',
            '📯': '1f4ef',
            '📵': '1f4f5',
            '🔀': '1f500',
            '🔁': '1f501',
            '🔂': '1f502',
            '🔄': '1f504',
            '🔅': '1f505',
            '🔆': '1f506',
            '🔇': '1f507',
            '🔉': '1f509',
            '🔕': '1f515',
            '🔬': '1f52c',
            '🔭': '1f52d',
            '🕜': '1f55c',
            '🕝': '1f55d',
            '🕞': '1f55e',
            '🕟': '1f55f',
            '🕠': '1f560',
            '🕡': '1f561',
            '🕢': '1f562',
            '🕣': '1f563',
            '🕤': '1f564',
            '🕥': '1f565',
            '🕦': '1f566',
            '🕧': '1f567',
            '🔈': '1f508',
            '🚋': '1f68b',
            '🏅': '1f3c5',
            '🏴': '1f3f4',
            '📸': '1f4f8',
            '🛌': '1f6cc',
            '🖕': '1f595',
            '🖖': '1f596',
            '🙁': '1f641',
            '🙂': '1f642',
            '🛫': '1f6eb',
            '🛬': '1f6ec',
            '🏻': '1f3fb',
            '🏼': '1f3fc',
            '🏽': '1f3fd',
            '🏾': '1f3fe',
            '🏿': '1f3ff',
            '🙃': '1f643',
            '🤑': '1f911',
            '🤓': '1f913',
            '🤗': '1f917',
            '🙄': '1f644',
            '🤔': '1f914',
            '🤐': '1f910',
            '🤒': '1f912',
            '🤕': '1f915',
            '🤖': '1f916',
            '🦁': '1f981',
            '🦄': '1f984',
            '🦂': '1f982',
            '🦀': '1f980',
            '🦃': '1f983',
            '🧀': '1f9c0',
            '🌭': '1f32d',
            '🌮': '1f32e',
            '🌯': '1f32f',
            '🍿': '1f37f',
            '🍾': '1f37e',
            '🏹': '1f3f9',
            '🏺': '1f3fa',
            '🛐': '1f6d0',
            '🕋': '1f54b',
            '🕌': '1f54c',
            '🕍': '1f54d',
            '🕎': '1f54e',
            '📿': '1f4ff',
            '🏏': '1f3cf',
            '🏐': '1f3d0',
            '🏑': '1f3d1',
            '🏒': '1f3d2',
            '🏓': '1f3d3',
            '🏸': '1f3f8',
            '🥁': '1f941',
            '🦐': '1f990',
            '🦑': '1f991',
            '🥚': '1f95a',
            '🥛': '1f95b',
            '🥜': '1f95c',
            '🥝': '1f95d',
            '🥞': '1f95e',
            '🇼': '1f1fc',
            '🇻': '1f1fb',
            '🇺': '1f1fa',
            '🇹': '1f1f9',
            '🇸': '1f1f8',
            '🇷': '1f1f7',
            '🇶': '1f1f6',
            '🇵': '1f1f5',
            '🇴': '1f1f4',
            '🇳': '1f1f3',
            '🇲': '1f1f2',
            '🇱': '1f1f1',
            '🇰': '1f1f0',
            '🇯': '1f1ef',
            '🇮': '1f1ee',
            '🇭': '1f1ed',
            '🇬': '1f1ec',
            '🇫': '1f1eb',
            '🇪': '1f1ea',
            '🇩': '1f1e9',
            '🇨': '1f1e8',
            '🇧': '1f1e7',
            '🇦': '1f1e6',
            '⏩': '23e9',
            '⏪': '23ea',
            '⏫': '23eb',
            '⏬': '23ec',
            '⏰': '23f0',
            '⏳': '23f3',
            '⛎': '26ce',
            '✅': '2705',
            '✊': '270a',
            '✋': '270b',
            '✨': '2728',
            '❌': '274c',
            '❎': '274e',
            '❓': '2753',
            '❔': '2754',
            '❕': '2755',
            '➕': '2795',
            '➖': '2796',
            '➗': '2797',
            '➰': '27b0',
            '➿': '27bf',
            '©': '00a9',
            '®': '00ae',
            '‼': '203c',
            '⁉': '2049',
            '™': '2122',
            ℹ: '2139',
            '↔': '2194',
            '↕': '2195',
            '↖': '2196',
            '↗': '2197',
            '↘': '2198',
            '↙': '2199',
            '↩': '21a9',
            '↪': '21aa',
            '⌚': '231a',
            '⌛': '231b',
            'Ⓜ': '24c2',
            '▪': '25aa',
            '▫': '25ab',
            '▶': '25b6',
            '◀': '25c0',
            '◻': '25fb',
            '◼': '25fc',
            '◽': '25fd',
            '◾': '25fe',
            '☀': '2600',
            '☁': '2601',
            '☎': '260e',
            '☑': '2611',
            '☔': '2614',
            '☕': '2615',
            '☝': '261d',
            '☺': '263a',
            '♈': '2648',
            '♉': '2649',
            '♊': '264a',
            '♋': '264b',
            '♌': '264c',
            '♍': '264d',
            '♎': '264e',
            '♏': '264f',
            '♐': '2650',
            '♑': '2651',
            '♒': '2652',
            '♓': '2653',
            '♠': '2660',
            '♣': '2663',
            '♥': '2665',
            '♦': '2666',
            '♨': '2668',
            '♻': '267b',
            '♿': '267f',
            '⚓': '2693',
            '⚠': '26a0',
            '⚡': '26a1',
            '⚪': '26aa',
            '⚫': '26ab',
            '⚽': '26bd',
            '⚾': '26be',
            '⛄': '26c4',
            '⛅': '26c5',
            '⛔': '26d4',
            '⛪': '26ea',
            '⛲': '26f2',
            '⛳': '26f3',
            '⛵': '26f5',
            '⛺': '26fa',
            '⛽': '26fd',
            '✂': '2702',
            '✈': '2708',
            '✉': '2709',
            '✌': '270c',
            '✏': '270f',
            '✒': '2712',
            '✔': '2714',
            '✖': '2716',
            '✳': '2733',
            '✴': '2734',
            '❄': '2744',
            '❇': '2747',
            '❗': '2757',
            '❤': '2764',
            '➡': '27a1',
            '⤴': '2934',
            '⤵': '2935',
            '⬅': '2b05',
            '⬆': '2b06',
            '⬇': '2b07',
            '⬛': '2b1b',
            '⬜': '2b1c',
            '⭐': '2b50',
            '⭕': '2b55',
            '〰': '3030',
            '〽': '303d',
            '㊗': '3297',
            '㊙': '3299',
            '🀄': '1f004',
            '🅿': '1f17f',
            '🈂': '1f202',
            '🈚': '1f21a',
            '🈯': '1f22f',
            '🈷': '1f237',
            '🎞': '1f39e',
            '🎟': '1f39f',
            '🏋': '1f3cb',
            '🏌': '1f3cc',
            '🏍': '1f3cd',
            '🏎': '1f3ce',
            '🎖': '1f396',
            '🎗': '1f397',
            '🌶': '1f336',
            '🌧': '1f327',
            '🌨': '1f328',
            '🌩': '1f329',
            '🌪': '1f32a',
            '🌫': '1f32b',
            '🌬': '1f32c',
            '🐿': '1f43f',
            '🕷': '1f577',
            '🕸': '1f578',
            '🌡': '1f321',
            '🎙': '1f399',
            '🎚': '1f39a',
            '🎛': '1f39b',
            '🏳': '1f3f3',
            '🏵': '1f3f5',
            '🏷': '1f3f7',
            '📽': '1f4fd',
            '✝': '271d',
            '🕉': '1f549',
            '🕊': '1f54a',
            '🕯': '1f56f',
            '🕰': '1f570',
            '🕳': '1f573',
            '🕶': '1f576',
            '🕹': '1f579',
            '🖇': '1f587',
            '🖊': '1f58a',
            '🖋': '1f58b',
            '🖌': '1f58c',
            '🖍': '1f58d',
            '🖥': '1f5a5',
            '🖨': '1f5a8',
            '⌨': '2328',
            '🖲': '1f5b2',
            '🖼': '1f5bc',
            '🗂': '1f5c2',
            '🗃': '1f5c3',
            '🗄': '1f5c4',
            '🗑': '1f5d1',
            '🗒': '1f5d2',
            '🗓': '1f5d3',
            '🗜': '1f5dc',
            '🗝': '1f5dd',
            '🗞': '1f5de',
            '🗡': '1f5e1',
            '🗣': '1f5e3',
            '🗨': '1f5e8',
            '🗯': '1f5ef',
            '🗳': '1f5f3',
            '🗺': '1f5fa',
            '🛠': '1f6e0',
            '🛡': '1f6e1',
            '🛢': '1f6e2',
            '🛰': '1f6f0',
            '🍽': '1f37d',
            '👁': '1f441',
            '🕴': '1f574',
            '🕵': '1f575',
            '✍': '270d',
            '🖐': '1f590',
            '🏔': '1f3d4',
            '🏕': '1f3d5',
            '🏖': '1f3d6',
            '🏗': '1f3d7',
            '🏘': '1f3d8',
            '🏙': '1f3d9',
            '🏚': '1f3da',
            '🏛': '1f3db',
            '🏜': '1f3dc',
            '🏝': '1f3dd',
            '🏞': '1f3de',
            '🏟': '1f3df',
            '🛋': '1f6cb',
            '🛍': '1f6cd',
            '🛎': '1f6ce',
            '🛏': '1f6cf',
            '🛣': '1f6e3',
            '🛤': '1f6e4',
            '🛥': '1f6e5',
            '🛩': '1f6e9',
            '🛳': '1f6f3',
            '⏏': '23cf',
            '⏭': '23ed',
            '⏮': '23ee',
            '⏯': '23ef',
            '⏱': '23f1',
            '⏲': '23f2',
            '⏸': '23f8',
            '⏹': '23f9',
            '⏺': '23fa',
            '☂': '2602',
            '☃': '2603',
            '☄': '2604',
            '☘': '2618',
            '☠': '2620',
            '☢': '2622',
            '☣': '2623',
            '☦': '2626',
            '☪': '262a',
            '☮': '262e',
            '☯': '262f',
            '☸': '2638',
            '☹': '2639',
            '⚒': '2692',
            '⚔': '2694',
            '⚖': '2696',
            '⚗': '2697',
            '⚙': '2699',
            '⚛': '269b',
            '⚜': '269c',
            '⚰': '26b0',
            '⚱': '26b1',
            '⛈': '26c8',
            '⛏': '26cf',
            '⛑': '26d1',
            '⛓': '26d3',
            '⛩': '26e9',
            '⛰': '26f0',
            '⛱': '26f1',
            '⛴': '26f4',
            '⛷': '26f7',
            '⛸': '26f8',
            '⛹': '26f9',
            '✡': '2721',
            '❣': '2763',
            '🌤': '1f324',
            '🌥': '1f325',
            '🌦': '1f326',
            '🖱': '1f5b1'
        }),
        (a.imagePathPNG = 'https://cdn.jsdelivr.net/emojione/assets/png/'),
        (a.imagePathSVG = 'https://cdn.jsdelivr.net/emojione/assets/svg/'),
        (a.imagePathSVGSprites = './../assets/sprites/emojione.sprites.svg'),
        (a.imageType = 'png'),
        (a.imageTitleTag = !0),
        (a.sprites = !1),
        (a.unicodeAlt = !0),
        (a.ascii = !1),
        (a.cacheBustParam = '?v=2.2.7'),
        (a.regShortNames = new RegExp(
            '<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(' +
                a.shortnames +
                ')',
            'gi'
        )),
        (a.regAscii = new RegExp(
            '<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)' +
                a.asciiRegexp +
                '(?=\\s|$|[!,.?]))',
            'g'
        )),
        (a.regUnicode = new RegExp(
            '<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(' +
                a.unicodeRegexp +
                ')',
            'gi'
        )),
        (a.toImage = function(b) {
            return (b = a.unicodeToImage(b)), (b = a.shortnameToImage(b));
        }),
        (a.unifyUnicode = function(b) {
            return (b = a.toShort(b)), (b = a.shortnameToUnicode(b));
        }),
        (a.shortnameToAscii = function(b) {
            var c,
                d = a.objectFlip(a.asciiList);
            return (b = b.replace(a.regShortNames, function(b) {
                return 'undefined' != typeof b &&
                    '' !== b &&
                    b in a.emojioneList
                    ? ((c =
                          a.emojioneList[b].unicode[
                              a.emojioneList[b].unicode.length - 1
                          ]),
                      'undefined' != typeof d[c] ? d[c] : b)
                    : b;
            }));
        }),
        (a.shortnameToUnicode = function(b) {
            var c, d, e;
            return (
                (b = b.replace(a.regShortNames, function(b) {
                    return 'undefined' != typeof b &&
                        '' !== b &&
                        b in a.emojioneList
                        ? ((c = a.emojioneList[b].unicode[0].toUpperCase()),
                          (d = a.emojioneList[b].fname),
                          (e = a.emojioneList[b].uc),
                          a.convert(e))
                        : b;
                })),
                a.ascii &&
                    (b = b.replace(a.regAscii, function(b, d, e, f) {
                        return 'undefined' != typeof f &&
                            '' !== f &&
                            a.unescapeHTML(f) in a.asciiList
                            ? ((f = a.unescapeHTML(f)),
                              (c = a.asciiList[f].toUpperCase()),
                              e + a.convert(c))
                            : b;
                    })),
                b
            );
        }),
        (a.shortnameToImage = function(b) {
            var c, d, e, f;
            return (
                (b = b.replace(a.regShortNames, function(b) {
                    return 'undefined' != typeof b &&
                        '' !== b &&
                        b in a.emojioneList
                        ? ((d =
                              a.emojioneList[b].unicode[
                                  a.emojioneList[b].unicode.length - 1
                              ]),
                          (f = a.imageTitleTag ? 'title="' + b + '"' : ''),
                          (e = a.unicodeAlt ? a.convert(d.toUpperCase()) : b),
                          (c =
                              'png' === a.imageType
                                  ? a.sprites
                                    ? '<span class="emojione emojione-' +
                                      d +
                                      '" ' +
                                      f +
                                      '>' +
                                      e +
                                      '</span>'
                                    : '<img class="emojione" alt="' +
                                      e +
                                      '" ' +
                                      f +
                                      ' src="' +
                                      a.imagePathPNG +
                                      d +
                                      '.png' +
                                      a.cacheBustParam +
                                      '"/>'
                                  : a.sprites
                                    ? '<svg class="emojione"><description>' +
                                      e +
                                      '</description><use xlink:href="' +
                                      a.imagePathSVGSprites +
                                      '#emoji-' +
                                      d +
                                      '"></use></svg>'
                                    : '<object class="emojione" data="' +
                                      a.imagePathSVG +
                                      d +
                                      '.svg' +
                                      a.cacheBustParam +
                                      '" type="image/svg+xml" standby="' +
                                      e +
                                      '">' +
                                      e +
                                      '</object>'))
                        : b;
                })),
                a.ascii &&
                    (b = b.replace(a.regAscii, function(b, g, h, i) {
                        return 'undefined' != typeof i &&
                            '' !== i &&
                            a.unescapeHTML(i) in a.asciiList
                            ? ((i = a.unescapeHTML(i)),
                              (d = a.asciiList[i]),
                              (f = a.imageTitleTag
                                  ? 'title="' + a.escapeHTML(i) + '"'
                                  : ''),
                              (e = a.unicodeAlt
                                  ? a.convert(d.toUpperCase())
                                  : a.escapeHTML(i)),
                              (c =
                                  'png' === a.imageType
                                      ? a.sprites
                                        ? h +
                                          '<span class="emojione emojione-' +
                                          d +
                                          '"  ' +
                                          f +
                                          '>' +
                                          e +
                                          '</span>'
                                        : h +
                                          '<img class="emojione" alt="' +
                                          e +
                                          '" ' +
                                          f +
                                          ' src="' +
                                          a.imagePathPNG +
                                          d +
                                          '.png' +
                                          a.cacheBustParam +
                                          '"/>'
                                      : a.sprites
                                        ? '<svg class="emojione"><description>' +
                                          e +
                                          '</description><use xlink:href="' +
                                          a.imagePathSVGSprites +
                                          '#emoji-' +
                                          d +
                                          '"></use></svg>'
                                        : h +
                                          '<object class="emojione" data="' +
                                          a.imagePathSVG +
                                          d +
                                          '.svg' +
                                          a.cacheBustParam +
                                          '" type="image/svg+xml" standby="' +
                                          e +
                                          '">' +
                                          e +
                                          '</object>'))
                            : b;
                    })),
                b
            );
        }),
        (a.unicodeToImage = function(b) {
            var c,
                d,
                e,
                f,
                g,
                h,
                i = a.mapUnicodeToShort();
            return (b = b.replace(a.regUnicode, function(b) {
                return 'undefined' != typeof b && '' !== b && b in a.jsEscapeMap
                    ? ((d = a.jsEscapeMap[b]),
                      (e = i[d]),
                      (f = a.emojioneList[e].fname),
                      (g = a.unicodeAlt ? a.convert(d.toUpperCase()) : e),
                      (h = a.imageTitleTag ? 'title="' + e + '"' : ''),
                      (c =
                          'png' === a.imageType
                              ? a.sprites
                                ? '<span class="emojione emojione-' +
                                  d +
                                  '" ' +
                                  h +
                                  '>' +
                                  g +
                                  '</span>'
                                : '<img class="emojione" alt="' +
                                  g +
                                  '" ' +
                                  h +
                                  ' src="' +
                                  a.imagePathPNG +
                                  f +
                                  '.png' +
                                  a.cacheBustParam +
                                  '"/>'
                              : a.sprites
                                ? '<svg class="emojione"><description>' +
                                  g +
                                  '</description><use xlink:href="' +
                                  a.imagePathSVGSprites +
                                  '#emoji-' +
                                  d +
                                  '"></use></svg>'
                                : '<img class="emojione" alt="' +
                                  g +
                                  '" ' +
                                  h +
                                  ' src="' +
                                  a.imagePathSVG +
                                  f +
                                  '.svg' +
                                  a.cacheBustParam +
                                  '"/>'))
                    : b;
            }));
        }),
        (a.toShort = function(b) {
            var c = a.getUnicodeReplacementRegEx(),
                d = a.mapUnicodeCharactersToShort();
            return a.replaceAll(b, c, d);
        }),
        (a.convert = function(a) {
            if (a.indexOf('-') > -1) {
                for (var b = [], c = a.split('-'), d = 0; d < c.length; d++) {
                    var e = parseInt(c[d], 16);
                    if (e >= 65536 && 1114111 >= e) {
                        var f = Math.floor((e - 65536) / 1024) + 55296,
                            g = (e - 65536) % 1024 + 56320;
                        e = String.fromCharCode(f) + String.fromCharCode(g);
                    } else e = String.fromCharCode(e);
                    b.push(e);
                }
                return b.join('');
            }
            var c = parseInt(a, 16);
            if (c >= 65536 && 1114111 >= c) {
                var f = Math.floor((c - 65536) / 1024) + 55296,
                    g = (c - 65536) % 1024 + 56320;
                return String.fromCharCode(f) + String.fromCharCode(g);
            }
            return String.fromCharCode(c);
        }),
        (a.escapeHTML = function(a) {
            var b = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            return a.replace(/[&<>"']/g, function(a) {
                return b[a];
            });
        }),
        (a.unescapeHTML = function(a) {
            var b = {
                '&amp;': '&',
                '&#38;': '&',
                '&#x26;': '&',
                '&lt;': '<',
                '&#60;': '<',
                '&#x3C;': '<',
                '&gt;': '>',
                '&#62;': '>',
                '&#x3E;': '>',
                '&quot;': '"',
                '&#34;': '"',
                '&#x22;': '"',
                '&apos;': "'",
                '&#39;': "'",
                '&#x27;': "'"
            };
            return a.replace(
                /&(?:amp|#38|#x26|lt|#60|#x3C|gt|#62|#x3E|apos|#39|#x27|quot|#34|#x22);/gi,
                function(a) {
                    return b[a];
                }
            );
        }),
        (a.mapEmojioneList = function(b) {
            for (var c in a.emojioneList)
                if (a.emojioneList.hasOwnProperty(c))
                    for (
                        var d = 0, e = a.emojioneList[c].unicode.length;
                        e > d;
                        d++
                    ) {
                        var f = a.emojioneList[c].unicode[d];
                        b(f, c);
                    }
        }),
        (a.mapUnicodeToShort = function() {
            return (
                a.memMapShortToUnicode ||
                    ((a.memMapShortToUnicode = {}),
                    a.mapEmojioneList(function(b, c) {
                        a.memMapShortToUnicode[b] = c;
                    })),
                a.memMapShortToUnicode
            );
        }),
        (a.memoizeReplacement = function() {
            if (
                !a.unicodeReplacementRegEx ||
                !a.memMapShortToUnicodeCharacters
            ) {
                var b = [];
                (a.memMapShortToUnicodeCharacters = {}),
                    a.mapEmojioneList(function(c, d) {
                        var e = a.convert(c);
                        a.emojioneList[d].isCanonical &&
                            (a.memMapShortToUnicodeCharacters[e] = d),
                            b.push(e);
                    }),
                    (a.unicodeReplacementRegEx = b.join('|'));
            }
        }),
        (a.mapUnicodeCharactersToShort = function() {
            return a.memoizeReplacement(), a.memMapShortToUnicodeCharacters;
        }),
        (a.getUnicodeReplacementRegEx = function() {
            return a.memoizeReplacement(), a.unicodeReplacementRegEx;
        }),
        (a.objectFlip = function(a) {
            var b,
                c = {};
            for (b in a) a.hasOwnProperty(b) && (c[a[b]] = b);
            return c;
        }),
        (a.escapeRegExp = function(a) {
            return a.replace(/[-[\]{}()*+?.,;:&\\^$#\s]/g, '\\$&');
        }),
        (a.replaceAll = function(b, c, d) {
            var e = a.escapeRegExp(c),
                f = new RegExp(
                    '<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(' +
                        e +
                        ')',
                    'gi'
                ),
                g = function(a, b) {
                    return 'undefined' == typeof b || '' === b ? a : d[b];
                };
            return b.replace(f, g);
        });
})((this.emojione = this.emojione || {})),
    'object' == typeof module && (module.exports = this.emojione);



// WEBPACK FOOTER //
// ./resources/assets/js/libs/emojione.min.js